/**
 * =============================================================================
 * ASL Multi-Tenant Partner Shop - Slot-Register (Paket C, Task t_271df8b1)
 * =============================================================================
 * Zentrale Datenquelle für alle 408 Slot-Definitionen (398 Texte & 10 Bild-Slots)
 * aus 26 Quelldateien.
 */

export const CONTENT_PAGE_KEYS = [
  "home",
  "footer",
  "legal",
  "brand",
  "onboarding"
];

export const ALL_PAGE_KEYS = [
  "home",
  "catalog",
  "product",
  "cart",
  "inquiry",
  "header",
  "footer",
  "legal",
  "advisor",
  "copilot",
  "brand",
  "onboarding"
];

export const SLOT_REGISTRY = [
  {
    "id": "advisor_badge",
    "page": "advisor",
    "type": "text",
    "label": "Sicherheitsberater Badge",
    "defaultValue": "Interaktiver Bedarfsassistent",
    "default_value": "Interaktiver Bedarfsassistent",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_title",
    "page": "advisor",
    "type": "text",
    "label": "Sicherheitsberater Titel",
    "defaultValue": "Sicherheitslösung nach Maß planen",
    "default_value": "Sicherheitslösung nach Maß planen",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_subtitle",
    "page": "advisor",
    "type": "text",
    "label": "Sicherheitsberater Untertitel",
    "defaultValue": "In wenigen Schritten zur passenden Systemkonfiguration für Ihr Objekt.",
    "default_value": "In wenigen Schritten zur passenden Systemkonfiguration für Ihr Objekt.",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_intro_text",
    "page": "advisor",
    "type": "text",
    "label": "Sicherheitsberater Einleitung",
    "defaultValue": "Beantworten Sie 4 kurze Fragen. Unser System ermittelt kompatible Komponenten aus dem ASL-Fachgroßhandelsbestand.",
    "default_value": "Beantworten Sie 4 kurze Fragen. Unser System ermittelt kompatible Komponenten aus dem ASL-Fachgroßhandelsbestand.",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": true
  },
  {
    "id": "advisor_step1_title",
    "page": "advisor",
    "type": "text",
    "label": "Schritt 1 Titel",
    "defaultValue": "Objektart wählen",
    "default_value": "Objektart wählen",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_step1_desc",
    "page": "advisor",
    "type": "text",
    "label": "Schritt 1 Beschreibung",
    "defaultValue": "Um welches Gebäude oder Areal handelt es sich?",
    "default_value": "Um welches Gebäude oder Areal handelt es sich?",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_step2_title",
    "page": "advisor",
    "type": "text",
    "label": "Schritt 2 Titel",
    "defaultValue": "Schutzbereich festlegen",
    "default_value": "Schutzbereich festlegen",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_step2_desc",
    "page": "advisor",
    "type": "text",
    "label": "Schritt 2 Beschreibung",
    "defaultValue": "Welche Gewerke sollen abgedeckt werden?",
    "default_value": "Welche Gewerke sollen abgedeckt werden?",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_step3_title",
    "page": "advisor",
    "type": "text",
    "label": "Schritt 3 Titel",
    "defaultValue": "Objektgröße & Zonen",
    "default_value": "Objektgröße & Zonen",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_step3_desc",
    "page": "advisor",
    "type": "text",
    "label": "Schritt 3 Beschreibung",
    "defaultValue": "Wie groß ist die zu sichernde Fläche?",
    "default_value": "Wie groß ist die zu sichernde Fläche?",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_step4_title",
    "page": "advisor",
    "type": "text",
    "label": "Schritt 4 Titel",
    "defaultValue": "Anforderungen & Normen",
    "default_value": "Anforderungen & Normen",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_step4_desc",
    "page": "advisor",
    "type": "text",
    "label": "Schritt 4 Beschreibung",
    "defaultValue": "Besondere Zertifizierungen und Richtlinien.",
    "default_value": "Besondere Zertifizierungen und Richtlinien.",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_opt_commercial_title",
    "page": "advisor",
    "type": "text",
    "label": "Option Gewerbe Titel",
    "defaultValue": "Gewerbe & Industrie",
    "default_value": "Gewerbe & Industrie",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_opt_commercial_desc",
    "page": "advisor",
    "type": "text",
    "label": "Option Gewerbe Beschreibung",
    "defaultValue": "Bürogebäude, Lagerhallen, Produktionsstätten und Verkaufsflächen.",
    "default_value": "Bürogebäude, Lagerhallen, Produktionsstätten und Verkaufsflächen.",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_opt_residential_title",
    "page": "advisor",
    "type": "text",
    "label": "Option Wohnen Titel",
    "defaultValue": "Privat & Wohnobjekt",
    "default_value": "Privat & Wohnobjekt",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_opt_residential_desc",
    "page": "advisor",
    "type": "text",
    "label": "Option Wohnen Beschreibung",
    "defaultValue": "Einfamilienhäuser, Mehrfamilienhäuser und Wohnanlagen.",
    "default_value": "Einfamilienhäuser, Mehrfamilienhäuser und Wohnanlagen.",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_opt_public_title",
    "page": "advisor",
    "type": "text",
    "label": "Option Öffentlich Titel",
    "defaultValue": "Öffentliche Hand & Bildung",
    "default_value": "Öffentliche Hand & Bildung",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_opt_public_desc",
    "page": "advisor",
    "type": "text",
    "label": "Option Öffentlich Beschreibung",
    "defaultValue": "Schulen, Behörden, Sportstätten und Freizeitanlagen.",
    "default_value": "Schulen, Behörden, Sportstätten und Freizeitanlagen.",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_opt_critical_title",
    "page": "advisor",
    "type": "text",
    "label": "Option KRITIS Titel",
    "defaultValue": "Kritische Infrastruktur (KRITIS)",
    "default_value": "Kritische Infrastruktur (KRITIS)",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_opt_critical_desc",
    "page": "advisor",
    "type": "text",
    "label": "Option KRITIS Beschreibung",
    "defaultValue": "Umspannwerke, Rechenzentren, Wasserwerke mit erhöhten Sicherheitsauflagen.",
    "default_value": "Umspannwerke, Rechenzentren, Wasserwerke mit erhöhten Sicherheitsauflagen.",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_discipline_video",
    "page": "advisor",
    "type": "text",
    "label": "Gewerk Videoüberwachung",
    "defaultValue": "Videoüberwachung (CCTV)",
    "default_value": "Videoüberwachung (CCTV)",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_discipline_video_desc",
    "page": "advisor",
    "type": "text",
    "label": "Gewerk Video Beschreibung",
    "defaultValue": "IP-Kameras, NVR-Rekorder, KI-Videoanalytik und PTZ-Systeme.",
    "default_value": "IP-Kameras, NVR-Rekorder, KI-Videoanalytik und PTZ-Systeme.",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_discipline_alarm",
    "page": "advisor",
    "type": "text",
    "label": "Gewerk Einbruchmelde",
    "defaultValue": "Einbruchmelde- & Gefahrentechnik",
    "default_value": "Einbruchmelde- & Gefahrentechnik",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_discipline_alarm_desc",
    "page": "advisor",
    "type": "text",
    "label": "Gewerk Einbruchmelde Beschreibung",
    "defaultValue": "VdS-zertifizierte Zentralen, Bewegungsmelder, Magnetkontakte.",
    "default_value": "VdS-zertifizierte Zentralen, Bewegungsmelder, Magnetkontakte.",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_discipline_access",
    "page": "advisor",
    "type": "text",
    "label": "Gewerk Zutrittskontrolle",
    "defaultValue": "Zutrittskontrolle & Zeiterfassung",
    "default_value": "Zutrittskontrolle & Zeiterfassung",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_discipline_access_desc",
    "page": "advisor",
    "type": "text",
    "label": "Gewerk Zutrittskontrolle Beschreibung",
    "defaultValue": "RFID-Leser, Motorschlösser, biometrische Terminals, Drehkreuze.",
    "default_value": "RFID-Leser, Motorschlösser, biometrische Terminals, Drehkreuze.",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_discipline_fire",
    "page": "advisor",
    "type": "text",
    "label": "Gewerk Brandmeldetechnik",
    "defaultValue": "Brandmeldetechnik (BMA)",
    "default_value": "Brandmeldetechnik (BMA)",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_discipline_fire_desc",
    "page": "advisor",
    "type": "text",
    "label": "Gewerk Brandmelde Beschreibung",
    "defaultValue": "DIN 14675 / EN54-konforme Rauchmelder, Handfeuermelder, Koppler.",
    "default_value": "DIN 14675 / EN54-konforme Rauchmelder, Handfeuermelder, Koppler.",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_discipline_power",
    "page": "advisor",
    "type": "text",
    "label": "Gewerk Stromversorgung",
    "defaultValue": "Notstrom & USV-Systeme",
    "default_value": "Notstrom & USV-Systeme",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_discipline_power_desc",
    "page": "advisor",
    "type": "text",
    "label": "Gewerk Stromversorgung Beschreibung",
    "defaultValue": "Pulsar Netzteile, Akkumulatoren, Pufferstromversorgungen.",
    "default_value": "Pulsar Netzteile, Akkumulatoren, Pufferstromversorgungen.",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_size_small",
    "page": "advisor",
    "type": "text",
    "label": "Größe Klein",
    "defaultValue": "Bis 250 m² (Kompakt)",
    "default_value": "Bis 250 m² (Kompakt)",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_size_medium",
    "page": "advisor",
    "type": "text",
    "label": "Größe Mittel",
    "defaultValue": "250 bis 1.000 m² (Standard)",
    "default_value": "250 bis 1.000 m² (Standard)",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_size_large",
    "page": "advisor",
    "type": "text",
    "label": "Größe Groß",
    "defaultValue": "1.000 bis 5.000 m² (Erweitert)",
    "default_value": "1.000 bis 5.000 m² (Erweitert)",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_size_campus",
    "page": "advisor",
    "type": "text",
    "label": "Größe Campus",
    "defaultValue": "Über 5.000 m² / Campus-Areal",
    "default_value": "Über 5.000 m² / Campus-Areal",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_norm_vds_a",
    "page": "advisor",
    "type": "text",
    "label": "Norm VdS A",
    "defaultValue": "VdS Klasse A (Privat / Basisschutz)",
    "default_value": "VdS Klasse A (Privat / Basisschutz)",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_norm_vds_b",
    "page": "advisor",
    "type": "text",
    "label": "Norm VdS B",
    "defaultValue": "VdS Klasse B (Gewerbe / Mittleres Risiko)",
    "default_value": "VdS Klasse B (Gewerbe / Mittleres Risiko)",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_norm_vds_c",
    "page": "advisor",
    "type": "text",
    "label": "Norm VdS C",
    "defaultValue": "VdS Klasse C (Industrie / Hohes Risiko)",
    "default_value": "VdS Klasse C (Industrie / Hohes Risiko)",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_norm_din_14675",
    "page": "advisor",
    "type": "text",
    "label": "Norm DIN 14675",
    "defaultValue": "DIN 14675 Brandmeldeanlagen",
    "default_value": "DIN 14675 Brandmeldeanlagen",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_norm_en_50131",
    "page": "advisor",
    "type": "text",
    "label": "Norm EN 50131",
    "defaultValue": "DIN EN 50131 Grad 2 / Grad 3 EMA",
    "default_value": "DIN EN 50131 Grad 2 / Grad 3 EMA",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_norm_en_54",
    "page": "advisor",
    "type": "text",
    "label": "Norm EN 54",
    "defaultValue": "DIN EN 54 Brandmeldesysteme",
    "default_value": "DIN EN 54 Brandmeldesysteme",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_indoor_label",
    "page": "advisor",
    "type": "text",
    "label": "Innenbereich Label",
    "defaultValue": "Innenraumüberwachung",
    "default_value": "Innenraumüberwachung",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_outdoor_label",
    "page": "advisor",
    "type": "text",
    "label": "Außenbereich Label",
    "defaultValue": "Freigelände- & Perimeterabsicherung",
    "default_value": "Freigelände- & Perimeterabsicherung",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_perimeter_label",
    "page": "advisor",
    "type": "text",
    "label": "Perimeter Label",
    "defaultValue": "Zaun- und Zaunüberstiegsüberwachung",
    "default_value": "Zaun- und Zaunüberstiegsüberwachung",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_recording_label",
    "page": "advisor",
    "type": "text",
    "label": "Aufzeichnung Label",
    "defaultValue": "DSGVO-konforme Langzeitaufzeichnung",
    "default_value": "DSGVO-konforme Langzeitaufzeichnung",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_cloud_remote_label",
    "page": "advisor",
    "type": "text",
    "label": "Fernzugriff Label",
    "defaultValue": "Sicherer Fernzugriff / Leitstellenaufschaltung",
    "default_value": "Sicherer Fernzugriff / Leitstellenaufschaltung",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_results_title",
    "page": "advisor",
    "type": "text",
    "label": "Ergebnisse Titel",
    "defaultValue": "Empfohlene Systemzusammenstellung",
    "default_value": "Empfohlene Systemzusammenstellung",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_results_subtitle",
    "page": "advisor",
    "type": "text",
    "label": "Ergebnisse Untertitel",
    "defaultValue": "Basierend auf Ihren Angaben haben wir folgende Fachkomponenten vorausgewählt:",
    "default_value": "Basierend auf Ihren Angaben haben wir folgende Fachkomponenten vorausgewählt:",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_results_bom_title",
    "page": "advisor",
    "type": "text",
    "label": "Stückliste Titel",
    "defaultValue": "Vorläufige Systemstückliste (BOM)",
    "default_value": "Vorläufige Systemstückliste (BOM)",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_results_bom_empty",
    "page": "advisor",
    "type": "text",
    "label": "Keine Komponenten gefunden",
    "defaultValue": "Für die gewählte Kombination liegen derzeit keine Standardpakete vor. Bitte stellen Sie eine individuelle Projektanfrage.",
    "default_value": "Für die gewählte Kombination liegen derzeit keine Standardpakete vor. Bitte stellen Sie eine individuelle Projektanfrage.",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_results_net_estimate",
    "page": "advisor",
    "type": "text",
    "label": "Geschätzter Preis",
    "defaultValue": "Geschätztes Budget:",
    "default_value": "Geschätztes Budget:",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_results_disclaimer",
    "page": "advisor",
    "type": "text",
    "label": "Hinweis Preis",
    "defaultValue": "Die angezeigten Preise sind unverbindlich und verstehen sich zzgl. gesetzlicher MwSt. Montage und Inbetriebnahme erfolgen durch einen Fachbetrieb.",
    "default_value": "Die angezeigten Preise sind unverbindlich und verstehen sich zzgl. gesetzlicher MwSt. Montage und Inbetriebnahme erfolgen durch einen Fachbetrieb.",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": true
  },
  {
    "id": "advisor_btn_next",
    "page": "advisor",
    "type": "text",
    "label": "Button Weiter",
    "defaultValue": "Nächster Schritt",
    "default_value": "Nächster Schritt",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_btn_back",
    "page": "advisor",
    "type": "text",
    "label": "Button Zurück",
    "defaultValue": "Zurück",
    "default_value": "Zurück",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_btn_restart",
    "page": "advisor",
    "type": "text",
    "label": "Button Neustart",
    "defaultValue": "Konfiguration neu starten",
    "default_value": "Konfiguration neu starten",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_btn_transfer_cart",
    "page": "advisor",
    "type": "text",
    "label": "Button in Warenkorb",
    "defaultValue": "Auswahl in Anfragekorb übernehmen",
    "default_value": "Auswahl in Anfragekorb übernehmen",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_btn_request_quote",
    "page": "advisor",
    "type": "text",
    "label": "Button Projektanfrage",
    "defaultValue": "Projektanfrage für Konfiguration stellen",
    "default_value": "Projektanfrage für Konfiguration stellen",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_btn_expert_call",
    "page": "advisor",
    "type": "text",
    "label": "Button Expertenberatung",
    "defaultValue": "Fachberatung anfordern",
    "default_value": "Fachberatung anfordern",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_card_compatibility",
    "page": "advisor",
    "type": "text",
    "label": "Kompatibilität Hinweis",
    "defaultValue": "100% herstellerübergreifend geprüft",
    "default_value": "100% herstellerübergreifend geprüft",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_card_warranty",
    "page": "advisor",
    "type": "text",
    "label": "Garantie Hinweis",
    "defaultValue": "Bis zu 5 Jahre Herstellergarantie",
    "default_value": "Bis zu 5 Jahre Herstellergarantie",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_card_support",
    "page": "advisor",
    "type": "text",
    "label": "Support Hinweis",
    "defaultValue": "Technischer Projektsupport inklusive",
    "default_value": "Technischer Projektsupport inklusive",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_card_delivery",
    "page": "advisor",
    "type": "text",
    "label": "Lieferung Hinweis",
    "defaultValue": "Ab Zentrallager in 24/48h lieferbar",
    "default_value": "Ab Zentrallager in 24/48h lieferbar",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_summary_heading",
    "page": "advisor",
    "type": "text",
    "label": "Zusammenfassung Überschrift",
    "defaultValue": "Ihre Projektparameter",
    "default_value": "Ihre Projektparameter",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_summary_building",
    "page": "advisor",
    "type": "text",
    "label": "Zusammenfassung Gebäude",
    "defaultValue": "Objekttyp",
    "default_value": "Objekttyp",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_summary_disciplines",
    "page": "advisor",
    "type": "text",
    "label": "Zusammenfassung Gewerke",
    "defaultValue": "Gewählte Gewerke",
    "default_value": "Gewählte Gewerke",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_summary_size",
    "page": "advisor",
    "type": "text",
    "label": "Zusammenfassung Größe",
    "defaultValue": "Flächenklasse",
    "default_value": "Flächenklasse",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_summary_standards",
    "page": "advisor",
    "type": "text",
    "label": "Zusammenfassung Standards",
    "defaultValue": "Zertifizierungsstufe",
    "default_value": "Zertifizierungsstufe",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "advisor_expert_note",
    "page": "advisor",
    "type": "text",
    "label": "Expertenhinweis",
    "defaultValue": "Haben Sie Fragen zur Projektierung? Unsere zertifizierten Systemplaner unterstützen Sie bei der Auslegung.",
    "default_value": "Haben Sie Fragen zur Projektierung? Unsere zertifizierten Systemplaner unterstützen Sie bei der Auslegung.",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": true
  },
  {
    "id": "advisor_banner_image",
    "page": "advisor",
    "type": "image",
    "label": "Berater Banner Bild",
    "defaultValue": "",
    "default_value": "",
    "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
    "source_file": "src/features/advisor/SecurityAdvisor.jsx",
    "multiline": false
  },
  {
    "id": "pdp_breadcrumb_root",
    "page": "product",
    "type": "text",
    "label": "Breadcrumb Startseite",
    "defaultValue": "Startseite",
    "default_value": "Startseite",
    "sourceFile": "src/features/product/ProductDetailView.jsx",
    "source_file": "src/features/product/ProductDetailView.jsx",
    "multiline": false
  },
  {
    "id": "pdp_breadcrumb_catalog",
    "page": "product",
    "type": "text",
    "label": "Breadcrumb Katalog",
    "defaultValue": "Katalog",
    "default_value": "Katalog",
    "sourceFile": "src/features/product/ProductDetailView.jsx",
    "source_file": "src/features/product/ProductDetailView.jsx",
    "multiline": false
  },
  {
    "id": "pdp_back_link",
    "page": "product",
    "type": "text",
    "label": "Zurück-Button",
    "defaultValue": "Zurück zur Übersicht",
    "default_value": "Zurück zur Übersicht",
    "sourceFile": "src/features/product/ProductDetailView.jsx",
    "source_file": "src/features/product/ProductDetailView.jsx",
    "multiline": false
  },
  {
    "id": "pdp_sku_label",
    "page": "product",
    "type": "text",
    "label": "Artikelnr. Label",
    "defaultValue": "Art.-Nr.:",
    "default_value": "Art.-Nr.:",
    "sourceFile": "src/features/product/ProductDetailView.jsx",
    "source_file": "src/features/product/ProductDetailView.jsx",
    "multiline": false
  },
  {
    "id": "pdp_manufacturer_label",
    "page": "product",
    "type": "text",
    "label": "Hersteller Label",
    "defaultValue": "Hersteller:",
    "default_value": "Hersteller:",
    "sourceFile": "src/features/product/ProductDetailView.jsx",
    "source_file": "src/features/product/ProductDetailView.jsx",
    "multiline": false
  },
  {
    "id": "pdp_category_label",
    "page": "product",
    "type": "text",
    "label": "Kategorie Label",
    "defaultValue": "Fachbereich:",
    "default_value": "Fachbereich:",
    "sourceFile": "src/features/product/ProductDetailView.jsx",
    "source_file": "src/features/product/ProductDetailView.jsx",
    "multiline": false
  },
  {
    "id": "pdp_stock_in_stock",
    "page": "product",
    "type": "text",
    "label": "Lagerstatus Verfügbar",
    "defaultValue": "Auf Lager – Versandfertig in 24h",
    "default_value": "Auf Lager – Versandfertig in 24h",
    "sourceFile": "src/features/product/ProductDetailView.jsx",
    "source_file": "src/features/product/ProductDetailView.jsx",
    "multiline": false
  },
  {
    "id": "pdp_stock_on_request",
    "page": "product",
    "type": "text",
    "label": "Lagerstatus Anfrage",
    "defaultValue": "Lieferzeit auf Anfrage",
    "default_value": "Lieferzeit auf Anfrage",
    "sourceFile": "src/features/product/ProductDetailView.jsx",
    "source_file": "src/features/product/ProductDetailView.jsx",
    "multiline": false
  },
  {
    "id": "pdp_price_net_label",
    "page": "product",
    "type": "text",
    "label": "Netto-Preis Label",
    "defaultValue": "Preis:",
    "default_value": "Preis:",
    "sourceFile": "src/features/product/ProductDetailView.jsx",
    "source_file": "src/features/product/ProductDetailView.jsx",
    "multiline": false
  },
  {
    "id": "pdp_price_on_request",
    "page": "product",
    "type": "text",
    "label": "Preis auf Anfrage",
    "defaultValue": "Preis auf Anfrage",
    "default_value": "Preis auf Anfrage",
    "sourceFile": "src/features/product/ProductDetailView.jsx",
    "source_file": "src/features/product/ProductDetailView.jsx",
    "multiline": false
  },
  {
    "id": "pdp_vat_notice",
    "page": "product",
    "type": "text",
    "label": "MwSt. Hinweis",
    "defaultValue": "Alle Preise zzgl. gesetzlicher MwSt.",
    "default_value": "Alle Preise zzgl. gesetzlicher MwSt.",
    "sourceFile": "src/features/product/ProductDetailView.jsx",
    "source_file": "src/features/product/ProductDetailView.jsx",
    "multiline": false
  },
  {
    "id": "pdp_tiered_pricing_badge",
    "page": "product",
    "type": "text",
    "label": "Staffelpreis Badge",
    "defaultValue": "Projektkonditionen ab 5 Stk.",
    "default_value": "Projektkonditionen ab 5 Stk.",
    "sourceFile": "src/features/product/ProductDetailView.jsx",
    "source_file": "src/features/product/ProductDetailView.jsx",
    "multiline": false
  },
  {
    "id": "pdp_quantity_label",
    "page": "product",
    "type": "text",
    "label": "Menge Label",
    "defaultValue": "Menge:",
    "default_value": "Menge:",
    "sourceFile": "src/features/product/ProductDetailView.jsx",
    "source_file": "src/features/product/ProductDetailView.jsx",
    "multiline": false
  },
  {
    "id": "pdp_add_to_cart_btn",
    "page": "product",
    "type": "text",
    "label": "In Anfragekorb Button",
    "defaultValue": "In den Anfragekorb",
    "default_value": "In den Anfragekorb",
    "sourceFile": "src/features/product/ProductDetailView.jsx",
    "source_file": "src/features/product/ProductDetailView.jsx",
    "multiline": false
  },
  {
    "id": "pdp_added_to_cart_state",
    "page": "product",
    "type": "text",
    "label": "Hinzugefügt Status",
    "defaultValue": "Im Anfragekorb",
    "default_value": "Im Anfragekorb",
    "sourceFile": "src/features/product/ProductDetailView.jsx",
    "source_file": "src/features/product/ProductDetailView.jsx",
    "multiline": false
  },
  {
    "id": "pdp_direct_quote_btn",
    "page": "product",
    "type": "text",
    "label": "Direkt anfragen Button",
    "defaultValue": "Projektangebot anfordern",
    "default_value": "Projektangebot anfordern",
    "sourceFile": "src/features/product/ProductDetailView.jsx",
    "source_file": "src/features/product/ProductDetailView.jsx",
    "multiline": false
  },
  {
    "id": "pdp_tab_description",
    "page": "product",
    "type": "text",
    "label": "Tab Beschreibung",
    "defaultValue": "Produktbeschreibung",
    "default_value": "Produktbeschreibung",
    "sourceFile": "src/features/product/ProductDetailView.jsx",
    "source_file": "src/features/product/ProductDetailView.jsx",
    "multiline": false
  },
  {
    "id": "pdp_tab_specs",
    "page": "product",
    "type": "text",
    "label": "Tab Technische Daten",
    "defaultValue": "Technische Daten",
    "default_value": "Technische Daten",
    "sourceFile": "src/features/product/ProductDetailView.jsx",
    "source_file": "src/features/product/ProductDetailView.jsx",
    "multiline": false
  },
  {
    "id": "pdp_tab_downloads",
    "page": "product",
    "type": "text",
    "label": "Tab Downloads",
    "defaultValue": "Datenblätter & Dokumente",
    "default_value": "Datenblätter & Dokumente",
    "sourceFile": "src/features/product/ProductDetailView.jsx",
    "source_file": "src/features/product/ProductDetailView.jsx",
    "multiline": false
  },
  {
    "id": "pdp_tab_accessories",
    "page": "product",
    "type": "text",
    "label": "Tab Zubehör",
    "defaultValue": "Passendes Systemzubehör",
    "default_value": "Passendes Systemzubehör",
    "sourceFile": "src/features/product/ProductDetailView.jsx",
    "source_file": "src/features/product/ProductDetailView.jsx",
    "multiline": false
  },
  {
    "id": "pdp_no_specs_available",
    "page": "product",
    "type": "text",
    "label": "Keine Daten verfügbar",
    "defaultValue": "Für dieses Produkt liegen keine weiteren technischen Spezifikationen vor.",
    "default_value": "Für dieses Produkt liegen keine weiteren technischen Spezifikationen vor.",
    "sourceFile": "src/features/product/ProductDetailView.jsx",
    "source_file": "src/features/product/ProductDetailView.jsx",
    "multiline": false
  },
  {
    "id": "pdp_no_downloads_available",
    "page": "product",
    "type": "text",
    "label": "Keine Downloads verfügbar",
    "defaultValue": "Aktuell sind keine separaten PDF-Datenblätter hinterlegt.",
    "default_value": "Aktuell sind keine separaten PDF-Datenblätter hinterlegt.",
    "sourceFile": "src/features/product/ProductDetailView.jsx",
    "source_file": "src/features/product/ProductDetailView.jsx",
    "multiline": false
  },
  {
    "id": "pdp_download_datasheet_label",
    "page": "product",
    "type": "text",
    "label": "Datenblatt Download Label",
    "defaultValue": "Technisches Datenblatt (PDF)",
    "default_value": "Technisches Datenblatt (PDF)",
    "sourceFile": "src/features/product/ProductDetailView.jsx",
    "source_file": "src/features/product/ProductDetailView.jsx",
    "multiline": false
  },
  {
    "id": "pdp_download_manual_label",
    "page": "product",
    "type": "text",
    "label": "Handbuch Download Label",
    "defaultValue": "Installationsanleitung (PDF)",
    "default_value": "Installationsanleitung (PDF)",
    "sourceFile": "src/features/product/ProductDetailView.jsx",
    "source_file": "src/features/product/ProductDetailView.jsx",
    "multiline": false
  },
  {
    "id": "pdp_b2b_trade_notice",
    "page": "product",
    "type": "text",
    "label": "Hinweis",
    "defaultValue": "Verkauf ausschließlich an gewerbliche Kunden, Errichter und Fachplaner. Es gelten unsere B2B-Konditionen.",
    "default_value": "Verkauf ausschließlich an gewerbliche Kunden, Errichter und Fachplaner. Es gelten unsere B2B-Konditionen.",
    "sourceFile": "src/features/product/ProductDetailView.jsx",
    "source_file": "src/features/product/ProductDetailView.jsx",
    "multiline": true
  },
  {
    "id": "pdp_shipping_info_title",
    "page": "product",
    "type": "text",
    "label": "Versandinfo Titel",
    "defaultValue": "Direktversand ab Zentrallager",
    "default_value": "Direktversand ab Zentrallager",
    "sourceFile": "src/features/product/ProductDetailView.jsx",
    "source_file": "src/features/product/ProductDetailView.jsx",
    "multiline": false
  },
  {
    "id": "pdp_shipping_info_desc",
    "page": "product",
    "type": "text",
    "label": "Versandinfo Text",
    "defaultValue": "Bestellungen bis 14 Uhr werden in der Regel am selben Werktag disponiert.",
    "default_value": "Bestellungen bis 14 Uhr werden in der Regel am selben Werktag disponiert.",
    "sourceFile": "src/features/product/ProductDetailView.jsx",
    "source_file": "src/features/product/ProductDetailView.jsx",
    "multiline": false
  },
  {
    "id": "pdp_warranty_title",
    "page": "product",
    "type": "text",
    "label": "Garantie Titel",
    "defaultValue": "Offizieller Fachhandelsartikel",
    "default_value": "Offizieller Fachhandelsartikel",
    "sourceFile": "src/features/product/ProductDetailView.jsx",
    "source_file": "src/features/product/ProductDetailView.jsx",
    "multiline": false
  },
  {
    "id": "pdp_warranty_desc",
    "page": "product",
    "type": "text",
    "label": "Garantie Text",
    "defaultValue": "Originalverpackte Neuware mit vollem Herstellersupport und Gewährleistung.",
    "default_value": "Originalverpackte Neuware mit vollem Herstellersupport und Gewährleistung.",
    "sourceFile": "src/features/product/ProductDetailView.jsx",
    "source_file": "src/features/product/ProductDetailView.jsx",
    "multiline": false
  },
  {
    "id": "pdp_consultation_title",
    "page": "product",
    "type": "text",
    "label": "Beratung Box Titel",
    "defaultValue": "Fragen zu diesem Artikel?",
    "default_value": "Fragen zu diesem Artikel?",
    "sourceFile": "src/features/product/ProductDetailView.jsx",
    "source_file": "src/features/product/ProductDetailView.jsx",
    "multiline": false
  },
  {
    "id": "pdp_consultation_desc",
    "page": "product",
    "type": "text",
    "label": "Beratung Box Text",
    "defaultValue": "Unser technischer Vertrieb berät Sie gerne bei Planung und Ausschreibung.",
    "default_value": "Unser technischer Vertrieb berät Sie gerne bei Planung und Ausschreibung.",
    "sourceFile": "src/features/product/ProductDetailView.jsx",
    "source_file": "src/features/product/ProductDetailView.jsx",
    "multiline": false
  },
  {
    "id": "pdp_consultation_phone_label",
    "page": "product",
    "type": "text",
    "label": "Telefonkontakt Label",
    "defaultValue": "Technischer Support:",
    "default_value": "Technischer Support:",
    "sourceFile": "src/features/product/ProductDetailView.jsx",
    "source_file": "src/features/product/ProductDetailView.jsx",
    "multiline": false
  },
  {
    "id": "pdp_related_products_title",
    "page": "product",
    "type": "text",
    "label": "Ähnliche Produkte Titel",
    "defaultValue": "Ergänzende Systemkomponenten",
    "default_value": "Ergänzende Systemkomponenten",
    "sourceFile": "src/features/product/ProductDetailView.jsx",
    "source_file": "src/features/product/ProductDetailView.jsx",
    "multiline": false
  },
  {
    "id": "pdp_related_products_subtitle",
    "page": "product",
    "type": "text",
    "label": "Ähnliche Produkte Untertitel",
    "defaultValue": "Häufig zusammen projektiert und bestellt.",
    "default_value": "Häufig zusammen projektiert und bestellt.",
    "sourceFile": "src/features/product/ProductDetailView.jsx",
    "source_file": "src/features/product/ProductDetailView.jsx",
    "multiline": false
  },
  {
    "id": "pdp_spec_table_key_label",
    "page": "product",
    "type": "text",
    "label": "Spezifikation Merkmal Label",
    "defaultValue": "Merkmal",
    "default_value": "Merkmal",
    "sourceFile": "src/features/product/ProductDetailView.jsx",
    "source_file": "src/features/product/ProductDetailView.jsx",
    "multiline": false
  },
  {
    "id": "pdp_spec_table_val_label",
    "page": "product",
    "type": "text",
    "label": "Spezifikation Wert Label",
    "defaultValue": "Spezifikation",
    "default_value": "Spezifikation",
    "sourceFile": "src/features/product/ProductDetailView.jsx",
    "source_file": "src/features/product/ProductDetailView.jsx",
    "multiline": false
  },
  {
    "id": "inquiry_form_badge",
    "page": "inquiry",
    "type": "text",
    "label": "Anfrageformular Badge",
    "defaultValue": "Unverbindliche B2B-Projektanfrage",
    "default_value": "Unverbindliche B2B-Projektanfrage",
    "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
    "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
    "multiline": false
  },
  {
    "id": "inquiry_form_title",
    "page": "inquiry",
    "type": "text",
    "label": "Anfrageformular Titel",
    "defaultValue": "Projektkonditionen anfragen",
    "default_value": "Projektkonditionen anfragen",
    "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
    "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
    "multiline": false
  },
  {
    "id": "inquiry_form_subtitle",
    "page": "inquiry",
    "type": "text",
    "label": "Anfrageformular Untertitel",
    "defaultValue": "Erhalten Sie ein maßgeschneidertes Angebot für Ihren gewerblichen Bedarf.",
    "default_value": "Erhalten Sie ein maßgeschneidertes Angebot für Ihren gewerblichen Bedarf.",
    "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
    "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
    "multiline": false
  },
  {
    "id": "inquiry_field_company",
    "page": "inquiry",
    "type": "text",
    "label": "Feld Firma Label",
    "defaultValue": "Firma / Organisation *",
    "default_value": "Firma / Organisation *",
    "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
    "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
    "multiline": false
  },
  {
    "id": "inquiry_field_company_ph",
    "page": "inquiry",
    "type": "text",
    "label": "Feld Firma Platzhalter",
    "defaultValue": "z. B. Elektro Mustermann GmbH",
    "default_value": "z. B. Elektro Mustermann GmbH",
    "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
    "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
    "multiline": false
  },
  {
    "id": "inquiry_field_name",
    "page": "inquiry",
    "type": "text",
    "label": "Feld Ansprechpartner Label",
    "defaultValue": "Ansprechpartner (Vor- & Nachname) *",
    "default_value": "Ansprechpartner (Vor- & Nachname) *",
    "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
    "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
    "multiline": false
  },
  {
    "id": "inquiry_field_name_ph",
    "page": "inquiry",
    "type": "text",
    "label": "Feld Ansprechpartner Platzhalter",
    "defaultValue": "z. B. Max Mustermann",
    "default_value": "z. B. Max Mustermann",
    "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
    "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
    "multiline": false
  },
  {
    "id": "inquiry_field_email",
    "page": "inquiry",
    "type": "text",
    "label": "Feld E-Mail Label",
    "defaultValue": "E-Mail-Adresse *",
    "default_value": "E-Mail-Adresse *",
    "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
    "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
    "multiline": false
  },
  {
    "id": "inquiry_field_email_ph",
    "page": "inquiry",
    "type": "text",
    "label": "Feld E-Mail Platzhalter",
    "defaultValue": "name@unternehmen.de",
    "default_value": "name@unternehmen.de",
    "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
    "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
    "multiline": false
  },
  {
    "id": "inquiry_field_phone",
    "page": "inquiry",
    "type": "text",
    "label": "Feld Telefon Label",
    "defaultValue": "Telefonnummer für Rückfragen",
    "default_value": "Telefonnummer für Rückfragen",
    "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
    "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
    "multiline": false
  },
  {
    "id": "inquiry_field_phone_ph",
    "page": "inquiry",
    "type": "text",
    "label": "Feld Telefon Platzhalter",
    "defaultValue": "+49 123 4567890",
    "default_value": "+49 123 4567890",
    "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
    "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
    "multiline": false
  },
  {
    "id": "inquiry_field_street",
    "page": "inquiry",
    "type": "text",
    "label": "Feld Straße Label",
    "defaultValue": "Straße & Hausnummer",
    "default_value": "Straße & Hausnummer",
    "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
    "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
    "multiline": false
  },
  {
    "id": "inquiry_field_street_ph",
    "page": "inquiry",
    "type": "text",
    "label": "Feld Straße Platzhalter",
    "defaultValue": "Musterstraße 1",
    "default_value": "Musterstraße 1",
    "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
    "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
    "multiline": false
  },
  {
    "id": "inquiry_field_zip_city",
    "page": "inquiry",
    "type": "text",
    "label": "Feld PLZ & Ort Label",
    "defaultValue": "PLZ & Ort",
    "default_value": "PLZ & Ort",
    "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
    "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
    "multiline": false
  },
  {
    "id": "inquiry_field_zip_city_ph",
    "page": "inquiry",
    "type": "text",
    "label": "Feld PLZ & Ort Platzhalter",
    "defaultValue": "12345 Musterstadt",
    "default_value": "12345 Musterstadt",
    "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
    "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
    "multiline": false
  },
  {
    "id": "inquiry_field_project_title",
    "page": "inquiry",
    "type": "text",
    "label": "Feld Projektname Label",
    "defaultValue": "Projektname / Referenz",
    "default_value": "Projektname / Referenz",
    "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
    "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
    "multiline": false
  },
  {
    "id": "inquiry_field_project_title_ph",
    "page": "inquiry",
    "type": "text",
    "label": "Feld Projektname Platzhalter",
    "defaultValue": "z. B. Neubau Verwaltungsgebäude Süd",
    "default_value": "z. B. Neubau Verwaltungsgebäude Süd",
    "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
    "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
    "multiline": false
  },
  {
    "id": "inquiry_field_message",
    "page": "inquiry",
    "type": "text",
    "label": "Feld Nachricht Label",
    "defaultValue": "Ihre Projektanforderungen / Stückliste",
    "default_value": "Ihre Projektanforderungen / Stückliste",
    "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
    "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
    "multiline": false
  },
  {
    "id": "inquiry_field_message_ph",
    "page": "inquiry",
    "type": "text",
    "label": "Feld Nachricht Platzhalter",
    "defaultValue": "Bitte beschreiben Sie besondere Anforderungen, gewünschte Liefertermine oder Sonderwünsche...",
    "default_value": "Bitte beschreiben Sie besondere Anforderungen, gewünschte Liefertermine oder Sonderwünsche...",
    "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
    "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
    "multiline": false
  },
  {
    "id": "inquiry_field_callback_pref",
    "page": "inquiry",
    "type": "text",
    "label": "Checkbox Rückruf gewünscht",
    "defaultValue": "Telefonischer Rückruf durch technischen Vertrieb gewünscht",
    "default_value": "Telefonischer Rückruf durch technischen Vertrieb gewünscht",
    "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
    "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
    "multiline": false
  },
  {
    "id": "inquiry_field_privacy_consent",
    "page": "inquiry",
    "type": "text",
    "label": "Datenschutz Einwilligung",
    "defaultValue": "Ich stimme der Verarbeitung meiner Daten gemäß der Datenschutzerklärung zur Bearbeitung meiner Anfrage zu.",
    "default_value": "Ich stimme der Verarbeitung meiner Daten gemäß der Datenschutzerklärung zur Bearbeitung meiner Anfrage zu.",
    "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
    "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
    "multiline": true
  },
  {
    "id": "inquiry_btn_submit",
    "page": "inquiry",
    "type": "text",
    "label": "Button Absenden",
    "defaultValue": "Unverbindliche Anfrage absenden",
    "default_value": "Unverbindliche Anfrage absenden",
    "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
    "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
    "multiline": false
  },
  {
    "id": "inquiry_btn_submitting",
    "page": "inquiry",
    "type": "text",
    "label": "Button Sendet...",
    "defaultValue": "Anfrage wird übermittelt...",
    "default_value": "Anfrage wird übermittelt...",
    "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
    "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
    "multiline": false
  },
  {
    "id": "inquiry_btn_cancel",
    "page": "inquiry",
    "type": "text",
    "label": "Button Abbrechen",
    "defaultValue": "Abbrechen",
    "default_value": "Abbrechen",
    "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
    "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
    "multiline": false
  },
  {
    "id": "inquiry_err_company_required",
    "page": "inquiry",
    "type": "text",
    "label": "Fehler Firma Pflichtfeld",
    "defaultValue": "Bitte geben Sie den Firmennamen an.",
    "default_value": "Bitte geben Sie den Firmennamen an.",
    "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
    "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
    "multiline": false
  },
  {
    "id": "inquiry_err_name_required",
    "page": "inquiry",
    "type": "text",
    "label": "Fehler Name Pflichtfeld",
    "defaultValue": "Bitte geben Sie Ihren Namen an.",
    "default_value": "Bitte geben Sie Ihren Namen an.",
    "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
    "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
    "multiline": false
  },
  {
    "id": "inquiry_err_email_invalid",
    "page": "inquiry",
    "type": "text",
    "label": "Fehler E-Mail ungültig",
    "defaultValue": "Bitte geben Sie eine gültige E-Mail-Adresse an.",
    "default_value": "Bitte geben Sie eine gültige E-Mail-Adresse an.",
    "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
    "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
    "multiline": false
  },
  {
    "id": "inquiry_err_privacy_required",
    "page": "inquiry",
    "type": "text",
    "label": "Fehler Datenschutz nötig",
    "defaultValue": "Bitte bestätigen Sie die Datenschutzerklärung.",
    "default_value": "Bitte bestätigen Sie die Datenschutzerklärung.",
    "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
    "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
    "multiline": false
  },
  {
    "id": "inquiry_success_title",
    "page": "inquiry",
    "type": "text",
    "label": "Erfolg Überschrift",
    "defaultValue": "Vielen Dank für Ihre Projektanfrage!",
    "default_value": "Vielen Dank für Ihre Projektanfrage!",
    "sourceFile": "src/features/inquiry/InquirySuccessView.jsx",
    "source_file": "src/features/inquiry/InquirySuccessView.jsx",
    "multiline": false
  },
  {
    "id": "inquiry_success_subtitle",
    "page": "inquiry",
    "type": "text",
    "label": "Erfolg Untertitel",
    "defaultValue": "Ihre Anfrage ist erfolgreich bei unserem Vertriebsteam eingegangen.",
    "default_value": "Ihre Anfrage ist erfolgreich bei unserem Vertriebsteam eingegangen.",
    "sourceFile": "src/features/inquiry/InquirySuccessView.jsx",
    "source_file": "src/features/inquiry/InquirySuccessView.jsx",
    "multiline": false
  },
  {
    "id": "inquiry_success_reference_label",
    "page": "inquiry",
    "type": "text",
    "label": "Vorgangsnummer Label",
    "defaultValue": "Ihre Vorgangsnummer:",
    "default_value": "Ihre Vorgangsnummer:",
    "sourceFile": "src/features/inquiry/InquirySuccessView.jsx",
    "source_file": "src/features/inquiry/InquirySuccessView.jsx",
    "multiline": false
  },
  {
    "id": "inquiry_success_next_steps_title",
    "page": "inquiry",
    "type": "text",
    "label": "Nächste Schritte Titel",
    "defaultValue": "Wie geht es weiter?",
    "default_value": "Wie geht es weiter?",
    "sourceFile": "src/features/inquiry/InquirySuccessView.jsx",
    "source_file": "src/features/inquiry/InquirySuccessView.jsx",
    "multiline": false
  },
  {
    "id": "inquiry_success_step1",
    "page": "inquiry",
    "type": "text",
    "label": "Schritt 1 Text",
    "defaultValue": "1. Technische Prüfung Ihrer Stückliste und Verfügbarkeiten.",
    "default_value": "1. Technische Prüfung Ihrer Stückliste und Verfügbarkeiten.",
    "sourceFile": "src/features/inquiry/InquirySuccessView.jsx",
    "source_file": "src/features/inquiry/InquirySuccessView.jsx",
    "multiline": false
  },
  {
    "id": "inquiry_success_step2",
    "page": "inquiry",
    "type": "text",
    "label": "Schritt 2 Text",
    "defaultValue": "2. Erstellung eines individuellen B2B-Konditionenangebots.",
    "default_value": "2. Erstellung eines individuellen B2B-Konditionenangebots.",
    "sourceFile": "src/features/inquiry/InquirySuccessView.jsx",
    "source_file": "src/features/inquiry/InquirySuccessView.jsx",
    "multiline": false
  },
  {
    "id": "inquiry_success_step3",
    "page": "inquiry",
    "type": "text",
    "label": "Schritt 3 Text",
    "defaultValue": "3. Kontaktaufnahme per E-Mail oder Telefon innerhalb eines Werktages.",
    "default_value": "3. Kontaktaufnahme per E-Mail oder Telefon innerhalb eines Werktages.",
    "sourceFile": "src/features/inquiry/InquirySuccessView.jsx",
    "source_file": "src/features/inquiry/InquirySuccessView.jsx",
    "multiline": false
  },
  {
    "id": "inquiry_success_btn_catalog",
    "page": "inquiry",
    "type": "text",
    "label": "Button Weiter einkaufen",
    "defaultValue": "Zurück zum Produktkatalog",
    "default_value": "Zurück zum Produktkatalog",
    "sourceFile": "src/features/inquiry/InquirySuccessView.jsx",
    "source_file": "src/features/inquiry/InquirySuccessView.jsx",
    "multiline": false
  },
  {
    "id": "inquiry_success_btn_home",
    "page": "inquiry",
    "type": "text",
    "label": "Button Zur Startseite",
    "defaultValue": "Zur Startseite",
    "default_value": "Zur Startseite",
    "sourceFile": "src/features/inquiry/InquirySuccessView.jsx",
    "source_file": "src/features/inquiry/InquirySuccessView.jsx",
    "multiline": false
  },
  {
    "id": "cart_page_title",
    "page": "cart",
    "type": "text",
    "label": "Warenkorb Seitentitel",
    "defaultValue": "Ihr Anfragekorb",
    "default_value": "Ihr Anfragekorb",
    "sourceFile": "src/features/cart/CartView.jsx",
    "source_file": "src/features/cart/CartView.jsx",
    "multiline": false
  },
  {
    "id": "cart_page_subtitle",
    "page": "cart",
    "type": "text",
    "label": "Warenkorb Untertitel",
    "defaultValue": "Übersicht der ausgewählten Fachhandelsartikel für Ihre Projektanfrage.",
    "default_value": "Übersicht der ausgewählten Fachhandelsartikel für Ihre Projektanfrage.",
    "sourceFile": "src/features/cart/CartView.jsx",
    "source_file": "src/features/cart/CartView.jsx",
    "multiline": false
  },
  {
    "id": "cart_empty_title",
    "page": "cart",
    "type": "text",
    "label": "Leerer Warenkorb Titel",
    "defaultValue": "Ihr Anfragekorb ist leer",
    "default_value": "Ihr Anfragekorb ist leer",
    "sourceFile": "src/features/cart/CartView.jsx",
    "source_file": "src/features/cart/CartView.jsx",
    "multiline": false
  },
  {
    "id": "cart_empty_desc",
    "page": "cart",
    "type": "text",
    "label": "Leerer Warenkorb Text",
    "defaultValue": "Sie haben bisher keine Artikel zur Projektliste hinzugefügt. Durchsuchen Sie unser Fachsortiment.",
    "default_value": "Sie haben bisher keine Artikel zur Projektliste hinzugefügt. Durchsuchen Sie unser Fachsortiment.",
    "sourceFile": "src/features/cart/CartView.jsx",
    "source_file": "src/features/cart/CartView.jsx",
    "multiline": false
  },
  {
    "id": "cart_btn_browse_catalog",
    "page": "cart",
    "type": "text",
    "label": "Button Katalog durchsuchen",
    "defaultValue": "Katalog öffnen",
    "default_value": "Katalog öffnen",
    "sourceFile": "src/features/cart/CartView.jsx",
    "source_file": "src/features/cart/CartView.jsx",
    "multiline": false
  },
  {
    "id": "cart_table_th_product",
    "page": "cart",
    "type": "text",
    "label": "Tabelle Spalte Produkt",
    "defaultValue": "Artikel / Beschreibung",
    "default_value": "Artikel / Beschreibung",
    "sourceFile": "src/features/cart/CartView.jsx",
    "source_file": "src/features/cart/CartView.jsx",
    "multiline": false
  },
  {
    "id": "cart_table_th_sku",
    "page": "cart",
    "type": "text",
    "label": "Tabelle Spalte SKU",
    "defaultValue": "Art.-Nr.",
    "default_value": "Art.-Nr.",
    "sourceFile": "src/features/cart/CartView.jsx",
    "source_file": "src/features/cart/CartView.jsx",
    "multiline": false
  },
  {
    "id": "cart_table_th_price",
    "page": "cart",
    "type": "text",
    "label": "Tabelle Spalte Einzelpreis",
    "defaultValue": "Einzelpreis (netto)",
    "default_value": "Einzelpreis (netto)",
    "sourceFile": "src/features/cart/CartView.jsx",
    "source_file": "src/features/cart/CartView.jsx",
    "multiline": false
  },
  {
    "id": "cart_table_th_qty",
    "page": "cart",
    "type": "text",
    "label": "Tabelle Spalte Menge",
    "defaultValue": "Menge",
    "default_value": "Menge",
    "sourceFile": "src/features/cart/CartView.jsx",
    "source_file": "src/features/cart/CartView.jsx",
    "multiline": false
  },
  {
    "id": "cart_table_th_total",
    "page": "cart",
    "type": "text",
    "label": "Tabelle Spalte Gesamt",
    "defaultValue": "Gesamt (netto)",
    "default_value": "Gesamt (netto)",
    "sourceFile": "src/features/cart/CartView.jsx",
    "source_file": "src/features/cart/CartView.jsx",
    "multiline": false
  },
  {
    "id": "cart_btn_remove_item",
    "page": "cart",
    "type": "text",
    "label": "Position entfernen Label",
    "defaultValue": "Position entfernen",
    "default_value": "Position entfernen",
    "sourceFile": "src/features/cart/CartView.jsx",
    "source_file": "src/features/cart/CartView.jsx",
    "multiline": false
  },
  {
    "id": "cart_btn_clear_all",
    "page": "cart",
    "type": "text",
    "label": "Warenkorb leeren Button",
    "defaultValue": "Gesamte Liste leeren",
    "default_value": "Gesamte Liste leeren",
    "sourceFile": "src/features/cart/CartView.jsx",
    "source_file": "src/features/cart/CartView.jsx",
    "multiline": false
  },
  {
    "id": "cart_summary_title",
    "page": "cart",
    "type": "text",
    "label": "Summenübersicht Titel",
    "defaultValue": "Zusammenfassung",
    "default_value": "Zusammenfassung",
    "sourceFile": "src/features/cart/CartView.jsx",
    "source_file": "src/features/cart/CartView.jsx",
    "multiline": false
  },
  {
    "id": "cart_summary_subtotal_net",
    "page": "cart",
    "type": "text",
    "label": "Zwischensumme Netto",
    "defaultValue": "Zwischensumme (netto):",
    "default_value": "Zwischensumme (netto):",
    "sourceFile": "src/features/cart/CartView.jsx",
    "source_file": "src/features/cart/CartView.jsx",
    "multiline": false
  },
  {
    "id": "cart_summary_vat_label",
    "page": "cart",
    "type": "text",
    "label": "MwSt. Zeile Label",
    "defaultValue": "Zzgl. 19% USt.:",
    "default_value": "Zzgl. 19% USt.:",
    "sourceFile": "src/features/cart/CartView.jsx",
    "source_file": "src/features/cart/CartView.jsx",
    "multiline": false
  },
  {
    "id": "cart_summary_total_gross",
    "page": "cart",
    "type": "text",
    "label": "Gesamtsumme Brutto",
    "defaultValue": "Gesamtbetrag (brutto):",
    "default_value": "Gesamtbetrag (brutto):",
    "sourceFile": "src/features/cart/CartView.jsx",
    "source_file": "src/features/cart/CartView.jsx",
    "multiline": false
  },
  {
    "id": "cart_summary_b2b_notice",
    "page": "cart",
    "type": "text",
    "label": "Warenkorb B2B Hinweis",
    "defaultValue": "Großhandelskonditionen freibleibend. Verbindliche Endpreise und Lieferzeiten erhalten Sie mit dem Projektangebot.",
    "default_value": "Großhandelskonditionen freibleibend. Verbindliche Endpreise und Lieferzeiten erhalten Sie mit dem Projektangebot.",
    "sourceFile": "src/features/cart/CartView.jsx",
    "source_file": "src/features/cart/CartView.jsx",
    "multiline": true
  },
  {
    "id": "cart_btn_proceed_inquiry",
    "page": "cart",
    "type": "text",
    "label": "Button Zur Projektanfrage",
    "defaultValue": "Projektangebot anfordern",
    "default_value": "Projektangebot anfordern",
    "sourceFile": "src/features/cart/CartView.jsx",
    "source_file": "src/features/cart/CartView.jsx",
    "multiline": false
  },
  {
    "id": "cart_btn_continue_shopping",
    "page": "cart",
    "type": "text",
    "label": "Button Weiter einkaufen",
    "defaultValue": "Weitere Artikel hinzufügen",
    "default_value": "Weitere Artikel hinzufügen",
    "sourceFile": "src/features/cart/CartView.jsx",
    "source_file": "src/features/cart/CartView.jsx",
    "multiline": false
  },
  {
    "id": "cart_bom_import_title",
    "page": "cart",
    "type": "text",
    "label": "BOM Import Titel",
    "defaultValue": "Stückliste importieren (CSV/Excel)",
    "default_value": "Stückliste importieren (CSV/Excel)",
    "sourceFile": "src/features/cart/CartView.jsx",
    "source_file": "src/features/cart/CartView.jsx",
    "multiline": false
  },
  {
    "id": "cart_bom_import_desc",
    "page": "cart",
    "type": "text",
    "label": "BOM Import Beschreibung",
    "defaultValue": "Laden Sie Ihre Projektstückliste hoch, um Artikel automatisch zuzuordnen.",
    "default_value": "Laden Sie Ihre Projektstückliste hoch, um Artikel automatisch zuzuordnen.",
    "sourceFile": "src/features/cart/CartView.jsx",
    "source_file": "src/features/cart/CartView.jsx",
    "multiline": false
  },
  {
    "id": "cart_bom_import_btn",
    "page": "cart",
    "type": "text",
    "label": "BOM Import Button",
    "defaultValue": "Stückliste hochladen",
    "default_value": "Stückliste hochladen",
    "sourceFile": "src/features/cart/CartView.jsx",
    "source_file": "src/features/cart/CartView.jsx",
    "multiline": false
  },
  {
    "id": "cart_drawer_title",
    "page": "cart",
    "type": "text",
    "label": "Drawer Titel",
    "defaultValue": "Anfragekorb",
    "default_value": "Anfragekorb",
    "sourceFile": "src/features/cart/CartDrawer.jsx",
    "source_file": "src/features/cart/CartDrawer.jsx",
    "multiline": false
  },
  {
    "id": "cart_drawer_empty_text",
    "page": "cart",
    "type": "text",
    "label": "Drawer Leer Text",
    "defaultValue": "Noch keine Artikel im Korb.",
    "default_value": "Noch keine Artikel im Korb.",
    "sourceFile": "src/features/cart/CartDrawer.jsx",
    "source_file": "src/features/cart/CartDrawer.jsx",
    "multiline": false
  },
  {
    "id": "cart_drawer_subtotal_label",
    "page": "cart",
    "type": "text",
    "label": "Drawer Zwischensumme",
    "defaultValue": "Zwischensumme (netto)",
    "default_value": "Zwischensumme (netto)",
    "sourceFile": "src/features/cart/CartDrawer.jsx",
    "source_file": "src/features/cart/CartDrawer.jsx",
    "multiline": false
  },
  {
    "id": "cart_drawer_vat_hint",
    "page": "cart",
    "type": "text",
    "label": "Drawer MwSt. Hinweis",
    "defaultValue": "zzgl. 19% MwSt.",
    "default_value": "zzgl. 19% MwSt.",
    "sourceFile": "src/features/cart/CartDrawer.jsx",
    "source_file": "src/features/cart/CartDrawer.jsx",
    "multiline": false
  },
  {
    "id": "cart_drawer_btn_view_cart",
    "page": "cart",
    "type": "text",
    "label": "Drawer Button Korb ansehen",
    "defaultValue": "Korb bearbeiten",
    "default_value": "Korb bearbeiten",
    "sourceFile": "src/features/cart/CartDrawer.jsx",
    "source_file": "src/features/cart/CartDrawer.jsx",
    "multiline": false
  },
  {
    "id": "cart_drawer_btn_checkout",
    "page": "cart",
    "type": "text",
    "label": "Drawer Button Zur Anfrage",
    "defaultValue": "Direkt anfragen",
    "default_value": "Direkt anfragen",
    "sourceFile": "src/features/cart/CartDrawer.jsx",
    "source_file": "src/features/cart/CartDrawer.jsx",
    "multiline": false
  },
  {
    "id": "cart_drawer_btn_close",
    "page": "cart",
    "type": "text",
    "label": "Drawer Schließen Label",
    "defaultValue": "Schließen",
    "default_value": "Schließen",
    "sourceFile": "src/features/cart/CartDrawer.jsx",
    "source_file": "src/features/cart/CartDrawer.jsx",
    "multiline": false
  },
  {
    "id": "cart_drawer_item_qty_dec",
    "page": "cart",
    "type": "text",
    "label": "Menge verringern Label",
    "defaultValue": "Menge verringern",
    "default_value": "Menge verringern",
    "sourceFile": "src/features/cart/CartDrawer.jsx",
    "source_file": "src/features/cart/CartDrawer.jsx",
    "multiline": false
  },
  {
    "id": "cart_drawer_item_qty_inc",
    "page": "cart",
    "type": "text",
    "label": "Menge erhöhen Label",
    "defaultValue": "Menge erhöhen",
    "default_value": "Menge erhöhen",
    "sourceFile": "src/features/cart/CartDrawer.jsx",
    "source_file": "src/features/cart/CartDrawer.jsx",
    "multiline": false
  },
  {
    "id": "cart_drawer_items_count_suffix",
    "page": "cart",
    "type": "text",
    "label": "Artikel Anzahl Suffix",
    "defaultValue": "Artikel",
    "default_value": "Artikel",
    "sourceFile": "src/features/cart/CartDrawer.jsx",
    "source_file": "src/features/cart/CartDrawer.jsx",
    "multiline": false
  },
  {
    "id": "cart_drawer_free_shipping_hint",
    "page": "cart",
    "type": "text",
    "label": "Versandhinweis Drawer",
    "defaultValue": "Direktversand ab ASL-Zentrallager",
    "default_value": "Direktversand ab ASL-Zentrallager",
    "sourceFile": "src/features/cart/CartDrawer.jsx",
    "source_file": "src/features/cart/CartDrawer.jsx",
    "multiline": false
  },
  {
    "id": "cart_drawer_b2b_tag",
    "page": "cart",
    "type": "text",
    "label": "B2B Tag Drawer",
    "defaultValue": "Fachbetrieb",
    "default_value": "Fachbetrieb",
    "sourceFile": "src/features/cart/CartDrawer.jsx",
    "source_file": "src/features/cart/CartDrawer.jsx",
    "multiline": false
  },
  {
    "id": "catalog_page_title",
    "page": "catalog",
    "type": "text",
    "label": "Katalog Seitentitel",
    "defaultValue": "ASL Sicherheits- & Großhandelssortiment",
    "default_value": "ASL Sicherheits- & Großhandelssortiment",
    "sourceFile": "src/features/catalog/CatalogView.jsx",
    "source_file": "src/features/catalog/CatalogView.jsx",
    "multiline": false
  },
  {
    "id": "catalog_page_subtitle",
    "page": "catalog",
    "type": "text",
    "label": "Katalog Untertitel",
    "defaultValue": "Sicherheitstechnik führender Hersteller – persönlich beraten, regional montiert.",
    "default_value": "Sicherheitstechnik führender Hersteller – persönlich beraten, regional montiert.",
    "sourceFile": "src/features/catalog/CatalogView.jsx",
    "source_file": "src/features/catalog/CatalogView.jsx",
    "multiline": false
  },
  {
    "id": "catalog_results_found_prefix",
    "page": "catalog",
    "type": "text",
    "label": "Gefundene Artikel Präfix",
    "defaultValue": "Gefunden:",
    "default_value": "Gefunden:",
    "sourceFile": "src/features/catalog/CatalogView.jsx",
    "source_file": "src/features/catalog/CatalogView.jsx",
    "multiline": false
  },
  {
    "id": "catalog_results_found_suffix",
    "page": "catalog",
    "type": "text",
    "label": "Gefundene Artikel Suffix",
    "defaultValue": "Artikel",
    "default_value": "Artikel",
    "sourceFile": "src/features/catalog/CatalogView.jsx",
    "source_file": "src/features/catalog/CatalogView.jsx",
    "multiline": false
  },
  {
    "id": "catalog_empty_title",
    "page": "catalog",
    "type": "text",
    "label": "Keine Treffer Titel",
    "defaultValue": "Keine Produkte gefunden",
    "default_value": "Keine Produkte gefunden",
    "sourceFile": "src/features/catalog/CatalogView.jsx",
    "source_file": "src/features/catalog/CatalogView.jsx",
    "multiline": false
  },
  {
    "id": "catalog_empty_desc",
    "page": "catalog",
    "type": "text",
    "label": "Keine Treffer Text",
    "defaultValue": "Für Ihre gewählten Such- und Filterkriterien liegen keine passenden Artikel vor.",
    "default_value": "Für Ihre gewählten Such- und Filterkriterien liegen keine passenden Artikel vor.",
    "sourceFile": "src/features/catalog/CatalogView.jsx",
    "source_file": "src/features/catalog/CatalogView.jsx",
    "multiline": false
  },
  {
    "id": "catalog_btn_reset_filters",
    "page": "catalog",
    "type": "text",
    "label": "Button Filter zurücksetzen",
    "defaultValue": "Filter zurücksetzen",
    "default_value": "Filter zurücksetzen",
    "sourceFile": "src/features/catalog/CatalogView.jsx",
    "source_file": "src/features/catalog/CatalogView.jsx",
    "multiline": false
  },
  {
    "id": "catalog_loading_text",
    "page": "catalog",
    "type": "text",
    "label": "Katalog Lädt Text",
    "defaultValue": "Sortiment wird geladen...",
    "default_value": "Sortiment wird geladen...",
    "sourceFile": "src/features/catalog/CatalogView.jsx",
    "source_file": "src/features/catalog/CatalogView.jsx",
    "multiline": false
  },
  {
    "id": "catalog_pagination_prev",
    "page": "catalog",
    "type": "text",
    "label": "Paginierung Vorherige",
    "defaultValue": "Vorherige Seite",
    "default_value": "Vorherige Seite",
    "sourceFile": "src/features/catalog/CatalogView.jsx",
    "source_file": "src/features/catalog/CatalogView.jsx",
    "multiline": false
  },
  {
    "id": "catalog_pagination_next",
    "page": "catalog",
    "type": "text",
    "label": "Paginierung Nächste",
    "defaultValue": "Nächste Seite",
    "default_value": "Nächste Seite",
    "sourceFile": "src/features/catalog/CatalogView.jsx",
    "source_file": "src/features/catalog/CatalogView.jsx",
    "multiline": false
  },
  {
    "id": "catalog_pagination_page_of",
    "page": "catalog",
    "type": "text",
    "label": "Paginierung Seite von",
    "defaultValue": "Seite {current} von {total}",
    "default_value": "Seite {current} von {total}",
    "sourceFile": "src/features/catalog/CatalogView.jsx",
    "source_file": "src/features/catalog/CatalogView.jsx",
    "multiline": false
  },
  {
    "id": "catalog_view_mode_grid",
    "page": "catalog",
    "type": "text",
    "label": "Ansicht Raster",
    "defaultValue": "Rasteransicht",
    "default_value": "Rasteransicht",
    "sourceFile": "src/features/catalog/CatalogView.jsx",
    "source_file": "src/features/catalog/CatalogView.jsx",
    "multiline": false
  },
  {
    "id": "catalog_view_mode_list",
    "page": "catalog",
    "type": "text",
    "label": "Ansicht Liste",
    "defaultValue": "Listenansicht",
    "default_value": "Listenansicht",
    "sourceFile": "src/features/catalog/CatalogView.jsx",
    "source_file": "src/features/catalog/CatalogView.jsx",
    "multiline": false
  },
  {
    "id": "catalog_b2b_wholesale_banner",
    "page": "catalog",
    "type": "text",
    "label": "Katalog B2B Banner",
    "defaultValue": "Großhandelssortiment für zertifizierte Facherrichter und Planer",
    "default_value": "Großhandelssortiment für zertifizierte Facherrichter und Planer",
    "sourceFile": "src/features/catalog/CatalogView.jsx",
    "source_file": "src/features/catalog/CatalogView.jsx",
    "multiline": false
  },
  {
    "id": "catalog_sort_label",
    "page": "catalog",
    "type": "text",
    "label": "Sortierung Label",
    "defaultValue": "Sortierung:",
    "default_value": "Sortierung:",
    "sourceFile": "src/features/catalog/CatalogView.jsx",
    "source_file": "src/features/catalog/CatalogView.jsx",
    "multiline": false
  },
  {
    "id": "filter_topbar_all_categories",
    "page": "catalog",
    "type": "text",
    "label": "Topbar Alle Fachbereiche",
    "defaultValue": "Alle Fachbereiche",
    "default_value": "Alle Fachbereiche",
    "sourceFile": "src/registry/components/filters/TopbarFilterLayout.jsx",
    "source_file": "src/registry/components/filters/TopbarFilterLayout.jsx",
    "multiline": false
  },
  {
    "id": "filter_topbar_all_subcategories",
    "page": "catalog",
    "type": "text",
    "label": "Topbar Alle Untergruppen",
    "defaultValue": "Alle Untergruppen",
    "default_value": "Alle Untergruppen",
    "sourceFile": "src/registry/components/filters/TopbarFilterLayout.jsx",
    "source_file": "src/registry/components/filters/TopbarFilterLayout.jsx",
    "multiline": false
  },
  {
    "id": "filter_topbar_all_manufacturers",
    "page": "catalog",
    "type": "text",
    "label": "Topbar Alle Hersteller",
    "defaultValue": "Alle Hersteller",
    "default_value": "Alle Hersteller",
    "sourceFile": "src/registry/components/filters/TopbarFilterLayout.jsx",
    "source_file": "src/registry/components/filters/TopbarFilterLayout.jsx",
    "multiline": false
  },
  {
    "id": "filter_topbar_sort_standard",
    "page": "catalog",
    "type": "text",
    "label": "Sortierung Standard",
    "defaultValue": "Standard (ASL-Rang)",
    "default_value": "Standard (ASL-Rang)",
    "sourceFile": "src/registry/components/filters/TopbarFilterLayout.jsx",
    "source_file": "src/registry/components/filters/TopbarFilterLayout.jsx",
    "multiline": false
  },
  {
    "id": "filter_topbar_sort_price_asc",
    "page": "catalog",
    "type": "text",
    "label": "Sortierung Preis aufsteigend",
    "defaultValue": "Preis: aufsteigend",
    "default_value": "Preis: aufsteigend",
    "sourceFile": "src/registry/components/filters/TopbarFilterLayout.jsx",
    "source_file": "src/registry/components/filters/TopbarFilterLayout.jsx",
    "multiline": false
  },
  {
    "id": "filter_topbar_sort_price_desc",
    "page": "catalog",
    "type": "text",
    "label": "Sortierung Preis absteigend",
    "defaultValue": "Preis: absteigend",
    "default_value": "Preis: absteigend",
    "sourceFile": "src/registry/components/filters/TopbarFilterLayout.jsx",
    "source_file": "src/registry/components/filters/TopbarFilterLayout.jsx",
    "multiline": false
  },
  {
    "id": "filter_topbar_sort_name_asc",
    "page": "catalog",
    "type": "text",
    "label": "Sortierung Name",
    "defaultValue": "Name: A bis Z",
    "default_value": "Name: A bis Z",
    "sourceFile": "src/registry/components/filters/TopbarFilterLayout.jsx",
    "source_file": "src/registry/components/filters/TopbarFilterLayout.jsx",
    "multiline": false
  },
  {
    "id": "filter_topbar_search_ph",
    "page": "catalog",
    "type": "text",
    "label": "Suchfeld Platzhalter Topbar",
    "defaultValue": "SKU, Modell oder Begriff suchen...",
    "default_value": "SKU, Modell oder Begriff suchen...",
    "sourceFile": "src/registry/components/filters/TopbarFilterLayout.jsx",
    "source_file": "src/registry/components/filters/TopbarFilterLayout.jsx",
    "multiline": false
  },
  {
    "id": "filter_topbar_reset_all",
    "page": "catalog",
    "type": "text",
    "label": "Button Alle Filter löschen",
    "defaultValue": "Filter leeren",
    "default_value": "Filter leeren",
    "sourceFile": "src/registry/components/filters/TopbarFilterLayout.jsx",
    "source_file": "src/registry/components/filters/TopbarFilterLayout.jsx",
    "multiline": false
  },
  {
    "id": "filter_topbar_active_filters_label",
    "page": "catalog",
    "type": "text",
    "label": "Aktive Filter Label",
    "defaultValue": "Aktive Filter:",
    "default_value": "Aktive Filter:",
    "sourceFile": "src/registry/components/filters/TopbarFilterLayout.jsx",
    "source_file": "src/registry/components/filters/TopbarFilterLayout.jsx",
    "multiline": false
  },
  {
    "id": "filter_topbar_clear_search_tooltip",
    "page": "catalog",
    "type": "text",
    "label": "Suche leeren Tooltip",
    "defaultValue": "Suchbegriff löschen",
    "default_value": "Suchbegriff löschen",
    "sourceFile": "src/registry/components/filters/TopbarFilterLayout.jsx",
    "source_file": "src/registry/components/filters/TopbarFilterLayout.jsx",
    "multiline": false
  },
  {
    "id": "filter_topbar_apply_filter_label",
    "page": "catalog",
    "type": "text",
    "label": "Filter anwenden Label",
    "defaultValue": "Filter anwenden",
    "default_value": "Filter anwenden",
    "sourceFile": "src/registry/components/filters/TopbarFilterLayout.jsx",
    "source_file": "src/registry/components/filters/TopbarFilterLayout.jsx",
    "multiline": false
  },
  {
    "id": "filter_topbar_category_filter_label",
    "page": "catalog",
    "type": "text",
    "label": "Fachbereich Filter Label",
    "defaultValue": "Fachbereich wählen",
    "default_value": "Fachbereich wählen",
    "sourceFile": "src/registry/components/filters/TopbarFilterLayout.jsx",
    "source_file": "src/registry/components/filters/TopbarFilterLayout.jsx",
    "multiline": false
  },
  {
    "id": "filter_topbar_manufacturer_filter_label",
    "page": "catalog",
    "type": "text",
    "label": "Hersteller Filter Label",
    "defaultValue": "Hersteller wählen",
    "default_value": "Hersteller wählen",
    "sourceFile": "src/registry/components/filters/TopbarFilterLayout.jsx",
    "source_file": "src/registry/components/filters/TopbarFilterLayout.jsx",
    "multiline": false
  },
  {
    "id": "filter_sidebar_title",
    "page": "catalog",
    "type": "text",
    "label": "Sidebar Filter Titel",
    "defaultValue": "Filter & Kategorien",
    "default_value": "Filter & Kategorien",
    "sourceFile": "src/registry/components/filters/SidebarFilterLayout.jsx",
    "source_file": "src/registry/components/filters/SidebarFilterLayout.jsx",
    "multiline": false
  },
  {
    "id": "filter_sidebar_categories_heading",
    "page": "catalog",
    "type": "text",
    "label": "Sidebar Fachbereiche Titel",
    "defaultValue": "Fachbereiche",
    "default_value": "Fachbereiche",
    "sourceFile": "src/registry/components/filters/SidebarFilterLayout.jsx",
    "source_file": "src/registry/components/filters/SidebarFilterLayout.jsx",
    "multiline": false
  },
  {
    "id": "filter_sidebar_all_categories_btn",
    "page": "catalog",
    "type": "text",
    "label": "Sidebar Alle Produkte",
    "defaultValue": "Alle Produkte anzeigen",
    "default_value": "Alle Produkte anzeigen",
    "sourceFile": "src/registry/components/filters/SidebarFilterLayout.jsx",
    "source_file": "src/registry/components/filters/SidebarFilterLayout.jsx",
    "multiline": false
  },
  {
    "id": "filter_sidebar_manufacturers_heading",
    "page": "catalog",
    "type": "text",
    "label": "Sidebar Hersteller Titel",
    "defaultValue": "Hersteller",
    "default_value": "Hersteller",
    "sourceFile": "src/registry/components/filters/SidebarFilterLayout.jsx",
    "source_file": "src/registry/components/filters/SidebarFilterLayout.jsx",
    "multiline": false
  },
  {
    "id": "filter_sidebar_search_mfr_ph",
    "page": "catalog",
    "type": "text",
    "label": "Hersteller suchen Platzhalter",
    "defaultValue": "Hersteller filtern...",
    "default_value": "Hersteller filtern...",
    "sourceFile": "src/registry/components/filters/SidebarFilterLayout.jsx",
    "source_file": "src/registry/components/filters/SidebarFilterLayout.jsx",
    "multiline": false
  },
  {
    "id": "filter_sidebar_no_mfr_found",
    "page": "catalog",
    "type": "text",
    "label": "Kein Hersteller gefunden",
    "defaultValue": "Keine passenden Hersteller",
    "default_value": "Keine passenden Hersteller",
    "sourceFile": "src/registry/components/filters/SidebarFilterLayout.jsx",
    "source_file": "src/registry/components/filters/SidebarFilterLayout.jsx",
    "multiline": false
  },
  {
    "id": "filter_sidebar_reset_btn",
    "page": "catalog",
    "type": "text",
    "label": "Sidebar Reset Button",
    "defaultValue": "Auswahl zurücksetzen",
    "default_value": "Auswahl zurücksetzen",
    "sourceFile": "src/registry/components/filters/SidebarFilterLayout.jsx",
    "source_file": "src/registry/components/filters/SidebarFilterLayout.jsx",
    "multiline": false
  },
  {
    "id": "filter_sidebar_price_heading",
    "page": "catalog",
    "type": "text",
    "label": "Sidebar Preisspanne Titel",
    "defaultValue": "Preisbereich (netto)",
    "default_value": "Preisbereich (netto)",
    "sourceFile": "src/registry/components/filters/SidebarFilterLayout.jsx",
    "source_file": "src/registry/components/filters/SidebarFilterLayout.jsx",
    "multiline": false
  },
  {
    "id": "filter_sidebar_availability_heading",
    "page": "catalog",
    "type": "text",
    "label": "Sidebar Verfügbarkeit Titel",
    "defaultValue": "Verfügbarkeit",
    "default_value": "Verfügbarkeit",
    "sourceFile": "src/registry/components/filters/SidebarFilterLayout.jsx",
    "source_file": "src/registry/components/filters/SidebarFilterLayout.jsx",
    "multiline": false
  },
  {
    "id": "filter_sidebar_in_stock_only",
    "page": "catalog",
    "type": "text",
    "label": "Nur Lagerware Checkbox",
    "defaultValue": "Nur sofort lieferbare Artikel",
    "default_value": "Nur sofort lieferbare Artikel",
    "sourceFile": "src/registry/components/filters/SidebarFilterLayout.jsx",
    "source_file": "src/registry/components/filters/SidebarFilterLayout.jsx",
    "multiline": false
  },
  {
    "id": "filter_sidebar_b2b_certified",
    "page": "catalog",
    "type": "text",
    "label": "Nur Zertifizierte Checkbox",
    "defaultValue": "VdS / EN54 zertifiziert",
    "default_value": "VdS / EN54 zertifiziert",
    "sourceFile": "src/registry/components/filters/SidebarFilterLayout.jsx",
    "source_file": "src/registry/components/filters/SidebarFilterLayout.jsx",
    "multiline": false
  },
  {
    "id": "filter_sidebar_subcat_heading",
    "page": "catalog",
    "type": "text",
    "label": "Sidebar Untergruppen Titel",
    "defaultValue": "Unterkategorien",
    "default_value": "Unterkategorien",
    "sourceFile": "src/registry/components/filters/SidebarFilterLayout.jsx",
    "source_file": "src/registry/components/filters/SidebarFilterLayout.jsx",
    "multiline": false
  },
  {
    "id": "card_product_details_btn",
    "page": "catalog",
    "type": "text",
    "label": "Details ansehen Button",
    "defaultValue": "Details ansehen",
    "default_value": "Details ansehen",
    "sourceFile": "src/features/catalog/ProductCard.jsx",
    "source_file": "src/features/catalog/ProductCard.jsx",
    "multiline": false
  },
  {
    "id": "card_product_request_btn",
    "page": "catalog",
    "type": "text",
    "label": "Artikel anfragen Button",
    "defaultValue": "Anfragen",
    "default_value": "Anfragen",
    "sourceFile": "src/features/catalog/ProductCard.jsx",
    "source_file": "src/features/catalog/ProductCard.jsx",
    "multiline": false
  },
  {
    "id": "card_product_price_net_suffix",
    "page": "catalog",
    "type": "text",
    "label": "Netto Suffix",
    "defaultValue": "netto",
    "default_value": "netto",
    "sourceFile": "src/features/catalog/ProductCard.jsx",
    "source_file": "src/features/catalog/ProductCard.jsx",
    "multiline": false
  },
  {
    "id": "card_product_price_on_request",
    "page": "catalog",
    "type": "text",
    "label": "Karte Preis auf Anfrage",
    "defaultValue": "Auf Anfrage",
    "default_value": "Auf Anfrage",
    "sourceFile": "src/features/catalog/ProductCard.jsx",
    "source_file": "src/features/catalog/ProductCard.jsx",
    "multiline": false
  },
  {
    "id": "card_specs_sku_prefix",
    "page": "catalog",
    "type": "text",
    "label": "Specs Karte SKU Präfix",
    "defaultValue": "Art.-Nr.",
    "default_value": "Art.-Nr.",
    "sourceFile": "src/registry/components/cards/SpecsHeavyProductCard.jsx",
    "source_file": "src/registry/components/cards/SpecsHeavyProductCard.jsx",
    "multiline": false
  },
  {
    "id": "card_specs_mfr_fallback",
    "page": "catalog",
    "type": "text",
    "label": "Specs Karte Hersteller Fallback",
    "defaultValue": "Fachhandel",
    "default_value": "Fachhandel",
    "sourceFile": "src/registry/components/cards/SpecsHeavyProductCard.jsx",
    "source_file": "src/registry/components/cards/SpecsHeavyProductCard.jsx",
    "multiline": false
  },
  {
    "id": "card_specs_net_label",
    "page": "catalog",
    "type": "text",
    "label": "Specs Karte Netto Label",
    "defaultValue": "Preis",
    "default_value": "Preis",
    "sourceFile": "src/registry/components/cards/SpecsHeavyProductCard.jsx",
    "source_file": "src/registry/components/cards/SpecsHeavyProductCard.jsx",
    "multiline": false
  },
  {
    "id": "card_specs_vat_hint",
    "page": "catalog",
    "type": "text",
    "label": "Specs Karte MwSt. Hinweis",
    "defaultValue": "zzgl. MwSt.",
    "default_value": "zzgl. MwSt.",
    "sourceFile": "src/registry/components/cards/SpecsHeavyProductCard.jsx",
    "source_file": "src/registry/components/cards/SpecsHeavyProductCard.jsx",
    "multiline": false
  },
  {
    "id": "card_specs_add_btn",
    "page": "catalog",
    "type": "text",
    "label": "Specs Karte Hinzufügen Button",
    "defaultValue": "In den Anfragekorb",
    "default_value": "In den Anfragekorb",
    "sourceFile": "src/registry/components/cards/SpecsHeavyProductCard.jsx",
    "source_file": "src/registry/components/cards/SpecsHeavyProductCard.jsx",
    "multiline": false
  },
  {
    "id": "card_specs_added_state",
    "page": "catalog",
    "type": "text",
    "label": "Specs Karte Im Korb Status",
    "defaultValue": "Im Korb",
    "default_value": "Im Korb",
    "sourceFile": "src/registry/components/cards/SpecsHeavyProductCard.jsx",
    "source_file": "src/registry/components/cards/SpecsHeavyProductCard.jsx",
    "multiline": false
  },
  {
    "id": "card_specs_request_quote_btn",
    "page": "catalog",
    "type": "text",
    "label": "Specs Karte Anfragen Button",
    "defaultValue": "Angebot anfordern",
    "default_value": "Angebot anfordern",
    "sourceFile": "src/registry/components/cards/SpecsHeavyProductCard.jsx",
    "source_file": "src/registry/components/cards/SpecsHeavyProductCard.jsx",
    "multiline": false
  },
  {
    "id": "card_specs_fast_ship_badge",
    "page": "catalog",
    "type": "text",
    "label": "Specs Karte Schnellversand",
    "defaultValue": "24h Versand",
    "default_value": "24h Versand",
    "sourceFile": "src/registry/components/cards/SpecsHeavyProductCard.jsx",
    "source_file": "src/registry/components/cards/SpecsHeavyProductCard.jsx",
    "multiline": false
  },
  {
    "id": "card_compact_sku_label",
    "page": "catalog",
    "type": "text",
    "label": "Kompakt Karte SKU Label",
    "defaultValue": "SKU:",
    "default_value": "SKU:",
    "sourceFile": "src/registry/components/cards/CompactRowProductCard.jsx",
    "source_file": "src/registry/components/cards/CompactRowProductCard.jsx",
    "multiline": false
  },
  {
    "id": "card_compact_qty_dec",
    "page": "catalog",
    "type": "text",
    "label": "Kompakt Karte Menge minus",
    "defaultValue": "Menge reduzieren",
    "default_value": "Menge reduzieren",
    "sourceFile": "src/registry/components/cards/CompactRowProductCard.jsx",
    "source_file": "src/registry/components/cards/CompactRowProductCard.jsx",
    "multiline": false
  },
  {
    "id": "card_compact_qty_inc",
    "page": "catalog",
    "type": "text",
    "label": "Kompakt Karte Menge plus",
    "defaultValue": "Menge erhöhen",
    "default_value": "Menge erhöhen",
    "sourceFile": "src/registry/components/cards/CompactRowProductCard.jsx",
    "source_file": "src/registry/components/cards/CompactRowProductCard.jsx",
    "multiline": false
  },
  {
    "id": "card_compact_add_btn",
    "page": "catalog",
    "type": "text",
    "label": "Kompakt Karte 1-Klick Button",
    "defaultValue": "Hinzufügen",
    "default_value": "Hinzufügen",
    "sourceFile": "src/registry/components/cards/CompactRowProductCard.jsx",
    "source_file": "src/registry/components/cards/CompactRowProductCard.jsx",
    "multiline": false
  },
  {
    "id": "card_compact_net_price_label",
    "page": "catalog",
    "type": "text",
    "label": "Kompakt Karte Netto Preis",
    "defaultValue": "Netto",
    "default_value": "Netto",
    "sourceFile": "src/registry/components/cards/CompactRowProductCard.jsx",
    "source_file": "src/registry/components/cards/CompactRowProductCard.jsx",
    "multiline": false
  },
  {
    "id": "card_visual_recommendation_badge",
    "page": "catalog",
    "type": "text",
    "label": "Visuelle Karte Empfehlung Badge",
    "defaultValue": "Empfehlung",
    "default_value": "Empfehlung",
    "sourceFile": "src/registry/components/cards/VisualProductCard.jsx",
    "source_file": "src/registry/components/cards/VisualProductCard.jsx",
    "multiline": false
  },
  {
    "id": "card_visual_in_stock_badge",
    "page": "catalog",
    "type": "text",
    "label": "Visuelle Karte Lagernd Badge",
    "defaultValue": "Auf Lager",
    "default_value": "Auf Lager",
    "sourceFile": "src/registry/components/cards/VisualProductCard.jsx",
    "source_file": "src/registry/components/cards/VisualProductCard.jsx",
    "multiline": false
  },
  {
    "id": "card_visual_add_cta",
    "page": "catalog",
    "type": "text",
    "label": "Visuelle Karte In Korb CTA",
    "defaultValue": "In den Anfragekorb",
    "default_value": "In den Anfragekorb",
    "sourceFile": "src/registry/components/cards/VisualProductCard.jsx",
    "source_file": "src/registry/components/cards/VisualProductCard.jsx",
    "multiline": false
  },
  {
    "id": "card_visual_details_link",
    "page": "catalog",
    "type": "text",
    "label": "Visuelle Karte Details Link",
    "defaultValue": "Artikeldetails anzeigen",
    "default_value": "Artikeldetails anzeigen",
    "sourceFile": "src/registry/components/cards/VisualProductCard.jsx",
    "source_file": "src/registry/components/cards/VisualProductCard.jsx",
    "multiline": false
  },
  {
    "id": "card_visual_vat_note",
    "page": "catalog",
    "type": "text",
    "label": "Visuelle Karte MwSt. Hinweis",
    "defaultValue": "zzgl. 19% MwSt.",
    "default_value": "zzgl. 19% MwSt.",
    "sourceFile": "src/registry/components/cards/VisualProductCard.jsx",
    "source_file": "src/registry/components/cards/VisualProductCard.jsx",
    "multiline": false
  },
  {
    "id": "default_product_placeholder",
    "page": "catalog",
    "type": "image",
    "label": "Standard Produktbild Platzhalter",
    "defaultValue": "",
    "default_value": "",
    "sourceFile": "src/features/catalog/CatalogView.jsx",
    "source_file": "src/features/catalog/CatalogView.jsx",
    "multiline": false
  },
  {
    "id": "header_topbar_b2b_badge",
    "page": "header",
    "type": "text",
    "label": "Header Fachbetrieb Badge",
    "defaultValue": "Ihr Fachbetrieb für Sicherheitstechnik",
    "default_value": "Ihr Fachbetrieb für Sicherheitstechnik",
    "sourceFile": "src/registry/components/headers/EnterpriseHeader.jsx",
    "source_file": "src/registry/components/headers/EnterpriseHeader.jsx",
    "multiline": false
  },
  {
    "id": "header_topbar_direct_shipping",
    "page": "header",
    "type": "text",
    "label": "Header Direktversand Text",
    "defaultValue": "Direktversand ab Zentrallager",
    "default_value": "Direktversand ab Zentrallager",
    "sourceFile": "src/registry/components/headers/EnterpriseHeader.jsx",
    "source_file": "src/registry/components/headers/EnterpriseHeader.jsx",
    "multiline": false
  },
  {
    "id": "header_topbar_hotline_label",
    "page": "header",
    "type": "text",
    "label": "Header Hotline Label",
    "defaultValue": "Fachberatung:",
    "default_value": "Fachberatung:",
    "sourceFile": "src/registry/components/headers/EnterpriseHeader.jsx",
    "source_file": "src/registry/components/headers/EnterpriseHeader.jsx",
    "multiline": false
  },
  {
    "id": "header_topbar_hotline_number",
    "page": "header",
    "type": "text",
    "label": "Header Hotline Telefonnummer",
    "defaultValue": "+49 800 1234567",
    "default_value": "+49 800 1234567",
    "sourceFile": "src/registry/components/headers/EnterpriseHeader.jsx",
    "source_file": "src/registry/components/headers/EnterpriseHeader.jsx",
    "multiline": false
  },
  {
    "id": "header_topbar_email_label",
    "page": "header",
    "type": "text",
    "label": "Header E-Mail Label",
    "defaultValue": "vertrieb@asl-partner.de",
    "default_value": "vertrieb@asl-partner.de",
    "sourceFile": "src/registry/components/headers/EnterpriseHeader.jsx",
    "source_file": "src/registry/components/headers/EnterpriseHeader.jsx",
    "multiline": false
  },
  {
    "id": "header_megamenu_trigger_label",
    "page": "header",
    "type": "text",
    "label": "Mega-Menü Button Label",
    "defaultValue": "Alle Fachbereiche",
    "default_value": "Alle Fachbereiche",
    "sourceFile": "src/registry/components/headers/EnterpriseHeader.jsx",
    "source_file": "src/registry/components/headers/EnterpriseHeader.jsx",
    "multiline": false
  },
  {
    "id": "header_search_btn_label",
    "page": "header",
    "type": "text",
    "label": "Header Suche Button Label",
    "defaultValue": "Suchen",
    "default_value": "Suchen",
    "sourceFile": "src/registry/components/headers/EnterpriseHeader.jsx",
    "source_file": "src/registry/components/headers/EnterpriseHeader.jsx",
    "multiline": false
  },
  {
    "id": "header_search_input_ph",
    "page": "header",
    "type": "text",
    "label": "Header Suchfeld Platzhalter",
    "defaultValue": "Artikelnummer, Bezeichnung oder Hersteller eingeben...",
    "default_value": "Artikelnummer, Bezeichnung oder Hersteller eingeben...",
    "sourceFile": "src/registry/components/headers/EnterpriseHeader.jsx",
    "source_file": "src/registry/components/headers/EnterpriseHeader.jsx",
    "multiline": false
  },
  {
    "id": "header_quote_cta_label",
    "page": "header",
    "type": "text",
    "label": "Header Projektanfrage CTA",
    "defaultValue": "Projektanfrage",
    "default_value": "Projektanfrage",
    "sourceFile": "src/registry/components/headers/EnterpriseHeader.jsx",
    "source_file": "src/registry/components/headers/EnterpriseHeader.jsx",
    "multiline": false
  },
  {
    "id": "header_cart_btn_label",
    "page": "header",
    "type": "text",
    "label": "Header Warenkorb Button",
    "defaultValue": "Anfragekorb",
    "default_value": "Anfragekorb",
    "sourceFile": "src/registry/components/headers/EnterpriseHeader.jsx",
    "source_file": "src/registry/components/headers/EnterpriseHeader.jsx",
    "multiline": false
  },
  {
    "id": "header_mobile_menu_open_label",
    "page": "header",
    "type": "text",
    "label": "Mobil Menü öffnen Label",
    "defaultValue": "Menü öffnen",
    "default_value": "Menü öffnen",
    "sourceFile": "src/registry/components/headers/EnterpriseHeader.jsx",
    "source_file": "src/registry/components/headers/EnterpriseHeader.jsx",
    "multiline": false
  },
  {
    "id": "header_mobile_menu_close_label",
    "page": "header",
    "type": "text",
    "label": "Mobil Menü schließen Label",
    "defaultValue": "Menü schließen",
    "default_value": "Menü schließen",
    "sourceFile": "src/registry/components/headers/EnterpriseHeader.jsx",
    "source_file": "src/registry/components/headers/EnterpriseHeader.jsx",
    "multiline": false
  },
  {
    "id": "header_rubrik_video",
    "page": "header",
    "type": "text",
    "label": "Rubrik Videoüberwachung",
    "defaultValue": "Videoüberwachung",
    "default_value": "Videoüberwachung",
    "sourceFile": "src/registry/components/headers/EnterpriseHeader.jsx",
    "source_file": "src/registry/components/headers/EnterpriseHeader.jsx",
    "multiline": false
  },
  {
    "id": "header_rubrik_gefahr",
    "page": "header",
    "type": "text",
    "label": "Rubrik Gefahrenmelde",
    "defaultValue": "Gefahrenmeldetechnik",
    "default_value": "Gefahrenmeldetechnik",
    "sourceFile": "src/registry/components/headers/EnterpriseHeader.jsx",
    "source_file": "src/registry/components/headers/EnterpriseHeader.jsx",
    "multiline": false
  },
  {
    "id": "header_rubrik_zutritt",
    "page": "header",
    "type": "text",
    "label": "Rubrik Zutrittskontrolle",
    "defaultValue": "Zutrittskontrolle",
    "default_value": "Zutrittskontrolle",
    "sourceFile": "src/registry/components/headers/EnterpriseHeader.jsx",
    "source_file": "src/registry/components/headers/EnterpriseHeader.jsx",
    "multiline": false
  },
  {
    "id": "header_rubrik_brand",
    "page": "header",
    "type": "text",
    "label": "Rubrik Brandmeldetechnik",
    "defaultValue": "Brandmeldetechnik",
    "default_value": "Brandmeldetechnik",
    "sourceFile": "src/registry/components/headers/EnterpriseHeader.jsx",
    "source_file": "src/registry/components/headers/EnterpriseHeader.jsx",
    "multiline": false
  },
  {
    "id": "header_rubrik_pulsar",
    "page": "header",
    "type": "text",
    "label": "Rubrik PULSAR Stromversorgung",
    "defaultValue": "Stromversorgung & Gehäusetechnik",
    "default_value": "Stromversorgung & Gehäusetechnik",
    "sourceFile": "src/registry/components/headers/EnterpriseHeader.jsx",
    "source_file": "src/registry/components/headers/EnterpriseHeader.jsx",
    "multiline": false
  },
  {
    "id": "header_all_products_link",
    "page": "header",
    "type": "text",
    "label": "Header Alle Produkte Link",
    "defaultValue": "Gesamtes Sortiment durchsuchen",
    "default_value": "Gesamtes Sortiment durchsuchen",
    "sourceFile": "src/registry/components/headers/EnterpriseHeader.jsx",
    "source_file": "src/registry/components/headers/EnterpriseHeader.jsx",
    "multiline": false
  },
  {
    "id": "header_fast_delivery_badge",
    "page": "header",
    "type": "text",
    "label": "Header Schnellversand Badge",
    "defaultValue": "24h Expressversand",
    "default_value": "24h Expressversand",
    "sourceFile": "src/registry/components/headers/EnterpriseHeader.jsx",
    "source_file": "src/registry/components/headers/EnterpriseHeader.jsx",
    "multiline": false
  },
  {
    "id": "header_partner_portal_link",
    "page": "header",
    "type": "text",
    "label": "Header Partner Portal Link",
    "defaultValue": "Partnerbereich",
    "default_value": "Partnerbereich",
    "sourceFile": "src/registry/components/headers/EnterpriseHeader.jsx",
    "source_file": "src/registry/components/headers/EnterpriseHeader.jsx",
    "multiline": false
  },
  {
    "id": "header_advisor_link",
    "page": "header",
    "type": "text",
    "label": "Header Berater Link",
    "defaultValue": "Sicherheitsberater",
    "default_value": "Sicherheitsberater",
    "sourceFile": "src/registry/components/headers/EnterpriseHeader.jsx",
    "source_file": "src/registry/components/headers/EnterpriseHeader.jsx",
    "multiline": false
  },
  {
    "id": "header_slim_logo_fallback",
    "page": "header",
    "type": "text",
    "label": "Slim Header Logo Fallback",
    "defaultValue": "ASL Partner Shop",
    "default_value": "ASL Partner Shop",
    "sourceFile": "src/registry/components/headers/SlimHeader.jsx",
    "source_file": "src/registry/components/headers/SlimHeader.jsx",
    "multiline": false
  },
  {
    "id": "header_slim_search_ph",
    "page": "header",
    "type": "text",
    "label": "Slim Header Suche Platzhalter",
    "defaultValue": "Katalog durchsuchen...",
    "default_value": "Katalog durchsuchen...",
    "sourceFile": "src/registry/components/headers/SlimHeader.jsx",
    "source_file": "src/registry/components/headers/SlimHeader.jsx",
    "multiline": false
  },
  {
    "id": "header_slim_ctrl_k_hint",
    "page": "header",
    "type": "text",
    "label": "Slim Header Strg+K Hinweis",
    "defaultValue": "Strg+K",
    "default_value": "Strg+K",
    "sourceFile": "src/registry/components/headers/SlimHeader.jsx",
    "source_file": "src/registry/components/headers/SlimHeader.jsx",
    "multiline": false
  },
  {
    "id": "header_slim_hotline_badge",
    "page": "header",
    "type": "text",
    "label": "Slim Header Hotline Badge",
    "defaultValue": "B2B Support",
    "default_value": "B2B Support",
    "sourceFile": "src/registry/components/headers/SlimHeader.jsx",
    "source_file": "src/registry/components/headers/SlimHeader.jsx",
    "multiline": false
  },
  {
    "id": "header_slim_cart_title",
    "page": "header",
    "type": "text",
    "label": "Slim Header Korb Titel",
    "defaultValue": "Warenkorb öffnen",
    "default_value": "Warenkorb öffnen",
    "sourceFile": "src/registry/components/headers/SlimHeader.jsx",
    "source_file": "src/registry/components/headers/SlimHeader.jsx",
    "multiline": false
  },
  {
    "id": "header_slim_catalog_nav",
    "page": "header",
    "type": "text",
    "label": "Slim Header Nav Katalog",
    "defaultValue": "Katalog",
    "default_value": "Katalog",
    "sourceFile": "src/registry/components/headers/SlimHeader.jsx",
    "source_file": "src/registry/components/headers/SlimHeader.jsx",
    "multiline": false
  },
  {
    "id": "header_slim_inquiry_nav",
    "page": "header",
    "type": "text",
    "label": "Slim Header Nav Anfrage",
    "defaultValue": "Projektanfrage",
    "default_value": "Projektanfrage",
    "sourceFile": "src/registry/components/headers/SlimHeader.jsx",
    "source_file": "src/registry/components/headers/SlimHeader.jsx",
    "multiline": false
  },
  {
    "id": "header_slim_mobile_title",
    "page": "header",
    "type": "text",
    "label": "Slim Header Mobil Titel",
    "defaultValue": "Navigation",
    "default_value": "Navigation",
    "sourceFile": "src/registry/components/headers/SlimHeader.jsx",
    "source_file": "src/registry/components/headers/SlimHeader.jsx",
    "multiline": false
  },
  {
    "id": "header_centered_slogan_fallback",
    "page": "header",
    "type": "text",
    "label": "Centered Header Slogan",
    "defaultValue": "Ihr Partner für Sicherheitstechnik",
    "default_value": "Ihr Partner für Sicherheitstechnik",
    "sourceFile": "src/registry/components/headers/CenteredBrandHeader.jsx",
    "source_file": "src/registry/components/headers/CenteredBrandHeader.jsx",
    "multiline": false
  },
  {
    "id": "header_centered_nav_catalog",
    "page": "header",
    "type": "text",
    "label": "Centered Nav Katalog",
    "defaultValue": "Sortiment",
    "default_value": "Sortiment",
    "sourceFile": "src/registry/components/headers/CenteredBrandHeader.jsx",
    "source_file": "src/registry/components/headers/CenteredBrandHeader.jsx",
    "multiline": false
  },
  {
    "id": "header_centered_nav_categories",
    "page": "header",
    "type": "text",
    "label": "Centered Nav Kategorien",
    "defaultValue": "Fachbereiche",
    "default_value": "Fachbereiche",
    "sourceFile": "src/registry/components/headers/CenteredBrandHeader.jsx",
    "source_file": "src/registry/components/headers/CenteredBrandHeader.jsx",
    "multiline": false
  },
  {
    "id": "header_centered_nav_inquiry",
    "page": "header",
    "type": "text",
    "label": "Centered Nav Anfrage",
    "defaultValue": "Projektanfrage",
    "default_value": "Projektanfrage",
    "sourceFile": "src/registry/components/headers/CenteredBrandHeader.jsx",
    "source_file": "src/registry/components/headers/CenteredBrandHeader.jsx",
    "multiline": false
  },
  {
    "id": "header_centered_nav_advisor",
    "page": "header",
    "type": "text",
    "label": "Centered Nav Berater",
    "defaultValue": "Bedarfsberater",
    "default_value": "Bedarfsberater",
    "sourceFile": "src/registry/components/headers/CenteredBrandHeader.jsx",
    "source_file": "src/registry/components/headers/CenteredBrandHeader.jsx",
    "multiline": false
  },
  {
    "id": "header_centered_search_toggle",
    "page": "header",
    "type": "text",
    "label": "Centered Suche Toggle",
    "defaultValue": "Suche einblenden",
    "default_value": "Suche einblenden",
    "sourceFile": "src/registry/components/headers/CenteredBrandHeader.jsx",
    "source_file": "src/registry/components/headers/CenteredBrandHeader.jsx",
    "multiline": false
  },
  {
    "id": "header_centered_hotline_text",
    "page": "header",
    "type": "text",
    "label": "Centered Hotline Text",
    "defaultValue": "Fachhotline",
    "default_value": "Fachhotline",
    "sourceFile": "src/registry/components/headers/CenteredBrandHeader.jsx",
    "source_file": "src/registry/components/headers/CenteredBrandHeader.jsx",
    "multiline": false
  },
  {
    "id": "header_mobile_back_btn",
    "page": "header",
    "type": "text",
    "label": "Mobil Nav Zurück",
    "defaultValue": "Zurück zur Übersicht",
    "default_value": "Zurück zur Übersicht",
    "sourceFile": "src/registry/components/headers/MobileAslNode.jsx",
    "source_file": "src/registry/components/headers/MobileAslNode.jsx",
    "multiline": false
  },
  {
    "id": "header_mobile_view_all_cat",
    "page": "header",
    "type": "text",
    "label": "Mobil Nav Alle in Kategorie",
    "defaultValue": "Alle Artikel dieser Kategorie",
    "default_value": "Alle Artikel dieser Kategorie",
    "sourceFile": "src/registry/components/headers/MobileAslNode.jsx",
    "source_file": "src/registry/components/headers/MobileAslNode.jsx",
    "multiline": false
  },
  {
    "id": "header_mobile_items_suffix",
    "page": "header",
    "type": "text",
    "label": "Mobil Nav Artikel Suffix",
    "defaultValue": "Artikel",
    "default_value": "Artikel",
    "sourceFile": "src/registry/components/headers/MobileAslNode.jsx",
    "source_file": "src/registry/components/headers/MobileAslNode.jsx",
    "multiline": false
  },
  {
    "id": "search_overlay_title",
    "page": "header",
    "type": "text",
    "label": "Such-Overlay Überschrift",
    "defaultValue": "Katalogschnellsuche",
    "default_value": "Katalogschnellsuche",
    "sourceFile": "src/components/search/SearchOverlay.jsx",
    "source_file": "src/components/search/SearchOverlay.jsx",
    "multiline": false
  },
  {
    "id": "search_overlay_input_ph",
    "page": "header",
    "type": "text",
    "label": "Such-Overlay Platzhalter",
    "defaultValue": "Suchbegriff, Modellbezeichnung oder SKU...",
    "default_value": "Suchbegriff, Modellbezeichnung oder SKU...",
    "sourceFile": "src/components/search/SearchOverlay.jsx",
    "source_file": "src/components/search/SearchOverlay.jsx",
    "multiline": false
  },
  {
    "id": "search_overlay_hint",
    "page": "header",
    "type": "text",
    "label": "Such-Overlay Eingabehinweis",
    "defaultValue": "Tippen Sie mindestens 2 Zeichen für Live-Ergebnisse.",
    "default_value": "Tippen Sie mindestens 2 Zeichen für Live-Ergebnisse.",
    "sourceFile": "src/components/search/SearchOverlay.jsx",
    "source_file": "src/components/search/SearchOverlay.jsx",
    "multiline": false
  },
  {
    "id": "search_overlay_recent_title",
    "page": "header",
    "type": "text",
    "label": "Such-Overlay Letzte Suchen",
    "defaultValue": "Häufig gesucht:",
    "default_value": "Häufig gesucht:",
    "sourceFile": "src/components/search/SearchOverlay.jsx",
    "source_file": "src/components/search/SearchOverlay.jsx",
    "multiline": false
  },
  {
    "id": "search_overlay_categories_title",
    "page": "header",
    "type": "text",
    "label": "Such-Overlay Beliebte Rubriken",
    "defaultValue": "Schnellzugriff Fachbereiche:",
    "default_value": "Schnellzugriff Fachbereiche:",
    "sourceFile": "src/components/search/SearchOverlay.jsx",
    "source_file": "src/components/search/SearchOverlay.jsx",
    "multiline": false
  },
  {
    "id": "search_overlay_no_results_title",
    "page": "header",
    "type": "text",
    "label": "Such-Overlay Keine Treffer Titel",
    "defaultValue": "Keine passenden Artikel gefunden",
    "default_value": "Keine passenden Artikel gefunden",
    "sourceFile": "src/components/search/SearchOverlay.jsx",
    "source_file": "src/components/search/SearchOverlay.jsx",
    "multiline": false
  },
  {
    "id": "search_overlay_no_results_desc",
    "page": "header",
    "type": "text",
    "label": "Such-Overlay Keine Treffer Text",
    "defaultValue": "Prüfen Sie die Schreibweise oder suchen Sie nach übergeordneten Fachbegriffen.",
    "default_value": "Prüfen Sie die Schreibweise oder suchen Sie nach übergeordneten Fachbegriffen.",
    "sourceFile": "src/components/search/SearchOverlay.jsx",
    "source_file": "src/components/search/SearchOverlay.jsx",
    "multiline": false
  },
  {
    "id": "search_overlay_results_count",
    "page": "header",
    "type": "text",
    "label": "Such-Overlay Trefferanzahl",
    "defaultValue": "{count} Treffer gefunden",
    "default_value": "{count} Treffer gefunden",
    "sourceFile": "src/components/search/SearchOverlay.jsx",
    "source_file": "src/components/search/SearchOverlay.jsx",
    "multiline": false
  },
  {
    "id": "search_overlay_view_all_btn",
    "page": "header",
    "type": "text",
    "label": "Such-Overlay Alle anzeigen Button",
    "defaultValue": "Alle Suchergebnisse anzeigen",
    "default_value": "Alle Suchergebnisse anzeigen",
    "sourceFile": "src/components/search/SearchOverlay.jsx",
    "source_file": "src/components/search/SearchOverlay.jsx",
    "multiline": false
  },
  {
    "id": "search_overlay_close_btn",
    "page": "header",
    "type": "text",
    "label": "Such-Overlay Schließen Button",
    "defaultValue": "Schließen (ESC)",
    "default_value": "Schließen (ESC)",
    "sourceFile": "src/components/search/SearchOverlay.jsx",
    "source_file": "src/components/search/SearchOverlay.jsx",
    "multiline": false
  },
  {
    "id": "search_overlay_esc_hint",
    "page": "header",
    "type": "text",
    "label": "Such-Overlay ESC Taste",
    "defaultValue": "ESC zum Schließen",
    "default_value": "ESC zum Schließen",
    "sourceFile": "src/components/search/SearchOverlay.jsx",
    "source_file": "src/components/search/SearchOverlay.jsx",
    "multiline": false
  },
  {
    "id": "hero_title",
    "page": "home",
    "type": "text",
    "label": "Hero-Titel",
    "defaultValue": "Sicherheitstechnik direkt finden & disponieren.",
    "default_value": "Sicherheitstechnik direkt finden & disponieren.",
    "sourceFile": "src/features/home/HomeView.jsx",
    "source_file": "src/features/home/HomeView.jsx",
    "multiline": false
  },
  {
    "id": "hero_subtitle",
    "page": "home",
    "type": "text",
    "label": "Hero-Untertitel",
    "defaultValue": "Gezielte SKU-, Hersteller- und Artikelsuche im Fachgroßhandelsbestand für Errichter und Fachplaner.",
    "default_value": "Gezielte SKU-, Hersteller- und Artikelsuche im Fachgroßhandelsbestand für Errichter und Fachplaner.",
    "sourceFile": "src/features/home/HomeView.jsx",
    "source_file": "src/features/home/HomeView.jsx",
    "multiline": false
  },
  {
    "id": "hero_cta_primary",
    "page": "home",
    "type": "text",
    "label": "Hero-CTA 1: Gesamten Katalog durchsuchen",
    "defaultValue": "Gesamten Katalog durchsuchen",
    "default_value": "Gesamten Katalog durchsuchen",
    "sourceFile": "src/features/home/HomeView.jsx",
    "source_file": "src/features/home/HomeView.jsx",
    "multiline": false
  },
  {
    "id": "hero_cta_secondary",
    "page": "home",
    "type": "text",
    "label": "Hero-CTA 2: Projekt anfragen",
    "defaultValue": "Projekt anfragen",
    "default_value": "Projekt anfragen",
    "sourceFile": "src/features/home/HomeView.jsx",
    "source_file": "src/features/home/HomeView.jsx",
    "multiline": false
  },
  {
    "id": "trust_1_title",
    "page": "home",
    "type": "text",
    "label": "Vertrauenspunkt 1 (Fachberatung) – Titel",
    "defaultValue": "Fachberatung",
    "default_value": "Fachberatung",
    "sourceFile": "src/features/home/HomeView.jsx",
    "source_file": "src/features/home/HomeView.jsx",
    "multiline": false
  },
  {
    "id": "trust_1_desc",
    "page": "home",
    "type": "text",
    "label": "Vertrauenspunkt 1 (Fachberatung) – Beschreibung",
    "defaultValue": "Fachliche Beratung durch Ihren Fachpartner.",
    "default_value": "Fachliche Beratung durch Ihren Fachpartner.",
    "sourceFile": "src/features/home/HomeView.jsx",
    "source_file": "src/features/home/HomeView.jsx",
    "multiline": false
  },
  {
    "id": "trust_2_title",
    "page": "home",
    "type": "text",
    "label": "Vertrauenspunkt 2 (B2B-Sortiment) – Titel",
    "defaultValue": "B2B-Sortiment",
    "default_value": "B2B-Sortiment",
    "sourceFile": "src/features/home/HomeView.jsx",
    "source_file": "src/features/home/HomeView.jsx",
    "multiline": false
  },
  {
    "id": "trust_2_desc",
    "page": "home",
    "type": "text",
    "label": "Vertrauenspunkt 2 (B2B-Sortiment) – Beschreibung",
    "defaultValue": "Fachartikel für Sicherheitstechnik.",
    "default_value": "Fachartikel für Sicherheitstechnik.",
    "sourceFile": "src/features/home/HomeView.jsx",
    "source_file": "src/features/home/HomeView.jsx",
    "multiline": false
  },
  {
    "id": "trust_3_title",
    "page": "home",
    "type": "text",
    "label": "Vertrauenspunkt 3 (Projektanfragen) – Titel",
    "defaultValue": "Projektanfragen",
    "default_value": "Projektanfragen",
    "sourceFile": "src/features/home/HomeView.jsx",
    "source_file": "src/features/home/HomeView.jsx",
    "multiline": false
  },
  {
    "id": "trust_3_desc",
    "page": "home",
    "type": "text",
    "label": "Vertrauenspunkt 3 (Projektanfragen) – Beschreibung",
    "defaultValue": "Fachspezifische Konditionen und unverbindliche Projektanfragen.",
    "default_value": "Fachspezifische Konditionen und unverbindliche Projektanfragen.",
    "sourceFile": "src/features/home/HomeView.jsx",
    "source_file": "src/features/home/HomeView.jsx",
    "multiline": false
  },
  {
    "id": "section_categories_title",
    "page": "home",
    "type": "text",
    "label": "Abschnitt „Fachbereiche“ – Titel",
    "defaultValue": "Fachbereiche wählen",
    "default_value": "Fachbereiche wählen",
    "sourceFile": "src/features/home/HomeView.jsx",
    "source_file": "src/features/home/HomeView.jsx",
    "multiline": false
  },
  {
    "id": "section_categories_subtitle",
    "page": "home",
    "type": "text",
    "label": "Abschnitt „Fachbereiche“ – Untertitel",
    "defaultValue": "Wählen Sie den passenden Systembereich für Ihr Sicherheitsprojekt.",
    "default_value": "Wählen Sie den passenden Systembereich für Ihr Sicherheitsprojekt.",
    "sourceFile": "src/features/home/HomeView.jsx",
    "source_file": "src/features/home/HomeView.jsx",
    "multiline": false
  },
  {
    "id": "hero_background",
    "page": "home",
    "type": "image",
    "label": "Hero-Hintergrundbild",
    "defaultValue": "",
    "default_value": "",
    "sourceFile": "src/features/home/HomeView.jsx",
    "source_file": "src/features/home/HomeView.jsx",
    "multiline": false
  },
  {
    "id": "hero_background_strength",
    "page": "home",
    "type": "text",
    "label": "Hero-Hintergrund-Deckkraft",
    "defaultValue": "0.5",
    "default_value": "0.5",
    "sourceFile": "src/features/home/HomeView.jsx",
    "source_file": "src/features/home/HomeView.jsx",
    "multiline": false
  },
  {
    "id": "home_section_brands_title",
    "page": "home",
    "type": "text",
    "label": "Hersteller Sektion Titel",
    "defaultValue": "Führende Hersteller im Großhandelsportfolio",
    "default_value": "Führende Hersteller im Großhandelsportfolio",
    "sourceFile": "src/features/home/HomeView.jsx",
    "source_file": "src/features/home/HomeView.jsx",
    "multiline": false
  },
  {
    "id": "home_section_brands_subtitle",
    "page": "home",
    "type": "text",
    "label": "Hersteller Sektion Untertitel",
    "defaultValue": "Zertifizierte Markenqualität für anspruchsvolle Sicherheitsprojekte.",
    "default_value": "Zertifizierte Markenqualität für anspruchsvolle Sicherheitsprojekte.",
    "sourceFile": "src/features/home/HomeView.jsx",
    "source_file": "src/features/home/HomeView.jsx",
    "multiline": false
  },
  {
    "id": "home_section_cta_title",
    "page": "home",
    "type": "text",
    "label": "Abschluss CTA Titel",
    "defaultValue": "Sie planen ein größeres Sicherheitsprojekt?",
    "default_value": "Sie planen ein größeres Sicherheitsprojekt?",
    "sourceFile": "src/features/home/HomeView.jsx",
    "source_file": "src/features/home/HomeView.jsx",
    "multiline": false
  },
  {
    "id": "home_section_cta_desc",
    "page": "home",
    "type": "text",
    "label": "Abschluss CTA Beschreibung",
    "defaultValue": "Nutzen Sie unseren Projektierungsservice. Wir unterstützen Sie bei Ausschreibungen, Stücklisten und individuellen Staffelpreisen.",
    "default_value": "Nutzen Sie unseren Projektierungsservice. Wir unterstützen Sie bei Ausschreibungen, Stücklisten und individuellen Staffelpreisen.",
    "sourceFile": "src/features/home/HomeView.jsx",
    "source_file": "src/features/home/HomeView.jsx",
    "multiline": true
  },
  {
    "id": "home_section_cta_btn",
    "page": "home",
    "type": "text",
    "label": "Abschluss CTA Button",
    "defaultValue": "Jetzt unverbindlich anfragen",
    "default_value": "Jetzt unverbindlich anfragen",
    "sourceFile": "src/features/home/HomeView.jsx",
    "source_file": "src/features/home/HomeView.jsx",
    "multiline": false
  },
  {
    "id": "home_advisor_teaser_title",
    "page": "home",
    "type": "text",
    "label": "Berater Teaser Titel",
    "defaultValue": "Unsicher bei der Produktauswahl?",
    "default_value": "Unsicher bei der Produktauswahl?",
    "sourceFile": "src/features/home/HomeView.jsx",
    "source_file": "src/features/home/HomeView.jsx",
    "multiline": false
  },
  {
    "id": "home_advisor_teaser_desc",
    "page": "home",
    "type": "text",
    "label": "Berater Teaser Text",
    "defaultValue": "Unser digitaler Sicherheitsberater führt Sie in 4 Schritten zur passenden Lösung.",
    "default_value": "Unser digitaler Sicherheitsberater führt Sie in 4 Schritten zur passenden Lösung.",
    "sourceFile": "src/features/home/HomeView.jsx",
    "source_file": "src/features/home/HomeView.jsx",
    "multiline": false
  },
  {
    "id": "home_advisor_teaser_btn",
    "page": "home",
    "type": "text",
    "label": "Berater Teaser Button",
    "defaultValue": "Bedarfsberater starten",
    "default_value": "Bedarfsberater starten",
    "sourceFile": "src/features/home/HomeView.jsx",
    "source_file": "src/features/home/HomeView.jsx",
    "multiline": false
  },
  {
    "id": "hero_split_spotlight_badge",
    "page": "home",
    "type": "text",
    "label": "Split Hero Spotlight Badge",
    "defaultValue": "Partner-Spotlight",
    "default_value": "Partner-Spotlight",
    "sourceFile": "src/registry/components/heroes/SplitFeaturedHero.jsx",
    "source_file": "src/registry/components/heroes/SplitFeaturedHero.jsx",
    "multiline": false
  },
  {
    "id": "hero_split_stat1_label",
    "page": "home",
    "type": "text",
    "label": "Split Hero Statistik 1 Label",
    "defaultValue": "Verfügbare Fachartikel",
    "default_value": "Verfügbare Fachartikel",
    "sourceFile": "src/registry/components/heroes/SplitFeaturedHero.jsx",
    "source_file": "src/registry/components/heroes/SplitFeaturedHero.jsx",
    "multiline": false
  },
  {
    "id": "hero_split_stat1_val",
    "page": "home",
    "type": "text",
    "label": "Split Hero Statistik 1 Wert",
    "defaultValue": "1.400+",
    "default_value": "1.400+",
    "sourceFile": "src/registry/components/heroes/SplitFeaturedHero.jsx",
    "source_file": "src/registry/components/heroes/SplitFeaturedHero.jsx",
    "multiline": false
  },
  {
    "id": "hero_split_stat2_label",
    "page": "home",
    "type": "text",
    "label": "Split Hero Statistik 2 Label",
    "defaultValue": "Zertifizierte Hersteller",
    "default_value": "Zertifizierte Hersteller",
    "sourceFile": "src/registry/components/heroes/SplitFeaturedHero.jsx",
    "source_file": "src/registry/components/heroes/SplitFeaturedHero.jsx",
    "multiline": false
  },
  {
    "id": "hero_split_stat2_val",
    "page": "home",
    "type": "text",
    "label": "Split Hero Statistik 2 Wert",
    "defaultValue": "40+",
    "default_value": "40+",
    "sourceFile": "src/registry/components/heroes/SplitFeaturedHero.jsx",
    "source_file": "src/registry/components/heroes/SplitFeaturedHero.jsx",
    "multiline": false
  },
  {
    "id": "hero_split_stat3_label",
    "page": "home",
    "type": "text",
    "label": "Split Hero Statistik 3 Label",
    "defaultValue": "Lieferfähigkeit ab Lager",
    "default_value": "Lieferfähigkeit ab Lager",
    "sourceFile": "src/registry/components/heroes/SplitFeaturedHero.jsx",
    "source_file": "src/registry/components/heroes/SplitFeaturedHero.jsx",
    "multiline": false
  },
  {
    "id": "hero_split_stat3_val",
    "page": "home",
    "type": "text",
    "label": "Split Hero Statistik 3 Wert",
    "defaultValue": "24h",
    "default_value": "24h",
    "sourceFile": "src/registry/components/heroes/SplitFeaturedHero.jsx",
    "source_file": "src/registry/components/heroes/SplitFeaturedHero.jsx",
    "multiline": false
  },
  {
    "id": "hero_split_card_title",
    "page": "home",
    "type": "text",
    "label": "Split Hero Spotlight Titel",
    "defaultValue": "Top-Empfehlung der Woche",
    "default_value": "Top-Empfehlung der Woche",
    "sourceFile": "src/registry/components/heroes/SplitFeaturedHero.jsx",
    "source_file": "src/registry/components/heroes/SplitFeaturedHero.jsx",
    "multiline": false
  },
  {
    "id": "hero_split_card_sku_prefix",
    "page": "home",
    "type": "text",
    "label": "Split Hero Spotlight SKU",
    "defaultValue": "Art.-Nr.:",
    "default_value": "Art.-Nr.:",
    "sourceFile": "src/registry/components/heroes/SplitFeaturedHero.jsx",
    "source_file": "src/registry/components/heroes/SplitFeaturedHero.jsx",
    "multiline": false
  },
  {
    "id": "hero_split_card_price_label",
    "page": "home",
    "type": "text",
    "label": "Split Hero Spotlight Preis",
    "defaultValue": "Preis",
    "default_value": "Preis",
    "sourceFile": "src/registry/components/heroes/SplitFeaturedHero.jsx",
    "source_file": "src/registry/components/heroes/SplitFeaturedHero.jsx",
    "multiline": false
  },
  {
    "id": "hero_split_card_cart_btn",
    "page": "home",
    "type": "text",
    "label": "Split Hero Spotlight Korb CTA",
    "defaultValue": "In den Anfragekorb",
    "default_value": "In den Anfragekorb",
    "sourceFile": "src/registry/components/heroes/SplitFeaturedHero.jsx",
    "source_file": "src/registry/components/heroes/SplitFeaturedHero.jsx",
    "multiline": false
  },
  {
    "id": "hero_grid_partner_badge",
    "page": "home",
    "type": "text",
    "label": "Grid Hero Partner Badge",
    "defaultValue": "Autorisierter Fachpartner",
    "default_value": "Autorisierter Fachpartner",
    "sourceFile": "src/registry/components/heroes/HighlightGridHero.jsx",
    "source_file": "src/registry/components/heroes/HighlightGridHero.jsx",
    "multiline": false
  },
  {
    "id": "hero_grid_primary_cta",
    "page": "home",
    "type": "text",
    "label": "Grid Hero Primär CTA",
    "defaultValue": "Gesamten Katalog öffnen",
    "default_value": "Gesamten Katalog öffnen",
    "sourceFile": "src/registry/components/heroes/HighlightGridHero.jsx",
    "source_file": "src/registry/components/heroes/HighlightGridHero.jsx",
    "multiline": false
  },
  {
    "id": "hero_grid_secondary_cta",
    "page": "home",
    "type": "text",
    "label": "Grid Hero Sekundär CTA",
    "defaultValue": "Projektangebot anfragen",
    "default_value": "Projektangebot anfragen",
    "sourceFile": "src/registry/components/heroes/HighlightGridHero.jsx",
    "source_file": "src/registry/components/heroes/HighlightGridHero.jsx",
    "multiline": false
  },
  {
    "id": "hero_grid_card1_title",
    "page": "home",
    "type": "text",
    "label": "Grid Kachel 1 Titel",
    "defaultValue": "Videoüberwachung",
    "default_value": "Videoüberwachung",
    "sourceFile": "src/registry/components/heroes/HighlightGridHero.jsx",
    "source_file": "src/registry/components/heroes/HighlightGridHero.jsx",
    "multiline": false
  },
  {
    "id": "hero_grid_card1_desc",
    "page": "home",
    "type": "text",
    "label": "Grid Kachel 1 Text",
    "defaultValue": "IP-Kameras & Rekorder",
    "default_value": "IP-Kameras & Rekorder",
    "sourceFile": "src/registry/components/heroes/HighlightGridHero.jsx",
    "source_file": "src/registry/components/heroes/HighlightGridHero.jsx",
    "multiline": false
  },
  {
    "id": "hero_grid_card2_title",
    "page": "home",
    "type": "text",
    "label": "Grid Kachel 2 Titel",
    "defaultValue": "Gefahrenmeldetechnik",
    "default_value": "Gefahrenmeldetechnik",
    "sourceFile": "src/registry/components/heroes/HighlightGridHero.jsx",
    "source_file": "src/registry/components/heroes/HighlightGridHero.jsx",
    "multiline": false
  },
  {
    "id": "hero_grid_card2_desc",
    "page": "home",
    "type": "text",
    "label": "Grid Kachel 2 Text",
    "defaultValue": "Einbruch- & Funkmelder",
    "default_value": "Einbruch- & Funkmelder",
    "sourceFile": "src/registry/components/heroes/HighlightGridHero.jsx",
    "source_file": "src/registry/components/heroes/HighlightGridHero.jsx",
    "multiline": false
  },
  {
    "id": "hero_grid_card3_title",
    "page": "home",
    "type": "text",
    "label": "Grid Kachel 3 Titel",
    "defaultValue": "Zutrittskontrolle",
    "default_value": "Zutrittskontrolle",
    "sourceFile": "src/registry/components/heroes/HighlightGridHero.jsx",
    "source_file": "src/registry/components/heroes/HighlightGridHero.jsx",
    "multiline": false
  },
  {
    "id": "hero_grid_card3_desc",
    "page": "home",
    "type": "text",
    "label": "Grid Kachel 3 Text",
    "defaultValue": "RFID & Biometrie",
    "default_value": "RFID & Biometrie",
    "sourceFile": "src/registry/components/heroes/HighlightGridHero.jsx",
    "source_file": "src/registry/components/heroes/HighlightGridHero.jsx",
    "multiline": false
  },
  {
    "id": "hero_grid_card4_title",
    "page": "home",
    "type": "text",
    "label": "Grid Kachel 4 Titel",
    "defaultValue": "Brandmeldetechnik",
    "default_value": "Brandmeldetechnik",
    "sourceFile": "src/registry/components/heroes/HighlightGridHero.jsx",
    "source_file": "src/registry/components/heroes/HighlightGridHero.jsx",
    "multiline": false
  },
  {
    "id": "hero_grid_card4_desc",
    "page": "home",
    "type": "text",
    "label": "Grid Kachel 4 Text",
    "defaultValue": "DIN 14675 / EN54 BMA",
    "default_value": "DIN 14675 / EN54 BMA",
    "sourceFile": "src/registry/components/heroes/HighlightGridHero.jsx",
    "source_file": "src/registry/components/heroes/HighlightGridHero.jsx",
    "multiline": false
  },
  {
    "id": "hero_portal_badge",
    "page": "home",
    "type": "text",
    "label": "Portal Hero Badge",
    "defaultValue": "1.472 geprüfte ASL-Artikel",
    "default_value": "1.472 geprüfte ASL-Artikel",
    "sourceFile": "src/registry/components/heroes/PortalSearchHero.jsx",
    "source_file": "src/registry/components/heroes/PortalSearchHero.jsx",
    "multiline": false
  },
  {
    "id": "hero_portal_search_btn",
    "page": "home",
    "type": "text",
    "label": "Portal Hero Suche Button",
    "defaultValue": "Finden",
    "default_value": "Finden",
    "sourceFile": "src/registry/components/heroes/PortalSearchHero.jsx",
    "source_file": "src/registry/components/heroes/PortalSearchHero.jsx",
    "multiline": false
  },
  {
    "id": "hero_portal_chip_video",
    "page": "home",
    "type": "text",
    "label": "Portal Shortcut Video",
    "defaultValue": "IP-Kameras",
    "default_value": "IP-Kameras",
    "sourceFile": "src/registry/components/heroes/PortalSearchHero.jsx",
    "source_file": "src/registry/components/heroes/PortalSearchHero.jsx",
    "multiline": false
  },
  {
    "id": "hero_portal_chip_alarm",
    "page": "home",
    "type": "text",
    "label": "Portal Shortcut Alarm",
    "defaultValue": "Alarmzentralen",
    "default_value": "Alarmzentralen",
    "sourceFile": "src/registry/components/heroes/PortalSearchHero.jsx",
    "source_file": "src/registry/components/heroes/PortalSearchHero.jsx",
    "multiline": false
  },
  {
    "id": "hero_portal_chip_fire",
    "page": "home",
    "type": "text",
    "label": "Portal Shortcut Brand",
    "defaultValue": "Brandmelder",
    "default_value": "Brandmelder",
    "sourceFile": "src/registry/components/heroes/PortalSearchHero.jsx",
    "source_file": "src/registry/components/heroes/PortalSearchHero.jsx",
    "multiline": false
  },
  {
    "id": "hero_portal_chip_access",
    "page": "home",
    "type": "text",
    "label": "Portal Shortcut Zutritt",
    "defaultValue": "Zutrittsleser",
    "default_value": "Zutrittsleser",
    "sourceFile": "src/registry/components/heroes/PortalSearchHero.jsx",
    "source_file": "src/registry/components/heroes/PortalSearchHero.jsx",
    "multiline": false
  },
  {
    "id": "hero_portal_chip_power",
    "page": "home",
    "type": "text",
    "label": "Portal Shortcut Strom",
    "defaultValue": "Netzteile & USV",
    "default_value": "Netzteile & USV",
    "sourceFile": "src/registry/components/heroes/PortalSearchHero.jsx",
    "source_file": "src/registry/components/heroes/PortalSearchHero.jsx",
    "multiline": false
  },
  {
    "id": "category_img_alarm",
    "page": "home",
    "type": "image",
    "label": "Kategoriebild Alarmtechnik",
    "defaultValue": "",
    "default_value": "",
    "sourceFile": "src/features/home/HomeView.jsx",
    "source_file": "src/features/home/HomeView.jsx",
    "multiline": false
  },
  {
    "id": "category_img_video",
    "page": "home",
    "type": "image",
    "label": "Kategoriebild Videoüberwachung",
    "defaultValue": "",
    "default_value": "",
    "sourceFile": "src/features/home/HomeView.jsx",
    "source_file": "src/features/home/HomeView.jsx",
    "multiline": false
  },
  {
    "id": "category_img_brand",
    "page": "home",
    "type": "image",
    "label": "Kategoriebild Brandmeldetechnik",
    "defaultValue": "",
    "default_value": "",
    "sourceFile": "src/features/home/HomeView.jsx",
    "source_file": "src/features/home/HomeView.jsx",
    "multiline": false
  },
  {
    "id": "category_img_zutritt",
    "page": "home",
    "type": "image",
    "label": "Kategoriebild Zutrittskontrolle",
    "defaultValue": "",
    "default_value": "",
    "sourceFile": "src/features/home/HomeView.jsx",
    "source_file": "src/features/home/HomeView.jsx",
    "multiline": false
  },
  {
    "id": "category_img_strom",
    "page": "home",
    "type": "image",
    "label": "Kategoriebild Stromversorgung",
    "defaultValue": "",
    "default_value": "",
    "sourceFile": "src/features/home/HomeView.jsx",
    "source_file": "src/features/home/HomeView.jsx",
    "multiline": false
  },
  {
    "id": "footer_description",
    "page": "footer",
    "type": "text",
    "label": "Footer-Beschreibung",
    "defaultValue": "Ihr Partner für professionelle Sicherheitstechnik, Brandmeldetechnik und Systemlösungen.",
    "default_value": "Ihr Partner für professionelle Sicherheitstechnik, Brandmeldetechnik und Systemlösungen.",
    "sourceFile": "src/components/layout/ShellFooter.jsx",
    "source_file": "src/components/layout/ShellFooter.jsx",
    "multiline": false
  },
  {
    "id": "footer_partner_badge",
    "page": "footer",
    "type": "text",
    "label": "Partner-Badge Text",
    "defaultValue": "Fachpartner",
    "default_value": "Fachpartner",
    "sourceFile": "src/components/layout/ShellFooter.jsx",
    "source_file": "src/components/layout/ShellFooter.jsx",
    "multiline": false
  },
  {
    "id": "footer_b2b_notice",
    "page": "footer",
    "type": "text",
    "label": "B2B-Hinweis",
    "defaultValue": "Alle Preise zzgl. gesetzlicher MwSt. • Sicherheitstechnik für Zuhause und Betrieb",
    "default_value": "Alle Preise zzgl. gesetzlicher MwSt. • Sicherheitstechnik für Zuhause und Betrieb",
    "sourceFile": "src/components/layout/ShellFooter.jsx",
    "source_file": "src/components/layout/ShellFooter.jsx",
    "multiline": false
  },
  {
    "id": "footer_copyright",
    "page": "footer",
    "type": "text",
    "label": "Copyright-Hinweis",
    "defaultValue": "Alle Rechte vorbehalten.",
    "default_value": "Alle Rechte vorbehalten.",
    "sourceFile": "src/components/layout/ShellFooter.jsx",
    "source_file": "src/components/layout/ShellFooter.jsx",
    "multiline": false
  },
  {
    "id": "footer_col1_title",
    "page": "footer",
    "type": "text",
    "label": "Footer Spalte 1 Titel",
    "defaultValue": "Navigation & Katalog",
    "default_value": "Navigation & Katalog",
    "sourceFile": "src/components/layout/ShellFooter.jsx",
    "source_file": "src/components/layout/ShellFooter.jsx",
    "multiline": false
  },
  {
    "id": "footer_col2_title",
    "page": "footer",
    "type": "text",
    "label": "Footer Spalte 2 Titel",
    "defaultValue": "Rechtliches",
    "default_value": "Rechtliches",
    "sourceFile": "src/components/layout/ShellFooter.jsx",
    "source_file": "src/components/layout/ShellFooter.jsx",
    "multiline": false
  },
  {
    "id": "footer_col3_title",
    "page": "footer",
    "type": "text",
    "label": "Footer Spalte 3 Titel",
    "defaultValue": "Kontakt & Fachberatung",
    "default_value": "Kontakt & Fachberatung",
    "sourceFile": "src/components/layout/ShellFooter.jsx",
    "source_file": "src/components/layout/ShellFooter.jsx",
    "multiline": false
  },
  {
    "id": "footer_link_catalog",
    "page": "footer",
    "type": "text",
    "label": "Footer Link Katalog",
    "defaultValue": "Katalogübersicht",
    "default_value": "Katalogübersicht",
    "sourceFile": "src/components/layout/ShellFooter.jsx",
    "source_file": "src/components/layout/ShellFooter.jsx",
    "multiline": false
  },
  {
    "id": "footer_link_advisor",
    "page": "footer",
    "type": "text",
    "label": "Footer Link Berater",
    "defaultValue": "Sicherheitsberater",
    "default_value": "Sicherheitsberater",
    "sourceFile": "src/components/layout/ShellFooter.jsx",
    "source_file": "src/components/layout/ShellFooter.jsx",
    "multiline": false
  },
  {
    "id": "footer_link_inquiry",
    "page": "footer",
    "type": "text",
    "label": "Footer Link Projektanfrage",
    "defaultValue": "Projektanfrage",
    "default_value": "Projektanfrage",
    "sourceFile": "src/components/layout/ShellFooter.jsx",
    "source_file": "src/components/layout/ShellFooter.jsx",
    "multiline": false
  },
  {
    "id": "footer_link_imprint",
    "page": "footer",
    "type": "text",
    "label": "Footer Link Impressum",
    "defaultValue": "Impressum",
    "default_value": "Impressum",
    "sourceFile": "src/components/layout/ShellFooter.jsx",
    "source_file": "src/components/layout/ShellFooter.jsx",
    "multiline": false
  },
  {
    "id": "footer_link_privacy",
    "page": "footer",
    "type": "text",
    "label": "Footer Link Datenschutz",
    "defaultValue": "Datenschutzerklärung",
    "default_value": "Datenschutzerklärung",
    "sourceFile": "src/components/layout/ShellFooter.jsx",
    "source_file": "src/components/layout/ShellFooter.jsx",
    "multiline": false
  },
  {
    "id": "footer_link_agb",
    "page": "footer",
    "type": "text",
    "label": "Footer Link AGB",
    "defaultValue": "AGB & Widerrufsbelehrung",
    "default_value": "AGB & Widerrufsbelehrung",
    "sourceFile": "src/components/layout/ShellFooter.jsx",
    "source_file": "src/components/layout/ShellFooter.jsx",
    "multiline": false
  },
  {
    "id": "footer_link_shipping",
    "page": "footer",
    "type": "text",
    "label": "Footer Link Versand",
    "defaultValue": "Versand & Lieferung",
    "default_value": "Versand & Lieferung",
    "sourceFile": "src/components/layout/ShellFooter.jsx",
    "source_file": "src/components/layout/ShellFooter.jsx",
    "multiline": false
  },
  {
    "id": "footer_contact_phone_label",
    "page": "footer",
    "type": "text",
    "label": "Footer Kontakt Telefon Label",
    "defaultValue": "Telefon:",
    "default_value": "Telefon:",
    "sourceFile": "src/components/layout/ShellFooter.jsx",
    "source_file": "src/components/layout/ShellFooter.jsx",
    "multiline": false
  },
  {
    "id": "footer_contact_email_label",
    "page": "footer",
    "type": "text",
    "label": "Footer Kontakt E-Mail Label",
    "defaultValue": "E-Mail:",
    "default_value": "E-Mail:",
    "sourceFile": "src/components/layout/ShellFooter.jsx",
    "source_file": "src/components/layout/ShellFooter.jsx",
    "multiline": false
  },
  {
    "id": "footer_contact_hours_label",
    "page": "footer",
    "type": "text",
    "label": "Footer Geschäftszeiten Label",
    "defaultValue": "Mo.–Fr. 08:00 – 17:00 Uhr",
    "default_value": "Mo.–Fr. 08:00 – 17:00 Uhr",
    "sourceFile": "src/components/layout/ShellFooter.jsx",
    "source_file": "src/components/layout/ShellFooter.jsx",
    "multiline": false
  },
  {
    "id": "footer_asl_association_notice",
    "page": "footer",
    "type": "text",
    "label": "Footer ASL Verbandshinweis",
    "defaultValue": "ASL Großhandelspartner-Netzwerk",
    "default_value": "ASL Großhandelspartner-Netzwerk",
    "sourceFile": "src/components/layout/ShellFooter.jsx",
    "source_file": "src/components/layout/ShellFooter.jsx",
    "multiline": false
  },
  {
    "id": "footer_all_rights_reserved",
    "page": "footer",
    "type": "text",
    "label": "Footer Alle Rechte vorbehalten",
    "defaultValue": "Alle Rechte vorbehalten.",
    "default_value": "Alle Rechte vorbehalten.",
    "sourceFile": "src/components/layout/ShellFooter.jsx",
    "source_file": "src/components/layout/ShellFooter.jsx",
    "multiline": false
  },
  {
    "id": "footer_secure_ordering_hint",
    "page": "footer",
    "type": "text",
    "label": "Footer Sichere Übertragung",
    "defaultValue": "Verschlüsselte Datenübertragung (SSL/TLS)",
    "default_value": "Verschlüsselte Datenübertragung (SSL/TLS)",
    "sourceFile": "src/components/layout/ShellFooter.jsx",
    "source_file": "src/components/layout/ShellFooter.jsx",
    "multiline": false
  },
  {
    "id": "imprint_title",
    "page": "legal",
    "type": "text",
    "label": "Impressum – Titel",
    "defaultValue": "Impressum",
    "default_value": "Impressum",
    "sourceFile": "src/features/legal/LegalInfoView.jsx",
    "source_file": "src/features/legal/LegalInfoView.jsx",
    "multiline": false
  },
  {
    "id": "imprint_content",
    "page": "legal",
    "type": "text",
    "label": "Impressum – Inhalt",
    "defaultValue": "Dies ist ein unverbindlicher Demo-Platzhalter für das Impressum. Die Angaben gemäß § 5 DDG werden durch den jeweiligen Fachpartner vor Inbetriebnahme eingepflegt.",
    "default_value": "Dies ist ein unverbindlicher Demo-Platzhalter für das Impressum. Die Angaben gemäß § 5 DDG werden durch den jeweiligen Fachpartner vor Inbetriebnahme eingepflegt.",
    "sourceFile": "src/features/legal/LegalInfoView.jsx",
    "source_file": "src/features/legal/LegalInfoView.jsx",
    "multiline": true
  },
  {
    "id": "privacy_title",
    "page": "legal",
    "type": "text",
    "label": "Datenschutz – Titel",
    "defaultValue": "Datenschutzerklärung",
    "default_value": "Datenschutzerklärung",
    "sourceFile": "src/features/legal/LegalInfoView.jsx",
    "source_file": "src/features/legal/LegalInfoView.jsx",
    "multiline": false
  },
  {
    "id": "privacy_content",
    "page": "legal",
    "type": "text",
    "label": "Datenschutz – Inhalt",
    "defaultValue": "Dies ist ein unverbindlicher Demo-Platzhalter für die Datenschutzerklärung. Die Pflichtangaben gemäß DSGVO werden durch den jeweiligen Fachpartner vor Inbetriebnahme hinterlegt.",
    "default_value": "Dies ist ein unverbindlicher Demo-Platzhalter für die Datenschutzerklärung. Die Pflichtangaben gemäß DSGVO werden durch den jeweiligen Fachpartner vor Inbetriebnahme hinterlegt.",
    "sourceFile": "src/features/legal/LegalInfoView.jsx",
    "source_file": "src/features/legal/LegalInfoView.jsx",
    "multiline": true
  },
  {
    "id": "agb_title",
    "page": "legal",
    "type": "text",
    "label": "AGB & Widerruf – Titel",
    "defaultValue": "Allgemeine Geschäftsbedingungen & Widerrufsbelehrung",
    "default_value": "Allgemeine Geschäftsbedingungen & Widerrufsbelehrung",
    "sourceFile": "src/features/legal/LegalInfoView.jsx",
    "source_file": "src/features/legal/LegalInfoView.jsx",
    "multiline": false
  },
  {
    "id": "agb_content",
    "page": "legal",
    "type": "text",
    "label": "AGB & Widerruf – Inhalt",
    "defaultValue": "Dies ist ein unverbindlicher Demo-Platzhalter für die Allgemeinen Geschäftsbedingungen (AGB) und Widerrufsinformationen. Die vertraglichen Bestimmungen für den B2B-Fachvertrieb werden durch den jeweiligen Fachpartner hinterlegt.",
    "default_value": "Dies ist ein unverbindlicher Demo-Platzhalter für die Allgemeinen Geschäftsbedingungen (AGB) und Widerrufsinformationen. Die vertraglichen Bestimmungen für den B2B-Fachvertrieb werden durch den jeweiligen Fachpartner hinterlegt.",
    "sourceFile": "src/features/legal/LegalInfoView.jsx",
    "source_file": "src/features/legal/LegalInfoView.jsx",
    "multiline": true
  },
  {
    "id": "shipping_title",
    "page": "legal",
    "type": "text",
    "label": "Versand & Lieferung – Titel",
    "defaultValue": "Versand- & Lieferbedingungen",
    "default_value": "Versand- & Lieferbedingungen",
    "sourceFile": "src/features/legal/LegalInfoView.jsx",
    "source_file": "src/features/legal/LegalInfoView.jsx",
    "multiline": false
  },
  {
    "id": "shipping_content",
    "page": "legal",
    "type": "text",
    "label": "Versand & Lieferung – Inhalt",
    "defaultValue": "Dies ist ein unverbindlicher Demo-Platzhalter für Versand- und Lieferkonditionen. Angaben zu Lieferzeiten, Versandkosten, Spedition und Selbstabholung werden durch den jeweiligen Fachpartner hinterlegt.",
    "default_value": "Dies ist ein unverbindlicher Demo-Platzhalter für Versand- und Lieferkonditionen. Angaben zu Lieferzeiten, Versandkosten, Spedition und Selbstabholung werden durch den jeweiligen Fachpartner hinterlegt.",
    "sourceFile": "src/features/legal/LegalInfoView.jsx",
    "source_file": "src/features/legal/LegalInfoView.jsx",
    "multiline": true
  },
  {
    "id": "legal_demo_banner_title",
    "page": "legal",
    "type": "text",
    "label": "Rechtstexte Demo Warnung Titel",
    "defaultValue": "Demo-Inhalt — Unverbindliche Platzhalter",
    "default_value": "Demo-Inhalt — Unverbindliche Platzhalter",
    "sourceFile": "src/features/legal/LegalInfoView.jsx",
    "source_file": "src/features/legal/LegalInfoView.jsx",
    "multiline": false
  },
  {
    "id": "legal_demo_banner_text",
    "page": "legal",
    "type": "text",
    "label": "Rechtstexte Demo Warnung Text",
    "defaultValue": "Die nachfolgenden Texte sind unverbindliche Mustertexte und müssen vor dem Echtbetrieb durch den Betreiber / Partner an die tatsächlichen Gegebenheiten angepasst werden.",
    "default_value": "Die nachfolgenden Texte sind unverbindliche Mustertexte und müssen vor dem Echtbetrieb durch den Betreiber / Partner an die tatsächlichen Gegebenheiten angepasst werden.",
    "sourceFile": "src/features/legal/LegalInfoView.jsx",
    "source_file": "src/features/legal/LegalInfoView.jsx",
    "multiline": true
  },
  {
    "id": "legal_back_to_shop",
    "page": "legal",
    "type": "text",
    "label": "Zurück zum Shop Button",
    "defaultValue": "Zurück zum Shop",
    "default_value": "Zurück zum Shop",
    "sourceFile": "src/features/legal/LegalInfoView.jsx",
    "source_file": "src/features/legal/LegalInfoView.jsx",
    "multiline": false
  },
  {
    "id": "legal_last_updated_prefix",
    "page": "legal",
    "type": "text",
    "label": "Zuletzt aktualisiert Präfix",
    "defaultValue": "Stand:",
    "default_value": "Stand:",
    "sourceFile": "src/features/legal/LegalInfoView.jsx",
    "source_file": "src/features/legal/LegalInfoView.jsx",
    "multiline": false
  },
  {
    "id": "legal_tab_imprint",
    "page": "legal",
    "type": "text",
    "label": "Tab Impressum",
    "defaultValue": "Impressum (§ 5 DDG)",
    "default_value": "Impressum (§ 5 DDG)",
    "sourceFile": "src/features/legal/LegalInfoView.jsx",
    "source_file": "src/features/legal/LegalInfoView.jsx",
    "multiline": false
  },
  {
    "id": "legal_tab_privacy",
    "page": "legal",
    "type": "text",
    "label": "Tab Datenschutz",
    "defaultValue": "Datenschutz (DSGVO)",
    "default_value": "Datenschutz (DSGVO)",
    "sourceFile": "src/features/legal/LegalInfoView.jsx",
    "source_file": "src/features/legal/LegalInfoView.jsx",
    "multiline": false
  },
  {
    "id": "legal_tab_agb",
    "page": "legal",
    "type": "text",
    "label": "Tab AGB",
    "defaultValue": "AGB & Widerruf",
    "default_value": "AGB & Widerruf",
    "sourceFile": "src/features/legal/LegalInfoView.jsx",
    "source_file": "src/features/legal/LegalInfoView.jsx",
    "multiline": false
  },
  {
    "id": "legal_tab_shipping",
    "page": "legal",
    "type": "text",
    "label": "Tab Versand",
    "defaultValue": "Versand & Logistik",
    "default_value": "Versand & Logistik",
    "sourceFile": "src/features/legal/LegalInfoView.jsx",
    "source_file": "src/features/legal/LegalInfoView.jsx",
    "multiline": false
  },
  {
    "id": "legal_b2b_only_clause",
    "page": "legal",
    "type": "text",
    "label": "B2B Klausel Hinweis",
    "defaultValue": "Dieser Shop richtet sich an Privatkunden und Unternehmen.",
    "default_value": "Dieser Shop richtet sich an Privatkunden und Unternehmen.",
    "sourceFile": "src/features/legal/LegalInfoView.jsx",
    "source_file": "src/features/legal/LegalInfoView.jsx",
    "multiline": true
  },
  {
    "id": "legal_contact_representative",
    "page": "legal",
    "type": "text",
    "label": "Vertretungsberechtigter Label",
    "defaultValue": "Vertretungsberechtigte Geschäftsführung:",
    "default_value": "Vertretungsberechtigte Geschäftsführung:",
    "sourceFile": "src/features/legal/LegalInfoView.jsx",
    "source_file": "src/features/legal/LegalInfoView.jsx",
    "multiline": false
  },
  {
    "id": "legal_register_court_label",
    "page": "legal",
    "type": "text",
    "label": "Registergericht Label",
    "defaultValue": "Registergericht & Registernummer:",
    "default_value": "Registergericht & Registernummer:",
    "sourceFile": "src/features/legal/LegalInfoView.jsx",
    "source_file": "src/features/legal/LegalInfoView.jsx",
    "multiline": false
  },
  {
    "id": "legal_vat_id_label",
    "page": "legal",
    "type": "text",
    "label": "USt-IdNr Label",
    "defaultValue": "Umsatzsteuer-Identifikationsnummer:",
    "default_value": "Umsatzsteuer-Identifikationsnummer:",
    "sourceFile": "src/features/legal/LegalInfoView.jsx",
    "source_file": "src/features/legal/LegalInfoView.jsx",
    "multiline": false
  },
  {
    "id": "copilot_drawer_title",
    "page": "copilot",
    "type": "text",
    "label": "Copilot Drawer Titel",
    "defaultValue": "ALWIS KI-Projektassistent",
    "default_value": "ALWIS KI-Projektassistent",
    "sourceFile": "src/components/copilot/CopilotDrawer.jsx",
    "source_file": "src/components/copilot/CopilotDrawer.jsx",
    "multiline": false
  },
  {
    "id": "copilot_drawer_subtitle",
    "page": "copilot",
    "type": "text",
    "label": "Copilot Drawer Untertitel",
    "defaultValue": "Fachberatung zu Artikeln, Kompatibilität und Normen.",
    "default_value": "Fachberatung zu Artikeln, Kompatibilität und Normen.",
    "sourceFile": "src/components/copilot/CopilotDrawer.jsx",
    "source_file": "src/components/copilot/CopilotDrawer.jsx",
    "multiline": false
  },
  {
    "id": "copilot_welcome_msg",
    "page": "copilot",
    "type": "text",
    "label": "Copilot Willkommensnachricht",
    "defaultValue": "Hallo! Ich bin ALWIS, Ihr KI-Experte für Sicherheitstechnik. Wie kann ich Sie bei Ihrer Projektierung unterstützen?",
    "default_value": "Hallo! Ich bin ALWIS, Ihr KI-Experte für Sicherheitstechnik. Wie kann ich Sie bei Ihrer Projektierung unterstützen?",
    "sourceFile": "src/components/copilot/CopilotDrawer.jsx",
    "source_file": "src/components/copilot/CopilotDrawer.jsx",
    "multiline": true
  },
  {
    "id": "copilot_suggest_prompt1",
    "page": "copilot",
    "type": "text",
    "label": "Copilot Vorschlag 1",
    "defaultValue": "Welche Kameras eignen sich für Außenbereiche bei Nacht?",
    "default_value": "Welche Kameras eignen sich für Außenbereiche bei Nacht?",
    "sourceFile": "src/components/copilot/CopilotDrawer.jsx",
    "source_file": "src/components/copilot/CopilotDrawer.jsx",
    "multiline": false
  },
  {
    "id": "copilot_suggest_prompt2",
    "page": "copilot",
    "type": "text",
    "label": "Copilot Vorschlag 2",
    "defaultValue": "Welche VdS-Klasse brauche ich für ein Gewerbeobjekt?",
    "default_value": "Welche VdS-Klasse brauche ich für ein Gewerbeobjekt?",
    "sourceFile": "src/components/copilot/CopilotDrawer.jsx",
    "source_file": "src/components/copilot/CopilotDrawer.jsx",
    "multiline": false
  },
  {
    "id": "copilot_suggest_prompt3",
    "page": "copilot",
    "type": "text",
    "label": "Copilot Vorschlag 3",
    "defaultValue": "Gibt es kompatible Netzteile für Brandmelder?",
    "default_value": "Gibt es kompatible Netzteile für Brandmelder?",
    "sourceFile": "src/components/copilot/CopilotDrawer.jsx",
    "source_file": "src/components/copilot/CopilotDrawer.jsx",
    "multiline": false
  },
  {
    "id": "copilot_input_placeholder",
    "page": "copilot",
    "type": "text",
    "label": "Copilot Eingabe Platzhalter",
    "defaultValue": "Frage zur Sicherheitstechnik eingeben...",
    "default_value": "Frage zur Sicherheitstechnik eingeben...",
    "sourceFile": "src/components/copilot/CopilotDrawer.jsx",
    "source_file": "src/components/copilot/CopilotDrawer.jsx",
    "multiline": false
  },
  {
    "id": "copilot_btn_send",
    "page": "copilot",
    "type": "text",
    "label": "Copilot Senden Button",
    "defaultValue": "Senden",
    "default_value": "Senden",
    "sourceFile": "src/components/copilot/CopilotDrawer.jsx",
    "source_file": "src/components/copilot/CopilotDrawer.jsx",
    "multiline": false
  },
  {
    "id": "copilot_btn_clear",
    "page": "copilot",
    "type": "text",
    "label": "Copilot Verlauf leeren Button",
    "defaultValue": "Verlauf leeren",
    "default_value": "Verlauf leeren",
    "sourceFile": "src/components/copilot/CopilotDrawer.jsx",
    "source_file": "src/components/copilot/CopilotDrawer.jsx",
    "multiline": false
  },
  {
    "id": "copilot_disclaimer_note",
    "page": "copilot",
    "type": "text",
    "label": "Copilot Haftungshinweis",
    "defaultValue": "KI-generierte Auskünfte ersetzen keine fachtechnische Detailplanung vor Ort.",
    "default_value": "KI-generierte Auskünfte ersetzen keine fachtechnische Detailplanung vor Ort.",
    "sourceFile": "src/components/copilot/CopilotDrawer.jsx",
    "source_file": "src/components/copilot/CopilotDrawer.jsx",
    "multiline": true
  },
  {
    "id": "copilot_fab_tooltip",
    "page": "copilot",
    "type": "text",
    "label": "Copilot FAB Tooltip",
    "defaultValue": "KI-Fachberater öffnen",
    "default_value": "KI-Fachberater öffnen",
    "sourceFile": "src/components/copilot/CopilotFloatingFab.jsx",
    "source_file": "src/components/copilot/CopilotFloatingFab.jsx",
    "multiline": false
  },
  {
    "id": "copilot_fab_badge",
    "page": "copilot",
    "type": "text",
    "label": "Copilot FAB Badge",
    "defaultValue": "ALWIS KI",
    "default_value": "ALWIS KI",
    "sourceFile": "src/components/copilot/CopilotFloatingFab.jsx",
    "source_file": "src/components/copilot/CopilotFloatingFab.jsx",
    "multiline": false
  },
  {
    "id": "copilot_bom_card_title",
    "page": "copilot",
    "type": "text",
    "label": "Copilot BOM Karte Titel",
    "defaultValue": "Vorgeschlagene Komponenten",
    "default_value": "Vorgeschlagene Komponenten",
    "sourceFile": "src/components/copilot/BomCard.jsx",
    "source_file": "src/components/copilot/BomCard.jsx",
    "multiline": false
  },
  {
    "id": "copilot_bom_card_add_all",
    "page": "copilot",
    "type": "text",
    "label": "Copilot BOM Alle Hinzufügen",
    "defaultValue": "Alle in den Anfragekorb",
    "default_value": "Alle in den Anfragekorb",
    "sourceFile": "src/components/copilot/BomCard.jsx",
    "source_file": "src/components/copilot/BomCard.jsx",
    "multiline": false
  },
  {
    "id": "copilot_status_ready",
    "page": "copilot",
    "type": "text",
    "label": "Copilot Status Bereit",
    "defaultValue": "Bereit für Ihre Anfrage",
    "default_value": "Bereit für Ihre Anfrage",
    "sourceFile": "src/components/copilot/CopilotDrawer.jsx",
    "source_file": "src/components/copilot/CopilotDrawer.jsx",
    "multiline": false
  },
  {
    "id": "logo",
    "page": "brand",
    "type": "image",
    "label": "Shop-Logo",
    "defaultValue": "",
    "default_value": "",
    "sourceFile": "src/components/tenant/TenantLogo.jsx",
    "source_file": "src/components/tenant/TenantLogo.jsx",
    "multiline": false
  },
  {
    "id": "favicon",
    "page": "brand",
    "type": "image",
    "label": "Shop-Favicon",
    "defaultValue": "",
    "default_value": "",
    "sourceFile": "src/components/tenant/TenantLogo.jsx",
    "source_file": "src/components/tenant/TenantLogo.jsx",
    "multiline": false
  },
  {
    "id": "brand_tagline",
    "page": "brand",
    "type": "text",
    "label": "Shop Tagline / Slogan",
    "defaultValue": "Ihr Fachpartner für moderne Sicherheitstechnik",
    "default_value": "Ihr Fachpartner für moderne Sicherheitstechnik",
    "sourceFile": "src/components/tenant/TenantLogo.jsx",
    "source_file": "src/components/tenant/TenantLogo.jsx",
    "multiline": false
  },
  {
    "id": "brand_company_legal_name",
    "page": "brand",
    "type": "text",
    "label": "Vollständiger Firmenname",
    "defaultValue": "ASL Partner Sicherheitstechnik GmbH",
    "default_value": "ASL Partner Sicherheitstechnik GmbH",
    "sourceFile": "src/components/tenant/TenantLogo.jsx",
    "source_file": "src/components/tenant/TenantLogo.jsx",
    "multiline": false
  },
  {
    "id": "onboarding_guide",
    "page": "onboarding",
    "type": "text",
    "label": "Kurzanleitung für Interessenten",
    "defaultValue": "So bearbeiten Sie Ihren Shop: Wählen Sie eine Seite, klicken Sie in ein Textfeld und passen Sie die Inhalte an. Mit „Speichern“ werden die Änderungen sofort im Shop veröffentlicht.",
    "default_value": "So bearbeiten Sie Ihren Shop: Wählen Sie eine Seite, klicken Sie in ein Textfeld und passen Sie die Inhalte an. Mit „Speichern“ werden die Änderungen sofort im Shop veröffentlicht.",
    "sourceFile": "src/features/admin/ContentEditorTab.jsx",
    "source_file": "src/features/admin/ContentEditorTab.jsx",
    "multiline": true
  },
  {
    "id": "onboarding_welcome_title",
    "page": "onboarding",
    "type": "text",
    "label": "Onboarding Willkommen Titel",
    "defaultValue": "Willkommen in Ihrem White-Label Partner-Shop",
    "default_value": "Willkommen in Ihrem White-Label Partner-Shop",
    "sourceFile": "src/features/admin/ContentEditorTab.jsx",
    "source_file": "src/features/admin/ContentEditorTab.jsx",
    "multiline": false
  },
  {
    "id": "onboarding_step1_text",
    "page": "onboarding",
    "type": "text",
    "label": "Onboarding Schritt 1",
    "defaultValue": "1. Logo & Farben im Design-Drawer anpassen.",
    "default_value": "1. Logo & Farben im Design-Drawer anpassen.",
    "sourceFile": "src/features/admin/ContentEditorTab.jsx",
    "source_file": "src/features/admin/ContentEditorTab.jsx",
    "multiline": false
  },
  {
    "id": "onboarding_step2_text",
    "page": "onboarding",
    "type": "text",
    "label": "Onboarding Schritt 2",
    "defaultValue": "2. Texte und Kontaktdaten inline editieren.",
    "default_value": "2. Texte und Kontaktdaten inline editieren.",
    "sourceFile": "src/features/admin/ContentEditorTab.jsx",
    "source_file": "src/features/admin/ContentEditorTab.jsx",
    "multiline": false
  }
];

export const REGISTERED_SLOTS = {
  "advisor": {
    "advisor_badge": {
      "type": "text",
      "label": "Sicherheitsberater Badge"
    },
    "advisor_title": {
      "type": "text",
      "label": "Sicherheitsberater Titel"
    },
    "advisor_subtitle": {
      "type": "text",
      "label": "Sicherheitsberater Untertitel"
    },
    "advisor_intro_text": {
      "type": "text",
      "label": "Sicherheitsberater Einleitung"
    },
    "advisor_step1_title": {
      "type": "text",
      "label": "Schritt 1 Titel"
    },
    "advisor_step1_desc": {
      "type": "text",
      "label": "Schritt 1 Beschreibung"
    },
    "advisor_step2_title": {
      "type": "text",
      "label": "Schritt 2 Titel"
    },
    "advisor_step2_desc": {
      "type": "text",
      "label": "Schritt 2 Beschreibung"
    },
    "advisor_step3_title": {
      "type": "text",
      "label": "Schritt 3 Titel"
    },
    "advisor_step3_desc": {
      "type": "text",
      "label": "Schritt 3 Beschreibung"
    },
    "advisor_step4_title": {
      "type": "text",
      "label": "Schritt 4 Titel"
    },
    "advisor_step4_desc": {
      "type": "text",
      "label": "Schritt 4 Beschreibung"
    },
    "advisor_opt_commercial_title": {
      "type": "text",
      "label": "Option Gewerbe Titel"
    },
    "advisor_opt_commercial_desc": {
      "type": "text",
      "label": "Option Gewerbe Beschreibung"
    },
    "advisor_opt_residential_title": {
      "type": "text",
      "label": "Option Wohnen Titel"
    },
    "advisor_opt_residential_desc": {
      "type": "text",
      "label": "Option Wohnen Beschreibung"
    },
    "advisor_opt_public_title": {
      "type": "text",
      "label": "Option Öffentlich Titel"
    },
    "advisor_opt_public_desc": {
      "type": "text",
      "label": "Option Öffentlich Beschreibung"
    },
    "advisor_opt_critical_title": {
      "type": "text",
      "label": "Option KRITIS Titel"
    },
    "advisor_opt_critical_desc": {
      "type": "text",
      "label": "Option KRITIS Beschreibung"
    },
    "advisor_discipline_video": {
      "type": "text",
      "label": "Gewerk Videoüberwachung"
    },
    "advisor_discipline_video_desc": {
      "type": "text",
      "label": "Gewerk Video Beschreibung"
    },
    "advisor_discipline_alarm": {
      "type": "text",
      "label": "Gewerk Einbruchmelde"
    },
    "advisor_discipline_alarm_desc": {
      "type": "text",
      "label": "Gewerk Einbruchmelde Beschreibung"
    },
    "advisor_discipline_access": {
      "type": "text",
      "label": "Gewerk Zutrittskontrolle"
    },
    "advisor_discipline_access_desc": {
      "type": "text",
      "label": "Gewerk Zutrittskontrolle Beschreibung"
    },
    "advisor_discipline_fire": {
      "type": "text",
      "label": "Gewerk Brandmeldetechnik"
    },
    "advisor_discipline_fire_desc": {
      "type": "text",
      "label": "Gewerk Brandmelde Beschreibung"
    },
    "advisor_discipline_power": {
      "type": "text",
      "label": "Gewerk Stromversorgung"
    },
    "advisor_discipline_power_desc": {
      "type": "text",
      "label": "Gewerk Stromversorgung Beschreibung"
    },
    "advisor_size_small": {
      "type": "text",
      "label": "Größe Klein"
    },
    "advisor_size_medium": {
      "type": "text",
      "label": "Größe Mittel"
    },
    "advisor_size_large": {
      "type": "text",
      "label": "Größe Groß"
    },
    "advisor_size_campus": {
      "type": "text",
      "label": "Größe Campus"
    },
    "advisor_norm_vds_a": {
      "type": "text",
      "label": "Norm VdS A"
    },
    "advisor_norm_vds_b": {
      "type": "text",
      "label": "Norm VdS B"
    },
    "advisor_norm_vds_c": {
      "type": "text",
      "label": "Norm VdS C"
    },
    "advisor_norm_din_14675": {
      "type": "text",
      "label": "Norm DIN 14675"
    },
    "advisor_norm_en_50131": {
      "type": "text",
      "label": "Norm EN 50131"
    },
    "advisor_norm_en_54": {
      "type": "text",
      "label": "Norm EN 54"
    },
    "advisor_indoor_label": {
      "type": "text",
      "label": "Innenbereich Label"
    },
    "advisor_outdoor_label": {
      "type": "text",
      "label": "Außenbereich Label"
    },
    "advisor_perimeter_label": {
      "type": "text",
      "label": "Perimeter Label"
    },
    "advisor_recording_label": {
      "type": "text",
      "label": "Aufzeichnung Label"
    },
    "advisor_cloud_remote_label": {
      "type": "text",
      "label": "Fernzugriff Label"
    },
    "advisor_results_title": {
      "type": "text",
      "label": "Ergebnisse Titel"
    },
    "advisor_results_subtitle": {
      "type": "text",
      "label": "Ergebnisse Untertitel"
    },
    "advisor_results_bom_title": {
      "type": "text",
      "label": "Stückliste Titel"
    },
    "advisor_results_bom_empty": {
      "type": "text",
      "label": "Keine Komponenten gefunden"
    },
    "advisor_results_net_estimate": {
      "type": "text",
      "label": "Geschätzter Preis"
    },
    "advisor_results_disclaimer": {
      "type": "text",
      "label": "Hinweis Preis"
    },
    "advisor_btn_next": {
      "type": "text",
      "label": "Button Weiter"
    },
    "advisor_btn_back": {
      "type": "text",
      "label": "Button Zurück"
    },
    "advisor_btn_restart": {
      "type": "text",
      "label": "Button Neustart"
    },
    "advisor_btn_transfer_cart": {
      "type": "text",
      "label": "Button in Warenkorb"
    },
    "advisor_btn_request_quote": {
      "type": "text",
      "label": "Button Projektanfrage"
    },
    "advisor_btn_expert_call": {
      "type": "text",
      "label": "Button Expertenberatung"
    },
    "advisor_card_compatibility": {
      "type": "text",
      "label": "Kompatibilität Hinweis"
    },
    "advisor_card_warranty": {
      "type": "text",
      "label": "Garantie Hinweis"
    },
    "advisor_card_support": {
      "type": "text",
      "label": "Support Hinweis"
    },
    "advisor_card_delivery": {
      "type": "text",
      "label": "Lieferung Hinweis"
    },
    "advisor_summary_heading": {
      "type": "text",
      "label": "Zusammenfassung Überschrift"
    },
    "advisor_summary_building": {
      "type": "text",
      "label": "Zusammenfassung Gebäude"
    },
    "advisor_summary_disciplines": {
      "type": "text",
      "label": "Zusammenfassung Gewerke"
    },
    "advisor_summary_size": {
      "type": "text",
      "label": "Zusammenfassung Größe"
    },
    "advisor_summary_standards": {
      "type": "text",
      "label": "Zusammenfassung Standards"
    },
    "advisor_expert_note": {
      "type": "text",
      "label": "Expertenhinweis"
    },
    "advisor_banner_image": {
      "type": "image",
      "label": "Berater Banner Bild"
    }
  },
  "product": {
    "pdp_breadcrumb_root": {
      "type": "text",
      "label": "Breadcrumb Startseite"
    },
    "pdp_breadcrumb_catalog": {
      "type": "text",
      "label": "Breadcrumb Katalog"
    },
    "pdp_back_link": {
      "type": "text",
      "label": "Zurück-Button"
    },
    "pdp_sku_label": {
      "type": "text",
      "label": "Artikelnr. Label"
    },
    "pdp_manufacturer_label": {
      "type": "text",
      "label": "Hersteller Label"
    },
    "pdp_category_label": {
      "type": "text",
      "label": "Kategorie Label"
    },
    "pdp_stock_in_stock": {
      "type": "text",
      "label": "Lagerstatus Verfügbar"
    },
    "pdp_stock_on_request": {
      "type": "text",
      "label": "Lagerstatus Anfrage"
    },
    "pdp_price_net_label": {
      "type": "text",
      "label": "Netto-Preis Label"
    },
    "pdp_price_on_request": {
      "type": "text",
      "label": "Preis auf Anfrage"
    },
    "pdp_vat_notice": {
      "type": "text",
      "label": "MwSt. Hinweis"
    },
    "pdp_tiered_pricing_badge": {
      "type": "text",
      "label": "Staffelpreis Badge"
    },
    "pdp_quantity_label": {
      "type": "text",
      "label": "Menge Label"
    },
    "pdp_add_to_cart_btn": {
      "type": "text",
      "label": "In Anfragekorb Button"
    },
    "pdp_added_to_cart_state": {
      "type": "text",
      "label": "Hinzugefügt Status"
    },
    "pdp_direct_quote_btn": {
      "type": "text",
      "label": "Direkt anfragen Button"
    },
    "pdp_tab_description": {
      "type": "text",
      "label": "Tab Beschreibung"
    },
    "pdp_tab_specs": {
      "type": "text",
      "label": "Tab Technische Daten"
    },
    "pdp_tab_downloads": {
      "type": "text",
      "label": "Tab Downloads"
    },
    "pdp_tab_accessories": {
      "type": "text",
      "label": "Tab Zubehör"
    },
    "pdp_no_specs_available": {
      "type": "text",
      "label": "Keine Daten verfügbar"
    },
    "pdp_no_downloads_available": {
      "type": "text",
      "label": "Keine Downloads verfügbar"
    },
    "pdp_download_datasheet_label": {
      "type": "text",
      "label": "Datenblatt Download Label"
    },
    "pdp_download_manual_label": {
      "type": "text",
      "label": "Handbuch Download Label"
    },
    "pdp_b2b_trade_notice": {
      "type": "text",
      "label": "Hinweis"
    },
    "pdp_shipping_info_title": {
      "type": "text",
      "label": "Versandinfo Titel"
    },
    "pdp_shipping_info_desc": {
      "type": "text",
      "label": "Versandinfo Text"
    },
    "pdp_warranty_title": {
      "type": "text",
      "label": "Garantie Titel"
    },
    "pdp_warranty_desc": {
      "type": "text",
      "label": "Garantie Text"
    },
    "pdp_consultation_title": {
      "type": "text",
      "label": "Beratung Box Titel"
    },
    "pdp_consultation_desc": {
      "type": "text",
      "label": "Beratung Box Text"
    },
    "pdp_consultation_phone_label": {
      "type": "text",
      "label": "Telefonkontakt Label"
    },
    "pdp_related_products_title": {
      "type": "text",
      "label": "Ähnliche Produkte Titel"
    },
    "pdp_related_products_subtitle": {
      "type": "text",
      "label": "Ähnliche Produkte Untertitel"
    },
    "pdp_spec_table_key_label": {
      "type": "text",
      "label": "Spezifikation Merkmal Label"
    },
    "pdp_spec_table_val_label": {
      "type": "text",
      "label": "Spezifikation Wert Label"
    }
  },
  "inquiry": {
    "inquiry_form_badge": {
      "type": "text",
      "label": "Anfrageformular Badge"
    },
    "inquiry_form_title": {
      "type": "text",
      "label": "Anfrageformular Titel"
    },
    "inquiry_form_subtitle": {
      "type": "text",
      "label": "Anfrageformular Untertitel"
    },
    "inquiry_field_company": {
      "type": "text",
      "label": "Feld Firma Label"
    },
    "inquiry_field_company_ph": {
      "type": "text",
      "label": "Feld Firma Platzhalter"
    },
    "inquiry_field_name": {
      "type": "text",
      "label": "Feld Ansprechpartner Label"
    },
    "inquiry_field_name_ph": {
      "type": "text",
      "label": "Feld Ansprechpartner Platzhalter"
    },
    "inquiry_field_email": {
      "type": "text",
      "label": "Feld E-Mail Label"
    },
    "inquiry_field_email_ph": {
      "type": "text",
      "label": "Feld E-Mail Platzhalter"
    },
    "inquiry_field_phone": {
      "type": "text",
      "label": "Feld Telefon Label"
    },
    "inquiry_field_phone_ph": {
      "type": "text",
      "label": "Feld Telefon Platzhalter"
    },
    "inquiry_field_street": {
      "type": "text",
      "label": "Feld Straße Label"
    },
    "inquiry_field_street_ph": {
      "type": "text",
      "label": "Feld Straße Platzhalter"
    },
    "inquiry_field_zip_city": {
      "type": "text",
      "label": "Feld PLZ & Ort Label"
    },
    "inquiry_field_zip_city_ph": {
      "type": "text",
      "label": "Feld PLZ & Ort Platzhalter"
    },
    "inquiry_field_project_title": {
      "type": "text",
      "label": "Feld Projektname Label"
    },
    "inquiry_field_project_title_ph": {
      "type": "text",
      "label": "Feld Projektname Platzhalter"
    },
    "inquiry_field_message": {
      "type": "text",
      "label": "Feld Nachricht Label"
    },
    "inquiry_field_message_ph": {
      "type": "text",
      "label": "Feld Nachricht Platzhalter"
    },
    "inquiry_field_callback_pref": {
      "type": "text",
      "label": "Checkbox Rückruf gewünscht"
    },
    "inquiry_field_privacy_consent": {
      "type": "text",
      "label": "Datenschutz Einwilligung"
    },
    "inquiry_btn_submit": {
      "type": "text",
      "label": "Button Absenden"
    },
    "inquiry_btn_submitting": {
      "type": "text",
      "label": "Button Sendet..."
    },
    "inquiry_btn_cancel": {
      "type": "text",
      "label": "Button Abbrechen"
    },
    "inquiry_err_company_required": {
      "type": "text",
      "label": "Fehler Firma Pflichtfeld"
    },
    "inquiry_err_name_required": {
      "type": "text",
      "label": "Fehler Name Pflichtfeld"
    },
    "inquiry_err_email_invalid": {
      "type": "text",
      "label": "Fehler E-Mail ungültig"
    },
    "inquiry_err_privacy_required": {
      "type": "text",
      "label": "Fehler Datenschutz nötig"
    },
    "inquiry_success_title": {
      "type": "text",
      "label": "Erfolg Überschrift"
    },
    "inquiry_success_subtitle": {
      "type": "text",
      "label": "Erfolg Untertitel"
    },
    "inquiry_success_reference_label": {
      "type": "text",
      "label": "Vorgangsnummer Label"
    },
    "inquiry_success_next_steps_title": {
      "type": "text",
      "label": "Nächste Schritte Titel"
    },
    "inquiry_success_step1": {
      "type": "text",
      "label": "Schritt 1 Text"
    },
    "inquiry_success_step2": {
      "type": "text",
      "label": "Schritt 2 Text"
    },
    "inquiry_success_step3": {
      "type": "text",
      "label": "Schritt 3 Text"
    },
    "inquiry_success_btn_catalog": {
      "type": "text",
      "label": "Button Weiter einkaufen"
    },
    "inquiry_success_btn_home": {
      "type": "text",
      "label": "Button Zur Startseite"
    }
  },
  "cart": {
    "cart_page_title": {
      "type": "text",
      "label": "Warenkorb Seitentitel"
    },
    "cart_page_subtitle": {
      "type": "text",
      "label": "Warenkorb Untertitel"
    },
    "cart_empty_title": {
      "type": "text",
      "label": "Leerer Warenkorb Titel"
    },
    "cart_empty_desc": {
      "type": "text",
      "label": "Leerer Warenkorb Text"
    },
    "cart_btn_browse_catalog": {
      "type": "text",
      "label": "Button Katalog durchsuchen"
    },
    "cart_table_th_product": {
      "type": "text",
      "label": "Tabelle Spalte Produkt"
    },
    "cart_table_th_sku": {
      "type": "text",
      "label": "Tabelle Spalte SKU"
    },
    "cart_table_th_price": {
      "type": "text",
      "label": "Tabelle Spalte Einzelpreis"
    },
    "cart_table_th_qty": {
      "type": "text",
      "label": "Tabelle Spalte Menge"
    },
    "cart_table_th_total": {
      "type": "text",
      "label": "Tabelle Spalte Gesamt"
    },
    "cart_btn_remove_item": {
      "type": "text",
      "label": "Position entfernen Label"
    },
    "cart_btn_clear_all": {
      "type": "text",
      "label": "Warenkorb leeren Button"
    },
    "cart_summary_title": {
      "type": "text",
      "label": "Summenübersicht Titel"
    },
    "cart_summary_subtotal_net": {
      "type": "text",
      "label": "Zwischensumme Netto"
    },
    "cart_summary_vat_label": {
      "type": "text",
      "label": "MwSt. Zeile Label"
    },
    "cart_summary_total_gross": {
      "type": "text",
      "label": "Gesamtsumme Brutto"
    },
    "cart_summary_b2b_notice": {
      "type": "text",
      "label": "Warenkorb B2B Hinweis"
    },
    "cart_btn_proceed_inquiry": {
      "type": "text",
      "label": "Button Zur Projektanfrage"
    },
    "cart_btn_continue_shopping": {
      "type": "text",
      "label": "Button Weiter einkaufen"
    },
    "cart_bom_import_title": {
      "type": "text",
      "label": "BOM Import Titel"
    },
    "cart_bom_import_desc": {
      "type": "text",
      "label": "BOM Import Beschreibung"
    },
    "cart_bom_import_btn": {
      "type": "text",
      "label": "BOM Import Button"
    },
    "cart_drawer_title": {
      "type": "text",
      "label": "Drawer Titel"
    },
    "cart_drawer_empty_text": {
      "type": "text",
      "label": "Drawer Leer Text"
    },
    "cart_drawer_subtotal_label": {
      "type": "text",
      "label": "Drawer Zwischensumme"
    },
    "cart_drawer_vat_hint": {
      "type": "text",
      "label": "Drawer MwSt. Hinweis"
    },
    "cart_drawer_btn_view_cart": {
      "type": "text",
      "label": "Drawer Button Korb ansehen"
    },
    "cart_drawer_btn_checkout": {
      "type": "text",
      "label": "Drawer Button Zur Anfrage"
    },
    "cart_drawer_btn_close": {
      "type": "text",
      "label": "Drawer Schließen Label"
    },
    "cart_drawer_item_qty_dec": {
      "type": "text",
      "label": "Menge verringern Label"
    },
    "cart_drawer_item_qty_inc": {
      "type": "text",
      "label": "Menge erhöhen Label"
    },
    "cart_drawer_items_count_suffix": {
      "type": "text",
      "label": "Artikel Anzahl Suffix"
    },
    "cart_drawer_free_shipping_hint": {
      "type": "text",
      "label": "Versandhinweis Drawer"
    },
    "cart_drawer_b2b_tag": {
      "type": "text",
      "label": "B2B Tag Drawer"
    }
  },
  "catalog": {
    "catalog_page_title": {
      "type": "text",
      "label": "Katalog Seitentitel"
    },
    "catalog_page_subtitle": {
      "type": "text",
      "label": "Katalog Untertitel"
    },
    "catalog_results_found_prefix": {
      "type": "text",
      "label": "Gefundene Artikel Präfix"
    },
    "catalog_results_found_suffix": {
      "type": "text",
      "label": "Gefundene Artikel Suffix"
    },
    "catalog_empty_title": {
      "type": "text",
      "label": "Keine Treffer Titel"
    },
    "catalog_empty_desc": {
      "type": "text",
      "label": "Keine Treffer Text"
    },
    "catalog_btn_reset_filters": {
      "type": "text",
      "label": "Button Filter zurücksetzen"
    },
    "catalog_loading_text": {
      "type": "text",
      "label": "Katalog Lädt Text"
    },
    "catalog_pagination_prev": {
      "type": "text",
      "label": "Paginierung Vorherige"
    },
    "catalog_pagination_next": {
      "type": "text",
      "label": "Paginierung Nächste"
    },
    "catalog_pagination_page_of": {
      "type": "text",
      "label": "Paginierung Seite von"
    },
    "catalog_view_mode_grid": {
      "type": "text",
      "label": "Ansicht Raster"
    },
    "catalog_view_mode_list": {
      "type": "text",
      "label": "Ansicht Liste"
    },
    "catalog_b2b_wholesale_banner": {
      "type": "text",
      "label": "Katalog B2B Banner"
    },
    "catalog_sort_label": {
      "type": "text",
      "label": "Sortierung Label"
    },
    "filter_topbar_all_categories": {
      "type": "text",
      "label": "Topbar Alle Fachbereiche"
    },
    "filter_topbar_all_subcategories": {
      "type": "text",
      "label": "Topbar Alle Untergruppen"
    },
    "filter_topbar_all_manufacturers": {
      "type": "text",
      "label": "Topbar Alle Hersteller"
    },
    "filter_topbar_sort_standard": {
      "type": "text",
      "label": "Sortierung Standard"
    },
    "filter_topbar_sort_price_asc": {
      "type": "text",
      "label": "Sortierung Preis aufsteigend"
    },
    "filter_topbar_sort_price_desc": {
      "type": "text",
      "label": "Sortierung Preis absteigend"
    },
    "filter_topbar_sort_name_asc": {
      "type": "text",
      "label": "Sortierung Name"
    },
    "filter_topbar_search_ph": {
      "type": "text",
      "label": "Suchfeld Platzhalter Topbar"
    },
    "filter_topbar_reset_all": {
      "type": "text",
      "label": "Button Alle Filter löschen"
    },
    "filter_topbar_active_filters_label": {
      "type": "text",
      "label": "Aktive Filter Label"
    },
    "filter_topbar_clear_search_tooltip": {
      "type": "text",
      "label": "Suche leeren Tooltip"
    },
    "filter_topbar_apply_filter_label": {
      "type": "text",
      "label": "Filter anwenden Label"
    },
    "filter_topbar_category_filter_label": {
      "type": "text",
      "label": "Fachbereich Filter Label"
    },
    "filter_topbar_manufacturer_filter_label": {
      "type": "text",
      "label": "Hersteller Filter Label"
    },
    "filter_sidebar_title": {
      "type": "text",
      "label": "Sidebar Filter Titel"
    },
    "filter_sidebar_categories_heading": {
      "type": "text",
      "label": "Sidebar Fachbereiche Titel"
    },
    "filter_sidebar_all_categories_btn": {
      "type": "text",
      "label": "Sidebar Alle Produkte"
    },
    "filter_sidebar_manufacturers_heading": {
      "type": "text",
      "label": "Sidebar Hersteller Titel"
    },
    "filter_sidebar_search_mfr_ph": {
      "type": "text",
      "label": "Hersteller suchen Platzhalter"
    },
    "filter_sidebar_no_mfr_found": {
      "type": "text",
      "label": "Kein Hersteller gefunden"
    },
    "filter_sidebar_reset_btn": {
      "type": "text",
      "label": "Sidebar Reset Button"
    },
    "filter_sidebar_price_heading": {
      "type": "text",
      "label": "Sidebar Preisspanne Titel"
    },
    "filter_sidebar_availability_heading": {
      "type": "text",
      "label": "Sidebar Verfügbarkeit Titel"
    },
    "filter_sidebar_in_stock_only": {
      "type": "text",
      "label": "Nur Lagerware Checkbox"
    },
    "filter_sidebar_b2b_certified": {
      "type": "text",
      "label": "Nur Zertifizierte Checkbox"
    },
    "filter_sidebar_subcat_heading": {
      "type": "text",
      "label": "Sidebar Untergruppen Titel"
    },
    "card_product_details_btn": {
      "type": "text",
      "label": "Details ansehen Button"
    },
    "card_product_request_btn": {
      "type": "text",
      "label": "Artikel anfragen Button"
    },
    "card_product_price_net_suffix": {
      "type": "text",
      "label": "Netto Suffix"
    },
    "card_product_price_on_request": {
      "type": "text",
      "label": "Karte Preis auf Anfrage"
    },
    "card_specs_sku_prefix": {
      "type": "text",
      "label": "Specs Karte SKU Präfix"
    },
    "card_specs_mfr_fallback": {
      "type": "text",
      "label": "Specs Karte Hersteller Fallback"
    },
    "card_specs_net_label": {
      "type": "text",
      "label": "Specs Karte Netto Label"
    },
    "card_specs_vat_hint": {
      "type": "text",
      "label": "Specs Karte MwSt. Hinweis"
    },
    "card_specs_add_btn": {
      "type": "text",
      "label": "Specs Karte Hinzufügen Button"
    },
    "card_specs_added_state": {
      "type": "text",
      "label": "Specs Karte Im Korb Status"
    },
    "card_specs_request_quote_btn": {
      "type": "text",
      "label": "Specs Karte Anfragen Button"
    },
    "card_specs_fast_ship_badge": {
      "type": "text",
      "label": "Specs Karte Schnellversand"
    },
    "card_compact_sku_label": {
      "type": "text",
      "label": "Kompakt Karte SKU Label"
    },
    "card_compact_qty_dec": {
      "type": "text",
      "label": "Kompakt Karte Menge minus"
    },
    "card_compact_qty_inc": {
      "type": "text",
      "label": "Kompakt Karte Menge plus"
    },
    "card_compact_add_btn": {
      "type": "text",
      "label": "Kompakt Karte 1-Klick Button"
    },
    "card_compact_net_price_label": {
      "type": "text",
      "label": "Kompakt Karte Netto Preis"
    },
    "card_visual_recommendation_badge": {
      "type": "text",
      "label": "Visuelle Karte Empfehlung Badge"
    },
    "card_visual_in_stock_badge": {
      "type": "text",
      "label": "Visuelle Karte Lagernd Badge"
    },
    "card_visual_add_cta": {
      "type": "text",
      "label": "Visuelle Karte In Korb CTA"
    },
    "card_visual_details_link": {
      "type": "text",
      "label": "Visuelle Karte Details Link"
    },
    "card_visual_vat_note": {
      "type": "text",
      "label": "Visuelle Karte MwSt. Hinweis"
    },
    "default_product_placeholder": {
      "type": "image",
      "label": "Standard Produktbild Platzhalter"
    }
  },
  "header": {
    "header_topbar_b2b_badge": {
      "type": "text",
      "label": "Header Fachbetrieb Badge"
    },
    "header_topbar_direct_shipping": {
      "type": "text",
      "label": "Header Direktversand Text"
    },
    "header_topbar_hotline_label": {
      "type": "text",
      "label": "Header Hotline Label"
    },
    "header_topbar_hotline_number": {
      "type": "text",
      "label": "Header Hotline Telefonnummer"
    },
    "header_topbar_email_label": {
      "type": "text",
      "label": "Header E-Mail Label"
    },
    "header_megamenu_trigger_label": {
      "type": "text",
      "label": "Mega-Menü Button Label"
    },
    "header_search_btn_label": {
      "type": "text",
      "label": "Header Suche Button Label"
    },
    "header_search_input_ph": {
      "type": "text",
      "label": "Header Suchfeld Platzhalter"
    },
    "header_quote_cta_label": {
      "type": "text",
      "label": "Header Projektanfrage CTA"
    },
    "header_cart_btn_label": {
      "type": "text",
      "label": "Header Warenkorb Button"
    },
    "header_mobile_menu_open_label": {
      "type": "text",
      "label": "Mobil Menü öffnen Label"
    },
    "header_mobile_menu_close_label": {
      "type": "text",
      "label": "Mobil Menü schließen Label"
    },
    "header_rubrik_video": {
      "type": "text",
      "label": "Rubrik Videoüberwachung"
    },
    "header_rubrik_gefahr": {
      "type": "text",
      "label": "Rubrik Gefahrenmelde"
    },
    "header_rubrik_zutritt": {
      "type": "text",
      "label": "Rubrik Zutrittskontrolle"
    },
    "header_rubrik_brand": {
      "type": "text",
      "label": "Rubrik Brandmeldetechnik"
    },
    "header_rubrik_pulsar": {
      "type": "text",
      "label": "Rubrik PULSAR Stromversorgung"
    },
    "header_all_products_link": {
      "type": "text",
      "label": "Header Alle Produkte Link"
    },
    "header_fast_delivery_badge": {
      "type": "text",
      "label": "Header Schnellversand Badge"
    },
    "header_partner_portal_link": {
      "type": "text",
      "label": "Header Partner Portal Link"
    },
    "header_advisor_link": {
      "type": "text",
      "label": "Header Berater Link"
    },
    "header_slim_logo_fallback": {
      "type": "text",
      "label": "Slim Header Logo Fallback"
    },
    "header_slim_search_ph": {
      "type": "text",
      "label": "Slim Header Suche Platzhalter"
    },
    "header_slim_ctrl_k_hint": {
      "type": "text",
      "label": "Slim Header Strg+K Hinweis"
    },
    "header_slim_hotline_badge": {
      "type": "text",
      "label": "Slim Header Hotline Badge"
    },
    "header_slim_cart_title": {
      "type": "text",
      "label": "Slim Header Korb Titel"
    },
    "header_slim_catalog_nav": {
      "type": "text",
      "label": "Slim Header Nav Katalog"
    },
    "header_slim_inquiry_nav": {
      "type": "text",
      "label": "Slim Header Nav Anfrage"
    },
    "header_slim_mobile_title": {
      "type": "text",
      "label": "Slim Header Mobil Titel"
    },
    "header_centered_slogan_fallback": {
      "type": "text",
      "label": "Centered Header Slogan"
    },
    "header_centered_nav_catalog": {
      "type": "text",
      "label": "Centered Nav Katalog"
    },
    "header_centered_nav_categories": {
      "type": "text",
      "label": "Centered Nav Kategorien"
    },
    "header_centered_nav_inquiry": {
      "type": "text",
      "label": "Centered Nav Anfrage"
    },
    "header_centered_nav_advisor": {
      "type": "text",
      "label": "Centered Nav Berater"
    },
    "header_centered_search_toggle": {
      "type": "text",
      "label": "Centered Suche Toggle"
    },
    "header_centered_hotline_text": {
      "type": "text",
      "label": "Centered Hotline Text"
    },
    "header_mobile_back_btn": {
      "type": "text",
      "label": "Mobil Nav Zurück"
    },
    "header_mobile_view_all_cat": {
      "type": "text",
      "label": "Mobil Nav Alle in Kategorie"
    },
    "header_mobile_items_suffix": {
      "type": "text",
      "label": "Mobil Nav Artikel Suffix"
    },
    "search_overlay_title": {
      "type": "text",
      "label": "Such-Overlay Überschrift"
    },
    "search_overlay_input_ph": {
      "type": "text",
      "label": "Such-Overlay Platzhalter"
    },
    "search_overlay_hint": {
      "type": "text",
      "label": "Such-Overlay Eingabehinweis"
    },
    "search_overlay_recent_title": {
      "type": "text",
      "label": "Such-Overlay Letzte Suchen"
    },
    "search_overlay_categories_title": {
      "type": "text",
      "label": "Such-Overlay Beliebte Rubriken"
    },
    "search_overlay_no_results_title": {
      "type": "text",
      "label": "Such-Overlay Keine Treffer Titel"
    },
    "search_overlay_no_results_desc": {
      "type": "text",
      "label": "Such-Overlay Keine Treffer Text"
    },
    "search_overlay_results_count": {
      "type": "text",
      "label": "Such-Overlay Trefferanzahl"
    },
    "search_overlay_view_all_btn": {
      "type": "text",
      "label": "Such-Overlay Alle anzeigen Button"
    },
    "search_overlay_close_btn": {
      "type": "text",
      "label": "Such-Overlay Schließen Button"
    },
    "search_overlay_esc_hint": {
      "type": "text",
      "label": "Such-Overlay ESC Taste"
    }
  },
  "home": {
    "hero_title": {
      "type": "text",
      "label": "Hero-Titel"
    },
    "hero_subtitle": {
      "type": "text",
      "label": "Hero-Untertitel"
    },
    "hero_cta_primary": {
      "type": "text",
      "label": "Hero-CTA 1: Gesamten Katalog durchsuchen"
    },
    "hero_cta_secondary": {
      "type": "text",
      "label": "Hero-CTA 2: Projekt anfragen"
    },
    "trust_1_title": {
      "type": "text",
      "label": "Vertrauenspunkt 1 (Fachberatung) – Titel"
    },
    "trust_1_desc": {
      "type": "text",
      "label": "Vertrauenspunkt 1 (Fachberatung) – Beschreibung"
    },
    "trust_2_title": {
      "type": "text",
      "label": "Vertrauenspunkt 2 (B2B-Sortiment) – Titel"
    },
    "trust_2_desc": {
      "type": "text",
      "label": "Vertrauenspunkt 2 (B2B-Sortiment) – Beschreibung"
    },
    "trust_3_title": {
      "type": "text",
      "label": "Vertrauenspunkt 3 (Projektanfragen) – Titel"
    },
    "trust_3_desc": {
      "type": "text",
      "label": "Vertrauenspunkt 3 (Projektanfragen) – Beschreibung"
    },
    "section_categories_title": {
      "type": "text",
      "label": "Abschnitt „Fachbereiche“ – Titel"
    },
    "section_categories_subtitle": {
      "type": "text",
      "label": "Abschnitt „Fachbereiche“ – Untertitel"
    },
    "hero_background": {
      "type": "image",
      "label": "Hero-Hintergrundbild"
    },
    "hero_background_strength": {
      "type": "text",
      "label": "Hero-Hintergrund-Deckkraft"
    },
    "home_section_brands_title": {
      "type": "text",
      "label": "Hersteller Sektion Titel"
    },
    "home_section_brands_subtitle": {
      "type": "text",
      "label": "Hersteller Sektion Untertitel"
    },
    "home_section_cta_title": {
      "type": "text",
      "label": "Abschluss CTA Titel"
    },
    "home_section_cta_desc": {
      "type": "text",
      "label": "Abschluss CTA Beschreibung"
    },
    "home_section_cta_btn": {
      "type": "text",
      "label": "Abschluss CTA Button"
    },
    "home_advisor_teaser_title": {
      "type": "text",
      "label": "Berater Teaser Titel"
    },
    "home_advisor_teaser_desc": {
      "type": "text",
      "label": "Berater Teaser Text"
    },
    "home_advisor_teaser_btn": {
      "type": "text",
      "label": "Berater Teaser Button"
    },
    "hero_split_spotlight_badge": {
      "type": "text",
      "label": "Split Hero Spotlight Badge"
    },
    "hero_split_stat1_label": {
      "type": "text",
      "label": "Split Hero Statistik 1 Label"
    },
    "hero_split_stat1_val": {
      "type": "text",
      "label": "Split Hero Statistik 1 Wert"
    },
    "hero_split_stat2_label": {
      "type": "text",
      "label": "Split Hero Statistik 2 Label"
    },
    "hero_split_stat2_val": {
      "type": "text",
      "label": "Split Hero Statistik 2 Wert"
    },
    "hero_split_stat3_label": {
      "type": "text",
      "label": "Split Hero Statistik 3 Label"
    },
    "hero_split_stat3_val": {
      "type": "text",
      "label": "Split Hero Statistik 3 Wert"
    },
    "hero_split_card_title": {
      "type": "text",
      "label": "Split Hero Spotlight Titel"
    },
    "hero_split_card_sku_prefix": {
      "type": "text",
      "label": "Split Hero Spotlight SKU"
    },
    "hero_split_card_price_label": {
      "type": "text",
      "label": "Split Hero Spotlight Preis"
    },
    "hero_split_card_cart_btn": {
      "type": "text",
      "label": "Split Hero Spotlight Korb CTA"
    },
    "hero_grid_partner_badge": {
      "type": "text",
      "label": "Grid Hero Partner Badge"
    },
    "hero_grid_primary_cta": {
      "type": "text",
      "label": "Grid Hero Primär CTA"
    },
    "hero_grid_secondary_cta": {
      "type": "text",
      "label": "Grid Hero Sekundär CTA"
    },
    "hero_grid_card1_title": {
      "type": "text",
      "label": "Grid Kachel 1 Titel"
    },
    "hero_grid_card1_desc": {
      "type": "text",
      "label": "Grid Kachel 1 Text"
    },
    "hero_grid_card2_title": {
      "type": "text",
      "label": "Grid Kachel 2 Titel"
    },
    "hero_grid_card2_desc": {
      "type": "text",
      "label": "Grid Kachel 2 Text"
    },
    "hero_grid_card3_title": {
      "type": "text",
      "label": "Grid Kachel 3 Titel"
    },
    "hero_grid_card3_desc": {
      "type": "text",
      "label": "Grid Kachel 3 Text"
    },
    "hero_grid_card4_title": {
      "type": "text",
      "label": "Grid Kachel 4 Titel"
    },
    "hero_grid_card4_desc": {
      "type": "text",
      "label": "Grid Kachel 4 Text"
    },
    "hero_portal_badge": {
      "type": "text",
      "label": "Portal Hero Badge"
    },
    "hero_portal_search_btn": {
      "type": "text",
      "label": "Portal Hero Suche Button"
    },
    "hero_portal_chip_video": {
      "type": "text",
      "label": "Portal Shortcut Video"
    },
    "hero_portal_chip_alarm": {
      "type": "text",
      "label": "Portal Shortcut Alarm"
    },
    "hero_portal_chip_fire": {
      "type": "text",
      "label": "Portal Shortcut Brand"
    },
    "hero_portal_chip_access": {
      "type": "text",
      "label": "Portal Shortcut Zutritt"
    },
    "hero_portal_chip_power": {
      "type": "text",
      "label": "Portal Shortcut Strom"
    },
    "category_img_alarm": {
      "type": "image",
      "label": "Kategoriebild Alarmtechnik"
    },
    "category_img_video": {
      "type": "image",
      "label": "Kategoriebild Videoüberwachung"
    },
    "category_img_brand": {
      "type": "image",
      "label": "Kategoriebild Brandmeldetechnik"
    },
    "category_img_zutritt": {
      "type": "image",
      "label": "Kategoriebild Zutrittskontrolle"
    },
    "category_img_strom": {
      "type": "image",
      "label": "Kategoriebild Stromversorgung"
    }
  },
  "footer": {
    "footer_description": {
      "type": "text",
      "label": "Footer-Beschreibung"
    },
    "footer_partner_badge": {
      "type": "text",
      "label": "Partner-Badge Text"
    },
    "footer_b2b_notice": {
      "type": "text",
      "label": "B2B-Hinweis"
    },
    "footer_copyright": {
      "type": "text",
      "label": "Copyright-Hinweis"
    },
    "footer_col1_title": {
      "type": "text",
      "label": "Footer Spalte 1 Titel"
    },
    "footer_col2_title": {
      "type": "text",
      "label": "Footer Spalte 2 Titel"
    },
    "footer_col3_title": {
      "type": "text",
      "label": "Footer Spalte 3 Titel"
    },
    "footer_link_catalog": {
      "type": "text",
      "label": "Footer Link Katalog"
    },
    "footer_link_advisor": {
      "type": "text",
      "label": "Footer Link Berater"
    },
    "footer_link_inquiry": {
      "type": "text",
      "label": "Footer Link Projektanfrage"
    },
    "footer_link_imprint": {
      "type": "text",
      "label": "Footer Link Impressum"
    },
    "footer_link_privacy": {
      "type": "text",
      "label": "Footer Link Datenschutz"
    },
    "footer_link_agb": {
      "type": "text",
      "label": "Footer Link AGB"
    },
    "footer_link_shipping": {
      "type": "text",
      "label": "Footer Link Versand"
    },
    "footer_contact_phone_label": {
      "type": "text",
      "label": "Footer Kontakt Telefon Label"
    },
    "footer_contact_email_label": {
      "type": "text",
      "label": "Footer Kontakt E-Mail Label"
    },
    "footer_contact_hours_label": {
      "type": "text",
      "label": "Footer Geschäftszeiten Label"
    },
    "footer_asl_association_notice": {
      "type": "text",
      "label": "Footer ASL Verbandshinweis"
    },
    "footer_all_rights_reserved": {
      "type": "text",
      "label": "Footer Alle Rechte vorbehalten"
    },
    "footer_secure_ordering_hint": {
      "type": "text",
      "label": "Footer Sichere Übertragung"
    }
  },
  "legal": {
    "imprint_title": {
      "type": "text",
      "label": "Impressum – Titel"
    },
    "imprint_content": {
      "type": "text",
      "label": "Impressum – Inhalt"
    },
    "privacy_title": {
      "type": "text",
      "label": "Datenschutz – Titel"
    },
    "privacy_content": {
      "type": "text",
      "label": "Datenschutz – Inhalt"
    },
    "agb_title": {
      "type": "text",
      "label": "AGB & Widerruf – Titel"
    },
    "agb_content": {
      "type": "text",
      "label": "AGB & Widerruf – Inhalt"
    },
    "shipping_title": {
      "type": "text",
      "label": "Versand & Lieferung – Titel"
    },
    "shipping_content": {
      "type": "text",
      "label": "Versand & Lieferung – Inhalt"
    },
    "legal_demo_banner_title": {
      "type": "text",
      "label": "Rechtstexte Demo Warnung Titel"
    },
    "legal_demo_banner_text": {
      "type": "text",
      "label": "Rechtstexte Demo Warnung Text"
    },
    "legal_back_to_shop": {
      "type": "text",
      "label": "Zurück zum Shop Button"
    },
    "legal_last_updated_prefix": {
      "type": "text",
      "label": "Zuletzt aktualisiert Präfix"
    },
    "legal_tab_imprint": {
      "type": "text",
      "label": "Tab Impressum"
    },
    "legal_tab_privacy": {
      "type": "text",
      "label": "Tab Datenschutz"
    },
    "legal_tab_agb": {
      "type": "text",
      "label": "Tab AGB"
    },
    "legal_tab_shipping": {
      "type": "text",
      "label": "Tab Versand"
    },
    "legal_b2b_only_clause": {
      "type": "text",
      "label": "B2B Klausel Hinweis"
    },
    "legal_contact_representative": {
      "type": "text",
      "label": "Vertretungsberechtigter Label"
    },
    "legal_register_court_label": {
      "type": "text",
      "label": "Registergericht Label"
    },
    "legal_vat_id_label": {
      "type": "text",
      "label": "USt-IdNr Label"
    }
  },
  "copilot": {
    "copilot_drawer_title": {
      "type": "text",
      "label": "Copilot Drawer Titel"
    },
    "copilot_drawer_subtitle": {
      "type": "text",
      "label": "Copilot Drawer Untertitel"
    },
    "copilot_welcome_msg": {
      "type": "text",
      "label": "Copilot Willkommensnachricht"
    },
    "copilot_suggest_prompt1": {
      "type": "text",
      "label": "Copilot Vorschlag 1"
    },
    "copilot_suggest_prompt2": {
      "type": "text",
      "label": "Copilot Vorschlag 2"
    },
    "copilot_suggest_prompt3": {
      "type": "text",
      "label": "Copilot Vorschlag 3"
    },
    "copilot_input_placeholder": {
      "type": "text",
      "label": "Copilot Eingabe Platzhalter"
    },
    "copilot_btn_send": {
      "type": "text",
      "label": "Copilot Senden Button"
    },
    "copilot_btn_clear": {
      "type": "text",
      "label": "Copilot Verlauf leeren Button"
    },
    "copilot_disclaimer_note": {
      "type": "text",
      "label": "Copilot Haftungshinweis"
    },
    "copilot_fab_tooltip": {
      "type": "text",
      "label": "Copilot FAB Tooltip"
    },
    "copilot_fab_badge": {
      "type": "text",
      "label": "Copilot FAB Badge"
    },
    "copilot_bom_card_title": {
      "type": "text",
      "label": "Copilot BOM Karte Titel"
    },
    "copilot_bom_card_add_all": {
      "type": "text",
      "label": "Copilot BOM Alle Hinzufügen"
    },
    "copilot_status_ready": {
      "type": "text",
      "label": "Copilot Status Bereit"
    }
  },
  "brand": {
    "logo": {
      "type": "image",
      "label": "Shop-Logo"
    },
    "favicon": {
      "type": "image",
      "label": "Shop-Favicon"
    },
    "brand_tagline": {
      "type": "text",
      "label": "Shop Tagline / Slogan"
    },
    "brand_company_legal_name": {
      "type": "text",
      "label": "Vollständiger Firmenname"
    }
  },
  "onboarding": {
    "onboarding_guide": {
      "type": "text",
      "label": "Kurzanleitung für Interessenten"
    },
    "onboarding_welcome_title": {
      "type": "text",
      "label": "Onboarding Willkommen Titel"
    },
    "onboarding_step1_text": {
      "type": "text",
      "label": "Onboarding Schritt 1"
    },
    "onboarding_step2_text": {
      "type": "text",
      "label": "Onboarding Schritt 2"
    }
  }
};

export const SERVER_REGISTERED_SLOTS = {
  "advisor": {
    "advisor_badge": {
      "type": "text"
    },
    "advisor_title": {
      "type": "text"
    },
    "advisor_subtitle": {
      "type": "text"
    },
    "advisor_intro_text": {
      "type": "text"
    },
    "advisor_step1_title": {
      "type": "text"
    },
    "advisor_step1_desc": {
      "type": "text"
    },
    "advisor_step2_title": {
      "type": "text"
    },
    "advisor_step2_desc": {
      "type": "text"
    },
    "advisor_step3_title": {
      "type": "text"
    },
    "advisor_step3_desc": {
      "type": "text"
    },
    "advisor_step4_title": {
      "type": "text"
    },
    "advisor_step4_desc": {
      "type": "text"
    },
    "advisor_opt_commercial_title": {
      "type": "text"
    },
    "advisor_opt_commercial_desc": {
      "type": "text"
    },
    "advisor_opt_residential_title": {
      "type": "text"
    },
    "advisor_opt_residential_desc": {
      "type": "text"
    },
    "advisor_opt_public_title": {
      "type": "text"
    },
    "advisor_opt_public_desc": {
      "type": "text"
    },
    "advisor_opt_critical_title": {
      "type": "text"
    },
    "advisor_opt_critical_desc": {
      "type": "text"
    },
    "advisor_discipline_video": {
      "type": "text"
    },
    "advisor_discipline_video_desc": {
      "type": "text"
    },
    "advisor_discipline_alarm": {
      "type": "text"
    },
    "advisor_discipline_alarm_desc": {
      "type": "text"
    },
    "advisor_discipline_access": {
      "type": "text"
    },
    "advisor_discipline_access_desc": {
      "type": "text"
    },
    "advisor_discipline_fire": {
      "type": "text"
    },
    "advisor_discipline_fire_desc": {
      "type": "text"
    },
    "advisor_discipline_power": {
      "type": "text"
    },
    "advisor_discipline_power_desc": {
      "type": "text"
    },
    "advisor_size_small": {
      "type": "text"
    },
    "advisor_size_medium": {
      "type": "text"
    },
    "advisor_size_large": {
      "type": "text"
    },
    "advisor_size_campus": {
      "type": "text"
    },
    "advisor_norm_vds_a": {
      "type": "text"
    },
    "advisor_norm_vds_b": {
      "type": "text"
    },
    "advisor_norm_vds_c": {
      "type": "text"
    },
    "advisor_norm_din_14675": {
      "type": "text"
    },
    "advisor_norm_en_50131": {
      "type": "text"
    },
    "advisor_norm_en_54": {
      "type": "text"
    },
    "advisor_indoor_label": {
      "type": "text"
    },
    "advisor_outdoor_label": {
      "type": "text"
    },
    "advisor_perimeter_label": {
      "type": "text"
    },
    "advisor_recording_label": {
      "type": "text"
    },
    "advisor_cloud_remote_label": {
      "type": "text"
    },
    "advisor_results_title": {
      "type": "text"
    },
    "advisor_results_subtitle": {
      "type": "text"
    },
    "advisor_results_bom_title": {
      "type": "text"
    },
    "advisor_results_bom_empty": {
      "type": "text"
    },
    "advisor_results_net_estimate": {
      "type": "text"
    },
    "advisor_results_disclaimer": {
      "type": "text"
    },
    "advisor_btn_next": {
      "type": "text"
    },
    "advisor_btn_back": {
      "type": "text"
    },
    "advisor_btn_restart": {
      "type": "text"
    },
    "advisor_btn_transfer_cart": {
      "type": "text"
    },
    "advisor_btn_request_quote": {
      "type": "text"
    },
    "advisor_btn_expert_call": {
      "type": "text"
    },
    "advisor_card_compatibility": {
      "type": "text"
    },
    "advisor_card_warranty": {
      "type": "text"
    },
    "advisor_card_support": {
      "type": "text"
    },
    "advisor_card_delivery": {
      "type": "text"
    },
    "advisor_summary_heading": {
      "type": "text"
    },
    "advisor_summary_building": {
      "type": "text"
    },
    "advisor_summary_disciplines": {
      "type": "text"
    },
    "advisor_summary_size": {
      "type": "text"
    },
    "advisor_summary_standards": {
      "type": "text"
    },
    "advisor_expert_note": {
      "type": "text"
    },
    "advisor_banner_image": {
      "type": "image"
    }
  },
  "product": {
    "pdp_breadcrumb_root": {
      "type": "text"
    },
    "pdp_breadcrumb_catalog": {
      "type": "text"
    },
    "pdp_back_link": {
      "type": "text"
    },
    "pdp_sku_label": {
      "type": "text"
    },
    "pdp_manufacturer_label": {
      "type": "text"
    },
    "pdp_category_label": {
      "type": "text"
    },
    "pdp_stock_in_stock": {
      "type": "text"
    },
    "pdp_stock_on_request": {
      "type": "text"
    },
    "pdp_price_net_label": {
      "type": "text"
    },
    "pdp_price_on_request": {
      "type": "text"
    },
    "pdp_vat_notice": {
      "type": "text"
    },
    "pdp_tiered_pricing_badge": {
      "type": "text"
    },
    "pdp_quantity_label": {
      "type": "text"
    },
    "pdp_add_to_cart_btn": {
      "type": "text"
    },
    "pdp_added_to_cart_state": {
      "type": "text"
    },
    "pdp_direct_quote_btn": {
      "type": "text"
    },
    "pdp_tab_description": {
      "type": "text"
    },
    "pdp_tab_specs": {
      "type": "text"
    },
    "pdp_tab_downloads": {
      "type": "text"
    },
    "pdp_tab_accessories": {
      "type": "text"
    },
    "pdp_no_specs_available": {
      "type": "text"
    },
    "pdp_no_downloads_available": {
      "type": "text"
    },
    "pdp_download_datasheet_label": {
      "type": "text"
    },
    "pdp_download_manual_label": {
      "type": "text"
    },
    "pdp_b2b_trade_notice": {
      "type": "text"
    },
    "pdp_shipping_info_title": {
      "type": "text"
    },
    "pdp_shipping_info_desc": {
      "type": "text"
    },
    "pdp_warranty_title": {
      "type": "text"
    },
    "pdp_warranty_desc": {
      "type": "text"
    },
    "pdp_consultation_title": {
      "type": "text"
    },
    "pdp_consultation_desc": {
      "type": "text"
    },
    "pdp_consultation_phone_label": {
      "type": "text"
    },
    "pdp_related_products_title": {
      "type": "text"
    },
    "pdp_related_products_subtitle": {
      "type": "text"
    },
    "pdp_spec_table_key_label": {
      "type": "text"
    },
    "pdp_spec_table_val_label": {
      "type": "text"
    }
  },
  "inquiry": {
    "inquiry_form_badge": {
      "type": "text"
    },
    "inquiry_form_title": {
      "type": "text"
    },
    "inquiry_form_subtitle": {
      "type": "text"
    },
    "inquiry_field_company": {
      "type": "text"
    },
    "inquiry_field_company_ph": {
      "type": "text"
    },
    "inquiry_field_name": {
      "type": "text"
    },
    "inquiry_field_name_ph": {
      "type": "text"
    },
    "inquiry_field_email": {
      "type": "text"
    },
    "inquiry_field_email_ph": {
      "type": "text"
    },
    "inquiry_field_phone": {
      "type": "text"
    },
    "inquiry_field_phone_ph": {
      "type": "text"
    },
    "inquiry_field_street": {
      "type": "text"
    },
    "inquiry_field_street_ph": {
      "type": "text"
    },
    "inquiry_field_zip_city": {
      "type": "text"
    },
    "inquiry_field_zip_city_ph": {
      "type": "text"
    },
    "inquiry_field_project_title": {
      "type": "text"
    },
    "inquiry_field_project_title_ph": {
      "type": "text"
    },
    "inquiry_field_message": {
      "type": "text"
    },
    "inquiry_field_message_ph": {
      "type": "text"
    },
    "inquiry_field_callback_pref": {
      "type": "text"
    },
    "inquiry_field_privacy_consent": {
      "type": "text"
    },
    "inquiry_btn_submit": {
      "type": "text"
    },
    "inquiry_btn_submitting": {
      "type": "text"
    },
    "inquiry_btn_cancel": {
      "type": "text"
    },
    "inquiry_err_company_required": {
      "type": "text"
    },
    "inquiry_err_name_required": {
      "type": "text"
    },
    "inquiry_err_email_invalid": {
      "type": "text"
    },
    "inquiry_err_privacy_required": {
      "type": "text"
    },
    "inquiry_success_title": {
      "type": "text"
    },
    "inquiry_success_subtitle": {
      "type": "text"
    },
    "inquiry_success_reference_label": {
      "type": "text"
    },
    "inquiry_success_next_steps_title": {
      "type": "text"
    },
    "inquiry_success_step1": {
      "type": "text"
    },
    "inquiry_success_step2": {
      "type": "text"
    },
    "inquiry_success_step3": {
      "type": "text"
    },
    "inquiry_success_btn_catalog": {
      "type": "text"
    },
    "inquiry_success_btn_home": {
      "type": "text"
    }
  },
  "cart": {
    "cart_page_title": {
      "type": "text"
    },
    "cart_page_subtitle": {
      "type": "text"
    },
    "cart_empty_title": {
      "type": "text"
    },
    "cart_empty_desc": {
      "type": "text"
    },
    "cart_btn_browse_catalog": {
      "type": "text"
    },
    "cart_table_th_product": {
      "type": "text"
    },
    "cart_table_th_sku": {
      "type": "text"
    },
    "cart_table_th_price": {
      "type": "text"
    },
    "cart_table_th_qty": {
      "type": "text"
    },
    "cart_table_th_total": {
      "type": "text"
    },
    "cart_btn_remove_item": {
      "type": "text"
    },
    "cart_btn_clear_all": {
      "type": "text"
    },
    "cart_summary_title": {
      "type": "text"
    },
    "cart_summary_subtotal_net": {
      "type": "text"
    },
    "cart_summary_vat_label": {
      "type": "text"
    },
    "cart_summary_total_gross": {
      "type": "text"
    },
    "cart_summary_b2b_notice": {
      "type": "text"
    },
    "cart_btn_proceed_inquiry": {
      "type": "text"
    },
    "cart_btn_continue_shopping": {
      "type": "text"
    },
    "cart_bom_import_title": {
      "type": "text"
    },
    "cart_bom_import_desc": {
      "type": "text"
    },
    "cart_bom_import_btn": {
      "type": "text"
    },
    "cart_drawer_title": {
      "type": "text"
    },
    "cart_drawer_empty_text": {
      "type": "text"
    },
    "cart_drawer_subtotal_label": {
      "type": "text"
    },
    "cart_drawer_vat_hint": {
      "type": "text"
    },
    "cart_drawer_btn_view_cart": {
      "type": "text"
    },
    "cart_drawer_btn_checkout": {
      "type": "text"
    },
    "cart_drawer_btn_close": {
      "type": "text"
    },
    "cart_drawer_item_qty_dec": {
      "type": "text"
    },
    "cart_drawer_item_qty_inc": {
      "type": "text"
    },
    "cart_drawer_items_count_suffix": {
      "type": "text"
    },
    "cart_drawer_free_shipping_hint": {
      "type": "text"
    },
    "cart_drawer_b2b_tag": {
      "type": "text"
    }
  },
  "catalog": {
    "catalog_page_title": {
      "type": "text"
    },
    "catalog_page_subtitle": {
      "type": "text"
    },
    "catalog_results_found_prefix": {
      "type": "text"
    },
    "catalog_results_found_suffix": {
      "type": "text"
    },
    "catalog_empty_title": {
      "type": "text"
    },
    "catalog_empty_desc": {
      "type": "text"
    },
    "catalog_btn_reset_filters": {
      "type": "text"
    },
    "catalog_loading_text": {
      "type": "text"
    },
    "catalog_pagination_prev": {
      "type": "text"
    },
    "catalog_pagination_next": {
      "type": "text"
    },
    "catalog_pagination_page_of": {
      "type": "text"
    },
    "catalog_view_mode_grid": {
      "type": "text"
    },
    "catalog_view_mode_list": {
      "type": "text"
    },
    "catalog_b2b_wholesale_banner": {
      "type": "text"
    },
    "catalog_sort_label": {
      "type": "text"
    },
    "filter_topbar_all_categories": {
      "type": "text"
    },
    "filter_topbar_all_subcategories": {
      "type": "text"
    },
    "filter_topbar_all_manufacturers": {
      "type": "text"
    },
    "filter_topbar_sort_standard": {
      "type": "text"
    },
    "filter_topbar_sort_price_asc": {
      "type": "text"
    },
    "filter_topbar_sort_price_desc": {
      "type": "text"
    },
    "filter_topbar_sort_name_asc": {
      "type": "text"
    },
    "filter_topbar_search_ph": {
      "type": "text"
    },
    "filter_topbar_reset_all": {
      "type": "text"
    },
    "filter_topbar_active_filters_label": {
      "type": "text"
    },
    "filter_topbar_clear_search_tooltip": {
      "type": "text"
    },
    "filter_topbar_apply_filter_label": {
      "type": "text"
    },
    "filter_topbar_category_filter_label": {
      "type": "text"
    },
    "filter_topbar_manufacturer_filter_label": {
      "type": "text"
    },
    "filter_sidebar_title": {
      "type": "text"
    },
    "filter_sidebar_categories_heading": {
      "type": "text"
    },
    "filter_sidebar_all_categories_btn": {
      "type": "text"
    },
    "filter_sidebar_manufacturers_heading": {
      "type": "text"
    },
    "filter_sidebar_search_mfr_ph": {
      "type": "text"
    },
    "filter_sidebar_no_mfr_found": {
      "type": "text"
    },
    "filter_sidebar_reset_btn": {
      "type": "text"
    },
    "filter_sidebar_price_heading": {
      "type": "text"
    },
    "filter_sidebar_availability_heading": {
      "type": "text"
    },
    "filter_sidebar_in_stock_only": {
      "type": "text"
    },
    "filter_sidebar_b2b_certified": {
      "type": "text"
    },
    "filter_sidebar_subcat_heading": {
      "type": "text"
    },
    "card_product_details_btn": {
      "type": "text"
    },
    "card_product_request_btn": {
      "type": "text"
    },
    "card_product_price_net_suffix": {
      "type": "text"
    },
    "card_product_price_on_request": {
      "type": "text"
    },
    "card_specs_sku_prefix": {
      "type": "text"
    },
    "card_specs_mfr_fallback": {
      "type": "text"
    },
    "card_specs_net_label": {
      "type": "text"
    },
    "card_specs_vat_hint": {
      "type": "text"
    },
    "card_specs_add_btn": {
      "type": "text"
    },
    "card_specs_added_state": {
      "type": "text"
    },
    "card_specs_request_quote_btn": {
      "type": "text"
    },
    "card_specs_fast_ship_badge": {
      "type": "text"
    },
    "card_compact_sku_label": {
      "type": "text"
    },
    "card_compact_qty_dec": {
      "type": "text"
    },
    "card_compact_qty_inc": {
      "type": "text"
    },
    "card_compact_add_btn": {
      "type": "text"
    },
    "card_compact_net_price_label": {
      "type": "text"
    },
    "card_visual_recommendation_badge": {
      "type": "text"
    },
    "card_visual_in_stock_badge": {
      "type": "text"
    },
    "card_visual_add_cta": {
      "type": "text"
    },
    "card_visual_details_link": {
      "type": "text"
    },
    "card_visual_vat_note": {
      "type": "text"
    },
    "default_product_placeholder": {
      "type": "image"
    }
  },
  "header": {
    "header_topbar_b2b_badge": {
      "type": "text"
    },
    "header_topbar_direct_shipping": {
      "type": "text"
    },
    "header_topbar_hotline_label": {
      "type": "text"
    },
    "header_topbar_hotline_number": {
      "type": "text"
    },
    "header_topbar_email_label": {
      "type": "text"
    },
    "header_megamenu_trigger_label": {
      "type": "text"
    },
    "header_search_btn_label": {
      "type": "text"
    },
    "header_search_input_ph": {
      "type": "text"
    },
    "header_quote_cta_label": {
      "type": "text"
    },
    "header_cart_btn_label": {
      "type": "text"
    },
    "header_mobile_menu_open_label": {
      "type": "text"
    },
    "header_mobile_menu_close_label": {
      "type": "text"
    },
    "header_rubrik_video": {
      "type": "text"
    },
    "header_rubrik_gefahr": {
      "type": "text"
    },
    "header_rubrik_zutritt": {
      "type": "text"
    },
    "header_rubrik_brand": {
      "type": "text"
    },
    "header_rubrik_pulsar": {
      "type": "text"
    },
    "header_all_products_link": {
      "type": "text"
    },
    "header_fast_delivery_badge": {
      "type": "text"
    },
    "header_partner_portal_link": {
      "type": "text"
    },
    "header_advisor_link": {
      "type": "text"
    },
    "header_slim_logo_fallback": {
      "type": "text"
    },
    "header_slim_search_ph": {
      "type": "text"
    },
    "header_slim_ctrl_k_hint": {
      "type": "text"
    },
    "header_slim_hotline_badge": {
      "type": "text"
    },
    "header_slim_cart_title": {
      "type": "text"
    },
    "header_slim_catalog_nav": {
      "type": "text"
    },
    "header_slim_inquiry_nav": {
      "type": "text"
    },
    "header_slim_mobile_title": {
      "type": "text"
    },
    "header_centered_slogan_fallback": {
      "type": "text"
    },
    "header_centered_nav_catalog": {
      "type": "text"
    },
    "header_centered_nav_categories": {
      "type": "text"
    },
    "header_centered_nav_inquiry": {
      "type": "text"
    },
    "header_centered_nav_advisor": {
      "type": "text"
    },
    "header_centered_search_toggle": {
      "type": "text"
    },
    "header_centered_hotline_text": {
      "type": "text"
    },
    "header_mobile_back_btn": {
      "type": "text"
    },
    "header_mobile_view_all_cat": {
      "type": "text"
    },
    "header_mobile_items_suffix": {
      "type": "text"
    },
    "search_overlay_title": {
      "type": "text"
    },
    "search_overlay_input_ph": {
      "type": "text"
    },
    "search_overlay_hint": {
      "type": "text"
    },
    "search_overlay_recent_title": {
      "type": "text"
    },
    "search_overlay_categories_title": {
      "type": "text"
    },
    "search_overlay_no_results_title": {
      "type": "text"
    },
    "search_overlay_no_results_desc": {
      "type": "text"
    },
    "search_overlay_results_count": {
      "type": "text"
    },
    "search_overlay_view_all_btn": {
      "type": "text"
    },
    "search_overlay_close_btn": {
      "type": "text"
    },
    "search_overlay_esc_hint": {
      "type": "text"
    }
  },
  "home": {
    "hero_title": {
      "type": "text"
    },
    "hero_subtitle": {
      "type": "text"
    },
    "hero_cta_primary": {
      "type": "text"
    },
    "hero_cta_secondary": {
      "type": "text"
    },
    "trust_1_title": {
      "type": "text"
    },
    "trust_1_desc": {
      "type": "text"
    },
    "trust_2_title": {
      "type": "text"
    },
    "trust_2_desc": {
      "type": "text"
    },
    "trust_3_title": {
      "type": "text"
    },
    "trust_3_desc": {
      "type": "text"
    },
    "section_categories_title": {
      "type": "text"
    },
    "section_categories_subtitle": {
      "type": "text"
    },
    "hero_background": {
      "type": "image"
    },
    "hero_background_strength": {
      "type": "text"
    },
    "home_section_brands_title": {
      "type": "text"
    },
    "home_section_brands_subtitle": {
      "type": "text"
    },
    "home_section_cta_title": {
      "type": "text"
    },
    "home_section_cta_desc": {
      "type": "text"
    },
    "home_section_cta_btn": {
      "type": "text"
    },
    "home_advisor_teaser_title": {
      "type": "text"
    },
    "home_advisor_teaser_desc": {
      "type": "text"
    },
    "home_advisor_teaser_btn": {
      "type": "text"
    },
    "hero_split_spotlight_badge": {
      "type": "text"
    },
    "hero_split_stat1_label": {
      "type": "text"
    },
    "hero_split_stat1_val": {
      "type": "text"
    },
    "hero_split_stat2_label": {
      "type": "text"
    },
    "hero_split_stat2_val": {
      "type": "text"
    },
    "hero_split_stat3_label": {
      "type": "text"
    },
    "hero_split_stat3_val": {
      "type": "text"
    },
    "hero_split_card_title": {
      "type": "text"
    },
    "hero_split_card_sku_prefix": {
      "type": "text"
    },
    "hero_split_card_price_label": {
      "type": "text"
    },
    "hero_split_card_cart_btn": {
      "type": "text"
    },
    "hero_grid_partner_badge": {
      "type": "text"
    },
    "hero_grid_primary_cta": {
      "type": "text"
    },
    "hero_grid_secondary_cta": {
      "type": "text"
    },
    "hero_grid_card1_title": {
      "type": "text"
    },
    "hero_grid_card1_desc": {
      "type": "text"
    },
    "hero_grid_card2_title": {
      "type": "text"
    },
    "hero_grid_card2_desc": {
      "type": "text"
    },
    "hero_grid_card3_title": {
      "type": "text"
    },
    "hero_grid_card3_desc": {
      "type": "text"
    },
    "hero_grid_card4_title": {
      "type": "text"
    },
    "hero_grid_card4_desc": {
      "type": "text"
    },
    "hero_portal_badge": {
      "type": "text"
    },
    "hero_portal_search_btn": {
      "type": "text"
    },
    "hero_portal_chip_video": {
      "type": "text"
    },
    "hero_portal_chip_alarm": {
      "type": "text"
    },
    "hero_portal_chip_fire": {
      "type": "text"
    },
    "hero_portal_chip_access": {
      "type": "text"
    },
    "hero_portal_chip_power": {
      "type": "text"
    },
    "category_img_alarm": {
      "type": "image"
    },
    "category_img_video": {
      "type": "image"
    },
    "category_img_brand": {
      "type": "image"
    },
    "category_img_zutritt": {
      "type": "image"
    },
    "category_img_strom": {
      "type": "image"
    }
  },
  "footer": {
    "footer_description": {
      "type": "text"
    },
    "footer_partner_badge": {
      "type": "text"
    },
    "footer_b2b_notice": {
      "type": "text"
    },
    "footer_copyright": {
      "type": "text"
    },
    "footer_col1_title": {
      "type": "text"
    },
    "footer_col2_title": {
      "type": "text"
    },
    "footer_col3_title": {
      "type": "text"
    },
    "footer_link_catalog": {
      "type": "text"
    },
    "footer_link_advisor": {
      "type": "text"
    },
    "footer_link_inquiry": {
      "type": "text"
    },
    "footer_link_imprint": {
      "type": "text"
    },
    "footer_link_privacy": {
      "type": "text"
    },
    "footer_link_agb": {
      "type": "text"
    },
    "footer_link_shipping": {
      "type": "text"
    },
    "footer_contact_phone_label": {
      "type": "text"
    },
    "footer_contact_email_label": {
      "type": "text"
    },
    "footer_contact_hours_label": {
      "type": "text"
    },
    "footer_asl_association_notice": {
      "type": "text"
    },
    "footer_all_rights_reserved": {
      "type": "text"
    },
    "footer_secure_ordering_hint": {
      "type": "text"
    }
  },
  "legal": {
    "imprint_title": {
      "type": "text"
    },
    "imprint_content": {
      "type": "text"
    },
    "privacy_title": {
      "type": "text"
    },
    "privacy_content": {
      "type": "text"
    },
    "agb_title": {
      "type": "text"
    },
    "agb_content": {
      "type": "text"
    },
    "shipping_title": {
      "type": "text"
    },
    "shipping_content": {
      "type": "text"
    },
    "legal_demo_banner_title": {
      "type": "text"
    },
    "legal_demo_banner_text": {
      "type": "text"
    },
    "legal_back_to_shop": {
      "type": "text"
    },
    "legal_last_updated_prefix": {
      "type": "text"
    },
    "legal_tab_imprint": {
      "type": "text"
    },
    "legal_tab_privacy": {
      "type": "text"
    },
    "legal_tab_agb": {
      "type": "text"
    },
    "legal_tab_shipping": {
      "type": "text"
    },
    "legal_b2b_only_clause": {
      "type": "text"
    },
    "legal_contact_representative": {
      "type": "text"
    },
    "legal_register_court_label": {
      "type": "text"
    },
    "legal_vat_id_label": {
      "type": "text"
    }
  },
  "copilot": {
    "copilot_drawer_title": {
      "type": "text"
    },
    "copilot_drawer_subtitle": {
      "type": "text"
    },
    "copilot_welcome_msg": {
      "type": "text"
    },
    "copilot_suggest_prompt1": {
      "type": "text"
    },
    "copilot_suggest_prompt2": {
      "type": "text"
    },
    "copilot_suggest_prompt3": {
      "type": "text"
    },
    "copilot_input_placeholder": {
      "type": "text"
    },
    "copilot_btn_send": {
      "type": "text"
    },
    "copilot_btn_clear": {
      "type": "text"
    },
    "copilot_disclaimer_note": {
      "type": "text"
    },
    "copilot_fab_tooltip": {
      "type": "text"
    },
    "copilot_fab_badge": {
      "type": "text"
    },
    "copilot_bom_card_title": {
      "type": "text"
    },
    "copilot_bom_card_add_all": {
      "type": "text"
    },
    "copilot_status_ready": {
      "type": "text"
    }
  },
  "brand": {
    "logo": {
      "type": "image"
    },
    "favicon": {
      "type": "image"
    },
    "brand_tagline": {
      "type": "text"
    },
    "brand_company_legal_name": {
      "type": "text"
    }
  },
  "onboarding": {
    "onboarding_guide": {
      "type": "text"
    },
    "onboarding_welcome_title": {
      "type": "text"
    },
    "onboarding_step1_text": {
      "type": "text"
    },
    "onboarding_step2_text": {
      "type": "text"
    }
  }
};

export const CONTENT_FALLBACKS = {
  "advisor": {
    "advisor_badge": "Interaktiver Bedarfsassistent",
    "advisor_title": "Sicherheitslösung nach Maß planen",
    "advisor_subtitle": "In wenigen Schritten zur passenden Systemkonfiguration für Ihr Objekt.",
    "advisor_intro_text": "Beantworten Sie 4 kurze Fragen. Unser System ermittelt kompatible Komponenten aus dem ASL-Fachgroßhandelsbestand.",
    "advisor_step1_title": "Objektart wählen",
    "advisor_step1_desc": "Um welches Gebäude oder Areal handelt es sich?",
    "advisor_step2_title": "Schutzbereich festlegen",
    "advisor_step2_desc": "Welche Gewerke sollen abgedeckt werden?",
    "advisor_step3_title": "Objektgröße & Zonen",
    "advisor_step3_desc": "Wie groß ist die zu sichernde Fläche?",
    "advisor_step4_title": "Anforderungen & Normen",
    "advisor_step4_desc": "Besondere Zertifizierungen und Richtlinien.",
    "advisor_opt_commercial_title": "Gewerbe & Industrie",
    "advisor_opt_commercial_desc": "Bürogebäude, Lagerhallen, Produktionsstätten und Verkaufsflächen.",
    "advisor_opt_residential_title": "Privat & Wohnobjekt",
    "advisor_opt_residential_desc": "Einfamilienhäuser, Mehrfamilienhäuser und Wohnanlagen.",
    "advisor_opt_public_title": "Öffentliche Hand & Bildung",
    "advisor_opt_public_desc": "Schulen, Behörden, Sportstätten und Freizeitanlagen.",
    "advisor_opt_critical_title": "Kritische Infrastruktur (KRITIS)",
    "advisor_opt_critical_desc": "Umspannwerke, Rechenzentren, Wasserwerke mit erhöhten Sicherheitsauflagen.",
    "advisor_discipline_video": "Videoüberwachung (CCTV)",
    "advisor_discipline_video_desc": "IP-Kameras, NVR-Rekorder, KI-Videoanalytik und PTZ-Systeme.",
    "advisor_discipline_alarm": "Einbruchmelde- & Gefahrentechnik",
    "advisor_discipline_alarm_desc": "VdS-zertifizierte Zentralen, Bewegungsmelder, Magnetkontakte.",
    "advisor_discipline_access": "Zutrittskontrolle & Zeiterfassung",
    "advisor_discipline_access_desc": "RFID-Leser, Motorschlösser, biometrische Terminals, Drehkreuze.",
    "advisor_discipline_fire": "Brandmeldetechnik (BMA)",
    "advisor_discipline_fire_desc": "DIN 14675 / EN54-konforme Rauchmelder, Handfeuermelder, Koppler.",
    "advisor_discipline_power": "Notstrom & USV-Systeme",
    "advisor_discipline_power_desc": "Pulsar Netzteile, Akkumulatoren, Pufferstromversorgungen.",
    "advisor_size_small": "Bis 250 m² (Kompakt)",
    "advisor_size_medium": "250 bis 1.000 m² (Standard)",
    "advisor_size_large": "1.000 bis 5.000 m² (Erweitert)",
    "advisor_size_campus": "Über 5.000 m² / Campus-Areal",
    "advisor_norm_vds_a": "VdS Klasse A (Privat / Basisschutz)",
    "advisor_norm_vds_b": "VdS Klasse B (Gewerbe / Mittleres Risiko)",
    "advisor_norm_vds_c": "VdS Klasse C (Industrie / Hohes Risiko)",
    "advisor_norm_din_14675": "DIN 14675 Brandmeldeanlagen",
    "advisor_norm_en_50131": "DIN EN 50131 Grad 2 / Grad 3 EMA",
    "advisor_norm_en_54": "DIN EN 54 Brandmeldesysteme",
    "advisor_indoor_label": "Innenraumüberwachung",
    "advisor_outdoor_label": "Freigelände- & Perimeterabsicherung",
    "advisor_perimeter_label": "Zaun- und Zaunüberstiegsüberwachung",
    "advisor_recording_label": "DSGVO-konforme Langzeitaufzeichnung",
    "advisor_cloud_remote_label": "Sicherer Fernzugriff / Leitstellenaufschaltung",
    "advisor_results_title": "Empfohlene Systemzusammenstellung",
    "advisor_results_subtitle": "Basierend auf Ihren Angaben haben wir folgende Fachkomponenten vorausgewählt:",
    "advisor_results_bom_title": "Vorläufige Systemstückliste (BOM)",
    "advisor_results_bom_empty": "Für die gewählte Kombination liegen derzeit keine Standardpakete vor. Bitte stellen Sie eine individuelle Projektanfrage.",
    "advisor_results_net_estimate": "Geschätztes Budget:",
    "advisor_results_disclaimer": "Die angezeigten Preise sind unverbindlich und verstehen sich zzgl. gesetzlicher MwSt. Montage und Inbetriebnahme erfolgen durch einen Fachbetrieb.",
    "advisor_btn_next": "Nächster Schritt",
    "advisor_btn_back": "Zurück",
    "advisor_btn_restart": "Konfiguration neu starten",
    "advisor_btn_transfer_cart": "Auswahl in Anfragekorb übernehmen",
    "advisor_btn_request_quote": "Projektanfrage für Konfiguration stellen",
    "advisor_btn_expert_call": "Fachberatung anfordern",
    "advisor_card_compatibility": "100% herstellerübergreifend geprüft",
    "advisor_card_warranty": "Bis zu 5 Jahre Herstellergarantie",
    "advisor_card_support": "Technischer Projektsupport inklusive",
    "advisor_card_delivery": "Ab Zentrallager in 24/48h lieferbar",
    "advisor_summary_heading": "Ihre Projektparameter",
    "advisor_summary_building": "Objekttyp",
    "advisor_summary_disciplines": "Gewählte Gewerke",
    "advisor_summary_size": "Flächenklasse",
    "advisor_summary_standards": "Zertifizierungsstufe",
    "advisor_expert_note": "Haben Sie Fragen zur Projektierung? Unsere zertifizierten Systemplaner unterstützen Sie bei der Auslegung.",
    "advisor_banner_image": ""
  },
  "product": {
    "pdp_breadcrumb_root": "Startseite",
    "pdp_breadcrumb_catalog": "Katalog",
    "pdp_back_link": "Zurück zur Übersicht",
    "pdp_sku_label": "Art.-Nr.:",
    "pdp_manufacturer_label": "Hersteller:",
    "pdp_category_label": "Fachbereich:",
    "pdp_stock_in_stock": "Auf Lager – Versandfertig in 24h",
    "pdp_stock_on_request": "Lieferzeit auf Anfrage",
    "pdp_price_net_label": "Preis:",
    "pdp_price_on_request": "Preis auf Anfrage",
    "pdp_vat_notice": "Alle Preise zzgl. gesetzlicher MwSt.",
    "pdp_tiered_pricing_badge": "Projektkonditionen ab 5 Stk.",
    "pdp_quantity_label": "Menge:",
    "pdp_add_to_cart_btn": "In den Anfragekorb",
    "pdp_added_to_cart_state": "Im Anfragekorb",
    "pdp_direct_quote_btn": "Projektangebot anfordern",
    "pdp_tab_description": "Produktbeschreibung",
    "pdp_tab_specs": "Technische Daten",
    "pdp_tab_downloads": "Datenblätter & Dokumente",
    "pdp_tab_accessories": "Passendes Systemzubehör",
    "pdp_no_specs_available": "Für dieses Produkt liegen keine weiteren technischen Spezifikationen vor.",
    "pdp_no_downloads_available": "Aktuell sind keine separaten PDF-Datenblätter hinterlegt.",
    "pdp_download_datasheet_label": "Technisches Datenblatt (PDF)",
    "pdp_download_manual_label": "Installationsanleitung (PDF)",
    "pdp_b2b_trade_notice": "Verkauf ausschließlich an gewerbliche Kunden, Errichter und Fachplaner. Es gelten unsere B2B-Konditionen.",
    "pdp_shipping_info_title": "Direktversand ab Zentrallager",
    "pdp_shipping_info_desc": "Bestellungen bis 14 Uhr werden in der Regel am selben Werktag disponiert.",
    "pdp_warranty_title": "Offizieller Fachhandelsartikel",
    "pdp_warranty_desc": "Originalverpackte Neuware mit vollem Herstellersupport und Gewährleistung.",
    "pdp_consultation_title": "Fragen zu diesem Artikel?",
    "pdp_consultation_desc": "Unser technischer Vertrieb berät Sie gerne bei Planung und Ausschreibung.",
    "pdp_consultation_phone_label": "Technischer Support:",
    "pdp_related_products_title": "Ergänzende Systemkomponenten",
    "pdp_related_products_subtitle": "Häufig zusammen projektiert und bestellt.",
    "pdp_spec_table_key_label": "Merkmal",
    "pdp_spec_table_val_label": "Spezifikation"
  },
  "inquiry": {
    "inquiry_form_badge": "Unverbindliche B2B-Projektanfrage",
    "inquiry_form_title": "Projektkonditionen anfragen",
    "inquiry_form_subtitle": "Erhalten Sie ein maßgeschneidertes Angebot für Ihren gewerblichen Bedarf.",
    "inquiry_field_company": "Firma / Organisation *",
    "inquiry_field_company_ph": "z. B. Elektro Mustermann GmbH",
    "inquiry_field_name": "Ansprechpartner (Vor- & Nachname) *",
    "inquiry_field_name_ph": "z. B. Max Mustermann",
    "inquiry_field_email": "E-Mail-Adresse *",
    "inquiry_field_email_ph": "name@unternehmen.de",
    "inquiry_field_phone": "Telefonnummer für Rückfragen",
    "inquiry_field_phone_ph": "+49 123 4567890",
    "inquiry_field_street": "Straße & Hausnummer",
    "inquiry_field_street_ph": "Musterstraße 1",
    "inquiry_field_zip_city": "PLZ & Ort",
    "inquiry_field_zip_city_ph": "12345 Musterstadt",
    "inquiry_field_project_title": "Projektname / Referenz",
    "inquiry_field_project_title_ph": "z. B. Neubau Verwaltungsgebäude Süd",
    "inquiry_field_message": "Ihre Projektanforderungen / Stückliste",
    "inquiry_field_message_ph": "Bitte beschreiben Sie besondere Anforderungen, gewünschte Liefertermine oder Sonderwünsche...",
    "inquiry_field_callback_pref": "Telefonischer Rückruf durch technischen Vertrieb gewünscht",
    "inquiry_field_privacy_consent": "Ich stimme der Verarbeitung meiner Daten gemäß der Datenschutzerklärung zur Bearbeitung meiner Anfrage zu.",
    "inquiry_btn_submit": "Unverbindliche Anfrage absenden",
    "inquiry_btn_submitting": "Anfrage wird übermittelt...",
    "inquiry_btn_cancel": "Abbrechen",
    "inquiry_err_company_required": "Bitte geben Sie den Firmennamen an.",
    "inquiry_err_name_required": "Bitte geben Sie Ihren Namen an.",
    "inquiry_err_email_invalid": "Bitte geben Sie eine gültige E-Mail-Adresse an.",
    "inquiry_err_privacy_required": "Bitte bestätigen Sie die Datenschutzerklärung.",
    "inquiry_success_title": "Vielen Dank für Ihre Projektanfrage!",
    "inquiry_success_subtitle": "Ihre Anfrage ist erfolgreich bei unserem Vertriebsteam eingegangen.",
    "inquiry_success_reference_label": "Ihre Vorgangsnummer:",
    "inquiry_success_next_steps_title": "Wie geht es weiter?",
    "inquiry_success_step1": "1. Technische Prüfung Ihrer Stückliste und Verfügbarkeiten.",
    "inquiry_success_step2": "2. Erstellung eines individuellen B2B-Konditionenangebots.",
    "inquiry_success_step3": "3. Kontaktaufnahme per E-Mail oder Telefon innerhalb eines Werktages.",
    "inquiry_success_btn_catalog": "Zurück zum Produktkatalog",
    "inquiry_success_btn_home": "Zur Startseite"
  },
  "cart": {
    "cart_page_title": "Ihr Anfragekorb",
    "cart_page_subtitle": "Übersicht der ausgewählten Fachhandelsartikel für Ihre Projektanfrage.",
    "cart_empty_title": "Ihr Anfragekorb ist leer",
    "cart_empty_desc": "Sie haben bisher keine Artikel zur Projektliste hinzugefügt. Durchsuchen Sie unser Fachsortiment.",
    "cart_btn_browse_catalog": "Katalog öffnen",
    "cart_table_th_product": "Artikel / Beschreibung",
    "cart_table_th_sku": "Art.-Nr.",
    "cart_table_th_price": "Einzelpreis (netto)",
    "cart_table_th_qty": "Menge",
    "cart_table_th_total": "Gesamt (netto)",
    "cart_btn_remove_item": "Position entfernen",
    "cart_btn_clear_all": "Gesamte Liste leeren",
    "cart_summary_title": "Zusammenfassung",
    "cart_summary_subtotal_net": "Zwischensumme (netto):",
    "cart_summary_vat_label": "Zzgl. 19% USt.:",
    "cart_summary_total_gross": "Gesamtbetrag (brutto):",
    "cart_summary_b2b_notice": "Großhandelskonditionen freibleibend. Verbindliche Endpreise und Lieferzeiten erhalten Sie mit dem Projektangebot.",
    "cart_btn_proceed_inquiry": "Projektangebot anfordern",
    "cart_btn_continue_shopping": "Weitere Artikel hinzufügen",
    "cart_bom_import_title": "Stückliste importieren (CSV/Excel)",
    "cart_bom_import_desc": "Laden Sie Ihre Projektstückliste hoch, um Artikel automatisch zuzuordnen.",
    "cart_bom_import_btn": "Stückliste hochladen",
    "cart_drawer_title": "Anfragekorb",
    "cart_drawer_empty_text": "Noch keine Artikel im Korb.",
    "cart_drawer_subtotal_label": "Zwischensumme (netto)",
    "cart_drawer_vat_hint": "zzgl. 19% MwSt.",
    "cart_drawer_btn_view_cart": "Korb bearbeiten",
    "cart_drawer_btn_checkout": "Direkt anfragen",
    "cart_drawer_btn_close": "Schließen",
    "cart_drawer_item_qty_dec": "Menge verringern",
    "cart_drawer_item_qty_inc": "Menge erhöhen",
    "cart_drawer_items_count_suffix": "Artikel",
    "cart_drawer_free_shipping_hint": "Direktversand ab ASL-Zentrallager",
    "cart_drawer_b2b_tag": "Fachbetrieb"
  },
  "catalog": {
    "catalog_page_title": "ASL Sicherheits- & Großhandelssortiment",
    "catalog_page_subtitle": "Sicherheitstechnik führender Hersteller – persönlich beraten, regional montiert.",
    "catalog_results_found_prefix": "Gefunden:",
    "catalog_results_found_suffix": "Artikel",
    "catalog_empty_title": "Keine Produkte gefunden",
    "catalog_empty_desc": "Für Ihre gewählten Such- und Filterkriterien liegen keine passenden Artikel vor.",
    "catalog_btn_reset_filters": "Filter zurücksetzen",
    "catalog_loading_text": "Sortiment wird geladen...",
    "catalog_pagination_prev": "Vorherige Seite",
    "catalog_pagination_next": "Nächste Seite",
    "catalog_pagination_page_of": "Seite {current} von {total}",
    "catalog_view_mode_grid": "Rasteransicht",
    "catalog_view_mode_list": "Listenansicht",
    "catalog_b2b_wholesale_banner": "Großhandelssortiment für zertifizierte Facherrichter und Planer",
    "catalog_sort_label": "Sortierung:",
    "filter_topbar_all_categories": "Alle Fachbereiche",
    "filter_topbar_all_subcategories": "Alle Untergruppen",
    "filter_topbar_all_manufacturers": "Alle Hersteller",
    "filter_topbar_sort_standard": "Standard (ASL-Rang)",
    "filter_topbar_sort_price_asc": "Preis: aufsteigend",
    "filter_topbar_sort_price_desc": "Preis: absteigend",
    "filter_topbar_sort_name_asc": "Name: A bis Z",
    "filter_topbar_search_ph": "SKU, Modell oder Begriff suchen...",
    "filter_topbar_reset_all": "Filter leeren",
    "filter_topbar_active_filters_label": "Aktive Filter:",
    "filter_topbar_clear_search_tooltip": "Suchbegriff löschen",
    "filter_topbar_apply_filter_label": "Filter anwenden",
    "filter_topbar_category_filter_label": "Fachbereich wählen",
    "filter_topbar_manufacturer_filter_label": "Hersteller wählen",
    "filter_sidebar_title": "Filter & Kategorien",
    "filter_sidebar_categories_heading": "Fachbereiche",
    "filter_sidebar_all_categories_btn": "Alle Produkte anzeigen",
    "filter_sidebar_manufacturers_heading": "Hersteller",
    "filter_sidebar_search_mfr_ph": "Hersteller filtern...",
    "filter_sidebar_no_mfr_found": "Keine passenden Hersteller",
    "filter_sidebar_reset_btn": "Auswahl zurücksetzen",
    "filter_sidebar_price_heading": "Preisbereich (netto)",
    "filter_sidebar_availability_heading": "Verfügbarkeit",
    "filter_sidebar_in_stock_only": "Nur sofort lieferbare Artikel",
    "filter_sidebar_b2b_certified": "VdS / EN54 zertifiziert",
    "filter_sidebar_subcat_heading": "Unterkategorien",
    "card_product_details_btn": "Details ansehen",
    "card_product_request_btn": "Anfragen",
    "card_product_price_net_suffix": "netto",
    "card_product_price_on_request": "Auf Anfrage",
    "card_specs_sku_prefix": "Art.-Nr.",
    "card_specs_mfr_fallback": "Fachhandel",
    "card_specs_net_label": "Preis",
    "card_specs_vat_hint": "zzgl. MwSt.",
    "card_specs_add_btn": "In den Anfragekorb",
    "card_specs_added_state": "Im Korb",
    "card_specs_request_quote_btn": "Angebot anfordern",
    "card_specs_fast_ship_badge": "24h Versand",
    "card_compact_sku_label": "SKU:",
    "card_compact_qty_dec": "Menge reduzieren",
    "card_compact_qty_inc": "Menge erhöhen",
    "card_compact_add_btn": "Hinzufügen",
    "card_compact_net_price_label": "Netto",
    "card_visual_recommendation_badge": "Empfehlung",
    "card_visual_in_stock_badge": "Auf Lager",
    "card_visual_add_cta": "In den Anfragekorb",
    "card_visual_details_link": "Artikeldetails anzeigen",
    "card_visual_vat_note": "zzgl. 19% MwSt.",
    "default_product_placeholder": ""
  },
  "header": {
    "header_topbar_b2b_badge": "Ihr Fachbetrieb für Sicherheitstechnik",
    "header_topbar_direct_shipping": "Direktversand ab Zentrallager",
    "header_topbar_hotline_label": "Fachberatung:",
    "header_topbar_hotline_number": "+49 800 1234567",
    "header_topbar_email_label": "vertrieb@asl-partner.de",
    "header_megamenu_trigger_label": "Alle Fachbereiche",
    "header_search_btn_label": "Suchen",
    "header_search_input_ph": "Artikelnummer, Bezeichnung oder Hersteller eingeben...",
    "header_quote_cta_label": "Projektanfrage",
    "header_cart_btn_label": "Anfragekorb",
    "header_mobile_menu_open_label": "Menü öffnen",
    "header_mobile_menu_close_label": "Menü schließen",
    "header_rubrik_video": "Videoüberwachung",
    "header_rubrik_gefahr": "Gefahrenmeldetechnik",
    "header_rubrik_zutritt": "Zutrittskontrolle",
    "header_rubrik_brand": "Brandmeldetechnik",
    "header_rubrik_pulsar": "Stromversorgung & Gehäusetechnik",
    "header_all_products_link": "Gesamtes Sortiment durchsuchen",
    "header_fast_delivery_badge": "24h Expressversand",
    "header_partner_portal_link": "Partnerbereich",
    "header_advisor_link": "Sicherheitsberater",
    "header_slim_logo_fallback": "ASL Partner Shop",
    "header_slim_search_ph": "Katalog durchsuchen...",
    "header_slim_ctrl_k_hint": "Strg+K",
    "header_slim_hotline_badge": "B2B Support",
    "header_slim_cart_title": "Warenkorb öffnen",
    "header_slim_catalog_nav": "Katalog",
    "header_slim_inquiry_nav": "Projektanfrage",
    "header_slim_mobile_title": "Navigation",
    "header_centered_slogan_fallback": "Ihr Partner für Sicherheitstechnik",
    "header_centered_nav_catalog": "Sortiment",
    "header_centered_nav_categories": "Fachbereiche",
    "header_centered_nav_inquiry": "Projektanfrage",
    "header_centered_nav_advisor": "Bedarfsberater",
    "header_centered_search_toggle": "Suche einblenden",
    "header_centered_hotline_text": "Fachhotline",
    "header_mobile_back_btn": "Zurück zur Übersicht",
    "header_mobile_view_all_cat": "Alle Artikel dieser Kategorie",
    "header_mobile_items_suffix": "Artikel",
    "search_overlay_title": "Katalogschnellsuche",
    "search_overlay_input_ph": "Suchbegriff, Modellbezeichnung oder SKU...",
    "search_overlay_hint": "Tippen Sie mindestens 2 Zeichen für Live-Ergebnisse.",
    "search_overlay_recent_title": "Häufig gesucht:",
    "search_overlay_categories_title": "Schnellzugriff Fachbereiche:",
    "search_overlay_no_results_title": "Keine passenden Artikel gefunden",
    "search_overlay_no_results_desc": "Prüfen Sie die Schreibweise oder suchen Sie nach übergeordneten Fachbegriffen.",
    "search_overlay_results_count": "{count} Treffer gefunden",
    "search_overlay_view_all_btn": "Alle Suchergebnisse anzeigen",
    "search_overlay_close_btn": "Schließen (ESC)",
    "search_overlay_esc_hint": "ESC zum Schließen"
  },
  "home": {
    "hero_title": "Sicherheitstechnik direkt finden & disponieren.",
    "hero_subtitle": "Gezielte SKU-, Hersteller- und Artikelsuche im Fachgroßhandelsbestand für Errichter und Fachplaner.",
    "hero_cta_primary": "Gesamten Katalog durchsuchen",
    "hero_cta_secondary": "Projekt anfragen",
    "trust_1_title": "Fachberatung",
    "trust_1_desc": "Fachliche Beratung durch Ihren Fachpartner.",
    "trust_2_title": "B2B-Sortiment",
    "trust_2_desc": "Fachartikel für Sicherheitstechnik.",
    "trust_3_title": "Projektanfragen",
    "trust_3_desc": "Fachspezifische Konditionen und unverbindliche Projektanfragen.",
    "section_categories_title": "Fachbereiche wählen",
    "section_categories_subtitle": "Wählen Sie den passenden Systembereich für Ihr Sicherheitsprojekt.",
    "hero_background": "",
    "hero_background_strength": "0.5",
    "home_section_brands_title": "Führende Hersteller im Großhandelsportfolio",
    "home_section_brands_subtitle": "Zertifizierte Markenqualität für anspruchsvolle Sicherheitsprojekte.",
    "home_section_cta_title": "Sie planen ein größeres Sicherheitsprojekt?",
    "home_section_cta_desc": "Nutzen Sie unseren Projektierungsservice. Wir unterstützen Sie bei Ausschreibungen, Stücklisten und individuellen Staffelpreisen.",
    "home_section_cta_btn": "Jetzt unverbindlich anfragen",
    "home_advisor_teaser_title": "Unsicher bei der Produktauswahl?",
    "home_advisor_teaser_desc": "Unser digitaler Sicherheitsberater führt Sie in 4 Schritten zur passenden Lösung.",
    "home_advisor_teaser_btn": "Bedarfsberater starten",
    "hero_split_spotlight_badge": "Partner-Spotlight",
    "hero_split_stat1_label": "Verfügbare Fachartikel",
    "hero_split_stat1_val": "1.400+",
    "hero_split_stat2_label": "Zertifizierte Hersteller",
    "hero_split_stat2_val": "40+",
    "hero_split_stat3_label": "Lieferfähigkeit ab Lager",
    "hero_split_stat3_val": "24h",
    "hero_split_card_title": "Top-Empfehlung der Woche",
    "hero_split_card_sku_prefix": "Art.-Nr.:",
    "hero_split_card_price_label": "Preis",
    "hero_split_card_cart_btn": "In den Anfragekorb",
    "hero_grid_partner_badge": "Autorisierter Fachpartner",
    "hero_grid_primary_cta": "Gesamten Katalog öffnen",
    "hero_grid_secondary_cta": "Projektangebot anfragen",
    "hero_grid_card1_title": "Videoüberwachung",
    "hero_grid_card1_desc": "IP-Kameras & Rekorder",
    "hero_grid_card2_title": "Gefahrenmeldetechnik",
    "hero_grid_card2_desc": "Einbruch- & Funkmelder",
    "hero_grid_card3_title": "Zutrittskontrolle",
    "hero_grid_card3_desc": "RFID & Biometrie",
    "hero_grid_card4_title": "Brandmeldetechnik",
    "hero_grid_card4_desc": "DIN 14675 / EN54 BMA",
    "hero_portal_badge": "1.472 geprüfte ASL-Artikel",
    "hero_portal_search_btn": "Finden",
    "hero_portal_chip_video": "IP-Kameras",
    "hero_portal_chip_alarm": "Alarmzentralen",
    "hero_portal_chip_fire": "Brandmelder",
    "hero_portal_chip_access": "Zutrittsleser",
    "hero_portal_chip_power": "Netzteile & USV",
    "category_img_alarm": "",
    "category_img_video": "",
    "category_img_brand": "",
    "category_img_zutritt": "",
    "category_img_strom": ""
  },
  "footer": {
    "footer_description": "Ihr Partner für professionelle Sicherheitstechnik, Brandmeldetechnik und Systemlösungen.",
    "footer_partner_badge": "Fachpartner",
    "footer_b2b_notice": "Alle Preise zzgl. gesetzlicher MwSt. • Sicherheitstechnik für Zuhause und Betrieb",
    "footer_copyright": "Alle Rechte vorbehalten.",
    "footer_col1_title": "Navigation & Katalog",
    "footer_col2_title": "Rechtliches",
    "footer_col3_title": "Kontakt & Fachberatung",
    "footer_link_catalog": "Katalogübersicht",
    "footer_link_advisor": "Sicherheitsberater",
    "footer_link_inquiry": "Projektanfrage",
    "footer_link_imprint": "Impressum",
    "footer_link_privacy": "Datenschutzerklärung",
    "footer_link_agb": "AGB & Widerrufsbelehrung",
    "footer_link_shipping": "Versand & Lieferung",
    "footer_contact_phone_label": "Telefon:",
    "footer_contact_email_label": "E-Mail:",
    "footer_contact_hours_label": "Mo.–Fr. 08:00 – 17:00 Uhr",
    "footer_asl_association_notice": "ASL Großhandelspartner-Netzwerk",
    "footer_all_rights_reserved": "Alle Rechte vorbehalten.",
    "footer_secure_ordering_hint": "Verschlüsselte Datenübertragung (SSL/TLS)"
  },
  "legal": {
    "imprint_title": "Impressum",
    "imprint_content": "Dies ist ein unverbindlicher Demo-Platzhalter für das Impressum. Die Angaben gemäß § 5 DDG werden durch den jeweiligen Fachpartner vor Inbetriebnahme eingepflegt.",
    "privacy_title": "Datenschutzerklärung",
    "privacy_content": "Dies ist ein unverbindlicher Demo-Platzhalter für die Datenschutzerklärung. Die Pflichtangaben gemäß DSGVO werden durch den jeweiligen Fachpartner vor Inbetriebnahme hinterlegt.",
    "agb_title": "Allgemeine Geschäftsbedingungen & Widerrufsbelehrung",
    "agb_content": "Dies ist ein unverbindlicher Demo-Platzhalter für die Allgemeinen Geschäftsbedingungen (AGB) und Widerrufsinformationen. Die vertraglichen Bestimmungen für den B2B-Fachvertrieb werden durch den jeweiligen Fachpartner hinterlegt.",
    "shipping_title": "Versand- & Lieferbedingungen",
    "shipping_content": "Dies ist ein unverbindlicher Demo-Platzhalter für Versand- und Lieferkonditionen. Angaben zu Lieferzeiten, Versandkosten, Spedition und Selbstabholung werden durch den jeweiligen Fachpartner hinterlegt.",
    "legal_demo_banner_title": "Demo-Inhalt — Unverbindliche Platzhalter",
    "legal_demo_banner_text": "Die nachfolgenden Texte sind unverbindliche Mustertexte und müssen vor dem Echtbetrieb durch den Betreiber / Partner an die tatsächlichen Gegebenheiten angepasst werden.",
    "legal_back_to_shop": "Zurück zum Shop",
    "legal_last_updated_prefix": "Stand:",
    "legal_tab_imprint": "Impressum (§ 5 DDG)",
    "legal_tab_privacy": "Datenschutz (DSGVO)",
    "legal_tab_agb": "AGB & Widerruf",
    "legal_tab_shipping": "Versand & Logistik",
    "legal_b2b_only_clause": "Dieser Shop richtet sich an Privatkunden und Unternehmen.",
    "legal_contact_representative": "Vertretungsberechtigte Geschäftsführung:",
    "legal_register_court_label": "Registergericht & Registernummer:",
    "legal_vat_id_label": "Umsatzsteuer-Identifikationsnummer:"
  },
  "copilot": {
    "copilot_drawer_title": "ALWIS KI-Projektassistent",
    "copilot_drawer_subtitle": "Fachberatung zu Artikeln, Kompatibilität und Normen.",
    "copilot_welcome_msg": "Hallo! Ich bin ALWIS, Ihr KI-Experte für Sicherheitstechnik. Wie kann ich Sie bei Ihrer Projektierung unterstützen?",
    "copilot_suggest_prompt1": "Welche Kameras eignen sich für Außenbereiche bei Nacht?",
    "copilot_suggest_prompt2": "Welche VdS-Klasse brauche ich für ein Gewerbeobjekt?",
    "copilot_suggest_prompt3": "Gibt es kompatible Netzteile für Brandmelder?",
    "copilot_input_placeholder": "Frage zur Sicherheitstechnik eingeben...",
    "copilot_btn_send": "Senden",
    "copilot_btn_clear": "Verlauf leeren",
    "copilot_disclaimer_note": "KI-generierte Auskünfte ersetzen keine fachtechnische Detailplanung vor Ort.",
    "copilot_fab_tooltip": "KI-Fachberater öffnen",
    "copilot_fab_badge": "ALWIS KI",
    "copilot_bom_card_title": "Vorgeschlagene Komponenten",
    "copilot_bom_card_add_all": "Alle in den Anfragekorb",
    "copilot_status_ready": "Bereit für Ihre Anfrage"
  },
  "brand": {
    "logo": "",
    "favicon": "",
    "brand_tagline": "Ihr Fachpartner für moderne Sicherheitstechnik",
    "brand_company_legal_name": "ASL Partner Sicherheitstechnik GmbH"
  },
  "onboarding": {
    "onboarding_guide": "So bearbeiten Sie Ihren Shop: Wählen Sie eine Seite, klicken Sie in ein Textfeld und passen Sie die Inhalte an. Mit „Speichern“ werden die Änderungen sofort im Shop veröffentlicht.",
    "onboarding_welcome_title": "Willkommen in Ihrem White-Label Partner-Shop",
    "onboarding_step1_text": "1. Logo & Farben im Design-Drawer anpassen.",
    "onboarding_step2_text": "2. Texte und Kontaktdaten inline editieren."
  }
};

export const SLOT_METADATA = {
  "advisor": {
    "advisor_badge": {
      "type": "text",
      "label": "Sicherheitsberater Badge",
      "defaultValue": "Interaktiver Bedarfsassistent",
      "default_value": "Interaktiver Bedarfsassistent",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_title": {
      "type": "text",
      "label": "Sicherheitsberater Titel",
      "defaultValue": "Sicherheitslösung nach Maß planen",
      "default_value": "Sicherheitslösung nach Maß planen",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_subtitle": {
      "type": "text",
      "label": "Sicherheitsberater Untertitel",
      "defaultValue": "In wenigen Schritten zur passenden Systemkonfiguration für Ihr Objekt.",
      "default_value": "In wenigen Schritten zur passenden Systemkonfiguration für Ihr Objekt.",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_intro_text": {
      "type": "text",
      "label": "Sicherheitsberater Einleitung",
      "defaultValue": "Beantworten Sie 4 kurze Fragen. Unser System ermittelt kompatible Komponenten aus dem ASL-Fachgroßhandelsbestand.",
      "default_value": "Beantworten Sie 4 kurze Fragen. Unser System ermittelt kompatible Komponenten aus dem ASL-Fachgroßhandelsbestand.",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": true
    },
    "advisor_step1_title": {
      "type": "text",
      "label": "Schritt 1 Titel",
      "defaultValue": "Objektart wählen",
      "default_value": "Objektart wählen",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_step1_desc": {
      "type": "text",
      "label": "Schritt 1 Beschreibung",
      "defaultValue": "Um welches Gebäude oder Areal handelt es sich?",
      "default_value": "Um welches Gebäude oder Areal handelt es sich?",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_step2_title": {
      "type": "text",
      "label": "Schritt 2 Titel",
      "defaultValue": "Schutzbereich festlegen",
      "default_value": "Schutzbereich festlegen",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_step2_desc": {
      "type": "text",
      "label": "Schritt 2 Beschreibung",
      "defaultValue": "Welche Gewerke sollen abgedeckt werden?",
      "default_value": "Welche Gewerke sollen abgedeckt werden?",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_step3_title": {
      "type": "text",
      "label": "Schritt 3 Titel",
      "defaultValue": "Objektgröße & Zonen",
      "default_value": "Objektgröße & Zonen",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_step3_desc": {
      "type": "text",
      "label": "Schritt 3 Beschreibung",
      "defaultValue": "Wie groß ist die zu sichernde Fläche?",
      "default_value": "Wie groß ist die zu sichernde Fläche?",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_step4_title": {
      "type": "text",
      "label": "Schritt 4 Titel",
      "defaultValue": "Anforderungen & Normen",
      "default_value": "Anforderungen & Normen",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_step4_desc": {
      "type": "text",
      "label": "Schritt 4 Beschreibung",
      "defaultValue": "Besondere Zertifizierungen und Richtlinien.",
      "default_value": "Besondere Zertifizierungen und Richtlinien.",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_opt_commercial_title": {
      "type": "text",
      "label": "Option Gewerbe Titel",
      "defaultValue": "Gewerbe & Industrie",
      "default_value": "Gewerbe & Industrie",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_opt_commercial_desc": {
      "type": "text",
      "label": "Option Gewerbe Beschreibung",
      "defaultValue": "Bürogebäude, Lagerhallen, Produktionsstätten und Verkaufsflächen.",
      "default_value": "Bürogebäude, Lagerhallen, Produktionsstätten und Verkaufsflächen.",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_opt_residential_title": {
      "type": "text",
      "label": "Option Wohnen Titel",
      "defaultValue": "Privat & Wohnobjekt",
      "default_value": "Privat & Wohnobjekt",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_opt_residential_desc": {
      "type": "text",
      "label": "Option Wohnen Beschreibung",
      "defaultValue": "Einfamilienhäuser, Mehrfamilienhäuser und Wohnanlagen.",
      "default_value": "Einfamilienhäuser, Mehrfamilienhäuser und Wohnanlagen.",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_opt_public_title": {
      "type": "text",
      "label": "Option Öffentlich Titel",
      "defaultValue": "Öffentliche Hand & Bildung",
      "default_value": "Öffentliche Hand & Bildung",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_opt_public_desc": {
      "type": "text",
      "label": "Option Öffentlich Beschreibung",
      "defaultValue": "Schulen, Behörden, Sportstätten und Freizeitanlagen.",
      "default_value": "Schulen, Behörden, Sportstätten und Freizeitanlagen.",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_opt_critical_title": {
      "type": "text",
      "label": "Option KRITIS Titel",
      "defaultValue": "Kritische Infrastruktur (KRITIS)",
      "default_value": "Kritische Infrastruktur (KRITIS)",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_opt_critical_desc": {
      "type": "text",
      "label": "Option KRITIS Beschreibung",
      "defaultValue": "Umspannwerke, Rechenzentren, Wasserwerke mit erhöhten Sicherheitsauflagen.",
      "default_value": "Umspannwerke, Rechenzentren, Wasserwerke mit erhöhten Sicherheitsauflagen.",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_discipline_video": {
      "type": "text",
      "label": "Gewerk Videoüberwachung",
      "defaultValue": "Videoüberwachung (CCTV)",
      "default_value": "Videoüberwachung (CCTV)",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_discipline_video_desc": {
      "type": "text",
      "label": "Gewerk Video Beschreibung",
      "defaultValue": "IP-Kameras, NVR-Rekorder, KI-Videoanalytik und PTZ-Systeme.",
      "default_value": "IP-Kameras, NVR-Rekorder, KI-Videoanalytik und PTZ-Systeme.",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_discipline_alarm": {
      "type": "text",
      "label": "Gewerk Einbruchmelde",
      "defaultValue": "Einbruchmelde- & Gefahrentechnik",
      "default_value": "Einbruchmelde- & Gefahrentechnik",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_discipline_alarm_desc": {
      "type": "text",
      "label": "Gewerk Einbruchmelde Beschreibung",
      "defaultValue": "VdS-zertifizierte Zentralen, Bewegungsmelder, Magnetkontakte.",
      "default_value": "VdS-zertifizierte Zentralen, Bewegungsmelder, Magnetkontakte.",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_discipline_access": {
      "type": "text",
      "label": "Gewerk Zutrittskontrolle",
      "defaultValue": "Zutrittskontrolle & Zeiterfassung",
      "default_value": "Zutrittskontrolle & Zeiterfassung",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_discipline_access_desc": {
      "type": "text",
      "label": "Gewerk Zutrittskontrolle Beschreibung",
      "defaultValue": "RFID-Leser, Motorschlösser, biometrische Terminals, Drehkreuze.",
      "default_value": "RFID-Leser, Motorschlösser, biometrische Terminals, Drehkreuze.",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_discipline_fire": {
      "type": "text",
      "label": "Gewerk Brandmeldetechnik",
      "defaultValue": "Brandmeldetechnik (BMA)",
      "default_value": "Brandmeldetechnik (BMA)",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_discipline_fire_desc": {
      "type": "text",
      "label": "Gewerk Brandmelde Beschreibung",
      "defaultValue": "DIN 14675 / EN54-konforme Rauchmelder, Handfeuermelder, Koppler.",
      "default_value": "DIN 14675 / EN54-konforme Rauchmelder, Handfeuermelder, Koppler.",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_discipline_power": {
      "type": "text",
      "label": "Gewerk Stromversorgung",
      "defaultValue": "Notstrom & USV-Systeme",
      "default_value": "Notstrom & USV-Systeme",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_discipline_power_desc": {
      "type": "text",
      "label": "Gewerk Stromversorgung Beschreibung",
      "defaultValue": "Pulsar Netzteile, Akkumulatoren, Pufferstromversorgungen.",
      "default_value": "Pulsar Netzteile, Akkumulatoren, Pufferstromversorgungen.",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_size_small": {
      "type": "text",
      "label": "Größe Klein",
      "defaultValue": "Bis 250 m² (Kompakt)",
      "default_value": "Bis 250 m² (Kompakt)",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_size_medium": {
      "type": "text",
      "label": "Größe Mittel",
      "defaultValue": "250 bis 1.000 m² (Standard)",
      "default_value": "250 bis 1.000 m² (Standard)",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_size_large": {
      "type": "text",
      "label": "Größe Groß",
      "defaultValue": "1.000 bis 5.000 m² (Erweitert)",
      "default_value": "1.000 bis 5.000 m² (Erweitert)",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_size_campus": {
      "type": "text",
      "label": "Größe Campus",
      "defaultValue": "Über 5.000 m² / Campus-Areal",
      "default_value": "Über 5.000 m² / Campus-Areal",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_norm_vds_a": {
      "type": "text",
      "label": "Norm VdS A",
      "defaultValue": "VdS Klasse A (Privat / Basisschutz)",
      "default_value": "VdS Klasse A (Privat / Basisschutz)",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_norm_vds_b": {
      "type": "text",
      "label": "Norm VdS B",
      "defaultValue": "VdS Klasse B (Gewerbe / Mittleres Risiko)",
      "default_value": "VdS Klasse B (Gewerbe / Mittleres Risiko)",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_norm_vds_c": {
      "type": "text",
      "label": "Norm VdS C",
      "defaultValue": "VdS Klasse C (Industrie / Hohes Risiko)",
      "default_value": "VdS Klasse C (Industrie / Hohes Risiko)",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_norm_din_14675": {
      "type": "text",
      "label": "Norm DIN 14675",
      "defaultValue": "DIN 14675 Brandmeldeanlagen",
      "default_value": "DIN 14675 Brandmeldeanlagen",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_norm_en_50131": {
      "type": "text",
      "label": "Norm EN 50131",
      "defaultValue": "DIN EN 50131 Grad 2 / Grad 3 EMA",
      "default_value": "DIN EN 50131 Grad 2 / Grad 3 EMA",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_norm_en_54": {
      "type": "text",
      "label": "Norm EN 54",
      "defaultValue": "DIN EN 54 Brandmeldesysteme",
      "default_value": "DIN EN 54 Brandmeldesysteme",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_indoor_label": {
      "type": "text",
      "label": "Innenbereich Label",
      "defaultValue": "Innenraumüberwachung",
      "default_value": "Innenraumüberwachung",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_outdoor_label": {
      "type": "text",
      "label": "Außenbereich Label",
      "defaultValue": "Freigelände- & Perimeterabsicherung",
      "default_value": "Freigelände- & Perimeterabsicherung",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_perimeter_label": {
      "type": "text",
      "label": "Perimeter Label",
      "defaultValue": "Zaun- und Zaunüberstiegsüberwachung",
      "default_value": "Zaun- und Zaunüberstiegsüberwachung",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_recording_label": {
      "type": "text",
      "label": "Aufzeichnung Label",
      "defaultValue": "DSGVO-konforme Langzeitaufzeichnung",
      "default_value": "DSGVO-konforme Langzeitaufzeichnung",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_cloud_remote_label": {
      "type": "text",
      "label": "Fernzugriff Label",
      "defaultValue": "Sicherer Fernzugriff / Leitstellenaufschaltung",
      "default_value": "Sicherer Fernzugriff / Leitstellenaufschaltung",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_results_title": {
      "type": "text",
      "label": "Ergebnisse Titel",
      "defaultValue": "Empfohlene Systemzusammenstellung",
      "default_value": "Empfohlene Systemzusammenstellung",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_results_subtitle": {
      "type": "text",
      "label": "Ergebnisse Untertitel",
      "defaultValue": "Basierend auf Ihren Angaben haben wir folgende Fachkomponenten vorausgewählt:",
      "default_value": "Basierend auf Ihren Angaben haben wir folgende Fachkomponenten vorausgewählt:",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_results_bom_title": {
      "type": "text",
      "label": "Stückliste Titel",
      "defaultValue": "Vorläufige Systemstückliste (BOM)",
      "default_value": "Vorläufige Systemstückliste (BOM)",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_results_bom_empty": {
      "type": "text",
      "label": "Keine Komponenten gefunden",
      "defaultValue": "Für die gewählte Kombination liegen derzeit keine Standardpakete vor. Bitte stellen Sie eine individuelle Projektanfrage.",
      "default_value": "Für die gewählte Kombination liegen derzeit keine Standardpakete vor. Bitte stellen Sie eine individuelle Projektanfrage.",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_results_net_estimate": {
      "type": "text",
      "label": "Geschätzter Preis",
      "defaultValue": "Geschätztes Budget:",
      "default_value": "Geschätztes Budget:",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_results_disclaimer": {
      "type": "text",
      "label": "Hinweis Preis",
      "defaultValue": "Die angezeigten Preise sind unverbindlich und verstehen sich zzgl. gesetzlicher MwSt. Montage und Inbetriebnahme erfolgen durch einen Fachbetrieb.",
      "default_value": "Die angezeigten Preise sind unverbindlich und verstehen sich zzgl. gesetzlicher MwSt. Montage und Inbetriebnahme erfolgen durch einen Fachbetrieb.",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": true
    },
    "advisor_btn_next": {
      "type": "text",
      "label": "Button Weiter",
      "defaultValue": "Nächster Schritt",
      "default_value": "Nächster Schritt",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_btn_back": {
      "type": "text",
      "label": "Button Zurück",
      "defaultValue": "Zurück",
      "default_value": "Zurück",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_btn_restart": {
      "type": "text",
      "label": "Button Neustart",
      "defaultValue": "Konfiguration neu starten",
      "default_value": "Konfiguration neu starten",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_btn_transfer_cart": {
      "type": "text",
      "label": "Button in Warenkorb",
      "defaultValue": "Auswahl in Anfragekorb übernehmen",
      "default_value": "Auswahl in Anfragekorb übernehmen",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_btn_request_quote": {
      "type": "text",
      "label": "Button Projektanfrage",
      "defaultValue": "Projektanfrage für Konfiguration stellen",
      "default_value": "Projektanfrage für Konfiguration stellen",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_btn_expert_call": {
      "type": "text",
      "label": "Button Expertenberatung",
      "defaultValue": "Fachberatung anfordern",
      "default_value": "Fachberatung anfordern",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_card_compatibility": {
      "type": "text",
      "label": "Kompatibilität Hinweis",
      "defaultValue": "100% herstellerübergreifend geprüft",
      "default_value": "100% herstellerübergreifend geprüft",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_card_warranty": {
      "type": "text",
      "label": "Garantie Hinweis",
      "defaultValue": "Bis zu 5 Jahre Herstellergarantie",
      "default_value": "Bis zu 5 Jahre Herstellergarantie",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_card_support": {
      "type": "text",
      "label": "Support Hinweis",
      "defaultValue": "Technischer Projektsupport inklusive",
      "default_value": "Technischer Projektsupport inklusive",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_card_delivery": {
      "type": "text",
      "label": "Lieferung Hinweis",
      "defaultValue": "Ab Zentrallager in 24/48h lieferbar",
      "default_value": "Ab Zentrallager in 24/48h lieferbar",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_summary_heading": {
      "type": "text",
      "label": "Zusammenfassung Überschrift",
      "defaultValue": "Ihre Projektparameter",
      "default_value": "Ihre Projektparameter",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_summary_building": {
      "type": "text",
      "label": "Zusammenfassung Gebäude",
      "defaultValue": "Objekttyp",
      "default_value": "Objekttyp",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_summary_disciplines": {
      "type": "text",
      "label": "Zusammenfassung Gewerke",
      "defaultValue": "Gewählte Gewerke",
      "default_value": "Gewählte Gewerke",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_summary_size": {
      "type": "text",
      "label": "Zusammenfassung Größe",
      "defaultValue": "Flächenklasse",
      "default_value": "Flächenklasse",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_summary_standards": {
      "type": "text",
      "label": "Zusammenfassung Standards",
      "defaultValue": "Zertifizierungsstufe",
      "default_value": "Zertifizierungsstufe",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    },
    "advisor_expert_note": {
      "type": "text",
      "label": "Expertenhinweis",
      "defaultValue": "Haben Sie Fragen zur Projektierung? Unsere zertifizierten Systemplaner unterstützen Sie bei der Auslegung.",
      "default_value": "Haben Sie Fragen zur Projektierung? Unsere zertifizierten Systemplaner unterstützen Sie bei der Auslegung.",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": true
    },
    "advisor_banner_image": {
      "type": "image",
      "label": "Berater Banner Bild",
      "defaultValue": "",
      "default_value": "",
      "source_file": "src/features/advisor/SecurityAdvisor.jsx",
      "sourceFile": "src/features/advisor/SecurityAdvisor.jsx",
      "multiline": false
    }
  },
  "product": {
    "pdp_breadcrumb_root": {
      "type": "text",
      "label": "Breadcrumb Startseite",
      "defaultValue": "Startseite",
      "default_value": "Startseite",
      "source_file": "src/features/product/ProductDetailView.jsx",
      "sourceFile": "src/features/product/ProductDetailView.jsx",
      "multiline": false
    },
    "pdp_breadcrumb_catalog": {
      "type": "text",
      "label": "Breadcrumb Katalog",
      "defaultValue": "Katalog",
      "default_value": "Katalog",
      "source_file": "src/features/product/ProductDetailView.jsx",
      "sourceFile": "src/features/product/ProductDetailView.jsx",
      "multiline": false
    },
    "pdp_back_link": {
      "type": "text",
      "label": "Zurück-Button",
      "defaultValue": "Zurück zur Übersicht",
      "default_value": "Zurück zur Übersicht",
      "source_file": "src/features/product/ProductDetailView.jsx",
      "sourceFile": "src/features/product/ProductDetailView.jsx",
      "multiline": false
    },
    "pdp_sku_label": {
      "type": "text",
      "label": "Artikelnr. Label",
      "defaultValue": "Art.-Nr.:",
      "default_value": "Art.-Nr.:",
      "source_file": "src/features/product/ProductDetailView.jsx",
      "sourceFile": "src/features/product/ProductDetailView.jsx",
      "multiline": false
    },
    "pdp_manufacturer_label": {
      "type": "text",
      "label": "Hersteller Label",
      "defaultValue": "Hersteller:",
      "default_value": "Hersteller:",
      "source_file": "src/features/product/ProductDetailView.jsx",
      "sourceFile": "src/features/product/ProductDetailView.jsx",
      "multiline": false
    },
    "pdp_category_label": {
      "type": "text",
      "label": "Kategorie Label",
      "defaultValue": "Fachbereich:",
      "default_value": "Fachbereich:",
      "source_file": "src/features/product/ProductDetailView.jsx",
      "sourceFile": "src/features/product/ProductDetailView.jsx",
      "multiline": false
    },
    "pdp_stock_in_stock": {
      "type": "text",
      "label": "Lagerstatus Verfügbar",
      "defaultValue": "Auf Lager – Versandfertig in 24h",
      "default_value": "Auf Lager – Versandfertig in 24h",
      "source_file": "src/features/product/ProductDetailView.jsx",
      "sourceFile": "src/features/product/ProductDetailView.jsx",
      "multiline": false
    },
    "pdp_stock_on_request": {
      "type": "text",
      "label": "Lagerstatus Anfrage",
      "defaultValue": "Lieferzeit auf Anfrage",
      "default_value": "Lieferzeit auf Anfrage",
      "source_file": "src/features/product/ProductDetailView.jsx",
      "sourceFile": "src/features/product/ProductDetailView.jsx",
      "multiline": false
    },
    "pdp_price_net_label": {
      "type": "text",
      "label": "Netto-Preis Label",
      "defaultValue": "Preis:",
      "default_value": "Preis:",
      "source_file": "src/features/product/ProductDetailView.jsx",
      "sourceFile": "src/features/product/ProductDetailView.jsx",
      "multiline": false
    },
    "pdp_price_on_request": {
      "type": "text",
      "label": "Preis auf Anfrage",
      "defaultValue": "Preis auf Anfrage",
      "default_value": "Preis auf Anfrage",
      "source_file": "src/features/product/ProductDetailView.jsx",
      "sourceFile": "src/features/product/ProductDetailView.jsx",
      "multiline": false
    },
    "pdp_vat_notice": {
      "type": "text",
      "label": "MwSt. Hinweis",
      "defaultValue": "Alle Preise zzgl. gesetzlicher MwSt.",
      "default_value": "Alle Preise zzgl. gesetzlicher MwSt.",
      "source_file": "src/features/product/ProductDetailView.jsx",
      "sourceFile": "src/features/product/ProductDetailView.jsx",
      "multiline": false
    },
    "pdp_tiered_pricing_badge": {
      "type": "text",
      "label": "Staffelpreis Badge",
      "defaultValue": "Projektkonditionen ab 5 Stk.",
      "default_value": "Projektkonditionen ab 5 Stk.",
      "source_file": "src/features/product/ProductDetailView.jsx",
      "sourceFile": "src/features/product/ProductDetailView.jsx",
      "multiline": false
    },
    "pdp_quantity_label": {
      "type": "text",
      "label": "Menge Label",
      "defaultValue": "Menge:",
      "default_value": "Menge:",
      "source_file": "src/features/product/ProductDetailView.jsx",
      "sourceFile": "src/features/product/ProductDetailView.jsx",
      "multiline": false
    },
    "pdp_add_to_cart_btn": {
      "type": "text",
      "label": "In Anfragekorb Button",
      "defaultValue": "In den Anfragekorb",
      "default_value": "In den Anfragekorb",
      "source_file": "src/features/product/ProductDetailView.jsx",
      "sourceFile": "src/features/product/ProductDetailView.jsx",
      "multiline": false
    },
    "pdp_added_to_cart_state": {
      "type": "text",
      "label": "Hinzugefügt Status",
      "defaultValue": "Im Anfragekorb",
      "default_value": "Im Anfragekorb",
      "source_file": "src/features/product/ProductDetailView.jsx",
      "sourceFile": "src/features/product/ProductDetailView.jsx",
      "multiline": false
    },
    "pdp_direct_quote_btn": {
      "type": "text",
      "label": "Direkt anfragen Button",
      "defaultValue": "Projektangebot anfordern",
      "default_value": "Projektangebot anfordern",
      "source_file": "src/features/product/ProductDetailView.jsx",
      "sourceFile": "src/features/product/ProductDetailView.jsx",
      "multiline": false
    },
    "pdp_tab_description": {
      "type": "text",
      "label": "Tab Beschreibung",
      "defaultValue": "Produktbeschreibung",
      "default_value": "Produktbeschreibung",
      "source_file": "src/features/product/ProductDetailView.jsx",
      "sourceFile": "src/features/product/ProductDetailView.jsx",
      "multiline": false
    },
    "pdp_tab_specs": {
      "type": "text",
      "label": "Tab Technische Daten",
      "defaultValue": "Technische Daten",
      "default_value": "Technische Daten",
      "source_file": "src/features/product/ProductDetailView.jsx",
      "sourceFile": "src/features/product/ProductDetailView.jsx",
      "multiline": false
    },
    "pdp_tab_downloads": {
      "type": "text",
      "label": "Tab Downloads",
      "defaultValue": "Datenblätter & Dokumente",
      "default_value": "Datenblätter & Dokumente",
      "source_file": "src/features/product/ProductDetailView.jsx",
      "sourceFile": "src/features/product/ProductDetailView.jsx",
      "multiline": false
    },
    "pdp_tab_accessories": {
      "type": "text",
      "label": "Tab Zubehör",
      "defaultValue": "Passendes Systemzubehör",
      "default_value": "Passendes Systemzubehör",
      "source_file": "src/features/product/ProductDetailView.jsx",
      "sourceFile": "src/features/product/ProductDetailView.jsx",
      "multiline": false
    },
    "pdp_no_specs_available": {
      "type": "text",
      "label": "Keine Daten verfügbar",
      "defaultValue": "Für dieses Produkt liegen keine weiteren technischen Spezifikationen vor.",
      "default_value": "Für dieses Produkt liegen keine weiteren technischen Spezifikationen vor.",
      "source_file": "src/features/product/ProductDetailView.jsx",
      "sourceFile": "src/features/product/ProductDetailView.jsx",
      "multiline": false
    },
    "pdp_no_downloads_available": {
      "type": "text",
      "label": "Keine Downloads verfügbar",
      "defaultValue": "Aktuell sind keine separaten PDF-Datenblätter hinterlegt.",
      "default_value": "Aktuell sind keine separaten PDF-Datenblätter hinterlegt.",
      "source_file": "src/features/product/ProductDetailView.jsx",
      "sourceFile": "src/features/product/ProductDetailView.jsx",
      "multiline": false
    },
    "pdp_download_datasheet_label": {
      "type": "text",
      "label": "Datenblatt Download Label",
      "defaultValue": "Technisches Datenblatt (PDF)",
      "default_value": "Technisches Datenblatt (PDF)",
      "source_file": "src/features/product/ProductDetailView.jsx",
      "sourceFile": "src/features/product/ProductDetailView.jsx",
      "multiline": false
    },
    "pdp_download_manual_label": {
      "type": "text",
      "label": "Handbuch Download Label",
      "defaultValue": "Installationsanleitung (PDF)",
      "default_value": "Installationsanleitung (PDF)",
      "source_file": "src/features/product/ProductDetailView.jsx",
      "sourceFile": "src/features/product/ProductDetailView.jsx",
      "multiline": false
    },
    "pdp_b2b_trade_notice": {
      "type": "text",
      "label": "Hinweis",
      "defaultValue": "Verkauf ausschließlich an gewerbliche Kunden, Errichter und Fachplaner. Es gelten unsere B2B-Konditionen.",
      "default_value": "Verkauf ausschließlich an gewerbliche Kunden, Errichter und Fachplaner. Es gelten unsere B2B-Konditionen.",
      "source_file": "src/features/product/ProductDetailView.jsx",
      "sourceFile": "src/features/product/ProductDetailView.jsx",
      "multiline": true
    },
    "pdp_shipping_info_title": {
      "type": "text",
      "label": "Versandinfo Titel",
      "defaultValue": "Direktversand ab Zentrallager",
      "default_value": "Direktversand ab Zentrallager",
      "source_file": "src/features/product/ProductDetailView.jsx",
      "sourceFile": "src/features/product/ProductDetailView.jsx",
      "multiline": false
    },
    "pdp_shipping_info_desc": {
      "type": "text",
      "label": "Versandinfo Text",
      "defaultValue": "Bestellungen bis 14 Uhr werden in der Regel am selben Werktag disponiert.",
      "default_value": "Bestellungen bis 14 Uhr werden in der Regel am selben Werktag disponiert.",
      "source_file": "src/features/product/ProductDetailView.jsx",
      "sourceFile": "src/features/product/ProductDetailView.jsx",
      "multiline": false
    },
    "pdp_warranty_title": {
      "type": "text",
      "label": "Garantie Titel",
      "defaultValue": "Offizieller Fachhandelsartikel",
      "default_value": "Offizieller Fachhandelsartikel",
      "source_file": "src/features/product/ProductDetailView.jsx",
      "sourceFile": "src/features/product/ProductDetailView.jsx",
      "multiline": false
    },
    "pdp_warranty_desc": {
      "type": "text",
      "label": "Garantie Text",
      "defaultValue": "Originalverpackte Neuware mit vollem Herstellersupport und Gewährleistung.",
      "default_value": "Originalverpackte Neuware mit vollem Herstellersupport und Gewährleistung.",
      "source_file": "src/features/product/ProductDetailView.jsx",
      "sourceFile": "src/features/product/ProductDetailView.jsx",
      "multiline": false
    },
    "pdp_consultation_title": {
      "type": "text",
      "label": "Beratung Box Titel",
      "defaultValue": "Fragen zu diesem Artikel?",
      "default_value": "Fragen zu diesem Artikel?",
      "source_file": "src/features/product/ProductDetailView.jsx",
      "sourceFile": "src/features/product/ProductDetailView.jsx",
      "multiline": false
    },
    "pdp_consultation_desc": {
      "type": "text",
      "label": "Beratung Box Text",
      "defaultValue": "Unser technischer Vertrieb berät Sie gerne bei Planung und Ausschreibung.",
      "default_value": "Unser technischer Vertrieb berät Sie gerne bei Planung und Ausschreibung.",
      "source_file": "src/features/product/ProductDetailView.jsx",
      "sourceFile": "src/features/product/ProductDetailView.jsx",
      "multiline": false
    },
    "pdp_consultation_phone_label": {
      "type": "text",
      "label": "Telefonkontakt Label",
      "defaultValue": "Technischer Support:",
      "default_value": "Technischer Support:",
      "source_file": "src/features/product/ProductDetailView.jsx",
      "sourceFile": "src/features/product/ProductDetailView.jsx",
      "multiline": false
    },
    "pdp_related_products_title": {
      "type": "text",
      "label": "Ähnliche Produkte Titel",
      "defaultValue": "Ergänzende Systemkomponenten",
      "default_value": "Ergänzende Systemkomponenten",
      "source_file": "src/features/product/ProductDetailView.jsx",
      "sourceFile": "src/features/product/ProductDetailView.jsx",
      "multiline": false
    },
    "pdp_related_products_subtitle": {
      "type": "text",
      "label": "Ähnliche Produkte Untertitel",
      "defaultValue": "Häufig zusammen projektiert und bestellt.",
      "default_value": "Häufig zusammen projektiert und bestellt.",
      "source_file": "src/features/product/ProductDetailView.jsx",
      "sourceFile": "src/features/product/ProductDetailView.jsx",
      "multiline": false
    },
    "pdp_spec_table_key_label": {
      "type": "text",
      "label": "Spezifikation Merkmal Label",
      "defaultValue": "Merkmal",
      "default_value": "Merkmal",
      "source_file": "src/features/product/ProductDetailView.jsx",
      "sourceFile": "src/features/product/ProductDetailView.jsx",
      "multiline": false
    },
    "pdp_spec_table_val_label": {
      "type": "text",
      "label": "Spezifikation Wert Label",
      "defaultValue": "Spezifikation",
      "default_value": "Spezifikation",
      "source_file": "src/features/product/ProductDetailView.jsx",
      "sourceFile": "src/features/product/ProductDetailView.jsx",
      "multiline": false
    }
  },
  "inquiry": {
    "inquiry_form_badge": {
      "type": "text",
      "label": "Anfrageformular Badge",
      "defaultValue": "Unverbindliche B2B-Projektanfrage",
      "default_value": "Unverbindliche B2B-Projektanfrage",
      "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
      "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
      "multiline": false
    },
    "inquiry_form_title": {
      "type": "text",
      "label": "Anfrageformular Titel",
      "defaultValue": "Projektkonditionen anfragen",
      "default_value": "Projektkonditionen anfragen",
      "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
      "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
      "multiline": false
    },
    "inquiry_form_subtitle": {
      "type": "text",
      "label": "Anfrageformular Untertitel",
      "defaultValue": "Erhalten Sie ein maßgeschneidertes Angebot für Ihren gewerblichen Bedarf.",
      "default_value": "Erhalten Sie ein maßgeschneidertes Angebot für Ihren gewerblichen Bedarf.",
      "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
      "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
      "multiline": false
    },
    "inquiry_field_company": {
      "type": "text",
      "label": "Feld Firma Label",
      "defaultValue": "Firma / Organisation *",
      "default_value": "Firma / Organisation *",
      "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
      "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
      "multiline": false
    },
    "inquiry_field_company_ph": {
      "type": "text",
      "label": "Feld Firma Platzhalter",
      "defaultValue": "z. B. Elektro Mustermann GmbH",
      "default_value": "z. B. Elektro Mustermann GmbH",
      "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
      "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
      "multiline": false
    },
    "inquiry_field_name": {
      "type": "text",
      "label": "Feld Ansprechpartner Label",
      "defaultValue": "Ansprechpartner (Vor- & Nachname) *",
      "default_value": "Ansprechpartner (Vor- & Nachname) *",
      "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
      "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
      "multiline": false
    },
    "inquiry_field_name_ph": {
      "type": "text",
      "label": "Feld Ansprechpartner Platzhalter",
      "defaultValue": "z. B. Max Mustermann",
      "default_value": "z. B. Max Mustermann",
      "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
      "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
      "multiline": false
    },
    "inquiry_field_email": {
      "type": "text",
      "label": "Feld E-Mail Label",
      "defaultValue": "E-Mail-Adresse *",
      "default_value": "E-Mail-Adresse *",
      "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
      "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
      "multiline": false
    },
    "inquiry_field_email_ph": {
      "type": "text",
      "label": "Feld E-Mail Platzhalter",
      "defaultValue": "name@unternehmen.de",
      "default_value": "name@unternehmen.de",
      "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
      "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
      "multiline": false
    },
    "inquiry_field_phone": {
      "type": "text",
      "label": "Feld Telefon Label",
      "defaultValue": "Telefonnummer für Rückfragen",
      "default_value": "Telefonnummer für Rückfragen",
      "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
      "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
      "multiline": false
    },
    "inquiry_field_phone_ph": {
      "type": "text",
      "label": "Feld Telefon Platzhalter",
      "defaultValue": "+49 123 4567890",
      "default_value": "+49 123 4567890",
      "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
      "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
      "multiline": false
    },
    "inquiry_field_street": {
      "type": "text",
      "label": "Feld Straße Label",
      "defaultValue": "Straße & Hausnummer",
      "default_value": "Straße & Hausnummer",
      "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
      "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
      "multiline": false
    },
    "inquiry_field_street_ph": {
      "type": "text",
      "label": "Feld Straße Platzhalter",
      "defaultValue": "Musterstraße 1",
      "default_value": "Musterstraße 1",
      "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
      "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
      "multiline": false
    },
    "inquiry_field_zip_city": {
      "type": "text",
      "label": "Feld PLZ & Ort Label",
      "defaultValue": "PLZ & Ort",
      "default_value": "PLZ & Ort",
      "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
      "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
      "multiline": false
    },
    "inquiry_field_zip_city_ph": {
      "type": "text",
      "label": "Feld PLZ & Ort Platzhalter",
      "defaultValue": "12345 Musterstadt",
      "default_value": "12345 Musterstadt",
      "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
      "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
      "multiline": false
    },
    "inquiry_field_project_title": {
      "type": "text",
      "label": "Feld Projektname Label",
      "defaultValue": "Projektname / Referenz",
      "default_value": "Projektname / Referenz",
      "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
      "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
      "multiline": false
    },
    "inquiry_field_project_title_ph": {
      "type": "text",
      "label": "Feld Projektname Platzhalter",
      "defaultValue": "z. B. Neubau Verwaltungsgebäude Süd",
      "default_value": "z. B. Neubau Verwaltungsgebäude Süd",
      "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
      "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
      "multiline": false
    },
    "inquiry_field_message": {
      "type": "text",
      "label": "Feld Nachricht Label",
      "defaultValue": "Ihre Projektanforderungen / Stückliste",
      "default_value": "Ihre Projektanforderungen / Stückliste",
      "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
      "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
      "multiline": false
    },
    "inquiry_field_message_ph": {
      "type": "text",
      "label": "Feld Nachricht Platzhalter",
      "defaultValue": "Bitte beschreiben Sie besondere Anforderungen, gewünschte Liefertermine oder Sonderwünsche...",
      "default_value": "Bitte beschreiben Sie besondere Anforderungen, gewünschte Liefertermine oder Sonderwünsche...",
      "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
      "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
      "multiline": false
    },
    "inquiry_field_callback_pref": {
      "type": "text",
      "label": "Checkbox Rückruf gewünscht",
      "defaultValue": "Telefonischer Rückruf durch technischen Vertrieb gewünscht",
      "default_value": "Telefonischer Rückruf durch technischen Vertrieb gewünscht",
      "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
      "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
      "multiline": false
    },
    "inquiry_field_privacy_consent": {
      "type": "text",
      "label": "Datenschutz Einwilligung",
      "defaultValue": "Ich stimme der Verarbeitung meiner Daten gemäß der Datenschutzerklärung zur Bearbeitung meiner Anfrage zu.",
      "default_value": "Ich stimme der Verarbeitung meiner Daten gemäß der Datenschutzerklärung zur Bearbeitung meiner Anfrage zu.",
      "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
      "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
      "multiline": true
    },
    "inquiry_btn_submit": {
      "type": "text",
      "label": "Button Absenden",
      "defaultValue": "Unverbindliche Anfrage absenden",
      "default_value": "Unverbindliche Anfrage absenden",
      "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
      "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
      "multiline": false
    },
    "inquiry_btn_submitting": {
      "type": "text",
      "label": "Button Sendet...",
      "defaultValue": "Anfrage wird übermittelt...",
      "default_value": "Anfrage wird übermittelt...",
      "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
      "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
      "multiline": false
    },
    "inquiry_btn_cancel": {
      "type": "text",
      "label": "Button Abbrechen",
      "defaultValue": "Abbrechen",
      "default_value": "Abbrechen",
      "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
      "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
      "multiline": false
    },
    "inquiry_err_company_required": {
      "type": "text",
      "label": "Fehler Firma Pflichtfeld",
      "defaultValue": "Bitte geben Sie den Firmennamen an.",
      "default_value": "Bitte geben Sie den Firmennamen an.",
      "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
      "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
      "multiline": false
    },
    "inquiry_err_name_required": {
      "type": "text",
      "label": "Fehler Name Pflichtfeld",
      "defaultValue": "Bitte geben Sie Ihren Namen an.",
      "default_value": "Bitte geben Sie Ihren Namen an.",
      "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
      "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
      "multiline": false
    },
    "inquiry_err_email_invalid": {
      "type": "text",
      "label": "Fehler E-Mail ungültig",
      "defaultValue": "Bitte geben Sie eine gültige E-Mail-Adresse an.",
      "default_value": "Bitte geben Sie eine gültige E-Mail-Adresse an.",
      "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
      "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
      "multiline": false
    },
    "inquiry_err_privacy_required": {
      "type": "text",
      "label": "Fehler Datenschutz nötig",
      "defaultValue": "Bitte bestätigen Sie die Datenschutzerklärung.",
      "default_value": "Bitte bestätigen Sie die Datenschutzerklärung.",
      "source_file": "src/features/inquiry/QuoteRequestForm.jsx",
      "sourceFile": "src/features/inquiry/QuoteRequestForm.jsx",
      "multiline": false
    },
    "inquiry_success_title": {
      "type": "text",
      "label": "Erfolg Überschrift",
      "defaultValue": "Vielen Dank für Ihre Projektanfrage!",
      "default_value": "Vielen Dank für Ihre Projektanfrage!",
      "source_file": "src/features/inquiry/InquirySuccessView.jsx",
      "sourceFile": "src/features/inquiry/InquirySuccessView.jsx",
      "multiline": false
    },
    "inquiry_success_subtitle": {
      "type": "text",
      "label": "Erfolg Untertitel",
      "defaultValue": "Ihre Anfrage ist erfolgreich bei unserem Vertriebsteam eingegangen.",
      "default_value": "Ihre Anfrage ist erfolgreich bei unserem Vertriebsteam eingegangen.",
      "source_file": "src/features/inquiry/InquirySuccessView.jsx",
      "sourceFile": "src/features/inquiry/InquirySuccessView.jsx",
      "multiline": false
    },
    "inquiry_success_reference_label": {
      "type": "text",
      "label": "Vorgangsnummer Label",
      "defaultValue": "Ihre Vorgangsnummer:",
      "default_value": "Ihre Vorgangsnummer:",
      "source_file": "src/features/inquiry/InquirySuccessView.jsx",
      "sourceFile": "src/features/inquiry/InquirySuccessView.jsx",
      "multiline": false
    },
    "inquiry_success_next_steps_title": {
      "type": "text",
      "label": "Nächste Schritte Titel",
      "defaultValue": "Wie geht es weiter?",
      "default_value": "Wie geht es weiter?",
      "source_file": "src/features/inquiry/InquirySuccessView.jsx",
      "sourceFile": "src/features/inquiry/InquirySuccessView.jsx",
      "multiline": false
    },
    "inquiry_success_step1": {
      "type": "text",
      "label": "Schritt 1 Text",
      "defaultValue": "1. Technische Prüfung Ihrer Stückliste und Verfügbarkeiten.",
      "default_value": "1. Technische Prüfung Ihrer Stückliste und Verfügbarkeiten.",
      "source_file": "src/features/inquiry/InquirySuccessView.jsx",
      "sourceFile": "src/features/inquiry/InquirySuccessView.jsx",
      "multiline": false
    },
    "inquiry_success_step2": {
      "type": "text",
      "label": "Schritt 2 Text",
      "defaultValue": "2. Erstellung eines individuellen B2B-Konditionenangebots.",
      "default_value": "2. Erstellung eines individuellen B2B-Konditionenangebots.",
      "source_file": "src/features/inquiry/InquirySuccessView.jsx",
      "sourceFile": "src/features/inquiry/InquirySuccessView.jsx",
      "multiline": false
    },
    "inquiry_success_step3": {
      "type": "text",
      "label": "Schritt 3 Text",
      "defaultValue": "3. Kontaktaufnahme per E-Mail oder Telefon innerhalb eines Werktages.",
      "default_value": "3. Kontaktaufnahme per E-Mail oder Telefon innerhalb eines Werktages.",
      "source_file": "src/features/inquiry/InquirySuccessView.jsx",
      "sourceFile": "src/features/inquiry/InquirySuccessView.jsx",
      "multiline": false
    },
    "inquiry_success_btn_catalog": {
      "type": "text",
      "label": "Button Weiter einkaufen",
      "defaultValue": "Zurück zum Produktkatalog",
      "default_value": "Zurück zum Produktkatalog",
      "source_file": "src/features/inquiry/InquirySuccessView.jsx",
      "sourceFile": "src/features/inquiry/InquirySuccessView.jsx",
      "multiline": false
    },
    "inquiry_success_btn_home": {
      "type": "text",
      "label": "Button Zur Startseite",
      "defaultValue": "Zur Startseite",
      "default_value": "Zur Startseite",
      "source_file": "src/features/inquiry/InquirySuccessView.jsx",
      "sourceFile": "src/features/inquiry/InquirySuccessView.jsx",
      "multiline": false
    }
  },
  "cart": {
    "cart_page_title": {
      "type": "text",
      "label": "Warenkorb Seitentitel",
      "defaultValue": "Ihr Anfragekorb",
      "default_value": "Ihr Anfragekorb",
      "source_file": "src/features/cart/CartView.jsx",
      "sourceFile": "src/features/cart/CartView.jsx",
      "multiline": false
    },
    "cart_page_subtitle": {
      "type": "text",
      "label": "Warenkorb Untertitel",
      "defaultValue": "Übersicht der ausgewählten Fachhandelsartikel für Ihre Projektanfrage.",
      "default_value": "Übersicht der ausgewählten Fachhandelsartikel für Ihre Projektanfrage.",
      "source_file": "src/features/cart/CartView.jsx",
      "sourceFile": "src/features/cart/CartView.jsx",
      "multiline": false
    },
    "cart_empty_title": {
      "type": "text",
      "label": "Leerer Warenkorb Titel",
      "defaultValue": "Ihr Anfragekorb ist leer",
      "default_value": "Ihr Anfragekorb ist leer",
      "source_file": "src/features/cart/CartView.jsx",
      "sourceFile": "src/features/cart/CartView.jsx",
      "multiline": false
    },
    "cart_empty_desc": {
      "type": "text",
      "label": "Leerer Warenkorb Text",
      "defaultValue": "Sie haben bisher keine Artikel zur Projektliste hinzugefügt. Durchsuchen Sie unser Fachsortiment.",
      "default_value": "Sie haben bisher keine Artikel zur Projektliste hinzugefügt. Durchsuchen Sie unser Fachsortiment.",
      "source_file": "src/features/cart/CartView.jsx",
      "sourceFile": "src/features/cart/CartView.jsx",
      "multiline": false
    },
    "cart_btn_browse_catalog": {
      "type": "text",
      "label": "Button Katalog durchsuchen",
      "defaultValue": "Katalog öffnen",
      "default_value": "Katalog öffnen",
      "source_file": "src/features/cart/CartView.jsx",
      "sourceFile": "src/features/cart/CartView.jsx",
      "multiline": false
    },
    "cart_table_th_product": {
      "type": "text",
      "label": "Tabelle Spalte Produkt",
      "defaultValue": "Artikel / Beschreibung",
      "default_value": "Artikel / Beschreibung",
      "source_file": "src/features/cart/CartView.jsx",
      "sourceFile": "src/features/cart/CartView.jsx",
      "multiline": false
    },
    "cart_table_th_sku": {
      "type": "text",
      "label": "Tabelle Spalte SKU",
      "defaultValue": "Art.-Nr.",
      "default_value": "Art.-Nr.",
      "source_file": "src/features/cart/CartView.jsx",
      "sourceFile": "src/features/cart/CartView.jsx",
      "multiline": false
    },
    "cart_table_th_price": {
      "type": "text",
      "label": "Tabelle Spalte Einzelpreis",
      "defaultValue": "Einzelpreis (netto)",
      "default_value": "Einzelpreis (netto)",
      "source_file": "src/features/cart/CartView.jsx",
      "sourceFile": "src/features/cart/CartView.jsx",
      "multiline": false
    },
    "cart_table_th_qty": {
      "type": "text",
      "label": "Tabelle Spalte Menge",
      "defaultValue": "Menge",
      "default_value": "Menge",
      "source_file": "src/features/cart/CartView.jsx",
      "sourceFile": "src/features/cart/CartView.jsx",
      "multiline": false
    },
    "cart_table_th_total": {
      "type": "text",
      "label": "Tabelle Spalte Gesamt",
      "defaultValue": "Gesamt (netto)",
      "default_value": "Gesamt (netto)",
      "source_file": "src/features/cart/CartView.jsx",
      "sourceFile": "src/features/cart/CartView.jsx",
      "multiline": false
    },
    "cart_btn_remove_item": {
      "type": "text",
      "label": "Position entfernen Label",
      "defaultValue": "Position entfernen",
      "default_value": "Position entfernen",
      "source_file": "src/features/cart/CartView.jsx",
      "sourceFile": "src/features/cart/CartView.jsx",
      "multiline": false
    },
    "cart_btn_clear_all": {
      "type": "text",
      "label": "Warenkorb leeren Button",
      "defaultValue": "Gesamte Liste leeren",
      "default_value": "Gesamte Liste leeren",
      "source_file": "src/features/cart/CartView.jsx",
      "sourceFile": "src/features/cart/CartView.jsx",
      "multiline": false
    },
    "cart_summary_title": {
      "type": "text",
      "label": "Summenübersicht Titel",
      "defaultValue": "Zusammenfassung",
      "default_value": "Zusammenfassung",
      "source_file": "src/features/cart/CartView.jsx",
      "sourceFile": "src/features/cart/CartView.jsx",
      "multiline": false
    },
    "cart_summary_subtotal_net": {
      "type": "text",
      "label": "Zwischensumme Netto",
      "defaultValue": "Zwischensumme (netto):",
      "default_value": "Zwischensumme (netto):",
      "source_file": "src/features/cart/CartView.jsx",
      "sourceFile": "src/features/cart/CartView.jsx",
      "multiline": false
    },
    "cart_summary_vat_label": {
      "type": "text",
      "label": "MwSt. Zeile Label",
      "defaultValue": "Zzgl. 19% USt.:",
      "default_value": "Zzgl. 19% USt.:",
      "source_file": "src/features/cart/CartView.jsx",
      "sourceFile": "src/features/cart/CartView.jsx",
      "multiline": false
    },
    "cart_summary_total_gross": {
      "type": "text",
      "label": "Gesamtsumme Brutto",
      "defaultValue": "Gesamtbetrag (brutto):",
      "default_value": "Gesamtbetrag (brutto):",
      "source_file": "src/features/cart/CartView.jsx",
      "sourceFile": "src/features/cart/CartView.jsx",
      "multiline": false
    },
    "cart_summary_b2b_notice": {
      "type": "text",
      "label": "Warenkorb B2B Hinweis",
      "defaultValue": "Großhandelskonditionen freibleibend. Verbindliche Endpreise und Lieferzeiten erhalten Sie mit dem Projektangebot.",
      "default_value": "Großhandelskonditionen freibleibend. Verbindliche Endpreise und Lieferzeiten erhalten Sie mit dem Projektangebot.",
      "source_file": "src/features/cart/CartView.jsx",
      "sourceFile": "src/features/cart/CartView.jsx",
      "multiline": true
    },
    "cart_btn_proceed_inquiry": {
      "type": "text",
      "label": "Button Zur Projektanfrage",
      "defaultValue": "Projektangebot anfordern",
      "default_value": "Projektangebot anfordern",
      "source_file": "src/features/cart/CartView.jsx",
      "sourceFile": "src/features/cart/CartView.jsx",
      "multiline": false
    },
    "cart_btn_continue_shopping": {
      "type": "text",
      "label": "Button Weiter einkaufen",
      "defaultValue": "Weitere Artikel hinzufügen",
      "default_value": "Weitere Artikel hinzufügen",
      "source_file": "src/features/cart/CartView.jsx",
      "sourceFile": "src/features/cart/CartView.jsx",
      "multiline": false
    },
    "cart_bom_import_title": {
      "type": "text",
      "label": "BOM Import Titel",
      "defaultValue": "Stückliste importieren (CSV/Excel)",
      "default_value": "Stückliste importieren (CSV/Excel)",
      "source_file": "src/features/cart/CartView.jsx",
      "sourceFile": "src/features/cart/CartView.jsx",
      "multiline": false
    },
    "cart_bom_import_desc": {
      "type": "text",
      "label": "BOM Import Beschreibung",
      "defaultValue": "Laden Sie Ihre Projektstückliste hoch, um Artikel automatisch zuzuordnen.",
      "default_value": "Laden Sie Ihre Projektstückliste hoch, um Artikel automatisch zuzuordnen.",
      "source_file": "src/features/cart/CartView.jsx",
      "sourceFile": "src/features/cart/CartView.jsx",
      "multiline": false
    },
    "cart_bom_import_btn": {
      "type": "text",
      "label": "BOM Import Button",
      "defaultValue": "Stückliste hochladen",
      "default_value": "Stückliste hochladen",
      "source_file": "src/features/cart/CartView.jsx",
      "sourceFile": "src/features/cart/CartView.jsx",
      "multiline": false
    },
    "cart_drawer_title": {
      "type": "text",
      "label": "Drawer Titel",
      "defaultValue": "Anfragekorb",
      "default_value": "Anfragekorb",
      "source_file": "src/features/cart/CartDrawer.jsx",
      "sourceFile": "src/features/cart/CartDrawer.jsx",
      "multiline": false
    },
    "cart_drawer_empty_text": {
      "type": "text",
      "label": "Drawer Leer Text",
      "defaultValue": "Noch keine Artikel im Korb.",
      "default_value": "Noch keine Artikel im Korb.",
      "source_file": "src/features/cart/CartDrawer.jsx",
      "sourceFile": "src/features/cart/CartDrawer.jsx",
      "multiline": false
    },
    "cart_drawer_subtotal_label": {
      "type": "text",
      "label": "Drawer Zwischensumme",
      "defaultValue": "Zwischensumme (netto)",
      "default_value": "Zwischensumme (netto)",
      "source_file": "src/features/cart/CartDrawer.jsx",
      "sourceFile": "src/features/cart/CartDrawer.jsx",
      "multiline": false
    },
    "cart_drawer_vat_hint": {
      "type": "text",
      "label": "Drawer MwSt. Hinweis",
      "defaultValue": "zzgl. 19% MwSt.",
      "default_value": "zzgl. 19% MwSt.",
      "source_file": "src/features/cart/CartDrawer.jsx",
      "sourceFile": "src/features/cart/CartDrawer.jsx",
      "multiline": false
    },
    "cart_drawer_btn_view_cart": {
      "type": "text",
      "label": "Drawer Button Korb ansehen",
      "defaultValue": "Korb bearbeiten",
      "default_value": "Korb bearbeiten",
      "source_file": "src/features/cart/CartDrawer.jsx",
      "sourceFile": "src/features/cart/CartDrawer.jsx",
      "multiline": false
    },
    "cart_drawer_btn_checkout": {
      "type": "text",
      "label": "Drawer Button Zur Anfrage",
      "defaultValue": "Direkt anfragen",
      "default_value": "Direkt anfragen",
      "source_file": "src/features/cart/CartDrawer.jsx",
      "sourceFile": "src/features/cart/CartDrawer.jsx",
      "multiline": false
    },
    "cart_drawer_btn_close": {
      "type": "text",
      "label": "Drawer Schließen Label",
      "defaultValue": "Schließen",
      "default_value": "Schließen",
      "source_file": "src/features/cart/CartDrawer.jsx",
      "sourceFile": "src/features/cart/CartDrawer.jsx",
      "multiline": false
    },
    "cart_drawer_item_qty_dec": {
      "type": "text",
      "label": "Menge verringern Label",
      "defaultValue": "Menge verringern",
      "default_value": "Menge verringern",
      "source_file": "src/features/cart/CartDrawer.jsx",
      "sourceFile": "src/features/cart/CartDrawer.jsx",
      "multiline": false
    },
    "cart_drawer_item_qty_inc": {
      "type": "text",
      "label": "Menge erhöhen Label",
      "defaultValue": "Menge erhöhen",
      "default_value": "Menge erhöhen",
      "source_file": "src/features/cart/CartDrawer.jsx",
      "sourceFile": "src/features/cart/CartDrawer.jsx",
      "multiline": false
    },
    "cart_drawer_items_count_suffix": {
      "type": "text",
      "label": "Artikel Anzahl Suffix",
      "defaultValue": "Artikel",
      "default_value": "Artikel",
      "source_file": "src/features/cart/CartDrawer.jsx",
      "sourceFile": "src/features/cart/CartDrawer.jsx",
      "multiline": false
    },
    "cart_drawer_free_shipping_hint": {
      "type": "text",
      "label": "Versandhinweis Drawer",
      "defaultValue": "Direktversand ab ASL-Zentrallager",
      "default_value": "Direktversand ab ASL-Zentrallager",
      "source_file": "src/features/cart/CartDrawer.jsx",
      "sourceFile": "src/features/cart/CartDrawer.jsx",
      "multiline": false
    },
    "cart_drawer_b2b_tag": {
      "type": "text",
      "label": "B2B Tag Drawer",
      "defaultValue": "Fachbetrieb",
      "default_value": "Fachbetrieb",
      "source_file": "src/features/cart/CartDrawer.jsx",
      "sourceFile": "src/features/cart/CartDrawer.jsx",
      "multiline": false
    }
  },
  "catalog": {
    "catalog_page_title": {
      "type": "text",
      "label": "Katalog Seitentitel",
      "defaultValue": "ASL Sicherheits- & Großhandelssortiment",
      "default_value": "ASL Sicherheits- & Großhandelssortiment",
      "source_file": "src/features/catalog/CatalogView.jsx",
      "sourceFile": "src/features/catalog/CatalogView.jsx",
      "multiline": false
    },
    "catalog_page_subtitle": {
      "type": "text",
      "label": "Katalog Untertitel",
      "defaultValue": "Sicherheitstechnik führender Hersteller – persönlich beraten, regional montiert.",
      "default_value": "Sicherheitstechnik führender Hersteller – persönlich beraten, regional montiert.",
      "source_file": "src/features/catalog/CatalogView.jsx",
      "sourceFile": "src/features/catalog/CatalogView.jsx",
      "multiline": false
    },
    "catalog_results_found_prefix": {
      "type": "text",
      "label": "Gefundene Artikel Präfix",
      "defaultValue": "Gefunden:",
      "default_value": "Gefunden:",
      "source_file": "src/features/catalog/CatalogView.jsx",
      "sourceFile": "src/features/catalog/CatalogView.jsx",
      "multiline": false
    },
    "catalog_results_found_suffix": {
      "type": "text",
      "label": "Gefundene Artikel Suffix",
      "defaultValue": "Artikel",
      "default_value": "Artikel",
      "source_file": "src/features/catalog/CatalogView.jsx",
      "sourceFile": "src/features/catalog/CatalogView.jsx",
      "multiline": false
    },
    "catalog_empty_title": {
      "type": "text",
      "label": "Keine Treffer Titel",
      "defaultValue": "Keine Produkte gefunden",
      "default_value": "Keine Produkte gefunden",
      "source_file": "src/features/catalog/CatalogView.jsx",
      "sourceFile": "src/features/catalog/CatalogView.jsx",
      "multiline": false
    },
    "catalog_empty_desc": {
      "type": "text",
      "label": "Keine Treffer Text",
      "defaultValue": "Für Ihre gewählten Such- und Filterkriterien liegen keine passenden Artikel vor.",
      "default_value": "Für Ihre gewählten Such- und Filterkriterien liegen keine passenden Artikel vor.",
      "source_file": "src/features/catalog/CatalogView.jsx",
      "sourceFile": "src/features/catalog/CatalogView.jsx",
      "multiline": false
    },
    "catalog_btn_reset_filters": {
      "type": "text",
      "label": "Button Filter zurücksetzen",
      "defaultValue": "Filter zurücksetzen",
      "default_value": "Filter zurücksetzen",
      "source_file": "src/features/catalog/CatalogView.jsx",
      "sourceFile": "src/features/catalog/CatalogView.jsx",
      "multiline": false
    },
    "catalog_loading_text": {
      "type": "text",
      "label": "Katalog Lädt Text",
      "defaultValue": "Sortiment wird geladen...",
      "default_value": "Sortiment wird geladen...",
      "source_file": "src/features/catalog/CatalogView.jsx",
      "sourceFile": "src/features/catalog/CatalogView.jsx",
      "multiline": false
    },
    "catalog_pagination_prev": {
      "type": "text",
      "label": "Paginierung Vorherige",
      "defaultValue": "Vorherige Seite",
      "default_value": "Vorherige Seite",
      "source_file": "src/features/catalog/CatalogView.jsx",
      "sourceFile": "src/features/catalog/CatalogView.jsx",
      "multiline": false
    },
    "catalog_pagination_next": {
      "type": "text",
      "label": "Paginierung Nächste",
      "defaultValue": "Nächste Seite",
      "default_value": "Nächste Seite",
      "source_file": "src/features/catalog/CatalogView.jsx",
      "sourceFile": "src/features/catalog/CatalogView.jsx",
      "multiline": false
    },
    "catalog_pagination_page_of": {
      "type": "text",
      "label": "Paginierung Seite von",
      "defaultValue": "Seite {current} von {total}",
      "default_value": "Seite {current} von {total}",
      "source_file": "src/features/catalog/CatalogView.jsx",
      "sourceFile": "src/features/catalog/CatalogView.jsx",
      "multiline": false
    },
    "catalog_view_mode_grid": {
      "type": "text",
      "label": "Ansicht Raster",
      "defaultValue": "Rasteransicht",
      "default_value": "Rasteransicht",
      "source_file": "src/features/catalog/CatalogView.jsx",
      "sourceFile": "src/features/catalog/CatalogView.jsx",
      "multiline": false
    },
    "catalog_view_mode_list": {
      "type": "text",
      "label": "Ansicht Liste",
      "defaultValue": "Listenansicht",
      "default_value": "Listenansicht",
      "source_file": "src/features/catalog/CatalogView.jsx",
      "sourceFile": "src/features/catalog/CatalogView.jsx",
      "multiline": false
    },
    "catalog_b2b_wholesale_banner": {
      "type": "text",
      "label": "Katalog B2B Banner",
      "defaultValue": "Großhandelssortiment für zertifizierte Facherrichter und Planer",
      "default_value": "Großhandelssortiment für zertifizierte Facherrichter und Planer",
      "source_file": "src/features/catalog/CatalogView.jsx",
      "sourceFile": "src/features/catalog/CatalogView.jsx",
      "multiline": false
    },
    "catalog_sort_label": {
      "type": "text",
      "label": "Sortierung Label",
      "defaultValue": "Sortierung:",
      "default_value": "Sortierung:",
      "source_file": "src/features/catalog/CatalogView.jsx",
      "sourceFile": "src/features/catalog/CatalogView.jsx",
      "multiline": false
    },
    "filter_topbar_all_categories": {
      "type": "text",
      "label": "Topbar Alle Fachbereiche",
      "defaultValue": "Alle Fachbereiche",
      "default_value": "Alle Fachbereiche",
      "source_file": "src/registry/components/filters/TopbarFilterLayout.jsx",
      "sourceFile": "src/registry/components/filters/TopbarFilterLayout.jsx",
      "multiline": false
    },
    "filter_topbar_all_subcategories": {
      "type": "text",
      "label": "Topbar Alle Untergruppen",
      "defaultValue": "Alle Untergruppen",
      "default_value": "Alle Untergruppen",
      "source_file": "src/registry/components/filters/TopbarFilterLayout.jsx",
      "sourceFile": "src/registry/components/filters/TopbarFilterLayout.jsx",
      "multiline": false
    },
    "filter_topbar_all_manufacturers": {
      "type": "text",
      "label": "Topbar Alle Hersteller",
      "defaultValue": "Alle Hersteller",
      "default_value": "Alle Hersteller",
      "source_file": "src/registry/components/filters/TopbarFilterLayout.jsx",
      "sourceFile": "src/registry/components/filters/TopbarFilterLayout.jsx",
      "multiline": false
    },
    "filter_topbar_sort_standard": {
      "type": "text",
      "label": "Sortierung Standard",
      "defaultValue": "Standard (ASL-Rang)",
      "default_value": "Standard (ASL-Rang)",
      "source_file": "src/registry/components/filters/TopbarFilterLayout.jsx",
      "sourceFile": "src/registry/components/filters/TopbarFilterLayout.jsx",
      "multiline": false
    },
    "filter_topbar_sort_price_asc": {
      "type": "text",
      "label": "Sortierung Preis aufsteigend",
      "defaultValue": "Preis: aufsteigend",
      "default_value": "Preis: aufsteigend",
      "source_file": "src/registry/components/filters/TopbarFilterLayout.jsx",
      "sourceFile": "src/registry/components/filters/TopbarFilterLayout.jsx",
      "multiline": false
    },
    "filter_topbar_sort_price_desc": {
      "type": "text",
      "label": "Sortierung Preis absteigend",
      "defaultValue": "Preis: absteigend",
      "default_value": "Preis: absteigend",
      "source_file": "src/registry/components/filters/TopbarFilterLayout.jsx",
      "sourceFile": "src/registry/components/filters/TopbarFilterLayout.jsx",
      "multiline": false
    },
    "filter_topbar_sort_name_asc": {
      "type": "text",
      "label": "Sortierung Name",
      "defaultValue": "Name: A bis Z",
      "default_value": "Name: A bis Z",
      "source_file": "src/registry/components/filters/TopbarFilterLayout.jsx",
      "sourceFile": "src/registry/components/filters/TopbarFilterLayout.jsx",
      "multiline": false
    },
    "filter_topbar_search_ph": {
      "type": "text",
      "label": "Suchfeld Platzhalter Topbar",
      "defaultValue": "SKU, Modell oder Begriff suchen...",
      "default_value": "SKU, Modell oder Begriff suchen...",
      "source_file": "src/registry/components/filters/TopbarFilterLayout.jsx",
      "sourceFile": "src/registry/components/filters/TopbarFilterLayout.jsx",
      "multiline": false
    },
    "filter_topbar_reset_all": {
      "type": "text",
      "label": "Button Alle Filter löschen",
      "defaultValue": "Filter leeren",
      "default_value": "Filter leeren",
      "source_file": "src/registry/components/filters/TopbarFilterLayout.jsx",
      "sourceFile": "src/registry/components/filters/TopbarFilterLayout.jsx",
      "multiline": false
    },
    "filter_topbar_active_filters_label": {
      "type": "text",
      "label": "Aktive Filter Label",
      "defaultValue": "Aktive Filter:",
      "default_value": "Aktive Filter:",
      "source_file": "src/registry/components/filters/TopbarFilterLayout.jsx",
      "sourceFile": "src/registry/components/filters/TopbarFilterLayout.jsx",
      "multiline": false
    },
    "filter_topbar_clear_search_tooltip": {
      "type": "text",
      "label": "Suche leeren Tooltip",
      "defaultValue": "Suchbegriff löschen",
      "default_value": "Suchbegriff löschen",
      "source_file": "src/registry/components/filters/TopbarFilterLayout.jsx",
      "sourceFile": "src/registry/components/filters/TopbarFilterLayout.jsx",
      "multiline": false
    },
    "filter_topbar_apply_filter_label": {
      "type": "text",
      "label": "Filter anwenden Label",
      "defaultValue": "Filter anwenden",
      "default_value": "Filter anwenden",
      "source_file": "src/registry/components/filters/TopbarFilterLayout.jsx",
      "sourceFile": "src/registry/components/filters/TopbarFilterLayout.jsx",
      "multiline": false
    },
    "filter_topbar_category_filter_label": {
      "type": "text",
      "label": "Fachbereich Filter Label",
      "defaultValue": "Fachbereich wählen",
      "default_value": "Fachbereich wählen",
      "source_file": "src/registry/components/filters/TopbarFilterLayout.jsx",
      "sourceFile": "src/registry/components/filters/TopbarFilterLayout.jsx",
      "multiline": false
    },
    "filter_topbar_manufacturer_filter_label": {
      "type": "text",
      "label": "Hersteller Filter Label",
      "defaultValue": "Hersteller wählen",
      "default_value": "Hersteller wählen",
      "source_file": "src/registry/components/filters/TopbarFilterLayout.jsx",
      "sourceFile": "src/registry/components/filters/TopbarFilterLayout.jsx",
      "multiline": false
    },
    "filter_sidebar_title": {
      "type": "text",
      "label": "Sidebar Filter Titel",
      "defaultValue": "Filter & Kategorien",
      "default_value": "Filter & Kategorien",
      "source_file": "src/registry/components/filters/SidebarFilterLayout.jsx",
      "sourceFile": "src/registry/components/filters/SidebarFilterLayout.jsx",
      "multiline": false
    },
    "filter_sidebar_categories_heading": {
      "type": "text",
      "label": "Sidebar Fachbereiche Titel",
      "defaultValue": "Fachbereiche",
      "default_value": "Fachbereiche",
      "source_file": "src/registry/components/filters/SidebarFilterLayout.jsx",
      "sourceFile": "src/registry/components/filters/SidebarFilterLayout.jsx",
      "multiline": false
    },
    "filter_sidebar_all_categories_btn": {
      "type": "text",
      "label": "Sidebar Alle Produkte",
      "defaultValue": "Alle Produkte anzeigen",
      "default_value": "Alle Produkte anzeigen",
      "source_file": "src/registry/components/filters/SidebarFilterLayout.jsx",
      "sourceFile": "src/registry/components/filters/SidebarFilterLayout.jsx",
      "multiline": false
    },
    "filter_sidebar_manufacturers_heading": {
      "type": "text",
      "label": "Sidebar Hersteller Titel",
      "defaultValue": "Hersteller",
      "default_value": "Hersteller",
      "source_file": "src/registry/components/filters/SidebarFilterLayout.jsx",
      "sourceFile": "src/registry/components/filters/SidebarFilterLayout.jsx",
      "multiline": false
    },
    "filter_sidebar_search_mfr_ph": {
      "type": "text",
      "label": "Hersteller suchen Platzhalter",
      "defaultValue": "Hersteller filtern...",
      "default_value": "Hersteller filtern...",
      "source_file": "src/registry/components/filters/SidebarFilterLayout.jsx",
      "sourceFile": "src/registry/components/filters/SidebarFilterLayout.jsx",
      "multiline": false
    },
    "filter_sidebar_no_mfr_found": {
      "type": "text",
      "label": "Kein Hersteller gefunden",
      "defaultValue": "Keine passenden Hersteller",
      "default_value": "Keine passenden Hersteller",
      "source_file": "src/registry/components/filters/SidebarFilterLayout.jsx",
      "sourceFile": "src/registry/components/filters/SidebarFilterLayout.jsx",
      "multiline": false
    },
    "filter_sidebar_reset_btn": {
      "type": "text",
      "label": "Sidebar Reset Button",
      "defaultValue": "Auswahl zurücksetzen",
      "default_value": "Auswahl zurücksetzen",
      "source_file": "src/registry/components/filters/SidebarFilterLayout.jsx",
      "sourceFile": "src/registry/components/filters/SidebarFilterLayout.jsx",
      "multiline": false
    },
    "filter_sidebar_price_heading": {
      "type": "text",
      "label": "Sidebar Preisspanne Titel",
      "defaultValue": "Preisbereich (netto)",
      "default_value": "Preisbereich (netto)",
      "source_file": "src/registry/components/filters/SidebarFilterLayout.jsx",
      "sourceFile": "src/registry/components/filters/SidebarFilterLayout.jsx",
      "multiline": false
    },
    "filter_sidebar_availability_heading": {
      "type": "text",
      "label": "Sidebar Verfügbarkeit Titel",
      "defaultValue": "Verfügbarkeit",
      "default_value": "Verfügbarkeit",
      "source_file": "src/registry/components/filters/SidebarFilterLayout.jsx",
      "sourceFile": "src/registry/components/filters/SidebarFilterLayout.jsx",
      "multiline": false
    },
    "filter_sidebar_in_stock_only": {
      "type": "text",
      "label": "Nur Lagerware Checkbox",
      "defaultValue": "Nur sofort lieferbare Artikel",
      "default_value": "Nur sofort lieferbare Artikel",
      "source_file": "src/registry/components/filters/SidebarFilterLayout.jsx",
      "sourceFile": "src/registry/components/filters/SidebarFilterLayout.jsx",
      "multiline": false
    },
    "filter_sidebar_b2b_certified": {
      "type": "text",
      "label": "Nur Zertifizierte Checkbox",
      "defaultValue": "VdS / EN54 zertifiziert",
      "default_value": "VdS / EN54 zertifiziert",
      "source_file": "src/registry/components/filters/SidebarFilterLayout.jsx",
      "sourceFile": "src/registry/components/filters/SidebarFilterLayout.jsx",
      "multiline": false
    },
    "filter_sidebar_subcat_heading": {
      "type": "text",
      "label": "Sidebar Untergruppen Titel",
      "defaultValue": "Unterkategorien",
      "default_value": "Unterkategorien",
      "source_file": "src/registry/components/filters/SidebarFilterLayout.jsx",
      "sourceFile": "src/registry/components/filters/SidebarFilterLayout.jsx",
      "multiline": false
    },
    "card_product_details_btn": {
      "type": "text",
      "label": "Details ansehen Button",
      "defaultValue": "Details ansehen",
      "default_value": "Details ansehen",
      "source_file": "src/features/catalog/ProductCard.jsx",
      "sourceFile": "src/features/catalog/ProductCard.jsx",
      "multiline": false
    },
    "card_product_request_btn": {
      "type": "text",
      "label": "Artikel anfragen Button",
      "defaultValue": "Anfragen",
      "default_value": "Anfragen",
      "source_file": "src/features/catalog/ProductCard.jsx",
      "sourceFile": "src/features/catalog/ProductCard.jsx",
      "multiline": false
    },
    "card_product_price_net_suffix": {
      "type": "text",
      "label": "Netto Suffix",
      "defaultValue": "netto",
      "default_value": "netto",
      "source_file": "src/features/catalog/ProductCard.jsx",
      "sourceFile": "src/features/catalog/ProductCard.jsx",
      "multiline": false
    },
    "card_product_price_on_request": {
      "type": "text",
      "label": "Karte Preis auf Anfrage",
      "defaultValue": "Auf Anfrage",
      "default_value": "Auf Anfrage",
      "source_file": "src/features/catalog/ProductCard.jsx",
      "sourceFile": "src/features/catalog/ProductCard.jsx",
      "multiline": false
    },
    "card_specs_sku_prefix": {
      "type": "text",
      "label": "Specs Karte SKU Präfix",
      "defaultValue": "Art.-Nr.",
      "default_value": "Art.-Nr.",
      "source_file": "src/registry/components/cards/SpecsHeavyProductCard.jsx",
      "sourceFile": "src/registry/components/cards/SpecsHeavyProductCard.jsx",
      "multiline": false
    },
    "card_specs_mfr_fallback": {
      "type": "text",
      "label": "Specs Karte Hersteller Fallback",
      "defaultValue": "Fachhandel",
      "default_value": "Fachhandel",
      "source_file": "src/registry/components/cards/SpecsHeavyProductCard.jsx",
      "sourceFile": "src/registry/components/cards/SpecsHeavyProductCard.jsx",
      "multiline": false
    },
    "card_specs_net_label": {
      "type": "text",
      "label": "Specs Karte Netto Label",
      "defaultValue": "Preis",
      "default_value": "Preis",
      "source_file": "src/registry/components/cards/SpecsHeavyProductCard.jsx",
      "sourceFile": "src/registry/components/cards/SpecsHeavyProductCard.jsx",
      "multiline": false
    },
    "card_specs_vat_hint": {
      "type": "text",
      "label": "Specs Karte MwSt. Hinweis",
      "defaultValue": "zzgl. MwSt.",
      "default_value": "zzgl. MwSt.",
      "source_file": "src/registry/components/cards/SpecsHeavyProductCard.jsx",
      "sourceFile": "src/registry/components/cards/SpecsHeavyProductCard.jsx",
      "multiline": false
    },
    "card_specs_add_btn": {
      "type": "text",
      "label": "Specs Karte Hinzufügen Button",
      "defaultValue": "In den Anfragekorb",
      "default_value": "In den Anfragekorb",
      "source_file": "src/registry/components/cards/SpecsHeavyProductCard.jsx",
      "sourceFile": "src/registry/components/cards/SpecsHeavyProductCard.jsx",
      "multiline": false
    },
    "card_specs_added_state": {
      "type": "text",
      "label": "Specs Karte Im Korb Status",
      "defaultValue": "Im Korb",
      "default_value": "Im Korb",
      "source_file": "src/registry/components/cards/SpecsHeavyProductCard.jsx",
      "sourceFile": "src/registry/components/cards/SpecsHeavyProductCard.jsx",
      "multiline": false
    },
    "card_specs_request_quote_btn": {
      "type": "text",
      "label": "Specs Karte Anfragen Button",
      "defaultValue": "Angebot anfordern",
      "default_value": "Angebot anfordern",
      "source_file": "src/registry/components/cards/SpecsHeavyProductCard.jsx",
      "sourceFile": "src/registry/components/cards/SpecsHeavyProductCard.jsx",
      "multiline": false
    },
    "card_specs_fast_ship_badge": {
      "type": "text",
      "label": "Specs Karte Schnellversand",
      "defaultValue": "24h Versand",
      "default_value": "24h Versand",
      "source_file": "src/registry/components/cards/SpecsHeavyProductCard.jsx",
      "sourceFile": "src/registry/components/cards/SpecsHeavyProductCard.jsx",
      "multiline": false
    },
    "card_compact_sku_label": {
      "type": "text",
      "label": "Kompakt Karte SKU Label",
      "defaultValue": "SKU:",
      "default_value": "SKU:",
      "source_file": "src/registry/components/cards/CompactRowProductCard.jsx",
      "sourceFile": "src/registry/components/cards/CompactRowProductCard.jsx",
      "multiline": false
    },
    "card_compact_qty_dec": {
      "type": "text",
      "label": "Kompakt Karte Menge minus",
      "defaultValue": "Menge reduzieren",
      "default_value": "Menge reduzieren",
      "source_file": "src/registry/components/cards/CompactRowProductCard.jsx",
      "sourceFile": "src/registry/components/cards/CompactRowProductCard.jsx",
      "multiline": false
    },
    "card_compact_qty_inc": {
      "type": "text",
      "label": "Kompakt Karte Menge plus",
      "defaultValue": "Menge erhöhen",
      "default_value": "Menge erhöhen",
      "source_file": "src/registry/components/cards/CompactRowProductCard.jsx",
      "sourceFile": "src/registry/components/cards/CompactRowProductCard.jsx",
      "multiline": false
    },
    "card_compact_add_btn": {
      "type": "text",
      "label": "Kompakt Karte 1-Klick Button",
      "defaultValue": "Hinzufügen",
      "default_value": "Hinzufügen",
      "source_file": "src/registry/components/cards/CompactRowProductCard.jsx",
      "sourceFile": "src/registry/components/cards/CompactRowProductCard.jsx",
      "multiline": false
    },
    "card_compact_net_price_label": {
      "type": "text",
      "label": "Kompakt Karte Netto Preis",
      "defaultValue": "Netto",
      "default_value": "Netto",
      "source_file": "src/registry/components/cards/CompactRowProductCard.jsx",
      "sourceFile": "src/registry/components/cards/CompactRowProductCard.jsx",
      "multiline": false
    },
    "card_visual_recommendation_badge": {
      "type": "text",
      "label": "Visuelle Karte Empfehlung Badge",
      "defaultValue": "Empfehlung",
      "default_value": "Empfehlung",
      "source_file": "src/registry/components/cards/VisualProductCard.jsx",
      "sourceFile": "src/registry/components/cards/VisualProductCard.jsx",
      "multiline": false
    },
    "card_visual_in_stock_badge": {
      "type": "text",
      "label": "Visuelle Karte Lagernd Badge",
      "defaultValue": "Auf Lager",
      "default_value": "Auf Lager",
      "source_file": "src/registry/components/cards/VisualProductCard.jsx",
      "sourceFile": "src/registry/components/cards/VisualProductCard.jsx",
      "multiline": false
    },
    "card_visual_add_cta": {
      "type": "text",
      "label": "Visuelle Karte In Korb CTA",
      "defaultValue": "In den Anfragekorb",
      "default_value": "In den Anfragekorb",
      "source_file": "src/registry/components/cards/VisualProductCard.jsx",
      "sourceFile": "src/registry/components/cards/VisualProductCard.jsx",
      "multiline": false
    },
    "card_visual_details_link": {
      "type": "text",
      "label": "Visuelle Karte Details Link",
      "defaultValue": "Artikeldetails anzeigen",
      "default_value": "Artikeldetails anzeigen",
      "source_file": "src/registry/components/cards/VisualProductCard.jsx",
      "sourceFile": "src/registry/components/cards/VisualProductCard.jsx",
      "multiline": false
    },
    "card_visual_vat_note": {
      "type": "text",
      "label": "Visuelle Karte MwSt. Hinweis",
      "defaultValue": "zzgl. 19% MwSt.",
      "default_value": "zzgl. 19% MwSt.",
      "source_file": "src/registry/components/cards/VisualProductCard.jsx",
      "sourceFile": "src/registry/components/cards/VisualProductCard.jsx",
      "multiline": false
    },
    "default_product_placeholder": {
      "type": "image",
      "label": "Standard Produktbild Platzhalter",
      "defaultValue": "",
      "default_value": "",
      "source_file": "src/features/catalog/CatalogView.jsx",
      "sourceFile": "src/features/catalog/CatalogView.jsx",
      "multiline": false
    }
  },
  "header": {
    "header_topbar_b2b_badge": {
      "type": "text",
      "label": "Header Fachbetrieb Badge",
      "defaultValue": "Ihr Fachbetrieb für Sicherheitstechnik",
      "default_value": "Ihr Fachbetrieb für Sicherheitstechnik",
      "source_file": "src/registry/components/headers/EnterpriseHeader.jsx",
      "sourceFile": "src/registry/components/headers/EnterpriseHeader.jsx",
      "multiline": false
    },
    "header_topbar_direct_shipping": {
      "type": "text",
      "label": "Header Direktversand Text",
      "defaultValue": "Direktversand ab Zentrallager",
      "default_value": "Direktversand ab Zentrallager",
      "source_file": "src/registry/components/headers/EnterpriseHeader.jsx",
      "sourceFile": "src/registry/components/headers/EnterpriseHeader.jsx",
      "multiline": false
    },
    "header_topbar_hotline_label": {
      "type": "text",
      "label": "Header Hotline Label",
      "defaultValue": "Fachberatung:",
      "default_value": "Fachberatung:",
      "source_file": "src/registry/components/headers/EnterpriseHeader.jsx",
      "sourceFile": "src/registry/components/headers/EnterpriseHeader.jsx",
      "multiline": false
    },
    "header_topbar_hotline_number": {
      "type": "text",
      "label": "Header Hotline Telefonnummer",
      "defaultValue": "+49 800 1234567",
      "default_value": "+49 800 1234567",
      "source_file": "src/registry/components/headers/EnterpriseHeader.jsx",
      "sourceFile": "src/registry/components/headers/EnterpriseHeader.jsx",
      "multiline": false
    },
    "header_topbar_email_label": {
      "type": "text",
      "label": "Header E-Mail Label",
      "defaultValue": "vertrieb@asl-partner.de",
      "default_value": "vertrieb@asl-partner.de",
      "source_file": "src/registry/components/headers/EnterpriseHeader.jsx",
      "sourceFile": "src/registry/components/headers/EnterpriseHeader.jsx",
      "multiline": false
    },
    "header_megamenu_trigger_label": {
      "type": "text",
      "label": "Mega-Menü Button Label",
      "defaultValue": "Alle Fachbereiche",
      "default_value": "Alle Fachbereiche",
      "source_file": "src/registry/components/headers/EnterpriseHeader.jsx",
      "sourceFile": "src/registry/components/headers/EnterpriseHeader.jsx",
      "multiline": false
    },
    "header_search_btn_label": {
      "type": "text",
      "label": "Header Suche Button Label",
      "defaultValue": "Suchen",
      "default_value": "Suchen",
      "source_file": "src/registry/components/headers/EnterpriseHeader.jsx",
      "sourceFile": "src/registry/components/headers/EnterpriseHeader.jsx",
      "multiline": false
    },
    "header_search_input_ph": {
      "type": "text",
      "label": "Header Suchfeld Platzhalter",
      "defaultValue": "Artikelnummer, Bezeichnung oder Hersteller eingeben...",
      "default_value": "Artikelnummer, Bezeichnung oder Hersteller eingeben...",
      "source_file": "src/registry/components/headers/EnterpriseHeader.jsx",
      "sourceFile": "src/registry/components/headers/EnterpriseHeader.jsx",
      "multiline": false
    },
    "header_quote_cta_label": {
      "type": "text",
      "label": "Header Projektanfrage CTA",
      "defaultValue": "Projektanfrage",
      "default_value": "Projektanfrage",
      "source_file": "src/registry/components/headers/EnterpriseHeader.jsx",
      "sourceFile": "src/registry/components/headers/EnterpriseHeader.jsx",
      "multiline": false
    },
    "header_cart_btn_label": {
      "type": "text",
      "label": "Header Warenkorb Button",
      "defaultValue": "Anfragekorb",
      "default_value": "Anfragekorb",
      "source_file": "src/registry/components/headers/EnterpriseHeader.jsx",
      "sourceFile": "src/registry/components/headers/EnterpriseHeader.jsx",
      "multiline": false
    },
    "header_mobile_menu_open_label": {
      "type": "text",
      "label": "Mobil Menü öffnen Label",
      "defaultValue": "Menü öffnen",
      "default_value": "Menü öffnen",
      "source_file": "src/registry/components/headers/EnterpriseHeader.jsx",
      "sourceFile": "src/registry/components/headers/EnterpriseHeader.jsx",
      "multiline": false
    },
    "header_mobile_menu_close_label": {
      "type": "text",
      "label": "Mobil Menü schließen Label",
      "defaultValue": "Menü schließen",
      "default_value": "Menü schließen",
      "source_file": "src/registry/components/headers/EnterpriseHeader.jsx",
      "sourceFile": "src/registry/components/headers/EnterpriseHeader.jsx",
      "multiline": false
    },
    "header_rubrik_video": {
      "type": "text",
      "label": "Rubrik Videoüberwachung",
      "defaultValue": "Videoüberwachung",
      "default_value": "Videoüberwachung",
      "source_file": "src/registry/components/headers/EnterpriseHeader.jsx",
      "sourceFile": "src/registry/components/headers/EnterpriseHeader.jsx",
      "multiline": false
    },
    "header_rubrik_gefahr": {
      "type": "text",
      "label": "Rubrik Gefahrenmelde",
      "defaultValue": "Gefahrenmeldetechnik",
      "default_value": "Gefahrenmeldetechnik",
      "source_file": "src/registry/components/headers/EnterpriseHeader.jsx",
      "sourceFile": "src/registry/components/headers/EnterpriseHeader.jsx",
      "multiline": false
    },
    "header_rubrik_zutritt": {
      "type": "text",
      "label": "Rubrik Zutrittskontrolle",
      "defaultValue": "Zutrittskontrolle",
      "default_value": "Zutrittskontrolle",
      "source_file": "src/registry/components/headers/EnterpriseHeader.jsx",
      "sourceFile": "src/registry/components/headers/EnterpriseHeader.jsx",
      "multiline": false
    },
    "header_rubrik_brand": {
      "type": "text",
      "label": "Rubrik Brandmeldetechnik",
      "defaultValue": "Brandmeldetechnik",
      "default_value": "Brandmeldetechnik",
      "source_file": "src/registry/components/headers/EnterpriseHeader.jsx",
      "sourceFile": "src/registry/components/headers/EnterpriseHeader.jsx",
      "multiline": false
    },
    "header_rubrik_pulsar": {
      "type": "text",
      "label": "Rubrik PULSAR Stromversorgung",
      "defaultValue": "Stromversorgung & Gehäusetechnik",
      "default_value": "Stromversorgung & Gehäusetechnik",
      "source_file": "src/registry/components/headers/EnterpriseHeader.jsx",
      "sourceFile": "src/registry/components/headers/EnterpriseHeader.jsx",
      "multiline": false
    },
    "header_all_products_link": {
      "type": "text",
      "label": "Header Alle Produkte Link",
      "defaultValue": "Gesamtes Sortiment durchsuchen",
      "default_value": "Gesamtes Sortiment durchsuchen",
      "source_file": "src/registry/components/headers/EnterpriseHeader.jsx",
      "sourceFile": "src/registry/components/headers/EnterpriseHeader.jsx",
      "multiline": false
    },
    "header_fast_delivery_badge": {
      "type": "text",
      "label": "Header Schnellversand Badge",
      "defaultValue": "24h Expressversand",
      "default_value": "24h Expressversand",
      "source_file": "src/registry/components/headers/EnterpriseHeader.jsx",
      "sourceFile": "src/registry/components/headers/EnterpriseHeader.jsx",
      "multiline": false
    },
    "header_partner_portal_link": {
      "type": "text",
      "label": "Header Partner Portal Link",
      "defaultValue": "Partnerbereich",
      "default_value": "Partnerbereich",
      "source_file": "src/registry/components/headers/EnterpriseHeader.jsx",
      "sourceFile": "src/registry/components/headers/EnterpriseHeader.jsx",
      "multiline": false
    },
    "header_advisor_link": {
      "type": "text",
      "label": "Header Berater Link",
      "defaultValue": "Sicherheitsberater",
      "default_value": "Sicherheitsberater",
      "source_file": "src/registry/components/headers/EnterpriseHeader.jsx",
      "sourceFile": "src/registry/components/headers/EnterpriseHeader.jsx",
      "multiline": false
    },
    "header_slim_logo_fallback": {
      "type": "text",
      "label": "Slim Header Logo Fallback",
      "defaultValue": "ASL Partner Shop",
      "default_value": "ASL Partner Shop",
      "source_file": "src/registry/components/headers/SlimHeader.jsx",
      "sourceFile": "src/registry/components/headers/SlimHeader.jsx",
      "multiline": false
    },
    "header_slim_search_ph": {
      "type": "text",
      "label": "Slim Header Suche Platzhalter",
      "defaultValue": "Katalog durchsuchen...",
      "default_value": "Katalog durchsuchen...",
      "source_file": "src/registry/components/headers/SlimHeader.jsx",
      "sourceFile": "src/registry/components/headers/SlimHeader.jsx",
      "multiline": false
    },
    "header_slim_ctrl_k_hint": {
      "type": "text",
      "label": "Slim Header Strg+K Hinweis",
      "defaultValue": "Strg+K",
      "default_value": "Strg+K",
      "source_file": "src/registry/components/headers/SlimHeader.jsx",
      "sourceFile": "src/registry/components/headers/SlimHeader.jsx",
      "multiline": false
    },
    "header_slim_hotline_badge": {
      "type": "text",
      "label": "Slim Header Hotline Badge",
      "defaultValue": "B2B Support",
      "default_value": "B2B Support",
      "source_file": "src/registry/components/headers/SlimHeader.jsx",
      "sourceFile": "src/registry/components/headers/SlimHeader.jsx",
      "multiline": false
    },
    "header_slim_cart_title": {
      "type": "text",
      "label": "Slim Header Korb Titel",
      "defaultValue": "Warenkorb öffnen",
      "default_value": "Warenkorb öffnen",
      "source_file": "src/registry/components/headers/SlimHeader.jsx",
      "sourceFile": "src/registry/components/headers/SlimHeader.jsx",
      "multiline": false
    },
    "header_slim_catalog_nav": {
      "type": "text",
      "label": "Slim Header Nav Katalog",
      "defaultValue": "Katalog",
      "default_value": "Katalog",
      "source_file": "src/registry/components/headers/SlimHeader.jsx",
      "sourceFile": "src/registry/components/headers/SlimHeader.jsx",
      "multiline": false
    },
    "header_slim_inquiry_nav": {
      "type": "text",
      "label": "Slim Header Nav Anfrage",
      "defaultValue": "Projektanfrage",
      "default_value": "Projektanfrage",
      "source_file": "src/registry/components/headers/SlimHeader.jsx",
      "sourceFile": "src/registry/components/headers/SlimHeader.jsx",
      "multiline": false
    },
    "header_slim_mobile_title": {
      "type": "text",
      "label": "Slim Header Mobil Titel",
      "defaultValue": "Navigation",
      "default_value": "Navigation",
      "source_file": "src/registry/components/headers/SlimHeader.jsx",
      "sourceFile": "src/registry/components/headers/SlimHeader.jsx",
      "multiline": false
    },
    "header_centered_slogan_fallback": {
      "type": "text",
      "label": "Centered Header Slogan",
      "defaultValue": "Ihr Partner für Sicherheitstechnik",
      "default_value": "Ihr Partner für Sicherheitstechnik",
      "source_file": "src/registry/components/headers/CenteredBrandHeader.jsx",
      "sourceFile": "src/registry/components/headers/CenteredBrandHeader.jsx",
      "multiline": false
    },
    "header_centered_nav_catalog": {
      "type": "text",
      "label": "Centered Nav Katalog",
      "defaultValue": "Sortiment",
      "default_value": "Sortiment",
      "source_file": "src/registry/components/headers/CenteredBrandHeader.jsx",
      "sourceFile": "src/registry/components/headers/CenteredBrandHeader.jsx",
      "multiline": false
    },
    "header_centered_nav_categories": {
      "type": "text",
      "label": "Centered Nav Kategorien",
      "defaultValue": "Fachbereiche",
      "default_value": "Fachbereiche",
      "source_file": "src/registry/components/headers/CenteredBrandHeader.jsx",
      "sourceFile": "src/registry/components/headers/CenteredBrandHeader.jsx",
      "multiline": false
    },
    "header_centered_nav_inquiry": {
      "type": "text",
      "label": "Centered Nav Anfrage",
      "defaultValue": "Projektanfrage",
      "default_value": "Projektanfrage",
      "source_file": "src/registry/components/headers/CenteredBrandHeader.jsx",
      "sourceFile": "src/registry/components/headers/CenteredBrandHeader.jsx",
      "multiline": false
    },
    "header_centered_nav_advisor": {
      "type": "text",
      "label": "Centered Nav Berater",
      "defaultValue": "Bedarfsberater",
      "default_value": "Bedarfsberater",
      "source_file": "src/registry/components/headers/CenteredBrandHeader.jsx",
      "sourceFile": "src/registry/components/headers/CenteredBrandHeader.jsx",
      "multiline": false
    },
    "header_centered_search_toggle": {
      "type": "text",
      "label": "Centered Suche Toggle",
      "defaultValue": "Suche einblenden",
      "default_value": "Suche einblenden",
      "source_file": "src/registry/components/headers/CenteredBrandHeader.jsx",
      "sourceFile": "src/registry/components/headers/CenteredBrandHeader.jsx",
      "multiline": false
    },
    "header_centered_hotline_text": {
      "type": "text",
      "label": "Centered Hotline Text",
      "defaultValue": "Fachhotline",
      "default_value": "Fachhotline",
      "source_file": "src/registry/components/headers/CenteredBrandHeader.jsx",
      "sourceFile": "src/registry/components/headers/CenteredBrandHeader.jsx",
      "multiline": false
    },
    "header_mobile_back_btn": {
      "type": "text",
      "label": "Mobil Nav Zurück",
      "defaultValue": "Zurück zur Übersicht",
      "default_value": "Zurück zur Übersicht",
      "source_file": "src/registry/components/headers/MobileAslNode.jsx",
      "sourceFile": "src/registry/components/headers/MobileAslNode.jsx",
      "multiline": false
    },
    "header_mobile_view_all_cat": {
      "type": "text",
      "label": "Mobil Nav Alle in Kategorie",
      "defaultValue": "Alle Artikel dieser Kategorie",
      "default_value": "Alle Artikel dieser Kategorie",
      "source_file": "src/registry/components/headers/MobileAslNode.jsx",
      "sourceFile": "src/registry/components/headers/MobileAslNode.jsx",
      "multiline": false
    },
    "header_mobile_items_suffix": {
      "type": "text",
      "label": "Mobil Nav Artikel Suffix",
      "defaultValue": "Artikel",
      "default_value": "Artikel",
      "source_file": "src/registry/components/headers/MobileAslNode.jsx",
      "sourceFile": "src/registry/components/headers/MobileAslNode.jsx",
      "multiline": false
    },
    "search_overlay_title": {
      "type": "text",
      "label": "Such-Overlay Überschrift",
      "defaultValue": "Katalogschnellsuche",
      "default_value": "Katalogschnellsuche",
      "source_file": "src/components/search/SearchOverlay.jsx",
      "sourceFile": "src/components/search/SearchOverlay.jsx",
      "multiline": false
    },
    "search_overlay_input_ph": {
      "type": "text",
      "label": "Such-Overlay Platzhalter",
      "defaultValue": "Suchbegriff, Modellbezeichnung oder SKU...",
      "default_value": "Suchbegriff, Modellbezeichnung oder SKU...",
      "source_file": "src/components/search/SearchOverlay.jsx",
      "sourceFile": "src/components/search/SearchOverlay.jsx",
      "multiline": false
    },
    "search_overlay_hint": {
      "type": "text",
      "label": "Such-Overlay Eingabehinweis",
      "defaultValue": "Tippen Sie mindestens 2 Zeichen für Live-Ergebnisse.",
      "default_value": "Tippen Sie mindestens 2 Zeichen für Live-Ergebnisse.",
      "source_file": "src/components/search/SearchOverlay.jsx",
      "sourceFile": "src/components/search/SearchOverlay.jsx",
      "multiline": false
    },
    "search_overlay_recent_title": {
      "type": "text",
      "label": "Such-Overlay Letzte Suchen",
      "defaultValue": "Häufig gesucht:",
      "default_value": "Häufig gesucht:",
      "source_file": "src/components/search/SearchOverlay.jsx",
      "sourceFile": "src/components/search/SearchOverlay.jsx",
      "multiline": false
    },
    "search_overlay_categories_title": {
      "type": "text",
      "label": "Such-Overlay Beliebte Rubriken",
      "defaultValue": "Schnellzugriff Fachbereiche:",
      "default_value": "Schnellzugriff Fachbereiche:",
      "source_file": "src/components/search/SearchOverlay.jsx",
      "sourceFile": "src/components/search/SearchOverlay.jsx",
      "multiline": false
    },
    "search_overlay_no_results_title": {
      "type": "text",
      "label": "Such-Overlay Keine Treffer Titel",
      "defaultValue": "Keine passenden Artikel gefunden",
      "default_value": "Keine passenden Artikel gefunden",
      "source_file": "src/components/search/SearchOverlay.jsx",
      "sourceFile": "src/components/search/SearchOverlay.jsx",
      "multiline": false
    },
    "search_overlay_no_results_desc": {
      "type": "text",
      "label": "Such-Overlay Keine Treffer Text",
      "defaultValue": "Prüfen Sie die Schreibweise oder suchen Sie nach übergeordneten Fachbegriffen.",
      "default_value": "Prüfen Sie die Schreibweise oder suchen Sie nach übergeordneten Fachbegriffen.",
      "source_file": "src/components/search/SearchOverlay.jsx",
      "sourceFile": "src/components/search/SearchOverlay.jsx",
      "multiline": false
    },
    "search_overlay_results_count": {
      "type": "text",
      "label": "Such-Overlay Trefferanzahl",
      "defaultValue": "{count} Treffer gefunden",
      "default_value": "{count} Treffer gefunden",
      "source_file": "src/components/search/SearchOverlay.jsx",
      "sourceFile": "src/components/search/SearchOverlay.jsx",
      "multiline": false
    },
    "search_overlay_view_all_btn": {
      "type": "text",
      "label": "Such-Overlay Alle anzeigen Button",
      "defaultValue": "Alle Suchergebnisse anzeigen",
      "default_value": "Alle Suchergebnisse anzeigen",
      "source_file": "src/components/search/SearchOverlay.jsx",
      "sourceFile": "src/components/search/SearchOverlay.jsx",
      "multiline": false
    },
    "search_overlay_close_btn": {
      "type": "text",
      "label": "Such-Overlay Schließen Button",
      "defaultValue": "Schließen (ESC)",
      "default_value": "Schließen (ESC)",
      "source_file": "src/components/search/SearchOverlay.jsx",
      "sourceFile": "src/components/search/SearchOverlay.jsx",
      "multiline": false
    },
    "search_overlay_esc_hint": {
      "type": "text",
      "label": "Such-Overlay ESC Taste",
      "defaultValue": "ESC zum Schließen",
      "default_value": "ESC zum Schließen",
      "source_file": "src/components/search/SearchOverlay.jsx",
      "sourceFile": "src/components/search/SearchOverlay.jsx",
      "multiline": false
    }
  },
  "home": {
    "hero_title": {
      "type": "text",
      "label": "Hero-Titel",
      "defaultValue": "Sicherheitstechnik direkt finden & disponieren.",
      "default_value": "Sicherheitstechnik direkt finden & disponieren.",
      "source_file": "src/features/home/HomeView.jsx",
      "sourceFile": "src/features/home/HomeView.jsx",
      "multiline": false
    },
    "hero_subtitle": {
      "type": "text",
      "label": "Hero-Untertitel",
      "defaultValue": "Gezielte SKU-, Hersteller- und Artikelsuche im Fachgroßhandelsbestand für Errichter und Fachplaner.",
      "default_value": "Gezielte SKU-, Hersteller- und Artikelsuche im Fachgroßhandelsbestand für Errichter und Fachplaner.",
      "source_file": "src/features/home/HomeView.jsx",
      "sourceFile": "src/features/home/HomeView.jsx",
      "multiline": false
    },
    "hero_cta_primary": {
      "type": "text",
      "label": "Hero-CTA 1: Gesamten Katalog durchsuchen",
      "defaultValue": "Gesamten Katalog durchsuchen",
      "default_value": "Gesamten Katalog durchsuchen",
      "source_file": "src/features/home/HomeView.jsx",
      "sourceFile": "src/features/home/HomeView.jsx",
      "multiline": false
    },
    "hero_cta_secondary": {
      "type": "text",
      "label": "Hero-CTA 2: Projekt anfragen",
      "defaultValue": "Projekt anfragen",
      "default_value": "Projekt anfragen",
      "source_file": "src/features/home/HomeView.jsx",
      "sourceFile": "src/features/home/HomeView.jsx",
      "multiline": false
    },
    "trust_1_title": {
      "type": "text",
      "label": "Vertrauenspunkt 1 (Fachberatung) – Titel",
      "defaultValue": "Fachberatung",
      "default_value": "Fachberatung",
      "source_file": "src/features/home/HomeView.jsx",
      "sourceFile": "src/features/home/HomeView.jsx",
      "multiline": false
    },
    "trust_1_desc": {
      "type": "text",
      "label": "Vertrauenspunkt 1 (Fachberatung) – Beschreibung",
      "defaultValue": "Fachliche Beratung durch Ihren Fachpartner.",
      "default_value": "Fachliche Beratung durch Ihren Fachpartner.",
      "source_file": "src/features/home/HomeView.jsx",
      "sourceFile": "src/features/home/HomeView.jsx",
      "multiline": false
    },
    "trust_2_title": {
      "type": "text",
      "label": "Vertrauenspunkt 2 (B2B-Sortiment) – Titel",
      "defaultValue": "B2B-Sortiment",
      "default_value": "B2B-Sortiment",
      "source_file": "src/features/home/HomeView.jsx",
      "sourceFile": "src/features/home/HomeView.jsx",
      "multiline": false
    },
    "trust_2_desc": {
      "type": "text",
      "label": "Vertrauenspunkt 2 (B2B-Sortiment) – Beschreibung",
      "defaultValue": "Fachartikel für Sicherheitstechnik.",
      "default_value": "Fachartikel für Sicherheitstechnik.",
      "source_file": "src/features/home/HomeView.jsx",
      "sourceFile": "src/features/home/HomeView.jsx",
      "multiline": false
    },
    "trust_3_title": {
      "type": "text",
      "label": "Vertrauenspunkt 3 (Projektanfragen) – Titel",
      "defaultValue": "Projektanfragen",
      "default_value": "Projektanfragen",
      "source_file": "src/features/home/HomeView.jsx",
      "sourceFile": "src/features/home/HomeView.jsx",
      "multiline": false
    },
    "trust_3_desc": {
      "type": "text",
      "label": "Vertrauenspunkt 3 (Projektanfragen) – Beschreibung",
      "defaultValue": "Fachspezifische Konditionen und unverbindliche Projektanfragen.",
      "default_value": "Fachspezifische Konditionen und unverbindliche Projektanfragen.",
      "source_file": "src/features/home/HomeView.jsx",
      "sourceFile": "src/features/home/HomeView.jsx",
      "multiline": false
    },
    "section_categories_title": {
      "type": "text",
      "label": "Abschnitt „Fachbereiche“ – Titel",
      "defaultValue": "Fachbereiche wählen",
      "default_value": "Fachbereiche wählen",
      "source_file": "src/features/home/HomeView.jsx",
      "sourceFile": "src/features/home/HomeView.jsx",
      "multiline": false
    },
    "section_categories_subtitle": {
      "type": "text",
      "label": "Abschnitt „Fachbereiche“ – Untertitel",
      "defaultValue": "Wählen Sie den passenden Systembereich für Ihr Sicherheitsprojekt.",
      "default_value": "Wählen Sie den passenden Systembereich für Ihr Sicherheitsprojekt.",
      "source_file": "src/features/home/HomeView.jsx",
      "sourceFile": "src/features/home/HomeView.jsx",
      "multiline": false
    },
    "hero_background": {
      "type": "image",
      "label": "Hero-Hintergrundbild",
      "defaultValue": "",
      "default_value": "",
      "source_file": "src/features/home/HomeView.jsx",
      "sourceFile": "src/features/home/HomeView.jsx",
      "multiline": false
    },
    "hero_background_strength": {
      "type": "text",
      "label": "Hero-Hintergrund-Deckkraft",
      "defaultValue": "0.5",
      "default_value": "0.5",
      "source_file": "src/features/home/HomeView.jsx",
      "sourceFile": "src/features/home/HomeView.jsx",
      "multiline": false
    },
    "home_section_brands_title": {
      "type": "text",
      "label": "Hersteller Sektion Titel",
      "defaultValue": "Führende Hersteller im Großhandelsportfolio",
      "default_value": "Führende Hersteller im Großhandelsportfolio",
      "source_file": "src/features/home/HomeView.jsx",
      "sourceFile": "src/features/home/HomeView.jsx",
      "multiline": false
    },
    "home_section_brands_subtitle": {
      "type": "text",
      "label": "Hersteller Sektion Untertitel",
      "defaultValue": "Zertifizierte Markenqualität für anspruchsvolle Sicherheitsprojekte.",
      "default_value": "Zertifizierte Markenqualität für anspruchsvolle Sicherheitsprojekte.",
      "source_file": "src/features/home/HomeView.jsx",
      "sourceFile": "src/features/home/HomeView.jsx",
      "multiline": false
    },
    "home_section_cta_title": {
      "type": "text",
      "label": "Abschluss CTA Titel",
      "defaultValue": "Sie planen ein größeres Sicherheitsprojekt?",
      "default_value": "Sie planen ein größeres Sicherheitsprojekt?",
      "source_file": "src/features/home/HomeView.jsx",
      "sourceFile": "src/features/home/HomeView.jsx",
      "multiline": false
    },
    "home_section_cta_desc": {
      "type": "text",
      "label": "Abschluss CTA Beschreibung",
      "defaultValue": "Nutzen Sie unseren Projektierungsservice. Wir unterstützen Sie bei Ausschreibungen, Stücklisten und individuellen Staffelpreisen.",
      "default_value": "Nutzen Sie unseren Projektierungsservice. Wir unterstützen Sie bei Ausschreibungen, Stücklisten und individuellen Staffelpreisen.",
      "source_file": "src/features/home/HomeView.jsx",
      "sourceFile": "src/features/home/HomeView.jsx",
      "multiline": true
    },
    "home_section_cta_btn": {
      "type": "text",
      "label": "Abschluss CTA Button",
      "defaultValue": "Jetzt unverbindlich anfragen",
      "default_value": "Jetzt unverbindlich anfragen",
      "source_file": "src/features/home/HomeView.jsx",
      "sourceFile": "src/features/home/HomeView.jsx",
      "multiline": false
    },
    "home_advisor_teaser_title": {
      "type": "text",
      "label": "Berater Teaser Titel",
      "defaultValue": "Unsicher bei der Produktauswahl?",
      "default_value": "Unsicher bei der Produktauswahl?",
      "source_file": "src/features/home/HomeView.jsx",
      "sourceFile": "src/features/home/HomeView.jsx",
      "multiline": false
    },
    "home_advisor_teaser_desc": {
      "type": "text",
      "label": "Berater Teaser Text",
      "defaultValue": "Unser digitaler Sicherheitsberater führt Sie in 4 Schritten zur passenden Lösung.",
      "default_value": "Unser digitaler Sicherheitsberater führt Sie in 4 Schritten zur passenden Lösung.",
      "source_file": "src/features/home/HomeView.jsx",
      "sourceFile": "src/features/home/HomeView.jsx",
      "multiline": false
    },
    "home_advisor_teaser_btn": {
      "type": "text",
      "label": "Berater Teaser Button",
      "defaultValue": "Bedarfsberater starten",
      "default_value": "Bedarfsberater starten",
      "source_file": "src/features/home/HomeView.jsx",
      "sourceFile": "src/features/home/HomeView.jsx",
      "multiline": false
    },
    "hero_split_spotlight_badge": {
      "type": "text",
      "label": "Split Hero Spotlight Badge",
      "defaultValue": "Partner-Spotlight",
      "default_value": "Partner-Spotlight",
      "source_file": "src/registry/components/heroes/SplitFeaturedHero.jsx",
      "sourceFile": "src/registry/components/heroes/SplitFeaturedHero.jsx",
      "multiline": false
    },
    "hero_split_stat1_label": {
      "type": "text",
      "label": "Split Hero Statistik 1 Label",
      "defaultValue": "Verfügbare Fachartikel",
      "default_value": "Verfügbare Fachartikel",
      "source_file": "src/registry/components/heroes/SplitFeaturedHero.jsx",
      "sourceFile": "src/registry/components/heroes/SplitFeaturedHero.jsx",
      "multiline": false
    },
    "hero_split_stat1_val": {
      "type": "text",
      "label": "Split Hero Statistik 1 Wert",
      "defaultValue": "1.400+",
      "default_value": "1.400+",
      "source_file": "src/registry/components/heroes/SplitFeaturedHero.jsx",
      "sourceFile": "src/registry/components/heroes/SplitFeaturedHero.jsx",
      "multiline": false
    },
    "hero_split_stat2_label": {
      "type": "text",
      "label": "Split Hero Statistik 2 Label",
      "defaultValue": "Zertifizierte Hersteller",
      "default_value": "Zertifizierte Hersteller",
      "source_file": "src/registry/components/heroes/SplitFeaturedHero.jsx",
      "sourceFile": "src/registry/components/heroes/SplitFeaturedHero.jsx",
      "multiline": false
    },
    "hero_split_stat2_val": {
      "type": "text",
      "label": "Split Hero Statistik 2 Wert",
      "defaultValue": "40+",
      "default_value": "40+",
      "source_file": "src/registry/components/heroes/SplitFeaturedHero.jsx",
      "sourceFile": "src/registry/components/heroes/SplitFeaturedHero.jsx",
      "multiline": false
    },
    "hero_split_stat3_label": {
      "type": "text",
      "label": "Split Hero Statistik 3 Label",
      "defaultValue": "Lieferfähigkeit ab Lager",
      "default_value": "Lieferfähigkeit ab Lager",
      "source_file": "src/registry/components/heroes/SplitFeaturedHero.jsx",
      "sourceFile": "src/registry/components/heroes/SplitFeaturedHero.jsx",
      "multiline": false
    },
    "hero_split_stat3_val": {
      "type": "text",
      "label": "Split Hero Statistik 3 Wert",
      "defaultValue": "24h",
      "default_value": "24h",
      "source_file": "src/registry/components/heroes/SplitFeaturedHero.jsx",
      "sourceFile": "src/registry/components/heroes/SplitFeaturedHero.jsx",
      "multiline": false
    },
    "hero_split_card_title": {
      "type": "text",
      "label": "Split Hero Spotlight Titel",
      "defaultValue": "Top-Empfehlung der Woche",
      "default_value": "Top-Empfehlung der Woche",
      "source_file": "src/registry/components/heroes/SplitFeaturedHero.jsx",
      "sourceFile": "src/registry/components/heroes/SplitFeaturedHero.jsx",
      "multiline": false
    },
    "hero_split_card_sku_prefix": {
      "type": "text",
      "label": "Split Hero Spotlight SKU",
      "defaultValue": "Art.-Nr.:",
      "default_value": "Art.-Nr.:",
      "source_file": "src/registry/components/heroes/SplitFeaturedHero.jsx",
      "sourceFile": "src/registry/components/heroes/SplitFeaturedHero.jsx",
      "multiline": false
    },
    "hero_split_card_price_label": {
      "type": "text",
      "label": "Split Hero Spotlight Preis",
      "defaultValue": "Preis",
      "default_value": "Preis",
      "source_file": "src/registry/components/heroes/SplitFeaturedHero.jsx",
      "sourceFile": "src/registry/components/heroes/SplitFeaturedHero.jsx",
      "multiline": false
    },
    "hero_split_card_cart_btn": {
      "type": "text",
      "label": "Split Hero Spotlight Korb CTA",
      "defaultValue": "In den Anfragekorb",
      "default_value": "In den Anfragekorb",
      "source_file": "src/registry/components/heroes/SplitFeaturedHero.jsx",
      "sourceFile": "src/registry/components/heroes/SplitFeaturedHero.jsx",
      "multiline": false
    },
    "hero_grid_partner_badge": {
      "type": "text",
      "label": "Grid Hero Partner Badge",
      "defaultValue": "Autorisierter Fachpartner",
      "default_value": "Autorisierter Fachpartner",
      "source_file": "src/registry/components/heroes/HighlightGridHero.jsx",
      "sourceFile": "src/registry/components/heroes/HighlightGridHero.jsx",
      "multiline": false
    },
    "hero_grid_primary_cta": {
      "type": "text",
      "label": "Grid Hero Primär CTA",
      "defaultValue": "Gesamten Katalog öffnen",
      "default_value": "Gesamten Katalog öffnen",
      "source_file": "src/registry/components/heroes/HighlightGridHero.jsx",
      "sourceFile": "src/registry/components/heroes/HighlightGridHero.jsx",
      "multiline": false
    },
    "hero_grid_secondary_cta": {
      "type": "text",
      "label": "Grid Hero Sekundär CTA",
      "defaultValue": "Projektangebot anfragen",
      "default_value": "Projektangebot anfragen",
      "source_file": "src/registry/components/heroes/HighlightGridHero.jsx",
      "sourceFile": "src/registry/components/heroes/HighlightGridHero.jsx",
      "multiline": false
    },
    "hero_grid_card1_title": {
      "type": "text",
      "label": "Grid Kachel 1 Titel",
      "defaultValue": "Videoüberwachung",
      "default_value": "Videoüberwachung",
      "source_file": "src/registry/components/heroes/HighlightGridHero.jsx",
      "sourceFile": "src/registry/components/heroes/HighlightGridHero.jsx",
      "multiline": false
    },
    "hero_grid_card1_desc": {
      "type": "text",
      "label": "Grid Kachel 1 Text",
      "defaultValue": "IP-Kameras & Rekorder",
      "default_value": "IP-Kameras & Rekorder",
      "source_file": "src/registry/components/heroes/HighlightGridHero.jsx",
      "sourceFile": "src/registry/components/heroes/HighlightGridHero.jsx",
      "multiline": false
    },
    "hero_grid_card2_title": {
      "type": "text",
      "label": "Grid Kachel 2 Titel",
      "defaultValue": "Gefahrenmeldetechnik",
      "default_value": "Gefahrenmeldetechnik",
      "source_file": "src/registry/components/heroes/HighlightGridHero.jsx",
      "sourceFile": "src/registry/components/heroes/HighlightGridHero.jsx",
      "multiline": false
    },
    "hero_grid_card2_desc": {
      "type": "text",
      "label": "Grid Kachel 2 Text",
      "defaultValue": "Einbruch- & Funkmelder",
      "default_value": "Einbruch- & Funkmelder",
      "source_file": "src/registry/components/heroes/HighlightGridHero.jsx",
      "sourceFile": "src/registry/components/heroes/HighlightGridHero.jsx",
      "multiline": false
    },
    "hero_grid_card3_title": {
      "type": "text",
      "label": "Grid Kachel 3 Titel",
      "defaultValue": "Zutrittskontrolle",
      "default_value": "Zutrittskontrolle",
      "source_file": "src/registry/components/heroes/HighlightGridHero.jsx",
      "sourceFile": "src/registry/components/heroes/HighlightGridHero.jsx",
      "multiline": false
    },
    "hero_grid_card3_desc": {
      "type": "text",
      "label": "Grid Kachel 3 Text",
      "defaultValue": "RFID & Biometrie",
      "default_value": "RFID & Biometrie",
      "source_file": "src/registry/components/heroes/HighlightGridHero.jsx",
      "sourceFile": "src/registry/components/heroes/HighlightGridHero.jsx",
      "multiline": false
    },
    "hero_grid_card4_title": {
      "type": "text",
      "label": "Grid Kachel 4 Titel",
      "defaultValue": "Brandmeldetechnik",
      "default_value": "Brandmeldetechnik",
      "source_file": "src/registry/components/heroes/HighlightGridHero.jsx",
      "sourceFile": "src/registry/components/heroes/HighlightGridHero.jsx",
      "multiline": false
    },
    "hero_grid_card4_desc": {
      "type": "text",
      "label": "Grid Kachel 4 Text",
      "defaultValue": "DIN 14675 / EN54 BMA",
      "default_value": "DIN 14675 / EN54 BMA",
      "source_file": "src/registry/components/heroes/HighlightGridHero.jsx",
      "sourceFile": "src/registry/components/heroes/HighlightGridHero.jsx",
      "multiline": false
    },
    "hero_portal_badge": {
      "type": "text",
      "label": "Portal Hero Badge",
      "defaultValue": "1.472 geprüfte ASL-Artikel",
      "default_value": "1.472 geprüfte ASL-Artikel",
      "source_file": "src/registry/components/heroes/PortalSearchHero.jsx",
      "sourceFile": "src/registry/components/heroes/PortalSearchHero.jsx",
      "multiline": false
    },
    "hero_portal_search_btn": {
      "type": "text",
      "label": "Portal Hero Suche Button",
      "defaultValue": "Finden",
      "default_value": "Finden",
      "source_file": "src/registry/components/heroes/PortalSearchHero.jsx",
      "sourceFile": "src/registry/components/heroes/PortalSearchHero.jsx",
      "multiline": false
    },
    "hero_portal_chip_video": {
      "type": "text",
      "label": "Portal Shortcut Video",
      "defaultValue": "IP-Kameras",
      "default_value": "IP-Kameras",
      "source_file": "src/registry/components/heroes/PortalSearchHero.jsx",
      "sourceFile": "src/registry/components/heroes/PortalSearchHero.jsx",
      "multiline": false
    },
    "hero_portal_chip_alarm": {
      "type": "text",
      "label": "Portal Shortcut Alarm",
      "defaultValue": "Alarmzentralen",
      "default_value": "Alarmzentralen",
      "source_file": "src/registry/components/heroes/PortalSearchHero.jsx",
      "sourceFile": "src/registry/components/heroes/PortalSearchHero.jsx",
      "multiline": false
    },
    "hero_portal_chip_fire": {
      "type": "text",
      "label": "Portal Shortcut Brand",
      "defaultValue": "Brandmelder",
      "default_value": "Brandmelder",
      "source_file": "src/registry/components/heroes/PortalSearchHero.jsx",
      "sourceFile": "src/registry/components/heroes/PortalSearchHero.jsx",
      "multiline": false
    },
    "hero_portal_chip_access": {
      "type": "text",
      "label": "Portal Shortcut Zutritt",
      "defaultValue": "Zutrittsleser",
      "default_value": "Zutrittsleser",
      "source_file": "src/registry/components/heroes/PortalSearchHero.jsx",
      "sourceFile": "src/registry/components/heroes/PortalSearchHero.jsx",
      "multiline": false
    },
    "hero_portal_chip_power": {
      "type": "text",
      "label": "Portal Shortcut Strom",
      "defaultValue": "Netzteile & USV",
      "default_value": "Netzteile & USV",
      "source_file": "src/registry/components/heroes/PortalSearchHero.jsx",
      "sourceFile": "src/registry/components/heroes/PortalSearchHero.jsx",
      "multiline": false
    },
    "category_img_alarm": {
      "type": "image",
      "label": "Kategoriebild Alarmtechnik",
      "defaultValue": "",
      "default_value": "",
      "source_file": "src/features/home/HomeView.jsx",
      "sourceFile": "src/features/home/HomeView.jsx",
      "multiline": false
    },
    "category_img_video": {
      "type": "image",
      "label": "Kategoriebild Videoüberwachung",
      "defaultValue": "",
      "default_value": "",
      "source_file": "src/features/home/HomeView.jsx",
      "sourceFile": "src/features/home/HomeView.jsx",
      "multiline": false
    },
    "category_img_brand": {
      "type": "image",
      "label": "Kategoriebild Brandmeldetechnik",
      "defaultValue": "",
      "default_value": "",
      "source_file": "src/features/home/HomeView.jsx",
      "sourceFile": "src/features/home/HomeView.jsx",
      "multiline": false
    },
    "category_img_zutritt": {
      "type": "image",
      "label": "Kategoriebild Zutrittskontrolle",
      "defaultValue": "",
      "default_value": "",
      "source_file": "src/features/home/HomeView.jsx",
      "sourceFile": "src/features/home/HomeView.jsx",
      "multiline": false
    },
    "category_img_strom": {
      "type": "image",
      "label": "Kategoriebild Stromversorgung",
      "defaultValue": "",
      "default_value": "",
      "source_file": "src/features/home/HomeView.jsx",
      "sourceFile": "src/features/home/HomeView.jsx",
      "multiline": false
    }
  },
  "footer": {
    "footer_description": {
      "type": "text",
      "label": "Footer-Beschreibung",
      "defaultValue": "Ihr Partner für professionelle Sicherheitstechnik, Brandmeldetechnik und Systemlösungen.",
      "default_value": "Ihr Partner für professionelle Sicherheitstechnik, Brandmeldetechnik und Systemlösungen.",
      "source_file": "src/components/layout/ShellFooter.jsx",
      "sourceFile": "src/components/layout/ShellFooter.jsx",
      "multiline": false
    },
    "footer_partner_badge": {
      "type": "text",
      "label": "Partner-Badge Text",
      "defaultValue": "Fachpartner",
      "default_value": "Fachpartner",
      "source_file": "src/components/layout/ShellFooter.jsx",
      "sourceFile": "src/components/layout/ShellFooter.jsx",
      "multiline": false
    },
    "footer_b2b_notice": {
      "type": "text",
      "label": "B2B-Hinweis",
      "defaultValue": "Alle Preise zzgl. gesetzlicher MwSt. • Sicherheitstechnik für Zuhause und Betrieb",
      "default_value": "Alle Preise zzgl. gesetzlicher MwSt. • Sicherheitstechnik für Zuhause und Betrieb",
      "source_file": "src/components/layout/ShellFooter.jsx",
      "sourceFile": "src/components/layout/ShellFooter.jsx",
      "multiline": false
    },
    "footer_copyright": {
      "type": "text",
      "label": "Copyright-Hinweis",
      "defaultValue": "Alle Rechte vorbehalten.",
      "default_value": "Alle Rechte vorbehalten.",
      "source_file": "src/components/layout/ShellFooter.jsx",
      "sourceFile": "src/components/layout/ShellFooter.jsx",
      "multiline": false
    },
    "footer_col1_title": {
      "type": "text",
      "label": "Footer Spalte 1 Titel",
      "defaultValue": "Navigation & Katalog",
      "default_value": "Navigation & Katalog",
      "source_file": "src/components/layout/ShellFooter.jsx",
      "sourceFile": "src/components/layout/ShellFooter.jsx",
      "multiline": false
    },
    "footer_col2_title": {
      "type": "text",
      "label": "Footer Spalte 2 Titel",
      "defaultValue": "Rechtliches",
      "default_value": "Rechtliches",
      "source_file": "src/components/layout/ShellFooter.jsx",
      "sourceFile": "src/components/layout/ShellFooter.jsx",
      "multiline": false
    },
    "footer_col3_title": {
      "type": "text",
      "label": "Footer Spalte 3 Titel",
      "defaultValue": "Kontakt & Fachberatung",
      "default_value": "Kontakt & Fachberatung",
      "source_file": "src/components/layout/ShellFooter.jsx",
      "sourceFile": "src/components/layout/ShellFooter.jsx",
      "multiline": false
    },
    "footer_link_catalog": {
      "type": "text",
      "label": "Footer Link Katalog",
      "defaultValue": "Katalogübersicht",
      "default_value": "Katalogübersicht",
      "source_file": "src/components/layout/ShellFooter.jsx",
      "sourceFile": "src/components/layout/ShellFooter.jsx",
      "multiline": false
    },
    "footer_link_advisor": {
      "type": "text",
      "label": "Footer Link Berater",
      "defaultValue": "Sicherheitsberater",
      "default_value": "Sicherheitsberater",
      "source_file": "src/components/layout/ShellFooter.jsx",
      "sourceFile": "src/components/layout/ShellFooter.jsx",
      "multiline": false
    },
    "footer_link_inquiry": {
      "type": "text",
      "label": "Footer Link Projektanfrage",
      "defaultValue": "Projektanfrage",
      "default_value": "Projektanfrage",
      "source_file": "src/components/layout/ShellFooter.jsx",
      "sourceFile": "src/components/layout/ShellFooter.jsx",
      "multiline": false
    },
    "footer_link_imprint": {
      "type": "text",
      "label": "Footer Link Impressum",
      "defaultValue": "Impressum",
      "default_value": "Impressum",
      "source_file": "src/components/layout/ShellFooter.jsx",
      "sourceFile": "src/components/layout/ShellFooter.jsx",
      "multiline": false
    },
    "footer_link_privacy": {
      "type": "text",
      "label": "Footer Link Datenschutz",
      "defaultValue": "Datenschutzerklärung",
      "default_value": "Datenschutzerklärung",
      "source_file": "src/components/layout/ShellFooter.jsx",
      "sourceFile": "src/components/layout/ShellFooter.jsx",
      "multiline": false
    },
    "footer_link_agb": {
      "type": "text",
      "label": "Footer Link AGB",
      "defaultValue": "AGB & Widerrufsbelehrung",
      "default_value": "AGB & Widerrufsbelehrung",
      "source_file": "src/components/layout/ShellFooter.jsx",
      "sourceFile": "src/components/layout/ShellFooter.jsx",
      "multiline": false
    },
    "footer_link_shipping": {
      "type": "text",
      "label": "Footer Link Versand",
      "defaultValue": "Versand & Lieferung",
      "default_value": "Versand & Lieferung",
      "source_file": "src/components/layout/ShellFooter.jsx",
      "sourceFile": "src/components/layout/ShellFooter.jsx",
      "multiline": false
    },
    "footer_contact_phone_label": {
      "type": "text",
      "label": "Footer Kontakt Telefon Label",
      "defaultValue": "Telefon:",
      "default_value": "Telefon:",
      "source_file": "src/components/layout/ShellFooter.jsx",
      "sourceFile": "src/components/layout/ShellFooter.jsx",
      "multiline": false
    },
    "footer_contact_email_label": {
      "type": "text",
      "label": "Footer Kontakt E-Mail Label",
      "defaultValue": "E-Mail:",
      "default_value": "E-Mail:",
      "source_file": "src/components/layout/ShellFooter.jsx",
      "sourceFile": "src/components/layout/ShellFooter.jsx",
      "multiline": false
    },
    "footer_contact_hours_label": {
      "type": "text",
      "label": "Footer Geschäftszeiten Label",
      "defaultValue": "Mo.–Fr. 08:00 – 17:00 Uhr",
      "default_value": "Mo.–Fr. 08:00 – 17:00 Uhr",
      "source_file": "src/components/layout/ShellFooter.jsx",
      "sourceFile": "src/components/layout/ShellFooter.jsx",
      "multiline": false
    },
    "footer_asl_association_notice": {
      "type": "text",
      "label": "Footer ASL Verbandshinweis",
      "defaultValue": "ASL Großhandelspartner-Netzwerk",
      "default_value": "ASL Großhandelspartner-Netzwerk",
      "source_file": "src/components/layout/ShellFooter.jsx",
      "sourceFile": "src/components/layout/ShellFooter.jsx",
      "multiline": false
    },
    "footer_all_rights_reserved": {
      "type": "text",
      "label": "Footer Alle Rechte vorbehalten",
      "defaultValue": "Alle Rechte vorbehalten.",
      "default_value": "Alle Rechte vorbehalten.",
      "source_file": "src/components/layout/ShellFooter.jsx",
      "sourceFile": "src/components/layout/ShellFooter.jsx",
      "multiline": false
    },
    "footer_secure_ordering_hint": {
      "type": "text",
      "label": "Footer Sichere Übertragung",
      "defaultValue": "Verschlüsselte Datenübertragung (SSL/TLS)",
      "default_value": "Verschlüsselte Datenübertragung (SSL/TLS)",
      "source_file": "src/components/layout/ShellFooter.jsx",
      "sourceFile": "src/components/layout/ShellFooter.jsx",
      "multiline": false
    }
  },
  "legal": {
    "imprint_title": {
      "type": "text",
      "label": "Impressum – Titel",
      "defaultValue": "Impressum",
      "default_value": "Impressum",
      "source_file": "src/features/legal/LegalInfoView.jsx",
      "sourceFile": "src/features/legal/LegalInfoView.jsx",
      "multiline": false
    },
    "imprint_content": {
      "type": "text",
      "label": "Impressum – Inhalt",
      "defaultValue": "Dies ist ein unverbindlicher Demo-Platzhalter für das Impressum. Die Angaben gemäß § 5 DDG werden durch den jeweiligen Fachpartner vor Inbetriebnahme eingepflegt.",
      "default_value": "Dies ist ein unverbindlicher Demo-Platzhalter für das Impressum. Die Angaben gemäß § 5 DDG werden durch den jeweiligen Fachpartner vor Inbetriebnahme eingepflegt.",
      "source_file": "src/features/legal/LegalInfoView.jsx",
      "sourceFile": "src/features/legal/LegalInfoView.jsx",
      "multiline": true
    },
    "privacy_title": {
      "type": "text",
      "label": "Datenschutz – Titel",
      "defaultValue": "Datenschutzerklärung",
      "default_value": "Datenschutzerklärung",
      "source_file": "src/features/legal/LegalInfoView.jsx",
      "sourceFile": "src/features/legal/LegalInfoView.jsx",
      "multiline": false
    },
    "privacy_content": {
      "type": "text",
      "label": "Datenschutz – Inhalt",
      "defaultValue": "Dies ist ein unverbindlicher Demo-Platzhalter für die Datenschutzerklärung. Die Pflichtangaben gemäß DSGVO werden durch den jeweiligen Fachpartner vor Inbetriebnahme hinterlegt.",
      "default_value": "Dies ist ein unverbindlicher Demo-Platzhalter für die Datenschutzerklärung. Die Pflichtangaben gemäß DSGVO werden durch den jeweiligen Fachpartner vor Inbetriebnahme hinterlegt.",
      "source_file": "src/features/legal/LegalInfoView.jsx",
      "sourceFile": "src/features/legal/LegalInfoView.jsx",
      "multiline": true
    },
    "agb_title": {
      "type": "text",
      "label": "AGB & Widerruf – Titel",
      "defaultValue": "Allgemeine Geschäftsbedingungen & Widerrufsbelehrung",
      "default_value": "Allgemeine Geschäftsbedingungen & Widerrufsbelehrung",
      "source_file": "src/features/legal/LegalInfoView.jsx",
      "sourceFile": "src/features/legal/LegalInfoView.jsx",
      "multiline": false
    },
    "agb_content": {
      "type": "text",
      "label": "AGB & Widerruf – Inhalt",
      "defaultValue": "Dies ist ein unverbindlicher Demo-Platzhalter für die Allgemeinen Geschäftsbedingungen (AGB) und Widerrufsinformationen. Die vertraglichen Bestimmungen für den B2B-Fachvertrieb werden durch den jeweiligen Fachpartner hinterlegt.",
      "default_value": "Dies ist ein unverbindlicher Demo-Platzhalter für die Allgemeinen Geschäftsbedingungen (AGB) und Widerrufsinformationen. Die vertraglichen Bestimmungen für den B2B-Fachvertrieb werden durch den jeweiligen Fachpartner hinterlegt.",
      "source_file": "src/features/legal/LegalInfoView.jsx",
      "sourceFile": "src/features/legal/LegalInfoView.jsx",
      "multiline": true
    },
    "shipping_title": {
      "type": "text",
      "label": "Versand & Lieferung – Titel",
      "defaultValue": "Versand- & Lieferbedingungen",
      "default_value": "Versand- & Lieferbedingungen",
      "source_file": "src/features/legal/LegalInfoView.jsx",
      "sourceFile": "src/features/legal/LegalInfoView.jsx",
      "multiline": false
    },
    "shipping_content": {
      "type": "text",
      "label": "Versand & Lieferung – Inhalt",
      "defaultValue": "Dies ist ein unverbindlicher Demo-Platzhalter für Versand- und Lieferkonditionen. Angaben zu Lieferzeiten, Versandkosten, Spedition und Selbstabholung werden durch den jeweiligen Fachpartner hinterlegt.",
      "default_value": "Dies ist ein unverbindlicher Demo-Platzhalter für Versand- und Lieferkonditionen. Angaben zu Lieferzeiten, Versandkosten, Spedition und Selbstabholung werden durch den jeweiligen Fachpartner hinterlegt.",
      "source_file": "src/features/legal/LegalInfoView.jsx",
      "sourceFile": "src/features/legal/LegalInfoView.jsx",
      "multiline": true
    },
    "legal_demo_banner_title": {
      "type": "text",
      "label": "Rechtstexte Demo Warnung Titel",
      "defaultValue": "Demo-Inhalt — Unverbindliche Platzhalter",
      "default_value": "Demo-Inhalt — Unverbindliche Platzhalter",
      "source_file": "src/features/legal/LegalInfoView.jsx",
      "sourceFile": "src/features/legal/LegalInfoView.jsx",
      "multiline": false
    },
    "legal_demo_banner_text": {
      "type": "text",
      "label": "Rechtstexte Demo Warnung Text",
      "defaultValue": "Die nachfolgenden Texte sind unverbindliche Mustertexte und müssen vor dem Echtbetrieb durch den Betreiber / Partner an die tatsächlichen Gegebenheiten angepasst werden.",
      "default_value": "Die nachfolgenden Texte sind unverbindliche Mustertexte und müssen vor dem Echtbetrieb durch den Betreiber / Partner an die tatsächlichen Gegebenheiten angepasst werden.",
      "source_file": "src/features/legal/LegalInfoView.jsx",
      "sourceFile": "src/features/legal/LegalInfoView.jsx",
      "multiline": true
    },
    "legal_back_to_shop": {
      "type": "text",
      "label": "Zurück zum Shop Button",
      "defaultValue": "Zurück zum Shop",
      "default_value": "Zurück zum Shop",
      "source_file": "src/features/legal/LegalInfoView.jsx",
      "sourceFile": "src/features/legal/LegalInfoView.jsx",
      "multiline": false
    },
    "legal_last_updated_prefix": {
      "type": "text",
      "label": "Zuletzt aktualisiert Präfix",
      "defaultValue": "Stand:",
      "default_value": "Stand:",
      "source_file": "src/features/legal/LegalInfoView.jsx",
      "sourceFile": "src/features/legal/LegalInfoView.jsx",
      "multiline": false
    },
    "legal_tab_imprint": {
      "type": "text",
      "label": "Tab Impressum",
      "defaultValue": "Impressum (§ 5 DDG)",
      "default_value": "Impressum (§ 5 DDG)",
      "source_file": "src/features/legal/LegalInfoView.jsx",
      "sourceFile": "src/features/legal/LegalInfoView.jsx",
      "multiline": false
    },
    "legal_tab_privacy": {
      "type": "text",
      "label": "Tab Datenschutz",
      "defaultValue": "Datenschutz (DSGVO)",
      "default_value": "Datenschutz (DSGVO)",
      "source_file": "src/features/legal/LegalInfoView.jsx",
      "sourceFile": "src/features/legal/LegalInfoView.jsx",
      "multiline": false
    },
    "legal_tab_agb": {
      "type": "text",
      "label": "Tab AGB",
      "defaultValue": "AGB & Widerruf",
      "default_value": "AGB & Widerruf",
      "source_file": "src/features/legal/LegalInfoView.jsx",
      "sourceFile": "src/features/legal/LegalInfoView.jsx",
      "multiline": false
    },
    "legal_tab_shipping": {
      "type": "text",
      "label": "Tab Versand",
      "defaultValue": "Versand & Logistik",
      "default_value": "Versand & Logistik",
      "source_file": "src/features/legal/LegalInfoView.jsx",
      "sourceFile": "src/features/legal/LegalInfoView.jsx",
      "multiline": false
    },
    "legal_b2b_only_clause": {
      "type": "text",
      "label": "B2B Klausel Hinweis",
      "defaultValue": "Dieser Shop richtet sich an Privatkunden und Unternehmen.",
      "default_value": "Dieser Shop richtet sich an Privatkunden und Unternehmen.",
      "source_file": "src/features/legal/LegalInfoView.jsx",
      "sourceFile": "src/features/legal/LegalInfoView.jsx",
      "multiline": true
    },
    "legal_contact_representative": {
      "type": "text",
      "label": "Vertretungsberechtigter Label",
      "defaultValue": "Vertretungsberechtigte Geschäftsführung:",
      "default_value": "Vertretungsberechtigte Geschäftsführung:",
      "source_file": "src/features/legal/LegalInfoView.jsx",
      "sourceFile": "src/features/legal/LegalInfoView.jsx",
      "multiline": false
    },
    "legal_register_court_label": {
      "type": "text",
      "label": "Registergericht Label",
      "defaultValue": "Registergericht & Registernummer:",
      "default_value": "Registergericht & Registernummer:",
      "source_file": "src/features/legal/LegalInfoView.jsx",
      "sourceFile": "src/features/legal/LegalInfoView.jsx",
      "multiline": false
    },
    "legal_vat_id_label": {
      "type": "text",
      "label": "USt-IdNr Label",
      "defaultValue": "Umsatzsteuer-Identifikationsnummer:",
      "default_value": "Umsatzsteuer-Identifikationsnummer:",
      "source_file": "src/features/legal/LegalInfoView.jsx",
      "sourceFile": "src/features/legal/LegalInfoView.jsx",
      "multiline": false
    }
  },
  "copilot": {
    "copilot_drawer_title": {
      "type": "text",
      "label": "Copilot Drawer Titel",
      "defaultValue": "ALWIS KI-Projektassistent",
      "default_value": "ALWIS KI-Projektassistent",
      "source_file": "src/components/copilot/CopilotDrawer.jsx",
      "sourceFile": "src/components/copilot/CopilotDrawer.jsx",
      "multiline": false
    },
    "copilot_drawer_subtitle": {
      "type": "text",
      "label": "Copilot Drawer Untertitel",
      "defaultValue": "Fachberatung zu Artikeln, Kompatibilität und Normen.",
      "default_value": "Fachberatung zu Artikeln, Kompatibilität und Normen.",
      "source_file": "src/components/copilot/CopilotDrawer.jsx",
      "sourceFile": "src/components/copilot/CopilotDrawer.jsx",
      "multiline": false
    },
    "copilot_welcome_msg": {
      "type": "text",
      "label": "Copilot Willkommensnachricht",
      "defaultValue": "Hallo! Ich bin ALWIS, Ihr KI-Experte für Sicherheitstechnik. Wie kann ich Sie bei Ihrer Projektierung unterstützen?",
      "default_value": "Hallo! Ich bin ALWIS, Ihr KI-Experte für Sicherheitstechnik. Wie kann ich Sie bei Ihrer Projektierung unterstützen?",
      "source_file": "src/components/copilot/CopilotDrawer.jsx",
      "sourceFile": "src/components/copilot/CopilotDrawer.jsx",
      "multiline": true
    },
    "copilot_suggest_prompt1": {
      "type": "text",
      "label": "Copilot Vorschlag 1",
      "defaultValue": "Welche Kameras eignen sich für Außenbereiche bei Nacht?",
      "default_value": "Welche Kameras eignen sich für Außenbereiche bei Nacht?",
      "source_file": "src/components/copilot/CopilotDrawer.jsx",
      "sourceFile": "src/components/copilot/CopilotDrawer.jsx",
      "multiline": false
    },
    "copilot_suggest_prompt2": {
      "type": "text",
      "label": "Copilot Vorschlag 2",
      "defaultValue": "Welche VdS-Klasse brauche ich für ein Gewerbeobjekt?",
      "default_value": "Welche VdS-Klasse brauche ich für ein Gewerbeobjekt?",
      "source_file": "src/components/copilot/CopilotDrawer.jsx",
      "sourceFile": "src/components/copilot/CopilotDrawer.jsx",
      "multiline": false
    },
    "copilot_suggest_prompt3": {
      "type": "text",
      "label": "Copilot Vorschlag 3",
      "defaultValue": "Gibt es kompatible Netzteile für Brandmelder?",
      "default_value": "Gibt es kompatible Netzteile für Brandmelder?",
      "source_file": "src/components/copilot/CopilotDrawer.jsx",
      "sourceFile": "src/components/copilot/CopilotDrawer.jsx",
      "multiline": false
    },
    "copilot_input_placeholder": {
      "type": "text",
      "label": "Copilot Eingabe Platzhalter",
      "defaultValue": "Frage zur Sicherheitstechnik eingeben...",
      "default_value": "Frage zur Sicherheitstechnik eingeben...",
      "source_file": "src/components/copilot/CopilotDrawer.jsx",
      "sourceFile": "src/components/copilot/CopilotDrawer.jsx",
      "multiline": false
    },
    "copilot_btn_send": {
      "type": "text",
      "label": "Copilot Senden Button",
      "defaultValue": "Senden",
      "default_value": "Senden",
      "source_file": "src/components/copilot/CopilotDrawer.jsx",
      "sourceFile": "src/components/copilot/CopilotDrawer.jsx",
      "multiline": false
    },
    "copilot_btn_clear": {
      "type": "text",
      "label": "Copilot Verlauf leeren Button",
      "defaultValue": "Verlauf leeren",
      "default_value": "Verlauf leeren",
      "source_file": "src/components/copilot/CopilotDrawer.jsx",
      "sourceFile": "src/components/copilot/CopilotDrawer.jsx",
      "multiline": false
    },
    "copilot_disclaimer_note": {
      "type": "text",
      "label": "Copilot Haftungshinweis",
      "defaultValue": "KI-generierte Auskünfte ersetzen keine fachtechnische Detailplanung vor Ort.",
      "default_value": "KI-generierte Auskünfte ersetzen keine fachtechnische Detailplanung vor Ort.",
      "source_file": "src/components/copilot/CopilotDrawer.jsx",
      "sourceFile": "src/components/copilot/CopilotDrawer.jsx",
      "multiline": true
    },
    "copilot_fab_tooltip": {
      "type": "text",
      "label": "Copilot FAB Tooltip",
      "defaultValue": "KI-Fachberater öffnen",
      "default_value": "KI-Fachberater öffnen",
      "source_file": "src/components/copilot/CopilotFloatingFab.jsx",
      "sourceFile": "src/components/copilot/CopilotFloatingFab.jsx",
      "multiline": false
    },
    "copilot_fab_badge": {
      "type": "text",
      "label": "Copilot FAB Badge",
      "defaultValue": "ALWIS KI",
      "default_value": "ALWIS KI",
      "source_file": "src/components/copilot/CopilotFloatingFab.jsx",
      "sourceFile": "src/components/copilot/CopilotFloatingFab.jsx",
      "multiline": false
    },
    "copilot_bom_card_title": {
      "type": "text",
      "label": "Copilot BOM Karte Titel",
      "defaultValue": "Vorgeschlagene Komponenten",
      "default_value": "Vorgeschlagene Komponenten",
      "source_file": "src/components/copilot/BomCard.jsx",
      "sourceFile": "src/components/copilot/BomCard.jsx",
      "multiline": false
    },
    "copilot_bom_card_add_all": {
      "type": "text",
      "label": "Copilot BOM Alle Hinzufügen",
      "defaultValue": "Alle in den Anfragekorb",
      "default_value": "Alle in den Anfragekorb",
      "source_file": "src/components/copilot/BomCard.jsx",
      "sourceFile": "src/components/copilot/BomCard.jsx",
      "multiline": false
    },
    "copilot_status_ready": {
      "type": "text",
      "label": "Copilot Status Bereit",
      "defaultValue": "Bereit für Ihre Anfrage",
      "default_value": "Bereit für Ihre Anfrage",
      "source_file": "src/components/copilot/CopilotDrawer.jsx",
      "sourceFile": "src/components/copilot/CopilotDrawer.jsx",
      "multiline": false
    }
  },
  "brand": {
    "logo": {
      "type": "image",
      "label": "Shop-Logo",
      "defaultValue": "",
      "default_value": "",
      "source_file": "src/components/tenant/TenantLogo.jsx",
      "sourceFile": "src/components/tenant/TenantLogo.jsx",
      "multiline": false
    },
    "favicon": {
      "type": "image",
      "label": "Shop-Favicon",
      "defaultValue": "",
      "default_value": "",
      "source_file": "src/components/tenant/TenantLogo.jsx",
      "sourceFile": "src/components/tenant/TenantLogo.jsx",
      "multiline": false
    },
    "brand_tagline": {
      "type": "text",
      "label": "Shop Tagline / Slogan",
      "defaultValue": "Ihr Fachpartner für moderne Sicherheitstechnik",
      "default_value": "Ihr Fachpartner für moderne Sicherheitstechnik",
      "source_file": "src/components/tenant/TenantLogo.jsx",
      "sourceFile": "src/components/tenant/TenantLogo.jsx",
      "multiline": false
    },
    "brand_company_legal_name": {
      "type": "text",
      "label": "Vollständiger Firmenname",
      "defaultValue": "ASL Partner Sicherheitstechnik GmbH",
      "default_value": "ASL Partner Sicherheitstechnik GmbH",
      "source_file": "src/components/tenant/TenantLogo.jsx",
      "sourceFile": "src/components/tenant/TenantLogo.jsx",
      "multiline": false
    }
  },
  "onboarding": {
    "onboarding_guide": {
      "type": "text",
      "label": "Kurzanleitung für Interessenten",
      "defaultValue": "So bearbeiten Sie Ihren Shop: Wählen Sie eine Seite, klicken Sie in ein Textfeld und passen Sie die Inhalte an. Mit „Speichern“ werden die Änderungen sofort im Shop veröffentlicht.",
      "default_value": "So bearbeiten Sie Ihren Shop: Wählen Sie eine Seite, klicken Sie in ein Textfeld und passen Sie die Inhalte an. Mit „Speichern“ werden die Änderungen sofort im Shop veröffentlicht.",
      "source_file": "src/features/admin/ContentEditorTab.jsx",
      "sourceFile": "src/features/admin/ContentEditorTab.jsx",
      "multiline": true
    },
    "onboarding_welcome_title": {
      "type": "text",
      "label": "Onboarding Willkommen Titel",
      "defaultValue": "Willkommen in Ihrem White-Label Partner-Shop",
      "default_value": "Willkommen in Ihrem White-Label Partner-Shop",
      "source_file": "src/features/admin/ContentEditorTab.jsx",
      "sourceFile": "src/features/admin/ContentEditorTab.jsx",
      "multiline": false
    },
    "onboarding_step1_text": {
      "type": "text",
      "label": "Onboarding Schritt 1",
      "defaultValue": "1. Logo & Farben im Design-Drawer anpassen.",
      "default_value": "1. Logo & Farben im Design-Drawer anpassen.",
      "source_file": "src/features/admin/ContentEditorTab.jsx",
      "sourceFile": "src/features/admin/ContentEditorTab.jsx",
      "multiline": false
    },
    "onboarding_step2_text": {
      "type": "text",
      "label": "Onboarding Schritt 2",
      "defaultValue": "2. Texte und Kontaktdaten inline editieren.",
      "default_value": "2. Texte und Kontaktdaten inline editieren.",
      "source_file": "src/features/admin/ContentEditorTab.jsx",
      "sourceFile": "src/features/admin/ContentEditorTab.jsx",
      "multiline": false
    }
  }
};

/**
 * Liefert die vollständige Slot-Definition für eine Seite und einen Slot-Key.
 */
export function getSlotDefinition(page, key) {
  if (!page || !key) return null;
  return SLOT_METADATA[page]?.[key] || null;
}

/**
 * Liefert den Standardwert für einen Slot aus dem Register.
 */
export function getDefaultSlotValue(page, key) {
  if (!page || !key) return '';
  return CONTENT_FALLBACKS[page]?.[key] ?? '';
}

/**
 * Prüft, ob ein Slot für eine bestimmte Seite im Register existiert.
 */
export function isValidSlot(page, key) {
  if (!page || !key) return false;
  return Boolean(REGISTERED_SLOTS[page]?.[key]);
}

/**
 * Liefert alle Slots als flaches Array.
 */
export function getAllSlots() {
  return SLOT_REGISTRY;
}

/**
 * Liefert alle Slots einer bestimmten Seite.
 */
export function getSlotsByPage(page) {
  return SLOT_REGISTRY.filter((s) => s.page === page);
}

/**
 * Liefert alle Slots einer Quelldatei.
 */
export function getSlotsByFile(sourceFile) {
  return SLOT_REGISTRY.filter((s) => s.sourceFile === sourceFile || s.source_file === sourceFile);
}

/**
 * Löst einen Textwert mit Fallback auf das Register auf.
 */
export function resolveSlotText(page, key, customValue) {
  if (typeof customValue === 'string' && customValue.trim().length > 0) {
    return customValue;
  }
  return getDefaultSlotValue(page, key);
}

/**
 * Liefert aggregierte Statistiken über das Slot-Register.
 */
export function getSlotStats() {
  const total = SLOT_REGISTRY.length;
  const textSlots = SLOT_REGISTRY.filter((s) => s.type === 'text').length;
  const imageSlots = SLOT_REGISTRY.filter((s) => s.type === 'image').length;
  const pages = Object.keys(REGISTERED_SLOTS).length;
  const files = new Set(SLOT_REGISTRY.map((s) => s.sourceFile)).size;
  return { total, textSlots, imageSlots, pages, files };
}
